"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataImportScheduleRepeatType = exports.DataImportScheduleRemovalType = exports.DataImportRunTriggerType = exports.DataImportRunTaskStage = exports.DataImportRunStatusType = exports.DataImportRunStartOption = exports.DataImportPreemptOption = exports.DataImportErrorType = exports.DataImportEditAccessType = exports.DataImportDuplicabilityType = exports.DataImportCreationSource = exports.CustomOAuthAppVisibility = exports.CustomApiPreviousImportOption = exports.CustomAPIPaginationType = exports.CustomAPIOffsetType = exports.CustomAPIHttpMethodType = exports.CustomAPIAuthType = exports.CreditTransactionType = exports.CreditCardType = exports.CreditActionType = exports.CloudTableImportRunStages = exports.CellFormat = exports.CampfireFetchMode = exports.CSVSourceType = exports.ButtonClickActionType = exports.BillingGatedActionType = exports.AutoAnalysesRunStatus = exports.AssistantFeedbackSentiment = exports.AnalyticsUserType = exports.AnalyticsEventPlatformType = exports.AnalyticsEventNameType = exports.AllowOrDisallowOption = exports.AlertType = exports.AlertSendStatusType = exports.AlertScheduleRepeatType = exports.AlertRunWarningType = exports.AlertRunErrorType = exports.AlertMode = exports.AlertContentType = exports.AlertChangeTableType = exports.AgentType = exports.AgentTaskRunStatus = exports.AgentSourceKind = exports.AgentRunStatus = exports.AgentRole = exports.AgentImportRunStatus = exports.AgentEventType = exports.AffiliateProgramType = exports.AddonPlatform = exports.AIAssistantType = void 0;
exports.MeterLimitEnforcementType = exports.MergedCellValueOption = exports.LookerFetchMode = exports.LookerConnectionEmailTriggerOptions = exports.LicenseRequestGateType = exports.LeadgenRunStatus = exports.InstaTimeframes = exports.InstaInsightOptions = exports.InstaFetchMode = exports.InstaDemographicMetricBreakdown = exports.InstaAudienceDemographicMetrics = exports.IdentityProvider = exports.HubspotObjectTypeFieldType = exports.GoogleSheetsCellValueType = exports.GmailImportType = exports.GmailActionType = exports.GenericScraperParserType = exports.GatedFeature = exports.GateEncounterSurface = exports.GSheetOAuthTokenStatus = exports.GPTFunctionName = exports.GPTBuilderType = exports.FormulaImportStatusLevel = exports.FormulaFunctionName = exports.FlatColumnType = exports.FilterOperatorType = exports.FilterOperandType = exports.FilterGroupType = exports.FilterClauseOperand = exports.FeatureGateId = exports.FeatureFlag = exports.ExcelWriterInstructionType = exports.ExcelWorkbookRedirectionType = exports.ExcelSourceType = exports.ExcelFileLocationType = exports.ExcelCellBorderWeightType = exports.ExcelCellBorderStyleType = exports.ExcelCellBorderIdType = exports.ExcelAgentInstructionType = exports.EnrichRunStatus = exports.DynamicCloneOverallStatusType = exports.DueInvoiceErrorType = exports.DomainFamilyChangeLogType = exports.DateFilterType = exports.DataSourceType = exports.DataSourceConnectionStatusType = exports.DataSourceCategory = exports.DataImportWarningType = exports.DataImportTransferUserAssociation = exports.DataImportStatusLevel = void 0;
exports.SubscriptionCancellationReason = exports.SubscriptionBillingInterval = exports.SpreadsheetShareOptions = exports.SpreadsheetColumnBehavior = exports.SourceType = exports.SortType = exports.SnowflakeKeypairOrigin = exports.SnapshotType = exports.SnapshotRunStatus = exports.SnapshotComponentType = exports.SnapshotAppendType = exports.SmartAlertThreadSource = exports.SmartAlertEditAccessType = exports.SmartAlertContentBlockType = exports.SignupSourceType = exports.SignupAttributionClaimTrigger = exports.SchemaFetchErrorStatus = exports.SaveMemoryDecisionType = exports.SalesforceReportType = exports.SalesforceReportRenderType = exports.SalesforceObjectTypeFieldType = exports.SalesforceFetchMode = exports.SalesforceCustomFetchType = exports.SageFetchMode = exports.SSOAuthorizationURLResponseMode = exports.SQLColumnDataType = exports.RilletFetchMode = exports.RestrictedFieldOptions = exports.QuiverFetchMode = exports.QuickstartVariantType = exports.QuickstartRedirectType = exports.QuickbooksReports = exports.QuickbooksObjects = exports.QuickbooksFetchMode = exports.PreviewAutoRefreshMode = exports.PivotValueAggregationType = exports.PivotDimensionBucketingType = exports.ParameterizedCellRefType = exports.PPressFormMode = exports.PBDashBlueprintID = exports.OpenaiRunStatus = exports.OauthAttemptStatus = exports.NumberFormat = exports.NumberFilterType = exports.NetsuiteFeatureAccessType = exports.NetSuiteFetchMode = exports.NOSQLColumnDataType = exports.MicrosoftAdsReports = exports.MeterType = exports.MeterLimitInterval = void 0;
exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.XeroTimeframe = exports.XeroReports = exports.XeroObjects = exports.XeroFetchMode = exports.XeroAgingGrouping = exports.XeroAgingBy = exports.WritebackScheduleExportType = exports.WritebackSalesforceApiType = exports.WritebackRunTriggerType = exports.WritebackRunTaskStage = exports.WritebackRunStartOption = exports.WritebackRunOverallStatusType = exports.WritebackMode = exports.WritebackMappingProblemType = exports.WriteResultsToSheetStatus = exports.WebDashboardUpdateType = exports.WebDashboardTrialStateType = exports.WebDashboardSubscriptionTriggerType = exports.WebDashboardSubscriptionScope = exports.WebDashboardSubscriptionRunStatus = exports.WebDashboardSharingLevel = exports.WebDashboardShareRole = exports.WebDashboardRunStatus = exports.WebDashboardRefreshType = exports.WebDashboardPlanLimitSource = exports.WebDashboardImportHealth = exports.WebDashboardEligibility = exports.WebDashboardBuildingPhase = exports.VibeDashViewerType = exports.VCRMode = exports.UserRoleType = exports.UserExtraType = exports.TrialStateType = exports.TotalRowCountType = exports.TextType = exports.TableauWorksheetZoneType = exports.TableauWorksheetParameterType = exports.TableauWorksheetFilterType = exports.TableauDownloadType = exports.TableauConnectedAppTrustType = exports.SupportEmailType = exports.SubscriptionUpdateType = exports.SubscriptionScheduledChangeType = exports.SubscriptionPlanType = exports.SubscriptionItemType = exports.SubscriptionInvoiceStatus = exports.SubscriptionCheckoutMode = void 0;
exports.DefaultApi = void 0;
var axios_1 = __importDefault(require("axios"));
var common_1 = require("./common");
var base_1 = require("./base");
exports.AIAssistantType = {
    SheetsAssistant: 'sheets_assistant',
    SheetsAssistantYoloMode: 'sheets_assistant_yolo_mode',
    AutoAnalyst: 'auto_analyst',
    DeepBuilder: 'deep_builder'
};
exports.AddonPlatform = {
    Excel: 'excel',
    GoogleSheets: 'google_sheets'
};
exports.AffiliateProgramType = {
    Rewardful: 'rewardful'
};
exports.AgentEventType = {
    Revert: 'revert',
    BlockScreenshotCapture: 'block_screenshot_capture',
    Compaction: 'compaction'
};
exports.AgentImportRunStatus = {
    Running: 'running',
    Succeeded: 'succeeded',
    SucceededWithWarning: 'succeeded_with_warning',
    Failed: 'failed'
};
exports.AgentRole = {
    User: 'user',
    Agent: 'agent',
    Event: 'event'
};
exports.AgentRunStatus = {
    Queued: 'queued',
    InProgress: 'in_progress',
    Paused: 'paused',
    Completed: 'completed',
    Failed: 'failed',
    AwaitingClientExecution: 'awaiting_client_execution'
};
exports.AgentSourceKind = {
    SqlTables: 'sql_tables',
    CrmObjects: 'crm_objects'
};
exports.AgentTaskRunStatus = {
    Queued: 'queued',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
};
exports.AgentType = {
    Funny: 'funny',
    CleanAndTransform: 'clean_and_transform',
    Enrich: 'enrich',
    Analysis: 'analysis',
    Browser: 'browser',
    LeadGen: 'lead_gen',
    HubspotAgent: 'hubspot_agent',
    SqlImport: 'sql_import',
    AnyApi: 'any_api',
    ApiDocumentParser: 'api_document_parser',
    SchemaDetector: 'schema_detector',
    WebDashboardBuilder: 'web_dashboard_builder',
    SheetAssistant: 'sheet_assistant',
    WebDashboardEditor: 'web_dashboard_editor',
    WebDashboardViewer: 'web_dashboard_viewer',
    WebDashboardRefresh: 'web_dashboard_refresh',
    CuratedApiAgent: 'curated_api_agent',
    SmartAlerts: 'smart_alerts',
    TriggerAgent: 'trigger_agent',
    ContentAgent: 'content_agent'
};
exports.AlertChangeTableType = {
    ColumnChanged: 'column_changed',
    NewRowAdded: 'new_row_added'
};
exports.AlertContentType = {
    Table: 'table',
    Chart: 'chart',
    Text: 'text',
    Gif: 'gif',
    Space: 'space',
    ChangeTable: 'change_table',
    Image: 'image',
    Separator: 'separator',
    Card: 'card'
};
exports.AlertMode = {
    Single: 'single',
    Grouped: 'grouped'
};
exports.AlertRunErrorType = {
    SlackChannelArchived: 'slack_channel_archived',
    SlackAccountInactive: 'slack_account_inactive',
    SlackChannelNotFound: 'slack_channel_not_found',
    SlackAuthError: 'slack_auth_error',
    SlackUserNotFound: 'slack_user_not_found',
    SlackUnknownError: 'slack_unknown_error',
    SlackRateLimitError: 'slack_rate_limit_error',
    SlackTemporaryError: 'slack_temporary_error',
    AlertRunUnknownError: 'alert_run_unknown_error',
    AlertMisconfigured: 'alert_misconfigured',
    AlertRateLimited: 'alert_rate_limited',
    AlertRangeVolatileFunction: 'alert_range_volatile_function',
    InvalidDynamicRecipient: 'invalid_dynamic_recipient',
    GoogleSheetsCellLimitExceeded: 'google_sheets_cell_limit_exceeded',
    AlertDisabledByAdmin: 'alert_disabled_by_admin'
};
exports.AlertRunWarningType = {
    AlertThrottled: 'alert_throttled',
    FeatureDisallowed: 'feature_disallowed'
};
exports.AlertScheduleRepeatType = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
};
exports.AlertSendStatusType = {
    Sent: 'sent',
    WillSend: 'will_send',
    NotifDisabled: 'notif_disabled',
    TooManyChanges: 'too_many_changes',
    RateLimited: 'rate_limited',
    Throttled: 'throttled',
    DynamicRecipientsRefError: 'dynamic_recipients_ref_error',
    NoChanges: 'no_changes',
    NoNewTriggeringCells: 'no_new_triggering_cells',
    NoNewRowsAppended: 'no_new_rows_appended',
    IdColumnChanged: 'id_column_changed',
    NoNewRowsWithId: 'no_new_rows_with_id',
    NoRecipients: 'no_recipients',
    TrixRecordMissing: 'trix_record_missing',
    TrixRecordOutOfSync: 'trix_record_out_of_sync',
    TrixRecordCorrupt: 'trix_record_corrupt',
    TrixRecordCustomFunctionError: 'trix_record_custom_function_error',
    DuplicateNotif: 'duplicate_notif',
    TransientError: 'transient_error',
    UnknownError: 'unknown_error',
    CellLimitExceeded: 'cell_limit_exceeded'
};
exports.AlertType = {
    MonitorChange: 'monitor_change',
    MonitorCondition: 'monitor_condition',
    NewRowsAppended: 'new_rows_appended',
    NewRowsWithId: 'new_rows_with_id',
    Snapshot: 'snapshot'
};
exports.AllowOrDisallowOption = {
    Allow: 'allow',
    Disallow: 'disallow'
};
exports.AnalyticsEventNameType = {
    ErrorBoundaryViewed: 'error_boundary_viewed',
    RedBoxErrorShown: 'red_box_error_shown',
    WarningBoxShown: 'warning_box_shown',
    ReconnectBoxShown: 'reconnect_box_shown',
    RedToastErrorShown: 'red_toast_error_shown',
    TopLevelErrorShown: 'top_level_error_shown',
    GsheetsClockTriggerErrorShown: 'gsheets_clock_trigger_error_shown',
    AuthorizationWindowPopupBlocked: 'authorization_window_popup_blocked',
    AuthorizationWindowPopupBlockedWarningCardShown: 'authorization_window_popup_blocked_warning_card_shown',
    ImportDeleted: 'import_deleted',
    ImportEdited: 'import_edited',
    ImportClonedLocalExcel: 'import_cloned_local_excel',
    ImportViewed: 'import_viewed',
    ImportManualRefreshDone: 'import_manual_refresh_done',
    ImportManualRefreshFailed: 'import_manual_refresh_failed',
    ImportManualRefreshStarted: 'import_manual_refresh_started',
    ImportScheduledRefreshDone: 'import_scheduled_refresh_done',
    ImportScheduledRefreshFailed: 'import_scheduled_refresh_failed',
    ImportScheduledRefreshStarted: 'import_scheduled_refresh_started',
    ImportAbandonedSpreadsheet: 'import_abandoned_spreadsheet',
    ImportDemoAccountScheduleExpired: 'import_demo_account_schedule_expired',
    DatasetManualRefreshDone: 'dataset_manual_refresh_done',
    DatasetManualRefreshFailed: 'dataset_manual_refresh_failed',
    DatasetManualRefreshStarted: 'dataset_manual_refresh_started',
    DatasetScheduledRefreshDone: 'dataset_scheduled_refresh_done',
    DatasetScheduledRefreshFailed: 'dataset_scheduled_refresh_failed',
    DatasetScheduledRefreshStarted: 'dataset_scheduled_refresh_started',
    DatasetErrorEmailSent: 'dataset_error_email_sent',
    AddImportClicked: 'add_import_clicked',
    AddImportSourceSelected: 'add_import_source_selected',
    AddImportSourceRequested: 'add_import_source_requested',
    ImportCreateDone: 'import_create_done',
    ImportCreateFailed: 'import_create_failed',
    ImportCreateStarted: 'import_create_started',
    ImportCreateViewed: 'import_create_viewed',
    ImportFileSelected: 'import_file_selected',
    ImportOauthDone: 'import_oauth_done',
    ImportOauthFailed: 'import_oauth_failed',
    ImportOauthStarted: 'import_oauth_started',
    AddImportConnectionDone: 'add_import_connection_done',
    AddImportConnectionFailed: 'add_import_connection_failed',
    AddImportConnectionStarted: 'add_import_connection_started',
    EditImportConnectionDone: 'edit_import_connection_done',
    EditImportConnectionFailed: 'edit_import_connection_failed',
    EditImportConnectionStarted: 'edit_import_connection_started',
    ImportRefreshAllClicked: 'import_refresh_all_clicked',
    DuplicateImportClicked: 'duplicate_import_clicked',
    ImportSuboptionsViewed: 'import_suboptions_viewed',
    ConnDetailsImportDataClicked: 'conn_details_import_data_clicked',
    ImportRunLimitReachedEmailSent: 'import_run_limit_reached_email_sent',
    ImportRefreshLimitThresholdCrossed: 'import_refresh_limit_threshold_crossed',
    RefreshLimitMeterShown: 'refresh_limit_meter_shown',
    FeaturePaywallShown: 'feature_paywall_shown',
    AiUsageLimitThresholdCrossed: 'ai_usage_limit_threshold_crossed',
    AiUsageLimitBlocked: 'ai_usage_limit_blocked',
    FeatureGateBlocked: 'feature_gate_blocked',
    ExcelImportApplyInstructionsStarted: 'excel_import_apply_instructions_started',
    ExcelImportApplyInstructionsDone: 'excel_import_apply_instructions_done',
    ExcelImportApplyInstructionsFailed: 'excel_import_apply_instructions_failed',
    ColumnDropdownSettingClicked: 'column_dropdown_setting_clicked',
    AddonLaunched: 'addon_launched',
    MsalLoginViewed: 'msal_login_viewed',
    MsalLoginStarted: 'msal_login_started',
    MsalLoginDone: 'msal_login_done',
    MsalLoginFailed: 'msal_login_failed',
    MsalLoginResumed: 'msal_login_resumed',
    TokenExchangeLoginDone: 'token_exchange_login_done',
    AuthTokenEmailMismatch: 'auth_token_email_mismatch',
    SsoLoginDone: 'sso_login_done',
    MultipleAccountsDetected: 'multiple_accounts_detected',
    MultipleAccountsModalDismissed: 'multiple_accounts_modal_dismissed',
    OidcLoginViewed: 'oidc_login_viewed',
    OidcLoginStarted: 'oidc_login_started',
    OidcLoginDone: 'oidc_login_done',
    OidcLoginFailed: 'oidc_login_failed',
    LoaderOnScreenTime: 'loader_on_screen_time',
    UserCreated: 'user_created',
    OnsheetSettingsClick: 'onsheet_settings_click',
    OnsheetExportToClick: 'onsheet_export_to_click',
    AppOnboardingExpansionWelcome: 'app_onboarding_expansion_welcome',
    AppOnboardingStarted: 'app_onboarding_started',
    AppOnboardingDone: 'app_onboarding_done',
    AppChatLaunched: 'app_chat_launched',
    GsheetsRedirectNoticePopupShown: 'gsheets_redirect_notice_popup_shown',
    GsheetsRedirectNoticePopupClosedByUser: 'gsheets_redirect_notice_popup_closed_by_user',
    GsheetsRedirectNoticePopupOkByUser: 'gsheets_redirect_notice_popup_ok_by_user',
    GsheetsAddonAuthTokenAcquired: 'gsheets_addon_auth_token_acquired',
    GsheetsAddonAuthTokenAcquisitionRejected: 'gsheets_addon_auth_token_acquisition_rejected',
    GsheetsAddonAuthTokenAcquisitionFailed: 'gsheets_addon_auth_token_acquisition_failed',
    CoeffEmailSent: 'coeff_email_sent',
    QuickstartRedirect: 'quickstart_redirect',
    QuickstartBlocked: 'quickstart_blocked',
    QuickstartInstallClicked: 'quickstart_install_clicked',
    QuickstartOpened: 'quickstart_opened',
    AddAlertClicked: 'add_alert_clicked',
    AddExportClicked: 'add_export_clicked',
    SnapshotClicked: 'snapshot_clicked',
    WebDashboardClicked: 'web_dashboard_clicked',
    BetaMenuClicked: 'beta_menu_clicked',
    CreateAgentSectionToggled: 'create_agent_section_toggled',
    AlertCreateStarted: 'alert_create_started',
    AlertSaveSubmitted: 'alert_save_submitted',
    AlertCreateFailed: 'alert_create_failed',
    AlertCreateDone: 'alert_create_done',
    AlertOnboardingStarted: 'alert_onboarding_started',
    AlertOnboardingDone: 'alert_onboarding_done',
    AlertViewed: 'alert_viewed',
    AlertEdited: 'alert_edited',
    AlertEditFailed: 'alert_edit_failed',
    AlertDeleted: 'alert_deleted',
    AlertSent: 'alert_sent',
    AlertSuppressed: 'alert_suppressed',
    AlertOnboardingTryoutStarted: 'alert_onboarding_tryout_started',
    AlertOnboardingTryoutFailed: 'alert_onboarding_tryout_failed',
    AlertOnboardingTryoutDone: 'alert_onboarding_tryout_done',
    AlertOptionsViewedSidebar: 'alert_options_viewed_sidebar',
    AlertOptionsCreateClicked: 'alert_options_create_clicked',
    AlertOptionsCreateFromTemplateClicked: 'alert_options_create_from_template_clicked',
    AlertOptionsCreateFromBannerClicked: 'alert_options_create_from_banner_clicked',
    AlertPromoteBannerShown: 'alert_promote_banner_shown',
    AlertPromotionBannerDismissed: 'alert_promotion_banner_dismissed',
    AlertSheetElementDetected: 'alert_sheet_element_detected',
    AlertChartProTipHomeClicked: 'alert_chart_pro_tip_home_clicked',
    AlertChartProTipHomeDismissed: 'alert_chart_pro_tip_home_dismissed',
    AlertChartProTipHomeShown: 'alert_chart_pro_tip_home_shown',
    AlertSheetChartDetected: 'alert_sheet_chart_detected',
    AlertSheetPivotTableDetected: 'alert_sheet_pivot_table_detected',
    AlertProTipHomeShown: 'alert_pro_tip_home_shown',
    AlertProTipHomeDismissed: 'alert_pro_tip_home_dismissed',
    AlertProTipHomeClicked: 'alert_pro_tip_home_clicked',
    AlertPopupShown: 'alert_popup_shown',
    AlertPopupCreateClicked: 'alert_popup_create_clicked',
    AlertMessageViewed: 'alert_message_viewed',
    AlertMessageBlockDeleted: 'alert_message_block_deleted',
    AlertMessageBlockSaveSubmitted: 'alert_message_block_save_submitted',
    AlertMessageBlockSaveFailed: 'alert_message_block_save_failed',
    AlertMessageBlockSaveSuccessful: 'alert_message_block_save_successful',
    AlertMessageSendPreviewSubmitted: 'alert_message_send_preview_submitted',
    AlertMessageModeSelected: 'alert_message_mode_selected',
    AlertMessageSendPreviewModalOpened: 'alert_message_send_preview_modal_opened',
    AlertDetailsTriggerConditionTypeSelected: 'alert_details_trigger_condition_type_selected',
    AlertDetailsTriggerConditionSelected: 'alert_details_trigger_condition_selected',
    AlertDetailsTriggerTypeViewed: 'alert_details_trigger_type_viewed',
    AlertDetailsTriggerTypeSelected: 'alert_details_trigger_type_selected',
    AlertDetailsTriggerTypeReset: 'alert_details_trigger_type_reset',
    AlertDetailsDataRangeViewed: 'alert_details_data_range_viewed',
    AlertDetailsDataRangeIdColumnSelected: 'alert_details_data_range_id_column_selected',
    AlertDetailsFrequencyViewed: 'alert_details_frequency_viewed',
    AlertDetailsFrequencyScheduleChanged: 'alert_details_frequency_schedule_changed',
    AlertDetailsFrequencyDigestToggled: 'alert_details_frequency_digest_toggled',
    AlertDetailsDataRangeRangeSelected: 'alert_details_data_range_range_selected',
    AlertDetailsSendToViewed: 'alert_details_send_to_viewed',
    AlertEditClicked: 'alert_edit_clicked',
    AlertRenameClicked: 'alert_rename_clicked',
    AlertRunHistoryClicked: 'alert_run_history_clicked',
    AlertDeleteClicked: 'alert_delete_clicked',
    AlertJumpToClicked: 'alert_jump_to_clicked',
    AlertPauseClicked: 'alert_pause_clicked',
    AlertMessageSaveSubmitted: 'alert_message_save_submitted',
    AlertMessageSaveSuccessful: 'alert_message_save_successful',
    AlertMessageSaveFailed: 'alert_message_save_failed',
    AlertMessageSendPreviewFailed: 'alert_message_send_preview_failed',
    AlertMessageSendPreviewSuccessful: 'alert_message_send_preview_successful',
    ConnOnboardingSelectedSuggestedSource: 'conn_onboarding_selected_suggested_source',
    ConnCreateViewed: 'conn_create_viewed',
    ConnCreateStarted: 'conn_create_started',
    ConnCreateFailed: 'conn_create_failed',
    ConnCreateDone: 'conn_create_done',
    ConnViewed: 'conn_viewed',
    ConnDeleted: 'conn_deleted',
    ConnEditStarted: 'conn_edit_started',
    ConnEditDone: 'conn_edit_done',
    ConnEditFailed: 'conn_edit_failed',
    ChangeDataSourceViewed: 'change_data_source_viewed',
    ChangeDataSourceCancelled: 'change_data_source_cancelled',
    ChangeDataSourceSuccess: 'change_data_source_success',
    ChangeDataSourceFailure: 'change_data_source_failure',
    AddConnectionSearch: 'add_connection_search',
    ImportRecipeCreated: 'import_recipe_created',
    ImportRecipeEdited: 'import_recipe_edited',
    ImportRecipeDeleted: 'import_recipe_deleted',
    ImportLibraryClicked: 'import_library_clicked',
    ImportLibrarySplashViewed: 'import_library_splash_viewed',
    ImportLibraryViewed: 'import_library_viewed',
    ImportEditAccessModified: 'import_edit_access_modified',
    ImportRecipeViewed: 'import_recipe_viewed',
    ImportRecipeCreationStart: 'import_recipe_creation_start',
    ImportRecipePromoteBannerDismissed: 'import_recipe_promote_banner_dismissed',
    ImportRecipePromoteBannerShown: 'import_recipe_promote_banner_shown',
    ImportRecipeShared: 'import_recipe_shared',
    ImportRecipeShareViewed: 'import_recipe_share_viewed',
    ImportRecipeShareDone: 'import_recipe_share_done',
    ImportRecipeShareTooltipViewed: 'import_recipe_share_tooltip_viewed',
    ImportRecipeUnshared: 'import_recipe_unshared',
    ImportRecipeShowMoreClicked: 'import_recipe_show_more_clicked',
    ImportRecipeSharedShowMoreClicked: 'import_recipe_shared_show_more_clicked',
    ImportRecipeShareButtonClicked: 'import_recipe_share_button_clicked',
    ImportRecipeSharePopupOpened: 'import_recipe_share_popup_opened',
    ImportRecipeEditClicked: 'import_recipe_edit_clicked',
    ImportRecipePopoverOpen: 'import_recipe_popover_open',
    ImportRecipePopoverRecipyClicked: 'import_recipe_popover_recipy_clicked',
    ImportRecipePopoverRecipyUndo: 'import_recipe_popover_recipy_undo',
    ImportRecipePopoverRecipeClicked: 'import_recipe_popover_recipe_clicked',
    ImportRecipePopoverRecipeUndo: 'import_recipe_popover_recipe_undo',
    ImportFromRecipeTemplateCreated: 'import_from_recipe_template_created',
    ImportRecipeTemplateClicked: 'import_recipe_template_clicked',
    WbOnboardingStarted: 'wb_onboarding_started',
    WbOnboardingDone: 'wb_onboarding_done',
    WbOptionsSourceSelected: 'wb_options_source_selected',
    WbOptionsViewed: 'wb_options_viewed',
    WbOptionsFeedbackSubmitted: 'wb_options_feedback_submitted',
    WbViewed: 'wb_viewed',
    WbActionClicked: 'wb_action_clicked',
    WbStarted: 'wb_started',
    WbDone: 'wb_done',
    WbFailed: 'wb_failed',
    WbDeleted: 'wb_deleted',
    WbScheduledStarted: 'wb_scheduled_started',
    WbScheduledDone: 'wb_scheduled_done',
    WbScheduledFailed: 'wb_scheduled_failed',
    WbPreviewSucceeded: 'wb_preview_succeeded',
    WbPreviewFailed: 'wb_preview_failed',
    WbPreviewViewed: 'wb_preview_viewed',
    WbBlocked: 'wb_blocked',
    WbMappingsBackfilled: 'wb_mappings_backfilled',
    WbMappingsNotBackfilled: 'wb_mappings_not_backfilled',
    WbConnectionSubstituted: 'wb_connection_substituted',
    WbViewerRunStarted: 'wb_viewer_run_started',
    WbViewerRunCompleted: 'wb_viewer_run_completed',
    AddWbSourceRequested: 'add_wb_source_requested',
    SalesforceFeedbackPopupShown: 'salesforce_feedback_popup_shown',
    SalesforceFeedbackPopupDismissed: 'salesforce_feedback_popup_dismissed',
    SalesforceFeedbackSubmitted: 'salesforce_feedback_submitted',
    SalesforceImportObjectSelected: 'salesforce_import_object_selected',
    SqlSchemaItemNameCopied: 'sql_schema_item_name_copied',
    RatingPopupShown: 'rating_popup_shown',
    RatingPopupRatingDeclined: 'rating_popup_rating_declined',
    RatingPopupRatingSubmitted: 'rating_popup_rating_submitted',
    RatingPopupMktplaceRateClicked: 'rating_popup_mktplace_rate_clicked',
    RatingPopupMktplaceRateDeclined: 'rating_popup_mktplace_rate_declined',
    RatingPopupFeedbackSubmitted: 'rating_popup_feedback_submitted',
    RatingPopupFeedbackDeclined: 'rating_popup_feedback_declined',
    RatingPopupFeedbackDismissed: 'rating_popup_feedback_dismissed',
    RefreshSchedulePopupShown: 'refresh_schedule_popup_shown',
    RefreshSchedulePopupDismissed: 'refresh_schedule_popup_dismissed',
    RefreshSchedulePopupSubmitted: 'refresh_schedule_popup_submitted',
    AutoAnalystPopupShown: 'auto_analyst_popup_shown',
    AutoAnalystPopupDismissed: 'auto_analyst_popup_dismissed',
    AgenticWorkflowsWelcomePopupShown: 'agentic_workflows_welcome_popup_shown',
    AgenticWorkflowsWelcomePopupDismissed: 'agentic_workflows_welcome_popup_dismissed',
    PbDashDeleted: 'pb_dash_deleted',
    PbDashEdited: 'pb_dash_edited',
    GlobalSchedulerActionClicked: 'global_scheduler_action_clicked',
    GlobalSchedulerDone: 'global_scheduler_done',
    GlobalSchedulerViewed: 'global_scheduler_viewed',
    BillingSubscriptionViewed: 'billing_subscription_viewed',
    BillingPaymentAndBillingViewed: 'billing_payment_and_billing_viewed',
    BillingTeamViewed: 'billing_team_viewed',
    BillingManageTeamViewed: 'billing_manage_team_viewed',
    BillingPlanChooserInvoked: 'billing_plan_chooser_invoked',
    BillingPlanChooserViewed: 'billing_plan_chooser_viewed',
    BillingPlanSelected: 'billing_plan_selected',
    BillingCheckoutClicked: 'billing_checkout_clicked',
    BillingPaymentClicked: 'billing_payment_clicked',
    BillingPaymentSucceeded: 'billing_payment_succeeded',
    BillingPaymentFailed: 'billing_payment_failed',
    BillingPlanChanged: 'billing_plan_changed',
    BillingManageTeamClicked: 'billing_manage_team_clicked',
    BillingManageTeamUserAdded: 'billing_manage_team_user_added',
    BillingManageTeamUserRemoved: 'billing_manage_team_user_removed',
    BillingManageTeamLicensesAdded: 'billing_manage_team_licenses_added',
    BillingManageTeamLicensesRemoved: 'billing_manage_team_licenses_removed',
    BillingManageTeamScheduledDowngradeCancelled: 'billing_manage_team_scheduled_downgrade_cancelled',
    BillingSettingsClicked: 'billing_settings_clicked',
    BillingSettingsPaymentUpdateClicked: 'billing_settings_payment_update_clicked',
    BillingSettingsFrequencyUpdateClicked: 'billing_settings_frequency_update_clicked',
    BillingAiDashboardsToggled: 'billing_ai_dashboards_toggled',
    BillingAiDashboardsPurchaseClicked: 'billing_ai_dashboards_purchase_clicked',
    BillingAiDashboardsPurchaseSucceeded: 'billing_ai_dashboards_purchase_succeeded',
    BillingAiDashboardsPurchaseFailed: 'billing_ai_dashboards_purchase_failed',
    BillingAiDashboardsRemoveClicked: 'billing_ai_dashboards_remove_clicked',
    BillingAiDashboardsRemoveCompleted: 'billing_ai_dashboards_remove_completed',
    BillingPaymentUpdateClicked: 'billing_payment_update_clicked',
    BillingPaymentUpdateSucceeded: 'billing_payment_update_succeeded',
    BillingPaymentUpdateFailed: 'billing_payment_update_failed',
    BillingFrequencyUpdateClicked: 'billing_frequency_update_clicked',
    BillingFrequencyUpdateSucceeded: 'billing_frequency_update_succeeded',
    BillingFrequencyUpdateFailed: 'billing_frequency_update_failed',
    BillingDataSourceChangeClicked: 'billing_data_source_change_clicked',
    BillingCancelModalOpened: 'billing_cancel_modal_opened',
    BillingCancelProceededToSurvey: 'billing_cancel_proceeded_to_survey',
    BillingCancelKeptPlan: 'billing_cancel_kept_plan',
    BillingCancelDowngradeClicked: 'billing_cancel_downgrade_clicked',
    BillingCancelCompleted: 'billing_cancel_completed',
    BillingCancelUndoCompleted: 'billing_cancel_undo_completed',
    ContactSalesButtonClicked: 'contact_sales_button_clicked',
    ContactAdminModalShown: 'contact_admin_modal_shown',
    ContactAdminCopyEmailsClicked: 'contact_admin_copy_emails_clicked',
    RequestLicenseModalShown: 'request_license_modal_shown',
    RequestLicenseClicked: 'request_license_clicked',
    RequestLicenseSent: 'request_license_sent',
    RequestLicenseFailed: 'request_license_failed',
    LicenseRequestCreated: 'license_request_created',
    LicenseRequestResolved: 'license_request_resolved',
    ProLicenseCapReached: 'pro_license_cap_reached',
    UpgradeToEnterpriseModalShown: 'upgrade_to_enterprise_modal_shown',
    UpgradeToEnterpriseScreenViewed: 'upgrade_to_enterprise_screen_viewed',
    ContactSalesModalShown: 'contact_sales_modal_shown',
    ContactSalesFormSubmitted: 'contact_sales_form_submitted',
    UpgradeToEnterpriseForDataSourceLimitBannerShown: 'upgrade_to_enterprise_for_data_source_limit_banner_shown',
    UpgradeToEnterpriseForDataSourceLimitModalShown: 'upgrade_to_enterprise_for_data_source_limit_modal_shown',
    ScheduleDemoClicked: 'schedule_demo_clicked',
    HelpCenterClicked: 'help_center_clicked',
    SlackCommunityClicked: 'slack_community_clicked',
    VideoThumbClicked: 'video_thumb_clicked',
    TemplateSplashViewed: 'template_splash_viewed',
    TemplateSetupStarted: 'template_setup_started',
    TemplateSetupDone: 'template_setup_done',
    TemplateSetupFailed: 'template_setup_failed',
    TemplateOptionsViewed: 'template_options_viewed',
    TemplateDetailsViewed: 'template_details_viewed',
    TemplateCtaClicked: 'template_cta_clicked',
    TemplateSsTaukCollected: 'template_ss_tauk_collected',
    WebappLoginViewed: 'webapp_login_viewed',
    WebappLogoutClicked: 'webapp_logout_clicked',
    WebappAuthPageViewed: 'webapp_auth_page_viewed',
    WebappReauthPageViewed: 'webapp_reauth_page_viewed',
    WorkspaceClicked: 'workspace_clicked',
    WorkspaceSpreadsheetsViewed: 'workspace_spreadsheets_viewed',
    WorkspaceSpreadsheetViewed: 'workspace_spreadsheet_viewed',
    WorkspaceImportViewed: 'workspace_import_viewed',
    WorkspaceWbViewed: 'workspace_wb_viewed',
    WorkspaceAlertViewed: 'workspace_alert_viewed',
    SmartAlertOnboardingViewed: 'smart_alert_onboarding_viewed',
    SmartAlertOnboardingCreateClicked: 'smart_alert_onboarding_create_clicked',
    SmartAlertChatMessageSubmitted: 'smart_alert_chat_message_submitted',
    SmartAlertChatViewed: 'smart_alert_chat_viewed',
    SmartAlertQuickstartPromptClicked: 'smart_alert_quickstart_prompt_clicked',
    SmartAlertQuickstartPromptClickedModal: 'smart_alert_quickstart_prompt_clicked_modal',
    SmartAlertChatStopped: 'smart_alert_chat_stopped',
    SmartAlertProgressIndicatorExpanded: 'smart_alert_progress_indicator_expanded',
    SmartAlertScreenshotCardEditDesignClicked: 'smart_alert_screenshot_card_edit_design_clicked',
    SmartAlertExamplesOpened: 'smart_alert_examples_opened',
    SmartAlertExamplesCategoryClicked: 'smart_alert_examples_category_clicked',
    SmartAlertExampleUsed: 'smart_alert_example_used',
    SmartAlertPreviewOpened: 'smart_alert_preview_opened',
    SmartAlertPreviewImageGenerated: 'smart_alert_preview_image_generated',
    SmartAlertPreviewImageFailed: 'smart_alert_preview_image_failed',
    SmartAlertPreviewImageRetried: 'smart_alert_preview_image_retried',
    SmartAlertOrientationChanged: 'smart_alert_orientation_changed',
    SmartAlertContentBlockAdded: 'smart_alert_content_block_added',
    SmartAlertContentBlockRemoved: 'smart_alert_content_block_removed',
    SmartAlertContentBlockReordered: 'smart_alert_content_block_reordered',
    SmartAlertSubjectEdited: 'smart_alert_subject_edited',
    SmartAlertPreviewSaveAndExitClicked: 'smart_alert_preview_save_and_exit_clicked',
    SmartAlertSendTestOpened: 'smart_alert_send_test_opened',
    SmartAlertSendTestSubmitted: 'smart_alert_send_test_submitted',
    SmartAlertSendTestSucceeded: 'smart_alert_send_test_succeeded',
    SmartAlertSendTestFailed: 'smart_alert_send_test_failed',
    SmartAlertSendTestSlackConnected: 'smart_alert_send_test_slack_connected',
    SmartAlertSendTestTeamsConnected: 'smart_alert_send_test_teams_connected',
    SmartAlertPreviewActionBarClicked: 'smart_alert_preview_action_bar_clicked',
    SmartAlertActivateStarted: 'smart_alert_activate_started',
    SmartAlertActivateSucceeded: 'smart_alert_activate_succeeded',
    SmartAlertActivateFailed: 'smart_alert_activate_failed',
    SmartAlertDetailsViewed: 'smart_alert_details_viewed',
    SmartAlertEditWithAiClicked: 'smart_alert_edit_with_ai_clicked',
    SmartAlertEditPreviewClicked: 'smart_alert_edit_preview_clicked',
    SmartAlertRenamed: 'smart_alert_renamed',
    SmartAlertDeleted: 'smart_alert_deleted',
    SmartAlertRunHistoryOpened: 'smart_alert_run_history_opened',
    SmartAlertRunNowClicked: 'smart_alert_run_now_clicked',
    SmartAlertSaveChangesClicked: 'smart_alert_save_changes_clicked',
    SmartAlertScheduleEditOpened: 'smart_alert_schedule_edit_opened',
    SmartAlertScheduleTriggerChanged: 'smart_alert_schedule_trigger_changed',
    SmartAlertScheduleFrequencyChanged: 'smart_alert_schedule_frequency_changed',
    SmartAlertScheduleSaved: 'smart_alert_schedule_saved',
    SmartAlertDeliveryEditOpened: 'smart_alert_delivery_edit_opened',
    SmartAlertDeliveryDestinationAdded: 'smart_alert_delivery_destination_added',
    SmartAlertDeliveryDestinationRemoved: 'smart_alert_delivery_destination_removed',
    SmartAlertDeliverySlackConnected: 'smart_alert_delivery_slack_connected',
    SmartAlertDeliveryTeamsConnected: 'smart_alert_delivery_teams_connected',
    SmartAlertDeliverySaved: 'smart_alert_delivery_saved',
    SmartAlertViewed: 'smart_alert_viewed',
    SmartAlertListItemClicked: 'smart_alert_list_item_clicked',
    SmartAlertOpenSheetClicked: 'smart_alert_open_sheet_clicked',
    SmartAlertRunDetailOpened: 'smart_alert_run_detail_opened',
    SmartAlertRunFanoutTabSwitched: 'smart_alert_run_fanout_tab_switched',
    SmartAlertRunHistoryPageChanged: 'smart_alert_run_history_page_changed',
    SmartAlertMonitorClicked: 'smart_alert_monitor_clicked',
    SmartAlertSent: 'smart_alert_sent',
    AlertTypeSelectionViewed: 'alert_type_selection_viewed',
    WorkspaceTeamActivityViewed: 'workspace_team_activity_viewed',
    WorkspaceOpenSheetClicked: 'workspace_open_sheet_clicked',
    AdminPanelClicked: 'admin_panel_clicked',
    WorkspaceAdminImportsListViewed: 'workspace_admin_imports_list_viewed',
    WorkspaceAdminAlertsListViewed: 'workspace_admin_alerts_list_viewed',
    WorkspaceAdminUsersListViewed: 'workspace_admin_users_list_viewed',
    WorkspaceAdminDataSourcesListViewed: 'workspace_admin_data_sources_list_viewed',
    WorkspaceAdminRunHistoryViewed: 'workspace_admin_run_history_viewed',
    WorkspaceAdminWritebacksViewed: 'workspace_admin_writebacks_viewed',
    WorkspaceAdminSettingsViewed: 'workspace_admin_settings_viewed',
    WorkspaceAdminCopyCsvViewed: 'workspace_admin_copy_csv_viewed',
    WorkspaceAdminCopyCsvCopied: 'workspace_admin_copy_csv_copied',
    WorkspaceSettingsViewed: 'workspace_settings_viewed',
    WorkspaceSettingsButtonClicked: 'workspace_settings_button_clicked',
    WorkspaceSettingsWeeklyEmailUnsubscribed: 'workspace_settings_weekly_email_unsubscribed',
    WorkspaceSettingsWeeklyEmailSubscribed: 'workspace_settings_weekly_email_subscribed',
    WorkspaceOauthSettingsViewed: 'workspace_oauth_settings_viewed',
    WorkspaceSnowflakeOauthSettingsViewed: 'workspace_snowflake_oauth_settings_viewed',
    WorkspaceLookerOauthSettingsViewed: 'workspace_looker_oauth_settings_viewed',
    WorkspaceNetsuiteOauthSettingsViewed: 'workspace_netsuite_oauth_settings_viewed',
    WorkspaceDatabricksOauthSettingsViewed: 'workspace_databricks_oauth_settings_viewed',
    WorkspaceArrowFlightSqlOauthSettingsViewed: 'workspace_arrow_flight_sql_oauth_settings_viewed',
    WorkspaceTableauOauthSettingsViewed: 'workspace_tableau_oauth_settings_viewed',
    TableauWorkspaceAccountViewed: 'tableau_workspace_account_viewed',
    WorkspaceCustomOauthSettingsViewed: 'workspace_custom_oauth_settings_viewed',
    WorkspaceCustomOauthAppSaved: 'workspace_custom_oauth_app_saved',
    WorkspaceCustomOauthAppDeleted: 'workspace_custom_oauth_app_deleted',
    ConnectionNamingViewed: 'connection_naming_viewed',
    ChangeConnectionClicked: 'change_connection_clicked',
    ChangeConnectionViewed: 'change_connection_viewed',
    ChangeConnectionSourceSelected: 'change_connection_source_selected',
    ChangeConnectionStarted: 'change_connection_started',
    ChangeConnectionDone: 'change_connection_done',
    ChangeConnectionFailed: 'change_connection_failed',
    TrialStateChanged: 'trial_state_changed',
    SsOpened: 'ss_opened',
    TemplateCopyDone: 'template_copy_done',
    InstallAttributionIframeShown: 'install_attribution_iframe_shown',
    InstallAttributionIframeMessageReceived: 'install_attribution_iframe_message_received',
    InstallAttributionIframeDone: 'install_attribution_iframe_done',
    InstallV2Sent: 'install_v2_sent',
    FufdV2Sent: 'fufd_v2_sent',
    NuddV2Sent: 'nudd_v2_sent',
    AttributionDeliveryResult: 'attribution_delivery_result',
    AffiliateAttributionIframeShown: 'affiliate_attribution_iframe_shown',
    AffiliateAttributionIframeMessageReceived: 'affiliate_attribution_iframe_message_received',
    AffiliateAttributionIframeDone: 'affiliate_attribution_iframe_done',
    FeatureWaitlistViewed: 'feature_waitlist_viewed',
    FeatureWaitlistJoined: 'feature_waitlist_joined',
    UseGptClicked: 'use_gpt_clicked',
    UseGptOptionSelected: 'use_gpt_option_selected',
    GptxFunctionsViewed: 'gptx_functions_viewed',
    GptxFunctionClicked: 'gptx_function_clicked',
    GptBuilderViewed: 'gpt_builder_viewed',
    GptBuilderStarted: 'gpt_builder_started',
    GptBuilderDone: 'gpt_builder_done',
    GptBuilderFailed: 'gpt_builder_failed',
    GptBuilderContextRequested: 'gpt_builder_context_requested',
    GptBuilderFeedbackSubmitted: 'gpt_builder_feedback_submitted',
    GptBuilderFormulaCopied: 'gpt_builder_formula_copied',
    GptBuilderSqlCopied: 'gpt_builder_sql_copied',
    GptBuilderWriterStarted: 'gpt_builder_writer_started',
    GptBuilderWriterDone: 'gpt_builder_writer_done',
    GptBuilderWriterFailed: 'gpt_builder_writer_failed',
    GptBuilderJumpToClicked: 'gpt_builder_jump_to_clicked',
    GptBuilderOnboardingStarted: 'gpt_builder_onboarding_started',
    GptBuilderOnboardingDone: 'gpt_builder_onboarding_done',
    InviteCoworkersClicked: 'invite_coworkers_clicked',
    InviteCoworkersTextCopied: 'invite_coworkers_text_copied',
    InviteCoworkersLinkCopied: 'invite_coworkers_link_copied',
    InviteCoworkersEmailsSent: 'invite_coworkers_emails_sent',
    InviteCoworkersViewed: 'invite_coworkers_viewed',
    UpgradeToProClicked: 'upgrade_to_pro_clicked',
    UpgradeButtonClicked: 'upgrade_button_clicked',
    UpgradePlanCtaClicked: 'upgrade_plan_cta_clicked',
    UpgradePlanModalShown: 'upgrade_plan_modal_shown',
    EventAttributionIframeShown: 'event_attribution_iframe_shown',
    VirtualImportsViewDataClicked: 'virtual_imports_view_data_clicked',
    VirtualImportsToggleVirtualConfirm: 'virtual_imports_toggle_virtual_confirm',
    VirtualImportsToggleVirtualCancel: 'virtual_imports_toggle_virtual_cancel',
    WorkspaceVirtualImportViewed: 'workspace_virtual_import_viewed',
    NewDatasetClicked: 'new_dataset_clicked',
    DatasetCreateStart: 'dataset_create_start',
    DatasetCreateDone: 'dataset_create_done',
    DatasetCreateFailed: 'dataset_create_failed',
    DatasetListViewedWeb: 'dataset_list_viewed_web',
    DatasetDataViewedWeb: 'dataset_data_viewed_web',
    DatasetOpenSheetClicked: 'dataset_open_sheet_clicked',
    DatasetRefreshClickedWeb: 'dataset_refresh_clicked_web',
    DatasetEdited: 'dataset_edited',
    DatasetListViewedSidebar: 'dataset_list_viewed_sidebar',
    WorkspaceSettingsDatasetsEnabled: 'workspace_settings_datasets_enabled',
    WorkspaceSettingsDatasetsDisabled: 'workspace_settings_datasets_disabled',
    WorkspaceSettingsGptFeaturesEnabled: 'workspace_settings_gpt_features_enabled',
    WorkspaceSettingsGptFeaturesDisabled: 'workspace_settings_gpt_features_disabled',
    WorkspaceSettingsSsoEnabled: 'workspace_settings_sso_enabled',
    WorkspaceSettingsSsoDisabled: 'workspace_settings_sso_disabled',
    WorkspaceSettingsConnectionSharingEnabled: 'workspace_settings_connection_sharing_enabled',
    WorkspaceSettingsConnectionSharingDisabled: 'workspace_settings_connection_sharing_disabled',
    WorkspaceSettingsWritebacksEnabled: 'workspace_settings_writebacks_enabled',
    WorkspaceSettingsWritebacksDisabled: 'workspace_settings_writebacks_disabled',
    WorkspaceSettingsSlackOrEmailAlertsEnabled: 'workspace_settings_slack_or_email_alerts_enabled',
    WorkspaceSettingsSlackOrEmailAlertsDisabled: 'workspace_settings_slack_or_email_alerts_disabled',
    WorkspaceAllowedDataSourceSettings: 'workspace_allowed_data_source_settings',
    EmailImportRefreshBlocked: 'email_import_refresh_blocked',
    ImportManualRefreshBlocked: 'import_manual_refresh_blocked',
    ImportBlockedUnlicensedUser: 'import_blocked_unlicensed_user',
    ImportRunLimitExtensionGranted: 'import_run_limit_extension_granted',
    AiLimitNoticeShown: 'ai_limit_notice_shown',
    AiLimitUpgradeClicked: 'ai_limit_upgrade_clicked',
    AiLimitContactSalesClicked: 'ai_limit_contact_sales_clicked',
    EmailFirstScheduledImportRefreshDone: 'email_first_scheduled_import_refresh_done',
    ExcelWorkbookRedirection: 'excel_workbook_redirection',
    ExcelDataImportRedirection: 'excel_data_import_redirection',
    ExcelWritebackRedirection: 'excel_writeback_redirection',
    WebScraperAuthPageOpened: 'web_scraper_auth_page_opened',
    WebScraperAuthPageClosed: 'web_scraper_auth_page_closed',
    WebScraperOnetimeLoginLinkModalShown: 'web_scraper_onetime_login_link_modal_shown',
    WebScraperOnetimeLoginLinkSubmitted: 'web_scraper_onetime_login_link_submitted',
    CopySourceErrorClicked: 'copy_source_error_clicked',
    ImportRunRefreshLimitModalOpen: 'import_run_refresh_limit_modal_open',
    SnapshotCreated: 'snapshot_created',
    SnapshotDeleted: 'snapshot_deleted',
    SnapshotEdited: 'snapshot_edited',
    SnapshotRunSuccess: 'snapshot_run_success',
    SnapshotRunFailed: 'snapshot_run_failed',
    SnapshotOnboardingStarted: 'snapshot_onboarding_started',
    SnapshotPaused: 'snapshot_paused',
    AgentThreadStarted: 'agent_thread_started',
    AgentActionCompleted: 'agent_action_completed',
    AgentActionFailed: 'agent_action_failed',
    AgentThreadAbandoned: 'agent_thread_abandoned',
    WebDashUserMemorySaveConfirmed: 'web_dash_user_memory_save_confirmed',
    WebDashUserMemorySaveRejected: 'web_dash_user_memory_save_rejected',
    WebDashUserMemorySaveExpired: 'web_dash_user_memory_save_expired',
    WebDashUserMemoryManualEdit: 'web_dash_user_memory_manual_edit',
    WebDashUserMemoryDrawerOpened: 'web_dash_user_memory_drawer_opened',
    SaSpreadsheetMemorySaveConfirmed: 'sa_spreadsheet_memory_save_confirmed',
    SaSpreadsheetMemorySaveRejected: 'sa_spreadsheet_memory_save_rejected',
    SaSpreadsheetMemorySaveExpired: 'sa_spreadsheet_memory_save_expired',
    SaSpreadsheetMemorySaveStale: 'sa_spreadsheet_memory_save_stale',
    AskcoeffBotQuestionAsked: 'askcoeff_bot_question_asked',
    AskcoeffBotAnswerCreated: 'askcoeff_bot_answer_created',
    AskcoeffBotAnswerFailed: 'askcoeff_bot_answer_failed',
    AskcoeffBotUpdated: 'askcoeff_bot_updated',
    AskcoeffBotUpdateFailed: 'askcoeff_bot_update_failed',
    AppendImportTurnedOn: 'append_import_turned_on',
    AppendImportTurnedOff: 'append_import_turned_off',
    AppendImportColumnChange: 'append_import_column_change',
    ImportPreviewOpenInitiated: 'import_preview_open_initiated',
    ImportPreviewOpened: 'import_preview_opened',
    ImportPreviewClosed: 'import_preview_closed',
    ImportPreviewRunStarted: 'import_preview_run_started',
    ImportPreviewRunDone: 'import_preview_run_done',
    ImportPreviewRunFailed: 'import_preview_run_failed',
    WritebackFieldMappingModalOpen: 'writeback_field_mapping_modal_open',
    WritebackFieldMappingModalClosed: 'writeback_field_mapping_modal_closed',
    WritebackFieldMappingModalFieldMapped: 'writeback_field_mapping_modal_field_mapped',
    WritebackFieldMappingModalButtonClearMapping: 'writeback_field_mapping_modal_button_clear_mapping',
    WritebackFieldMappingModalButtonAutoMap: 'writeback_field_mapping_modal_button_auto_map',
    WritebackFieldMappingModalButtonSave: 'writeback_field_mapping_modal_button_save',
    WritebackFieldMappingValidationError: 'writeback_field_mapping_validation_error',
    LookerSetupShared: 'looker_setup_shared',
    LookerSetupViewed: 'looker_setup_viewed',
    LookerSetupCompleted: 'looker_setup_completed',
    LookerOauthAddedFromEditMode: 'looker_oauth_added_from_edit_mode',
    LookerSetupFailed: 'looker_setup_failed',
    LookerWorkspaceViewed: 'looker_workspace_viewed',
    LookerWorkspaceNewAccountViewed: 'looker_workspace_new_account_viewed',
    LookerWorkspaceNewAccountCompleted: 'looker_workspace_new_account_completed',
    LookerWorkspaceNewAccountFailed: 'looker_workspace_new_account_failed',
    LookerWorkspaceAccountViewed: 'looker_workspace_account_viewed',
    LookerWorkspaceAccountDeleted: 'looker_workspace_account_deleted',
    LookerQuickImport: 'looker_quick_import',
    LookerPreview: 'looker_preview',
    AutoAnalystStarted: 'auto_analyst_started',
    AutoAnalystDone: 'auto_analyst_done',
    AutoAnalystFailed: 'auto_analyst_failed',
    AutoAnalystFeeback: 'auto_analyst_feeback',
    SheetsAssistantClicked: 'sheets_assistant_clicked',
    SheetsAssistantChatViewed: 'sheets_assistant_chat_viewed',
    SheetsAssistantChatMessageSubmitted: 'sheets_assistant_chat_message_submitted',
    SheetsAssistantChatStopped: 'sheets_assistant_chat_stopped',
    SheetsAssistantQuickstartSelected: 'sheets_assistant_quickstart_selected',
    SheetsAssistantThreadFailed: 'sheets_assistant_thread_failed',
    SheetsAssistantContextPopoverOpened: 'sheets_assistant_context_popover_opened',
    GmailFilterQueryExecuted: 'gmail_filter_query_executed',
    GmailSampleEmailPicked: 'gmail_sample_email_picked',
    GmailAttachmentSelected: 'gmail_attachment_selected',
    GmailChatWindowLoaded: 'gmail_chat_window_loaded',
    GmailChatUserPromptEntered: 'gmail_chat_user_prompt_entered',
    GmailChatGptResponded: 'gmail_chat_gpt_responded',
    GmailChatImportClicked: 'gmail_chat_import_clicked',
    GmailImportModeSelected: 'gmail_import_mode_selected',
    ConnectionFailureEmailNotificationSent: 'connection_failure_email_notification_sent',
    ConnectionFailureEmailNotificationClicked: 'connection_failure_email_notification_clicked',
    ReconnectDoneAfterEmailNotification: 'reconnect_done_after_email_notification',
    EnrichButtonViewed: 'enrich_button_viewed',
    EnrichClicked: 'enrich_clicked',
    EnrichOptionsViewedSidebar: 'enrich_options_viewed_sidebar',
    EnrichOptionSelected: 'enrich_option_selected',
    EnrichEarlyAccessFormSubmitted: 'enrich_early_access_form_submitted',
    ImportPreviewClicked: 'import_preview_clicked',
    ImportPreviewStarted: 'import_preview_started',
    ImportPreviewDone: 'import_preview_done',
    ImportPreviewFailed: 'import_preview_failed',
    FormulaExecutionStarted: 'formula_execution_started',
    FormulaExecutionSuccessful: 'formula_execution_successful',
    FormulaExecutionFailed: 'formula_execution_failed',
    FormulaExecutionBatched: 'formula_execution_batched',
    FormulaDiscoveryPageViewed: 'formula_discovery_page_viewed',
    FormulaDiscoveryFormulaExpanded: 'formula_discovery_formula_expanded',
    FormulaHelpGuideClicked: 'formula_help_guide_clicked',
    FormulaDetailsOpened: 'formula_details_opened',
    FormulaRefreshOptionsViewed: 'formula_refresh_options_viewed',
    FormulaRefreshActionInitiated: 'formula_refresh_action_initiated',
    FormulaRefreshActionCompleted: 'formula_refresh_action_completed',
    FormulaRefreshActionFailed: 'formula_refresh_action_failed',
    FormulaPasteAsValuesInitiated: 'formula_paste_as_values_initiated',
    FormulaPasteAsValuesCompleted: 'formula_paste_as_values_completed',
    FormulaPasteAsValuesFailed: 'formula_paste_as_values_failed',
    FormulaChangeSourceClicked: 'formula_change_source_clicked',
    FormulaImportUsed: 'formula_import_used',
    FormulaImportAdded: 'formula_import_added',
    WebhookTokenAccessed: 'webhook_token_accessed',
    WebhookTokenCopied: 'webhook_token_copied',
    WebhookTokenRegenerated: 'webhook_token_regenerated',
    WebhookRequestReceived: 'webhook_request_received',
    WebhookRequestFailed: 'webhook_request_failed',
    UpgradeToProPopup: 'upgrade_to_pro_popup',
    SfConnectedAppSetupViewed: 'sf_connected_app_setup_viewed',
    SfConnectedAppSetupNextClicked: 'sf_connected_app_setup_next_clicked',
    SfAdminHelpInstructionsCopied: 'sf_admin_help_instructions_copied',
    SfAdminHelpContinueClicked: 'sf_admin_help_continue_clicked',
    SfAdminPostConnectionSetupClicked: 'sf_admin_post_connection_setup_clicked',
    SfConnectionInstructionsClicked: 'sf_connection_instructions_clicked',
    SfAdminSetupWarningAcknowledged: 'sf_admin_setup_warning_acknowledged',
    NetsuiteCrxImportError: 'netsuite_crx_import_error',
    NetsuiteCrxFiltersError: 'netsuite_crx_filters_error',
    NetsuiteCrxUrlAdded: 'netsuite_crx_url_added',
    VibeDashCreated: 'vibe_dash_created',
    VibeDashViewed: 'vibe_dash_viewed',
    VibeDashEditChatViewed: 'vibe_dash_edit_chat_viewed',
    VibeDashEdited: 'vibe_dash_edited',
    VibeDashUndoClicked: 'vibe_dash_undo_clicked',
    VibeDashExplainClicked: 'vibe_dash_explain_clicked',
    VibeDashBlockDeleted: 'vibe_dash_block_deleted',
    VibeDashBlockRenderingFailed: 'vibe_dash_block_rendering_failed',
    VibeDashThemeChanged: 'vibe_dash_theme_changed',
    VibeDashThemeRequested: 'vibe_dash_theme_requested',
    VibeDashShareClicked: 'vibe_dash_share_clicked',
    VibeDashSlicerChanged: 'vibe_dash_slicer_changed',
    VibeDashSlicerReset: 'vibe_dash_slicer_reset',
    VibeDashFilterDefaultsSaved: 'vibe_dash_filter_defaults_saved',
    VibeDashRefreshClicked: 'vibe_dash_refresh_clicked',
    VibeDashRefreshStarted: 'vibe_dash_refresh_started',
    VibeDashRefreshCompleted: 'vibe_dash_refresh_completed',
    VibeDashRefreshFailed: 'vibe_dash_refresh_failed',
    VibeDashOpenSheetClicked: 'vibe_dash_open_sheet_clicked',
    VibeDashSlackConnectClicked: 'vibe_dash_slack_connect_clicked',
    VibeDashSlackConnected: 'vibe_dash_slack_connected',
    VibeDashBlockEditInChatClicked: 'vibe_dash_block_edit_in_chat_clicked',
    VibeDashLoaded: 'vibe_dash_loaded',
    VibeDashAddBlockMenuOpened: 'vibe_dash_add_block_menu_opened',
    VibeDashBlockAdded: 'vibe_dash_block_added',
    VibeDashBlockEditOpened: 'vibe_dash_block_edit_opened',
    VibeDashBlockEdited: 'vibe_dash_block_edited',
    VibeDashListViewed: 'vibe_dash_list_viewed',
    VibeDashListDashboardOpened: 'vibe_dash_list_dashboard_opened',
    VibeDashListDashboardDeleted: 'vibe_dash_list_dashboard_deleted',
    VibeDashListDashboardRenamed: 'vibe_dash_list_dashboard_renamed',
    VibeDashListShareClicked: 'vibe_dash_list_share_clicked',
    VibeDashListSourceSheetClicked: 'vibe_dash_list_source_sheet_clicked',
    VibeDashSupportFeedbackSubmitted: 'vibe_dash_support_feedback_submitted',
    VibeDashUpgradeModalViewed: 'vibe_dash_upgrade_modal_viewed',
    VibeDashUpgradeModalViewPlansClicked: 'vibe_dash_upgrade_modal_view_plans_clicked',
    VibeDashUpgradeModalContactSalesClicked: 'vibe_dash_upgrade_modal_contact_sales_clicked',
    AiDashboardsRoutedToSales: 'ai_dashboards_routed_to_sales'
};
exports.AnalyticsEventPlatformType = {
    GsheetsAddon: 'gsheets_addon',
    Webapp: 'webapp',
    ExcelAddon: 'excel_addon'
};
exports.AnalyticsUserType = {
    NoScheduledImports: 'user_with_no_scheduled_imports',
    ScheduledImports: 'user_with_scheduled_imports'
};
exports.AssistantFeedbackSentiment = {
    Like: 'like',
    Dislike: 'dislike',
    Skip: 'skip'
};
exports.AutoAnalysesRunStatus = {
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed'
};
exports.BillingGatedActionType = {
    Create: 'import_create',
    ManualRefresh: 'import_manual_refresh',
    ScheduledRefresh: 'import_scheduled_refresh'
};
exports.ButtonClickActionType = {
    OpenBillingOptions: 'open_billing_options',
    AuthRequired: 'auth_required',
    ChangeSource: 'change_source'
};
exports.CSVSourceType = {
    GoogleDrive: 'google_drive',
    OneDrive: 'one_drive',
    Box: 'box',
    Upload: 'upload',
    Url: 'url',
    Egnyte: 'egnyte'
};
exports.CampfireFetchMode = {
    Object: 'object',
    Report: 'report',
    CustomReport: 'custom_report'
};
exports.CellFormat = {
    Unknown: 'unknown',
    Empty: 'empty',
    String: 'string',
    Integer: 'integer',
    Double: 'double',
    Boolean: 'boolean',
    Error: 'error',
    Richvalue: 'richvalue'
};
exports.CloudTableImportRunStages = {
    CreatedOrUpdated: 'created_or_updated',
    InProgress: 'in_progress',
    Done: 'done',
    Failed: 'failed'
};
exports.CreditActionType = {
    Trial: 'credit_trial',
    Purchase: 'credit_purchase',
    ManualAddition: 'credit_manual_addition',
    AdditionMonthlyProPlan: 'credit_addition_monthly_pro_plan',
    Deduction: 'credit_deduction',
    DeductionForEnrichment: 'credit_deduction_for_enrichment',
    DeductionForLeadgen: 'credit_deduction_for_leadgen',
    DeductionForAgentTask: 'credit_deduction_for_agent_task',
    Hold: 'credit_hold',
    Release: 'credit_release'
};
exports.CreditCardType = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    AmericanExpress: 'american_express',
    Discover: 'discover',
    Jcb: 'jcb',
    DinersClub: 'diners_club',
    Bancontact: 'bancontact',
    Other: 'other'
};
exports.CreditTransactionType = {
    Addition: 'addition',
    Deduction: 'deduction',
    Hold: 'hold'
};
exports.CustomAPIAuthType = {
    None: 'none',
    BearerToken: 'bearer_token',
    UsernamePassword: 'username_password',
    Oauth: 'oauth',
    ApiKey: 'api_key'
};
exports.CustomAPIHttpMethodType = {
    Get: 'GET',
    Post: 'POST'
};
exports.CustomAPIOffsetType = {
    PageNumber: 'page_number',
    CurrOffset: 'curr_offset',
    NextOffset: 'next_offset'
};
exports.CustomAPIPaginationType = {
    None: 'none',
    CursorBased: 'cursor_based',
    OffsetBased: 'offset_based',
    ClientBased: 'client_based',
    PageNumber: 'page_number'
};
exports.CustomApiPreviousImportOption = {
    IncludeCustomApiPreviousImport: 'include_custom_api_previous_import',
    OnlyCustomApiPreviousImport: 'only_custom_api_previous_import'
};
exports.CustomOAuthAppVisibility = {
    AllUsers: 'all_users',
    AdminsOnly: 'admins_only'
};
exports.DataImportCreationSource = {
    FreshImport: 'fresh_import',
    ImportTemplate: 'import_template',
    CustomApiPreviousImport: 'custom_api_previous_import',
    SharedTemplate: 'shared_template',
    CoefficientTemplate: 'coefficient_template'
};
exports.DataImportDuplicabilityType = {
    UseBaseDataSource: 'use_base_data_source',
    CurrentUserDataSourceOnly: 'current_user_data_source_only',
    DisabledDueToNonSharedDataSource: 'disabled_due_to_non_shared_data_source'
};
exports.DataImportEditAccessType = {
    ImportOwner: 'import_owner',
    SameDomain: 'same_domain',
    Anyone: 'anyone'
};
exports.DataImportErrorType = {
    ImportPreempted: 'import_preempted',
    ImportKilledUnexpectedly: 'import_killed_unexpectedly',
    ImportRefreshLimitReached: 'import_refresh_limit_reached',
    ExcelSheetStateNotAvailable: 'excel_sheet_state_not_available',
    ExcelFileSizeLimitReached: 'excel_file_size_limit_reached',
    ExcelFileSizeLimitWillBeReached: 'excel_file_size_limit_will_be_reached',
    CellRefRangeNotFound: 'cell_ref_range_not_found',
    CouldNotFetchCsvUrl: 'could_not_fetch_csv_url',
    CollectionNotFound: 'collection_not_found',
    CsvUrlAuthError: 'csv_url_auth_error',
    CsvUrlNotFound: 'csv_url_not_found',
    CsvUrlTimeout: 'csv_url_timeout',
    CsvFieldLimitExceeded: 'csv_field_limit_exceeded',
    DataSourceNeedsReauth: 'data_source_needs_reauth',
    GoogleDriveFileNotFound: 'google_drive_file_not_found',
    GoogleSheetsCellLimitExceeded: 'google_sheets_cell_limit_exceeded',
    GoogleSheetsCellContentExceeded: 'google_sheets_cell_content_exceeded',
    TargetGoogleSheetsFileNotFound: 'target_google_sheets_file_not_found',
    GoogleSheetsReadTimedOut: 'google_sheets_read_timed_out',
    GoogleSheetsNotResponding: 'google_sheets_not_responding',
    GoogleSheetsServiceUnavailable: 'google_sheets_service_unavailable',
    GoogleSheetsWriteBatchFail: 'google_sheets_write_batch_fail',
    GoogleSheetsInternalServerError: 'google_sheets_internal_server_error',
    GoogleSheetsQuotaExceeded: 'google_sheets_quota_exceeded',
    TargetSheetProtected: 'target_sheet_protected',
    TargetGoogleSheetsTabDeleted: 'target_google_sheets_tab_deleted',
    SourceGoogleSheetsTabDeleted: 'source_google_sheets_tab_deleted',
    TargetExcelWorkbookNotFound: 'target_excel_workbook_not_found',
    ExcelCantCreateWorkbookSession: 'excel_cant_create_workbook_session',
    ExcelWorkbookNotSupported: 'excel_workbook_not_supported',
    TargetExcelWorksheetNotFound: 'target_excel_worksheet_not_found',
    TargetSheetInsufficientPermission: 'target_sheet_insufficient_permission',
    ArrayFormulaInDataTable: 'array_formula_in_data_table',
    InvalidCsvContentType: 'invalid_csv_content_type',
    InvalidCsvUrl: 'invalid_csv_url',
    NamedRangeParameterNotFound: 'named_range_parameter_not_found',
    NamedRangeParameterCellEmpty: 'named_range_parameter_cell_empty',
    NamedRangeParameterCellInvalid: 'named_range_parameter_cell_invalid',
    ParametrizedFilterCellEmpty: 'parametrized_filter_cell_empty',
    ExcelParameterReadError: 'excel_parameter_read_error',
    PivotTooManyColumns: 'pivot_too_many_columns',
    PivotDatasetTooLarge: 'pivot_dataset_too_large',
    PivotUnsupportedOptions: 'pivot_unsupported_options',
    SkipRowsOutOfRange: 'skip_rows_out_of_range',
    GoogleSheetsSourceTabNotFound: 'google_sheets_source_tab_not_found',
    GoogleSheetsInsufficientPermission: 'google_sheets_insufficient_permission',
    SourceDataIsEmpty: 'source_data_is_empty',
    SqlExecutionError: 'sql_execution_error',
    SqlSyntaxError: 'sql_syntax_error',
    SqlFixableError: 'sql_fixable_error',
    SqlTableNotFound: 'sql_table_not_found',
    SqlColumnNotFound: 'sql_column_not_found',
    SqlInsufficientPrivilege: 'sql_insufficient_privilege',
    SqlInvalidCredentials: 'sql_invalid_credentials',
    SqlSshInvalidCredentials: 'sql_ssh_invalid_credentials',
    SqlConnectionTimeout: 'sql_connection_timeout',
    SqlOperationalError: 'sql_operational_error',
    MssqlCheckHostPort: 'mssql_check_host_port',
    MssqlSslError: 'mssql_ssl_error',
    MysqlHostNotWhitelisted: 'mysql_host_not_whitelisted',
    SnowflakeIpNotAllowed: 'snowflake_ip_not_allowed',
    SnowflakeNoDefaultWarehouse: 'snowflake_no_default_warehouse',
    SnowflakeIncorrectWarehouse: 'snowflake_incorrect_warehouse',
    SnowflakeNoWarehousesFound: 'snowflake_no_warehouses_found',
    SnowflakeFreeTrialExpired: 'snowflake_free_trial_expired',
    SnowflakeInvalidAccountName: 'snowflake_invalid_account_name',
    SnowflakeUserDisabled: 'snowflake_user_disabled',
    SnowflakeUserTemporarilyLocked: 'snowflake_user_temporarily_locked',
    SnowflakeInvalidObject: 'snowflake_invalid_object',
    SnowflakeConnectionError: 'snowflake_connection_error',
    SnowflakeUnknownError: 'snowflake_unknown_error',
    LookerUnknownUrlType: 'looker_unknown_url_type',
    LookerCannotRunQuery: 'looker_cannot_run_query',
    LookerNotFound: 'looker_not_found',
    LookerModelOrExploreNotFound: 'looker_model_or_explore_not_found',
    LookerQueryTimeout: 'looker_query_timeout',
    LookerInsufficientPermissions: 'looker_insufficient_permissions',
    LookerInvalidCredentials: 'looker_invalid_credentials',
    LookerUserAccountTemporarilyLocked: 'looker_user_account_temporarily_locked',
    LookerMissingValuesNotFilled: 'looker_missing_values_not_filled',
    LookerUnableCreateClientApp: 'looker_unable_create_client_app',
    LookerAuthExpired: 'looker_auth_expired',
    NetflixQuiverViewNotFound: 'netflix_quiver_view_not_found',
    NetflixQuiverCannotRunQuery: 'netflix_quiver_cannot_run_query',
    NetflixQuiverInvalidCredentials: 'netflix_quiver_invalid_credentials',
    NetflixQuiverNestedFiltersNotSupported: 'netflix_quiver_nested_filters_not_supported',
    NetflixQuiverUnknownError: 'netflix_quiver_unknown_error',
    NetflixQuiverOauthConfigurationRemoved: 'netflix_quiver_oauth_configuration_removed',
    NetflixQuiverMissingPivotFields: 'netflix_quiver_missing_pivot_fields',
    NetflixQuiverInvalidValuesFields: 'netflix_quiver_invalid_values_fields',
    NetflixQuiverAuthServerError: 'netflix_quiver_auth_server_error',
    SalesforceInvalidTypeForOperation: 'salesforce_invalid_type_for_operation',
    SalesforceRequestLimitExceeded: 'salesforce_request_limit_exceeded',
    SalesforceRunReportRateLimit: 'salesforce_run_report_rate_limit',
    SalesforceMalformedQuery: 'salesforce_malformed_query',
    SalesforceInvalidField: 'salesforce_invalid_field',
    SalesforceMissingReportOrObject: 'salesforce_missing_report_or_object',
    SalesforceInvalidReport: 'salesforce_invalid_report',
    SalesforceUnknownError: 'salesforce_unknown_error',
    SalesforceQueryFailed: 'salesforce_query_failed',
    SalesforceServerError: 'salesforce_server_error',
    SalesforceMissingExportReportsPermission: 'salesforce_missing_export_reports_permission',
    SalesforceMissingRunReportsPermission: 'salesforce_missing_run_reports_permission',
    SalesforceApiDisabled: 'salesforce_api_disabled',
    SalesforceReportNotCsv: 'salesforce_report_not_csv',
    SalesforceQueryTimeout: 'salesforce_query_timeout',
    SalesforceServiceUnavailable: 'salesforce_service_unavailable',
    SalesforceBadRequest: 'salesforce_bad_request',
    SalesforceTooManyRequests: 'salesforce_too_many_requests',
    SalesforceUnauthorizedError: 'salesforce_unauthorized_error',
    SalesforceUriLengthExceeded: 'salesforce_uri_length_exceeded',
    SalesforceRequestSizeExceeded: 'salesforce_request_size_exceeded',
    SalesforceExportReportError: 'salesforce_export_report_error',
    SalesforceReportTypeNotSupported: 'salesforce_report_type_not_supported',
    SalesforceHighAssuranceSessionRequired: 'salesforce_high_assurance_session_required',
    SalesforceAsyncFetchDataError: 'salesforce_async_fetch_data_error',
    SalesforceAsyncReportTimeoutError: 'salesforce_async_report_timeout_error',
    GanalyticsDimsMetricsCannotGoTogether: 'ganalytics_dims_metrics_cannot_go_together',
    GanalyticsServiceUnavailable: 'ganalytics_service_unavailable',
    GanalyticsBadRequest: 'ganalytics_bad_request',
    GanalyticsInsufficientPermissions: 'ganalytics_insufficient_permissions',
    Ga4UnknownError: 'ga4_unknown_error',
    Ga4PermissionError: 'ga4_permission_error',
    Ga4ServiceUnavailable: 'ga4_service_unavailable',
    FbAdsUnknownError: 'fb_ads_unknown_error',
    FbAdsAsyncJobSkipped: 'fb_ads_async_job_skipped',
    FbAdsApiRateLimitExceeded: 'fb_ads_api_rate_limit_exceeded',
    FbAdsApiBadRequest: 'fb_ads_api_bad_request',
    FbAdsInsufficientPermissionsGrantedByUser: 'fb_ads_insufficient_permissions_granted_by_user',
    FbAdsAccountMissingAccessForAdsAccount: 'fb_ads_account_missing_access_for_ads_account',
    FbAdsCustomMetricEvaluationError: 'fb_ads_custom_metric_evaluation_error',
    FbInsightsUnknownError: 'fb_insights_unknown_error',
    FbInsightsApiRateLimitExceeded: 'fb_insights_api_rate_limit_exceeded',
    FbInsightsApiBadRequest: 'fb_insights_api_bad_request',
    FbInsightsNoMetricsSelected: 'fb_insights_no_metrics_selected',
    FbInsightsInsufficientPermissionsGrantedByUser: 'fb_insights_insufficient_permissions_granted_by_user',
    FbInsightsUnsupportedQueryError: 'fb_insights_unsupported_query_error',
    CalendlyApiRateLimitExceeded: 'calendly_api_rate_limit_exceeded',
    Ga4DimensionsLimitExceededError: 'ga4_dimensions_limit_exceeded_error',
    Ga4MetricsLimitExceededError: 'ga4_metrics_limit_exceeded_error',
    Ga4DimensionsAndMetricsIncompatibleError: 'ga4_dimensions_and_metrics_incompatible_error',
    Ga4BadRequestError: 'ga4_bad_request_error',
    Ga4ApiRateLimitExceeded: 'ga4_api_rate_limit_exceeded',
    GdriveServiceUnavailable: 'gdrive_service_unavailable',
    GdriveBadRequest: 'gdrive_bad_request',
    HubspotUnknownError: 'hubspot_unknown_error',
    HubspotServiceUnavailable: 'hubspot_service_unavailable',
    HubspotInternalError: 'hubspot_internal_error',
    HubspotApiRateLimitExceeded: 'hubspot_api_rate_limit_exceeded',
    HubspotTooManyFilters: 'hubspot_too_many_filters',
    HubspotTooManyFilterGroups: 'hubspot_too_many_filter_groups',
    HubspotFiltersMaxNestingLevelsExceeded: 'hubspot_filters_max_nesting_levels_exceeded',
    SalesforceFiltersMaxNestingLevelsExceeded: 'salesforce_filters_max_nesting_levels_exceeded',
    HubspotTooManySorts: 'hubspot_too_many_sorts',
    HubspotInsufficientPermissions: 'hubspot_insufficient_permissions',
    HubspotInsufficientPermissionsV2: 'hubspot_insufficient_permissions_v2',
    HubspotFilterTooManyMatches: 'hubspot_filter_too_many_matches',
    HubspotInvalidFilters: 'hubspot_invalid_filters',
    HubspotTooManyDatePointsRequested: 'hubspot_too_many_date_points_requested',
    HubspotNotFound: 'hubspot_not_found',
    HubspotBadRequest: 'hubspot_bad_request',
    HubspotObjectNotActivated: 'hubspot_object_not_activated',
    TableauInvalidEndpoint: 'tableau_invalid_endpoint',
    TableauWorksheetNotFound: 'tableau_worksheet_not_found',
    TableauRepatedMeasureName: 'tableau_repated_measure_name',
    TableauRepatedMeasureValues: 'tableau_repated_measure_values',
    TableauUnknownError: 'tableau_unknown_error',
    TableauServiceUnavailable: 'tableau_service_unavailable',
    TableauInsufficientPermissions: 'tableau_insufficient_permissions',
    TableauAuthExpired: 'tableau_auth_expired',
    TableauCustomViewNotSupported: 'tableau_custom_view_not_supported',
    OperationTimeoutError: 'operation_timeout_error',
    CeleryTimeoutError: 'celery_timeout_error',
    CeleryQueueTimeoutError: 'celery_queue_timeout_error',
    FreeTrialExpired: 'free_trial_expired',
    ImportRunBlockedDueToPremiumConnector: 'import_run_blocked_due_to_premium_connector',
    ImportRunBlockedDueToDataSourceConnectionLimit: 'import_run_blocked_due_to_data_source_connection_limit',
    ImportBlockedUnlicensedUser: 'import_blocked_unlicensed_user',
    JiraUnavailableFilterError: 'jira_unavailable_filter_error',
    JiraServiceUnavailableError: 'jira_service_unavailable_error',
    JiraUnknownError: 'jira_unknown_error',
    JiraRateLimitExceeded: 'jira_rate_limit_exceeded',
    JiraForbiddenError: 'jira_forbidden_error',
    InstagramUnknownError: 'instagram_unknown_error',
    InstagramInsufficientPermission: 'instagram_insufficient_permission',
    ZendeskUnknownError: 'zendesk_unknown_error',
    ZendeskRateLimitExceeded: 'zendesk_rate_limit_exceeded',
    ZendeskServiceUnavailable: 'zendesk_service_unavailable',
    ZendeskInsufficientPermission: 'zendesk_insufficient_permission',
    ZendeskHelpdeskNoLongerAvailable: 'zendesk_helpdesk_no_longer_available',
    QuickbooksUnknownError: 'quickbooks_unknown_error',
    QuickbooksAuthenticationError: 'quickbooks_authentication_error',
    QuickbooksInvalidCustomRangeError: 'quickbooks_invalid_custom_range_error',
    QuickbooksRateLimitExceeded: 'quickbooks_rate_limit_exceeded',
    PaymoRateLimitExceeded: 'paymo_rate_limit_exceeded',
    QuickbooksValidationError: 'quickbooks_validation_error',
    QuickbooksProjectsNotAvailable: 'quickbooks_projects_not_available',
    ShopifyUnknownError: 'shopify_unknown_error',
    ShopifyAccessDenied: 'shopify_access_denied',
    ShopifyAnotherQueryInProgress: 'shopify_another_query_in_progress',
    ShopifyQueryTimeout: 'shopify_query_timeout',
    ShopifyRateLimitExceeded: 'shopify_rate_limit_exceeded',
    ShopifyMaybeStoreLocked: 'shopify_maybe_store_locked',
    ShopifyTemporaryError: 'shopify_temporary_error',
    ShopifyQueryNotSupported: 'shopify_query_not_supported',
    ShopifyResourceNotFound: 'shopify_resource_not_found',
    ShopifyObjectNotSupported: 'shopify_object_not_supported',
    BigqueryUnknownError: 'bigquery_unknown_error',
    BigqueryInvalidGrantError: 'bigquery_invalid_grant_error',
    BigqueryPermissionError: 'bigquery_permission_error',
    StripeUnknownError: 'stripe_unknown_error',
    ImportNotSharedError: 'import_not_shared_error',
    DataSourceNotSharedError: 'data_source_not_shared_error',
    UncaughtException: 'uncaught_exception',
    GoogleSheetsApiTemporaryError: 'google_sheets_api_temporary_error',
    AirtableUnknownError: 'airtable_unknown_error',
    AirtableInsufficientPermissions: 'airtable_insufficient_permissions',
    AirtableNotFound: 'airtable_not_found',
    AirtableServiceUnavailable: 'airtable_service_unavailable',
    AirtableRateLimitExceeded: 'airtable_rate_limit_exceeded',
    DataSourceTypeKillSwitchEnabled: 'data_source_type_kill_switch_enabled',
    InvalidExcelContentType: 'invalid_excel_content_type',
    InvalidExcelUrl: 'invalid_excel_url',
    ExcelUrlAuthError: 'excel_url_auth_error',
    ExcelUrlNotFound: 'excel_url_not_found',
    ExcelUrlTimeout: 'excel_url_timeout',
    ExcelExecutingInstructionsError: 'excel_executing_instructions_error',
    CouldNotFetchExcelUrl: 'could_not_fetch_excel_url',
    MailchimpUnknownError: 'mailchimp_unknown_error',
    MailchimpDataNotFound: 'mailchimp_data_not_found',
    MailchimpTooManyRequests: 'mailchimp_too_many_requests',
    MailchimpServiceUnavailable: 'mailchimp_service_unavailable',
    PipedriveUnknownError: 'pipedrive_unknown_error',
    PipedrivePaymentRequired: 'pipedrive_payment_required',
    PipedriveRateLimitExceeded: 'pipedrive_rate_limit_exceeded',
    PipedriveServiceUnavailable: 'pipedrive_service_unavailable',
    PipedriveInternalError: 'pipedrive_internal_error',
    PipedriveBadRequest: 'pipedrive_bad_request',
    PipedriveTemporaryError: 'pipedrive_temporary_error',
    OneDriveUnknownError: 'one_drive_unknown_error',
    OneDriveRateLimitExceeded: 'one_drive_rate_limit_exceeded',
    OneDriveServiceUnavailable: 'one_drive_service_unavailable',
    OneDriveForbiddenError: 'one_drive_forbidden_error',
    SharepointListsForbiddenError: 'sharepoint_lists_forbidden_error',
    SharepointListsRateLimitExceeded: 'sharepoint_lists_rate_limit_exceeded',
    SharepointListsServiceUnavailable: 'sharepoint_lists_service_unavailable',
    SharepointListsUnknownError: 'sharepoint_lists_unknown_error',
    SharepointListsSiteNotFound: 'sharepoint_lists_site_not_found',
    SharepointListsListNotFound: 'sharepoint_lists_list_not_found',
    EgnyteUnknownError: 'egnyte_unknown_error',
    EgnyteRateLimitExceeded: 'egnyte_rate_limit_exceeded',
    EgnyteServiceUnavailable: 'egnyte_service_unavailable',
    EgnyteForbiddenError: 'egnyte_forbidden_error',
    EgnyteFileNotFound: 'egnyte_file_not_found',
    BoxUnknownError: 'box_unknown_error',
    BoxRateLimitExceeded: 'box_rate_limit_exceeded',
    BoxServiceUnavailable: 'box_service_unavailable',
    BoxForbiddenError: 'box_forbidden_error',
    ExcelFormatIncorrect: 'excel_format_incorrect',
    ExcelFilesizeExceeds: 'excel_filesize_exceeds',
    OutreachUnknownError: 'outreach_unknown_error',
    OutreachUnauthorizedRequest: 'outreach_unauthorized_request',
    OutreachRateLimitExceeded: 'outreach_rate_limit_exceeded',
    OutreachGatewayError: 'outreach_gateway_error',
    OutreachTooManySorts: 'outreach_too_many_sorts',
    OutreachDeprecatedFiltersSorts: 'outreach_deprecated_filters_sorts',
    ResourceExhausted: 'resource_exhausted',
    RateLimitExceeded: 'rate_limit_exceeded',
    RangeParsingFailure: 'range_parsing_failure',
    OutOfRangeValuesJsonNonComplaint: 'out_of_range_values_json_non_complaint',
    InvalidCredentialsRefreshAccessToken: 'invalid_credentials_refresh_access_token',
    GsheetsBadRequest: 'gsheets_bad_request',
    GscUnknownError: 'gsc_unknown_error',
    GscRateLimitExceeded: 'gsc_rate_limit_exceeded',
    GscServiceUnavailable: 'gsc_service_unavailable',
    GscNotFound: 'gsc_not_found',
    GscBadRequest: 'gsc_bad_request',
    GscServerError: 'gsc_server_error',
    GmailUnknownError: 'gmail_unknown_error',
    GmailRateLimitExceeded: 'gmail_rate_limit_exceeded',
    GmailServiceUnavailable: 'gmail_service_unavailable',
    GmailNotFound: 'gmail_not_found',
    GmailBadRequest: 'gmail_bad_request',
    GmailServerError: 'gmail_server_error',
    GoogleAdsUnknownError: 'google_ads_unknown_error',
    GoogleAdsBadRequest: 'google_ads_bad_request',
    GoogleAdsDataNotFound: 'google_ads_data_not_found',
    GoogleAdsMetricsAccessDenied: 'google_ads_metrics_access_denied',
    GoogleAdsTooManyRequests: 'google_ads_too_many_requests',
    GoogleAdsServiceUnavailable: 'google_ads_service_unavailable',
    GoogleAdsNotAdsUser: 'google_ads_not_ads_user',
    GoogleAdsPermissionDenied: 'google_ads_permission_denied',
    GoogleAdsCustomerAccountDeactivatedOrDisabled: 'google_ads_customer_account_deactivated_or_disabled',
    FeatureDisabled: 'feature_disabled',
    CloudTableDuplicateColumnNames: 'cloud_table_duplicate_column_names',
    CloudTableEmptyColumnNames: 'cloud_table_empty_column_names',
    CloudTableDataNotDetected: 'cloud_table_data_not_detected',
    CloudTablePushToRedshiftFailed: 'cloud_table_push_to_redshift_failed',
    CloudTableConnectorUnableToRefresh: 'cloud_table_connector_unable_to_refresh',
    ChargebeeUnknownError: 'chargebee_unknown_error',
    WritebackInProgress: 'writeback_in_progress',
    NotionUnknownError: 'notion_unknown_error',
    NotionRateLimitExceeded: 'notion_rate_limit_exceeded',
    NotionServiceUnavailable: 'notion_service_unavailable',
    NotionNotFound: 'notion_not_found',
    NotionBadRequest: 'notion_bad_request',
    NotionServerError: 'notion_server_error',
    NotionUnauthorizedRequest: 'notion_unauthorized_request',
    NotionDatabaseEmptyError: 'notion_database_empty_error',
    LinkedinAdsBadRequestError: 'linkedin_ads_bad_request_error',
    LinkedinAdsUnauthorizedError: 'linkedin_ads_unauthorized_error',
    LinkedinAdsAccessDeniedError: 'linkedin_ads_access_denied_error',
    LinkedinAdsResourceNotFoundError: 'linkedin_ads_resource_not_found_error',
    LinkedinAdsMethodNotAllowedError: 'linkedin_ads_method_not_allowed_error',
    LinkedinAdsRateLimitError: 'linkedin_ads_rate_limit_error',
    LinkedinAdsInternalServerError: 'linkedin_ads_internal_server_error',
    LinkedinAdsGatewayTimeoutError: 'linkedin_ads_gateway_timeout_error',
    LinkedinAdsTooLongRequestError: 'linkedin_ads_too_long_request_error',
    LinkedinAdsVersionDeprecatedError: 'linkedin_ads_version_deprecated_error',
    LinkedinAdsUnknownError: 'linkedin_ads_unknown_error',
    LinkedinAdsNoMetricsSelectedError: 'linkedin_ads_no_metrics_selected_error',
    LinkedinAdsAccountMismatchOnImportError: 'linkedin_ads_account_mismatch_on_import_error',
    YoutubeAnalyticsUnknownError: 'youtube_analytics_unknown_error',
    YoutubeAnalyticsBadRequest: 'youtube_analytics_bad_request',
    YoutubeAnalyticsQueryNotSupported: 'youtube_analytics_query_not_supported',
    YoutubeAnalyticsAuthError: 'youtube_analytics_auth_error',
    YoutubeAnalyticsServiceUnavailable: 'youtube_analytics_service_unavailable',
    YoutubeAnalyticsRateLimitExceeded: 'youtube_analytics_rate_limit_exceeded',
    YoutubeAnalyticsForbiddenAccess: 'youtube_analytics_forbidden_access',
    YoutubeAnalyticsIncompleteInputProvided: 'youtube_analytics_incomplete_input_provided',
    LinkedinPagesBadRequestError: 'linkedin_pages_bad_request_error',
    LinkedinPagesUnauthorizedError: 'linkedin_pages_unauthorized_error',
    LinkedinPagesAccessDeniedError: 'linkedin_pages_access_denied_error',
    LinkedinPagesResourceNotFoundError: 'linkedin_pages_resource_not_found_error',
    LinkedinPagesMethodNotAllowedError: 'linkedin_pages_method_not_allowed_error',
    LinkedinPagesRateLimitError: 'linkedin_pages_rate_limit_error',
    LinkedinPagesInternalServerError: 'linkedin_pages_internal_server_error',
    LinkedinPagesGatewayTimeoutError: 'linkedin_pages_gateway_timeout_error',
    LinkedinPagesUnknownError: 'linkedin_pages_unknown_error',
    LinkedinPagesNoParametersError: 'linkedin_pages_no_parameters_error',
    LinkedinPagesDateRangeError: 'linkedin_pages_date_range_error',
    MicrosoftAdsNoMetricsError: 'microsoft_ads_no_metrics_error',
    MicrosoftAdsColumnSelectionError: 'microsoft_ads_column_selection_error',
    MicrosoftAdsUnknownError: 'microsoft_ads_unknown_error',
    XeroServiceUnavailable: 'xero_service_unavailable',
    XeroObjectNotFound: 'xero_object_not_found',
    XeroInvalidFilter: 'xero_invalid_filter',
    XeroOrganizationNotAvailable: 'xero_organization_not_available',
    XeroReportNotAvailableForRegion: 'xero_report_not_available_for_region',
    KlaviyoUnknownError: 'klaviyo_unknown_error',
    HarvestUnknownError: 'harvest_unknown_error',
    GoogleCalendarServiceUnavailable: 'google_calendar_service_unavailable',
    AmazonSellerCentralServiceUnavailable: 'amazon_seller_central_service_unavailable',
    AmazonSellerCentralUnauthorized: 'amazon_seller_central_unauthorized',
    AmazonSellerCentralInvalidMarketplace: 'amazon_seller_central_invalid_marketplace',
    AmazonSellerCentralMissingRole: 'amazon_seller_central_missing_role',
    GoogleClassroomServiceUnavailable: 'google_classroom_service_unavailable',
    GreenhouseUnknownError: 'greenhouse_unknown_error',
    NetsuiteBadRequestError: 'netsuite_bad_request_error',
    NetsuiteNoTransactionDataInAccount: 'netsuite_no_transaction_data_in_account',
    NetsuiteUnauthorizedError: 'netsuite_unauthorized_error',
    NetsuiteAccessDeniedError: 'netsuite_access_denied_error',
    NetsuiteResourceNotFoundError: 'netsuite_resource_not_found_error',
    NetsuiteRecordNotFoundError: 'netsuite_record_not_found_error',
    NetsuiteAppInfoNotFoundError: 'netsuite_app_info_not_found_error',
    NetsuiteInvalidRestletError: 'netsuite_invalid_restlet_error',
    NetsuiteInvalidFileExtensionError: 'netsuite_invalid_file_extension_error',
    NetsuiteSavedSearchNotSupportedError: 'netsuite_saved_search_not_supported_error',
    NetsuiteRecordsSyntaxError: 'netsuite_records_syntax_error',
    NetsuiteMethodNotAllowedError: 'netsuite_method_not_allowed_error',
    NetsuiteRateLimitError: 'netsuite_rate_limit_error',
    NetsuiteInternalServerError: 'netsuite_internal_server_error',
    NetsuiteGatewayTimeoutError: 'netsuite_gateway_timeout_error',
    NetsuiteUnsupportedOperationError: 'netsuite_unsupported_operation_error',
    NetsuiteUnknownError: 'netsuite_unknown_error',
    NetsuiteReportsUnbalancedPartitionsError: 'netsuite_reports_unbalanced_partitions_error',
    NetsuiteNoAccessToReport: 'netsuite_no_access_to_report',
    NetsuiteNoAccessToAccountingPeriod: 'netsuite_no_access_to_accounting_period',
    NetsuiteInvalidMetadata: 'netsuite_invalid_metadata',
    NetsuitePermissionPreferenceNotSet: 'netsuite_permission_preference_not_set',
    NetsuiteInsufficientPermissionForFeature: 'netsuite_insufficient_permission_for_feature',
    NetsuiteInvalidLogin: 'netsuite_invalid_login',
    NetsuiteAgentApiGwEntryNotFound: 'netsuite_agent_api_gw_entry_not_found',
    NetsuiteAgentInvalidUrl: 'netsuite_agent_invalid_url',
    NetsuiteAgentUnsupportedUrl: 'netsuite_agent_unsupported_url',
    NetsuiteAgentUnsupportedFileFormat: 'netsuite_agent_unsupported_file_format',
    NetsuiteAgentFailedToFetchData: 'netsuite_agent_failed_to_fetch_data',
    NetsuiteAgentCrxRunAttemptFailed: 'netsuite_agent_crx_run_attempt_failed',
    NetsuiteAgentFailedToApplyFilters: 'netsuite_agent_failed_to_apply_filters',
    NetsuiteAgentAccountLoggedOut: 'netsuite_agent_account_logged_out',
    NetsuiteAgentFailedToSendWebsocketMessage: 'netsuite_agent_failed_to_send_websocket_message',
    NetsuiteAgentXmlParsingError: 'netsuite_agent_xml_parsing_error',
    NetsuiteAgentCsvParsingError: 'netsuite_agent_csv_parsing_error',
    NetsuiteAgentBlockNonOwnerRefresh: 'netsuite_agent_block_non_owner_refresh',
    NetsuiteAgentSsUnableToAcquireLock: 'netsuite_agent_ss_unable_to_acquire_lock',
    NetsuiteAgentErrorPageDetected: 'netsuite_agent_error_page_detected',
    NetsuiteAgentReportStillGenerating: 'netsuite_agent_report_still_generating',
    CustomApiUnauthorized: 'custom_api_unauthorized',
    CustomApiForbidden: 'custom_api_forbidden',
    CustomApiBadRequest: 'custom_api_bad_request',
    CustomApiNotFound: 'custom_api_not_found',
    CustomApiInternalServerError: 'custom_api_internal_server_error',
    CustomApiTemporaryError: 'custom_api_temporary_error',
    CustomApiSourceError: 'custom_api_source_error',
    CustomApiInvalidJsonResponse: 'custom_api_invalid_json_response',
    CustomApiInvalidUrl: 'custom_api_invalid_url',
    CustomApiSandboxExecutionError: 'custom_api_sandbox_execution_error',
    InvalidInputsProvided: 'invalid_inputs_provided',
    XeroApiRateLimitExceeded: 'xero_api_rate_limit_exceeded',
    AsanaInvalidProjectId: 'asana_invalid_project_id',
    DatabricksInvalidPatToken: 'databricks_invalid_pat_token',
    DatabricksInvalidOauthToken: 'databricks_invalid_oauth_token',
    DatabricksCatalogNotFound: 'databricks_catalog_not_found',
    DatabricksInvalidResourceDetails: 'databricks_invalid_resource_details',
    DatabricksInvalidJdbcUrl: 'databricks_invalid_jdbc_url',
    DatabricksUnknownError: 'databricks_unknown_error',
    DatabricksInvalidSchema: 'databricks_invalid_schema',
    ArrowFlightSqlInvalidToken: 'arrow_flight_sql_invalid_token',
    ArrowFlightSqlConnectionError: 'arrow_flight_sql_connection_error',
    ArrowFlightSqlUnknownError: 'arrow_flight_sql_unknown_error',
    ExcelColumnNameTooLong: 'excel_column_name_too_long',
    InvalidPivotInput: 'invalid_pivot_input',
    JotformForbiddenError: 'jotform_forbidden_error',
    ExcelAddinBatchRequestsThrottled: 'excel_addin_batch_requests_throttled',
    ExcelApiUnavailable: 'excel_api_unavailable',
    ExcelApiGatewayTimeout: 'excel_api_gateway_timeout',
    ExcelAddinBatchRequestsFailed: 'excel_addin_batch_requests_failed',
    ExcelAddinInvalidRefreshTokenError: 'excel_addin_invalid_refresh_token_error',
    ExcelAddinInsufficientMsPermissions: 'excel_addin_insufficient_ms_permissions',
    ExcelUrlBlockedDomain: 'excel_url_blocked_domain',
    ExcelWorkbookHasHugeNumberOfScheduledImports: 'excel_workbook_has_huge_number_of_scheduled_imports',
    ExcelScheduledRunPartiallyExecuted: 'excel_scheduled_run_partially_executed',
    ExcelUnknownError: 'excel_unknown_error',
    Ga4IncompleteDataError: 'ga4_incomplete_data_error',
    Ga4ActiveMetricRestrictionError: 'ga4_active_metric_restriction_error',
    InvalidAmplitudeChartUrl: 'invalid_amplitude_chart_url',
    UnsupportedAmplitudeChartType: 'unsupported_amplitude_chart_type',
    AnotherVcrSessionInProgressForLongTime: 'another_vcr_session_in_progress_for_long_time',
    CantStartVcrInstance: 'cant_start_vcr_instance',
    CantAttachUserToVcrInstance: 'cant_attach_user_to_vcr_instance',
    VcrUnknownError: 'vcr_unknown_error',
    VcrTooManyParallelRuns: 'vcr_too_many_parallel_runs',
    VcrAuthSessionInProgress: 'vcr_auth_session_in_progress',
    NoVcrInstanceAvailable: 'no_vcr_instance_available',
    ApolloUnknownError: 'apollo_unknown_error',
    ApolloBadRequest: 'apollo_bad_request',
    ApolloServiceUnavailable: 'apollo_service_unavailable',
    ApolloRateLimitExceeded: 'apollo_rate_limit_exceeded',
    ApolloDataNotFound: 'apollo_data_not_found',
    AwsBillingInvalidCredentials: 'aws_billing_invalid_credentials',
    AwsBillingValidationError: 'aws_billing_validation_error',
    AwsBillingAccessDenied: 'aws_billing_access_denied',
    AwsBillingUnknownError: 'aws_billing_unknown_error',
    AwsBillingMax2GroupBysError: 'aws_billing_max_2_group_bys_error',
    SageInvalidCredentials: 'sage_invalid_credentials',
    SageValidationError: 'sage_validation_error',
    SageAccessDenied: 'sage_access_denied',
    SageRecordsAccessDenied: 'sage_records_access_denied',
    SageReportNotFound: 'sage_report_not_found',
    SageDateFormatError: 'sage_date_format_error',
    SageUnknownError: 'sage_unknown_error',
    OpenaiTimeoutError: 'openai_timeout_error',
    OpenaiUnknownError: 'openai_unknown_error'
};
exports.DataImportPreemptOption = {
    WaitOnNewRun: 'wait_on_new_run',
    ReturnPreemptedStatus: 'return_preempted_status'
};
exports.DataImportRunStartOption = {
    LegacySyncMode: 'legacy_sync_mode',
    WaitIfInProgress: 'wait_if_in_progress',
    KillIfInProgress: 'kill_if_in_progress'
};
exports.DataImportRunStatusType = {
    Failed: 'failed',
    Ok: 'ok'
};
exports.DataImportRunTaskStage = {
    InQueue: 'in_queue',
    InProgress: 'in_progress',
    Done: 'done'
};
exports.DataImportRunTriggerType = {
    Manual: 'manual',
    Scheduled: 'scheduled',
    ParameterizedFilter: 'parameterized_filter',
    Webhook: 'webhook',
    Agent: 'agent'
};
exports.DataImportScheduleRemovalType = {
    BillingPlanChange: 'billing_plan_change',
    TooManyConsecutiveErrors: 'too_many_consecutive_errors',
    AbandonedSpreadsheet: 'abandoned_spreadsheet',
    ClonedSpreadsheet: 'cloned_spreadsheet',
    UserTurnedScheduleOff: 'user_turned_schedule_off',
    DemoAccountScheduleExpired: 'demo_account_schedule_expired'
};
exports.DataImportScheduleRepeatType = {
    Hourly: 'hourly',
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly'
};
exports.DataImportStatusLevel = {
    Warning: 'warning',
    Error: 'error'
};
exports.DataImportTransferUserAssociation = {
    DataImportOwner: 'data_import_owner',
    DataSourceOwner: 'data_source_owner',
    ScheduledRunUser: 'scheduled_run_user'
};
exports.DataImportWarningType = {
    NoMatchingRows: 'no_matching_rows',
    ReferEmptyCells: 'refer_empty_cells',
    NoNewMatchingRows: 'no_new_matching_rows',
    DataSourceChangedRerunImport: 'data_source_changed_rerun_import',
    NoSourceRowsToImport: 'no_source_rows_to_import',
    LookerPivotLookPreviewNotAvailable: 'looker_pivot_look_preview_not_available',
    ImportExceededSpecifiedLimit: 'import_exceeded_specified_limit',
    ImportExceededDataSourceLimit: 'import_exceeded_data_source_limit',
    ImportColumnsMissingInSource: 'import_columns_missing_in_source',
    LookerNoDownloadWithoutLimitPermission: 'looker_no_download_without_limit_permission',
    ImportRowsLimitedDueToFreemium: 'import_rows_limited_due_to_freemium',
    SalesforceReportRestApiFallback: 'salesforce_report_rest_api_fallback',
    SalesforceReportColumnLimit: 'salesforce_report_column_limit',
    SalesforceReportColumnAndRowLimit: 'salesforce_report_column_and_row_limit',
    SalesforceReportNoIdColumnDegraded: 'salesforce_report_no_id_column_degraded',
    SalesforceReportLongTextTruncated: 'salesforce_report_long_text_truncated',
    SnapshotFailedCellLimitExceeded: 'snapshot_failed_cell_limit_exceeded',
    ShopifyExceededTimeLimit: 'shopify_exceeded_time_limit',
    OnsheetFormulaAutofillFailed: 'onsheet_formula_autofill_failed',
    OnsheetFormulaAutofillRetryAsync: 'onsheet_formula_autofill_retry_async',
    NewRunTriggeredBeforeRetryAsync: 'new_run_triggered_before_retry_async',
    CloudTableConnectorUnableToRefresh: 'cloud_table_connector_unable_to_refresh',
    Ga4ImportHasIncompleteData: 'ga4_import_has_incomplete_data',
    Ga4ImportHasActiveMetricRestriction: 'ga4_import_has_active_metric_restriction',
    Ga4ImportHasSampledData: 'ga4_import_has_sampled_data',
    YoutubeAnalyticsImportHasIncompleteData: 'youtube_analytics_import_has_incomplete_data',
    AbandonedSpreadsheetScheduleRemoved: 'abandoned_spreadsheet_schedule_removed',
    DemoAccountScheduleRemoved: 'demo_account_schedule_removed',
    LookerFillDownValuesDisabled: 'looker_fill_down_values_disabled',
    LookerImportColumnsRemovedInSource: 'looker_import_columns_removed_in_source',
    LookerDashboardFilterNotSupportedForMergeQuery: 'looker_dashboard_filter_not_supported_for_merge_query',
    LookerFilterNotSupportedForMergeQuery: 'looker_filter_not_supported_for_merge_query',
    NetflixQuiverImportColumnsRemovedInSource: 'netflix_quiver_import_columns_removed_in_source',
    CustomApiEmptyResponse: 'custom_api_empty_response',
    NetsuiteOutdatedRestletWarning: 'netsuite_outdated_restlet_warning',
    ShopifyDeprecatedFields: 'shopify_deprecated_fields',
    FbAdsImportHasDeprecatedMetrics: 'fb_ads_import_has_deprecated_metrics',
    FbAdsDeprecatedMetricsAutoremoved: 'fb_ads_deprecated_metrics_autoremoved',
    FbInsightsDeprecatedMetrics: 'fb_insights_deprecated_metrics',
    NetsuiteOffsetErrorWarning: 'netsuite_offset_error_warning',
    NetsuiteCustomFieldMetadataPermissionWarning: 'netsuite_custom_field_metadata_permission_warning',
    PivotPreviewMaxSizeExceeded: 'pivot_preview_max_size_exceeded',
    PivotRawDataMaxSizeExceeded: 'pivot_raw_data_max_size_exceeded',
    GmailNoNewEmails: 'gmail_no_new_emails',
    GmailNoNewRows: 'gmail_no_new_rows',
    InstagramDeprecatedFields: 'instagram_deprecated_fields',
    QuickbooksReportExceedsCellLimit: 'quickbooks_report_exceeds_cell_limit',
    HubspotLimitReset: 'hubspot_limit_reset',
    PivotTooManyColumns: 'pivot_too_many_columns',
    PipedriveImportColumnsRemovedInSource: 'pipedrive_import_columns_removed_in_source',
    SageImportHasIncompleteData: 'sage_import_has_incomplete_data',
    SageImportContinuationInProgress: 'sage_import_continuation_in_progress',
    XeroReportTruncated: 'xero_report_truncated'
};
exports.DataSourceCategory = {
    Ppress: 'ppress',
    Sql: 'sql',
    CuratedApi: 'curated_api'
};
exports.DataSourceConnectionStatusType = {
    Failed: 'failed',
    Ok: 'ok'
};
exports.DataSourceType = {
    Csv: 'csv',
    GoogleSheets: 'google_sheets',
    Salesforce: 'salesforce',
    GptCopilot: 'gpt_copilot',
    Looker: 'looker',
    GoogleAnalytics: 'google_analytics',
    Hubspot: 'hubspot',
    Tableau: 'tableau',
    Jira: 'jira',
    Stripe: 'stripe',
    Zendesk: 'zendesk',
    Quickbooks: 'quickbooks',
    Shopify: 'shopify',
    GoogleDrive: 'google_drive',
    Excel: 'excel',
    Airtable: 'airtable',
    Mailchimp: 'mailchimp',
    Pipedrive: 'pipedrive',
    OneDrive: 'one_drive',
    SharepointLists: 'sharepoint_lists',
    Egnyte: 'egnyte',
    Box: 'box',
    Outreach: 'outreach',
    GoogleAnalytics4: 'google_analytics_4',
    GoogleSearchConsole: 'google_search_console',
    GoogleAds: 'google_ads',
    CloudTable: 'cloud_table',
    FacebookAds: 'facebook_ads',
    Notion: 'notion',
    Chargebee: 'chargebee',
    LinkedinAds: 'linkedin_ads',
    FacebookInsights: 'facebook_insights',
    YoutubeAnalytics: 'youtube_analytics',
    LinkedinPages: 'linkedin_pages',
    Linkedin: 'linkedin',
    CustomApi: 'custom_api',
    InstagramInsights: 'instagram_insights',
    MicrosoftAds: 'microsoft_ads',
    Netsuite: 'netsuite',
    NetsuiteCrx: 'netsuite_crx',
    Xero: 'xero',
    Klaviyo: 'klaviyo',
    Asana: 'asana',
    Razorpay: 'razorpay',
    Clickup: 'clickup',
    Typeform: 'typeform',
    Harvest: 'harvest',
    Freshdesk: 'freshdesk',
    Paymo: 'paymo',
    GoogleCalendar: 'google_calendar',
    AmazonSellerCentral: 'amazon_seller_central',
    Trello: 'trello',
    Gong: 'gong',
    Calendly: 'calendly',
    Smartsheet: 'smartsheet',
    RedditAds: 'reddit_ads',
    Surveymonkey: 'surveymonkey',
    QuoraAds: 'quora_ads',
    Podio: 'podio',
    Greenhouse: 'greenhouse',
    Gusto: 'gusto',
    Intercom: 'intercom',
    Etsy: 'etsy',
    PinterestAds: 'pinterest_ads',
    ActiveCampaign: 'active_campaign',
    Jotform: 'jotform',
    Basecamp: 'basecamp',
    Zohobooks: 'zohobooks',
    Coda: 'coda',
    Square: 'square',
    Zoom: 'zoom',
    Webflow: 'webflow',
    ZohoCrm: 'zoho_crm',
    Bigin: 'bigin',
    Lever: 'lever',
    Salesloft: 'salesloft',
    Wordpress: 'wordpress',
    WooCommerce: 'woo_commerce',
    Bigcommerce: 'bigcommerce',
    Smartlead: 'smartlead',
    Affinity: 'affinity',
    Shiprocket: 'shiprocket',
    AwsBilling: 'aws_billing',
    Gmail: 'gmail',
    Sage: 'sage',
    GoogleClassroom: 'google_classroom',
    Campfire: 'campfire',
    Rillet: 'rillet',
    NetflixQuiver: 'netflix_quiver',
    AnyApiAgent: 'any_api_agent',
    BrowserAgent: 'browser_agent',
    Mysql: 'mysql',
    Redshift: 'redshift',
    Postgres: 'postgres',
    Snowflake: 'snowflake',
    Mssql: 'mssql',
    Bigquery: 'bigquery',
    Databricks: 'databricks',
    ArrowFlightSql: 'arrow_flight_sql',
    Motherduck: 'motherduck',
    Clickhouse: 'clickhouse',
    AuroraPostgres: 'aurora_postgres',
    AuroraMysql: 'aurora_mysql',
    CloudSqlPostgres: 'cloud_sql_postgres',
    CloudSqlMysql: 'cloud_sql_mysql',
    Supabase: 'supabase',
    Neon: 'neon',
    Timescaledb: 'timescaledb',
    AzurePostgres: 'azure_postgres',
    AzureMysql: 'azure_mysql',
    AzureSql: 'azure_sql',
    Rippling: 'rippling',
    Apollo: 'apollo',
    Amplitude: 'amplitude',
    Sendgrid: 'sendgrid',
    Chargify: 'chargify',
    Marketo: 'marketo',
    Mongodb: 'mongodb',
    WebScraper: 'web_scraper',
    ChargebeeAi: 'chargebee_ai',
    StripeAi: 'stripe_ai',
    OutreachAi: 'outreach_ai',
    ClickupAi: 'clickup_ai',
    JiraAi: 'jira_ai',
    SquareAi: 'square_ai',
    ExpensifyAi: 'expensify_ai',
    TwilioAi: 'twilio_ai',
    SendgridAi: 'sendgrid_ai',
    KitAi: 'kit_ai',
    InsightlyAi: 'insightly_ai',
    FreshsalesAi: 'freshsales_ai',
    CloseAi: 'close_ai',
    XeroAi: 'xero_ai',
    ModeAi: 'mode_ai',
    MondayAi: 'monday_ai',
    MixpanelAi: 'mixpanel_ai',
    ClockifyAi: 'clockify_ai',
    KobotoolboxAi: 'kobotoolbox_ai',
    TogglTrackAi: 'toggl_track_ai',
    SmartsuiteAi: 'smartsuite_ai',
    OdooAi: 'odoo_ai',
    LinearAi: 'linear_ai',
    KlaviyoAi: 'klaviyo_ai',
    RazorpayAi: 'razorpay_ai',
    PaymoAi: 'paymo_ai',
    ActiveCampaignAi: 'active_campaign_ai',
    WordpressAi: 'wordpress_ai',
    WooCommerceAi: 'woo_commerce_ai',
    SmartleadAi: 'smartlead_ai',
    ShiprocketAi: 'shiprocket_ai',
    RipplingAi: 'rippling_ai',
    HarvestAi: 'harvest_ai',
    CalendlyAi: 'calendly_ai',
    ZohobooksAi: 'zohobooks_ai',
    ZohoCrmAi: 'zoho_crm_ai',
    BiginAi: 'bigin_ai',
    ApolloAi: 'apollo_ai',
    FreshdeskAi: 'freshdesk_ai',
    GreenhouseAi: 'greenhouse_ai',
    TrelloAi: 'trello_ai',
    JotformAi: 'jotform_ai',
    CodaAi: 'coda_ai',
    TypeformAi: 'typeform_ai',
    PodioAi: 'podio_ai',
    SmartsheetAi: 'smartsheet_ai',
    BasecampAi: 'basecamp_ai',
    MetabaseAi: 'metabase_ai',
    TeamworkAi: 'teamwork_ai',
    CatsAtsAi: 'cats_ats_ai',
    NutshellAi: 'nutshell_ai',
    PipelinerAi: 'pipeliner_ai',
    SalesflareAi: 'salesflare_ai',
    VtigerCrmAi: 'vtiger_crm_ai',
    FreshserviceAi: 'freshservice_ai',
    HiveAi: 'hive_ai',
    AircallAi: 'aircall_ai',
    NimbleCrmAi: 'nimble_crm_ai',
    DripAi: 'drip_ai',
    PaddleAi: 'paddle_ai',
    AgileCrmAi: 'agile_crm_ai',
    CheckoutAi: 'checkout_ai',
    CapsuleAi: 'capsule_ai',
    BitbucketAi: 'bitbucket_ai',
    GitlabAi: 'gitlab_ai',
    HelpscoutAi: 'helpscout_ai',
    FrontAi: 'front_ai',
    WrikeAi: 'wrike_ai',
    BamboohrAi: 'bamboohr_ai',
    DeelAi: 'deel_ai',
    ConfluenceAi: 'confluence_ai',
    TeamleaderAi: 'teamleader_ai',
    MiroAi: 'miro_ai',
    OmnisendAi: 'omnisend_ai',
    AttioAi: 'attio_ai',
    CreatioAi: 'creatio_ai',
    FreeagentAi: 'freeagent_ai',
    MoneybirdAi: 'moneybird_ai',
    AcceloAi: 'accelo_ai',
    ApplicantstackAi: 'applicantstack_ai',
    AlowareAi: 'aloware_ai',
    StackbyAi: 'stackby_ai',
    FloatAi: 'float_ai',
    ClickhouseAi: 'clickhouse_ai',
    AppsflyerAi: 'appsflyer_ai',
    MariadbAi: 'mariadb_ai',
    LaunchdarklyAi: 'launchdarkly_ai',
    PosthogAi: 'posthog_ai',
    DovetailAi: 'dovetail_ai',
    ShipstationAi: 'shipstation_ai',
    MindbodyAi: 'mindbody_ai',
    GrowwAi: 'groww_ai',
    AmazonSellerCentralAi: 'amazon_seller_central_ai',
    AirwallexAi: 'airwallex_ai',
    StatsigAi: 'statsig_ai',
    ModernTreasuryAi: 'modern_treasury_ai',
    RudderstackAi: 'rudderstack_ai',
    BrightDataAi: 'bright_data_ai',
    VwoAi: 'vwo_ai',
    PartnerizeAi: 'partnerize_ai',
    RilletAi: 'rillet_ai',
    TrolleyAi: 'trolley_ai',
    ScalefusionAi: 'scalefusion_ai',
    BaremetricsAi: 'baremetrics_ai',
    TodoistAi: 'todoist_ai',
    WorkableAi: 'workable_ai',
    PlausibleAi: 'plausible_ai',
    ApifyAi: 'apify_ai',
    DatascopeAi: 'datascope_ai',
    GorgiasAi: 'gorgias_ai',
    EverhourAi: 'everhour_ai',
    ExchangeratesAi: 'exchangerates_ai',
    FastbillAi: 'fastbill_ai',
    GlassfrogAi: 'glassfrog_ai',
    ResourceFlowHubplannerAi: 'resource_flow_hubplanner_ai',
    KatanaAi: 'katana_ai',
    MyhoursAi: 'myhours_ai',
    FisRailzAi: 'fis_railz_ai',
    TellentHrisAi: 'tellent_hris_ai',
    SimfinAi: 'simfin_ai',
    SmartwaiverAi: 'smartwaiver_ai',
    LokaliseAi: 'lokalise_ai',
    MailerliteAi: 'mailerlite_ai',
    MailersendAi: 'mailersend_ai',
    OnesignalAi: 'onesignal_ai',
    PostmarkAi: 'postmark_ai',
    ShortIoAi: 'short_io_ai',
    YotpoAi: 'yotpo_ai',
    ChartmogulAi: 'chartmogul_ai',
    ConfigcatAi: 'configcat_ai',
    PingdomAi: 'pingdom_ai',
    RetentlyAi: 'retently_ai',
    CoinmarketcapAi: 'coinmarketcap_ai',
    SoftrIoAi: 'softr_io_ai',
    EmailoctopusAi: 'emailoctopus_ai',
    GridlyAi: 'gridly_ai',
    MixmaxAi: 'mixmax_ai',
    ReplyIoAi: 'reply_io_ai',
    LessAnnoyingCrmAi: 'less_annoying_crm_ai',
    SnovIoAi: 'snov_io_ai',
    OnepagecrmAi: 'onepagecrm_ai',
    LemlistAi: 'lemlist_ai'
};
exports.DateFilterType = {
    LastWeekSunSat: 'last_week_sun_sat',
    LastWeekMonSun: 'last_week_mon_sun',
    ThisMonthToDate: 'this_month_to_date',
    ThisMonthToYesterday: 'this_month_to_yesterday',
    LastMonth: 'last_month',
    YearToDate: 'year_to_date',
    LastYear: 'last_year',
    LastYearAndYearToDate: 'last_year_and_year_to_date',
    LastXWeeksSunSat: 'last_x_weeks_sun_sat',
    LastXWeeksMonSun: 'last_x_weeks_mon_sun',
    CustomDateRange: 'custom_date_range',
    Today: 'today',
    Tomorrow: 'tomorrow',
    Yesterday: 'yesterday',
    CurrentWeek: 'current_week',
    CurrentMonth: 'current_month',
    CurrentYear: 'current_year',
    LastMonthEnd: 'last_month_end',
    LastXDays: 'last_x_days',
    LastXWeeks: 'last_x_weeks',
    LastXMonths: 'last_x_months',
    LastXYears: 'last_x_years',
    NextXDays: 'next_x_days',
    NextXWeeks: 'next_x_weeks',
    NextXMonths: 'next_x_months',
    NextXYears: 'next_x_years',
    ExactDate: 'exact_date',
    ExactDates: 'exact_dates',
    MatchesAdvanced: 'matches_advanced',
    Now: 'now',
    LastXSeconds: 'last_x_seconds',
    LastXMinutes: 'last_x_minutes',
    LastXHours: 'last_x_hours',
    LastXQuarters: 'last_x_quarters',
    NextXSeconds: 'next_x_seconds',
    NextXMinutes: 'next_x_minutes',
    NextXHours: 'next_x_hours',
    NextXQuarters: 'next_x_quarters',
    LastXCompleteSeconds: 'last_x_complete_seconds',
    LastXCompleteMinutes: 'last_x_complete_minutes',
    LastXCompleteHours: 'last_x_complete_hours',
    LastXCompleteDays: 'last_x_complete_days',
    LastXCompleteWeeks: 'last_x_complete_weeks',
    LastXCompleteMonths: 'last_x_complete_months',
    LastXCompleteQuarters: 'last_x_complete_quarters',
    LastXCompleteYears: 'last_x_complete_years',
    NextXCompleteSeconds: 'next_x_complete_seconds',
    NextXCompleteMinutes: 'next_x_complete_minutes',
    NextXCompleteHours: 'next_x_complete_hours',
    NextXCompleteDays: 'next_x_complete_days',
    NextXCompleteWeeks: 'next_x_complete_weeks',
    NextXCompleteMonths: 'next_x_complete_months',
    NextXCompleteQuarters: 'next_x_complete_quarters',
    NextXCompleteYears: 'next_x_complete_years'
};
exports.DomainFamilyChangeLogType = {
    AddDomains: 'add_domains',
    RemoveDomains: 'remove_domains',
    ChangeName: 'change_name',
    CreateDomainFamily: 'create_domain_family',
    DeleteDomainFamily: 'delete_domain_family',
    EditDomainFamily: 'edit_domain_family',
    ToggleShareDataSources: 'toggle_share_data_sources',
    ToggleShareImportActivity: 'toggle_share_import_activity',
    ToggleShareTrialUnlimited: 'toggle_share_trial_unlimited',
    ToggleAllowImportCloning: 'toggle_allow_import_cloning',
    ToggleAllowCrossDomainImportEdits: 'toggle_allow_cross_domain_import_edits'
};
exports.DueInvoiceErrorType = {
    PendingOfflinePayment: 'pending_offline_payment',
    NoPaymentMethod: 'no_payment_method',
    Other: 'other',
    PaymentFailed: 'payment_failed'
};
exports.DynamicCloneOverallStatusType = {
    Ok: 'ok',
    ValidationError: 'validation_error',
    UnknownError: 'unknown_error',
    FreeTrialExpired: 'free_trial_expired',
    SomeRowsFailed: 'some_rows_failed',
    AllRowsFailed: 'all_rows_failed'
};
exports.EnrichRunStatus = {
    Queued: 'queued',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
};
exports.ExcelAgentInstructionType = {
    ListTabs: 'list_tabs',
    ReadRange: 'read_range',
    ReadRangeSummary: 'read_range_summary',
    WriteData: 'write_data',
    ClearRange: 'clear_range',
    InsertRows: 'insert_rows',
    DeleteRows: 'delete_rows',
    InsertColumns: 'insert_columns',
    DeleteColumns: 'delete_columns',
    MoveRows: 'move_rows',
    MoveColumns: 'move_columns',
    FormatRange: 'format_range',
    FormatNumber: 'format_number',
    SetColumnWidth: 'set_column_width',
    SetGridlines: 'set_gridlines',
    CreateTab: 'create_tab',
    RenameTab: 'rename_tab',
    AddComment: 'add_comment',
    FillFormula: 'fill_formula',
    ListConditionalFormats: 'list_conditional_formats',
    ApplyConditionalFormat: 'apply_conditional_format',
    ClearConditionalFormats: 'clear_conditional_formats',
    ListFilters: 'list_filters',
    ApplyFilter: 'apply_filter',
    ClearFilters: 'clear_filters',
    CreatePivotTable: 'create_pivot_table',
    UpdatePivotTable: 'update_pivot_table',
    ListPivotTables: 'list_pivot_tables',
    ClearPivotTables: 'clear_pivot_tables',
    ListCharts: 'list_charts',
    GetChartInfo: 'get_chart_info',
    ExportChartImage: 'export_chart_image',
    CreateChart: 'create_chart',
    UpdateChart: 'update_chart',
    ClearCharts: 'clear_charts',
    TakeScreenshot: 'take_screenshot',
    ExecuteOfficeJs: 'execute_office_js'
};
exports.ExcelCellBorderIdType = {
    EdgeTop: 'EdgeTop',
    EdgeBottom: 'EdgeBottom',
    EdgeLeft: 'EdgeLeft',
    EdgeRight: 'EdgeRight',
    InsideVertical: 'InsideVertical',
    InsideHorizontal: 'InsideHorizontal',
    DiagonalDown: 'DiagonalDown',
    DiagonalUp: 'DiagonalUp'
};
exports.ExcelCellBorderStyleType = {
    Continuous: 'Continuous',
    Dash: 'Dash',
    DashDot: 'DashDot',
    DashDotDot: 'DashDotDot',
    Dot: 'Dot',
    Double: 'Double',
    SlantDashDot: 'SlantDashDot'
};
exports.ExcelCellBorderWeightType = {
    Hairline: 'Hairline',
    Thin: 'Thin',
    Medium: 'Medium',
    Thick: 'Thick'
};
exports.ExcelFileLocationType = {
    Local: 'local',
    Cloud: 'cloud'
};
exports.ExcelSourceType = {
    GoogleDrive: 'google_drive',
    OneDrive: 'one_drive',
    Box: 'box',
    Upload: 'upload',
    Url: 'url',
    Egnyte: 'egnyte'
};
exports.ExcelWorkbookRedirectionType = {
    Import: 'import',
    Export: 'export',
    Spreadsheet: 'spreadsheet'
};
exports.ExcelWriterInstructionType = {
    CreateTable: 'create_table',
    MoveColumn: 'move_column',
    InsertColumn: 'insert_column',
    DeleteColumn: 'delete_column',
    SetColumnWidth: 'set_column_width',
    ClearFilters: 'clear_filters',
    ClearRange: 'clear_range',
    UpdateData: 'update_data',
    ApplyFilters: 'apply_filters',
    DeleteRange: 'delete_range',
    AddRows: 'add_rows',
    AddColumnMetadata: 'add_column_metadata',
    DeleteColumnMetadata: 'delete_column_metadata',
    UpdateRangeFormat: 'update_range_format',
    UpdateRangeFontFormat: 'update_range_font_format',
    UpdateRangeFillColor: 'update_range_fill_color',
    UpdateTableStyle: 'update_table_style',
    UpdateBorderFormat: 'update_border_format',
    AddSheetMetadata: 'add_sheet_metadata',
    UpdateSheetName: 'update_sheet_name',
    UpdateWorksheetProperties: 'update_worksheet_properties',
    InsertRange: 'insert_range',
    MoveRow: 'move_row',
    AddCellComment: 'add_cell_comment',
    FillFormula: 'fill_formula'
};
exports.FeatureFlag = {
    EnableFacebookAdsAsyncApi: 'enable_facebook_ads_async_api',
    EnableStatsig: 'enable_statsig',
    EnableRowTwoFilterByDefault: 'enable_row_two_filter_by_default',
    EnableWritebackResultRowReordering: 'enable_writeback_result_row_reordering',
    EnableWritebackResultRowReorderLookupViaWriteback: 'enable_writeback_result_row_reorder_lookup_via_writeback',
    EnableSsOpenTrackerCap: 'enable_ss_open_tracker_cap',
    UseTodayForSsOpenTracker: 'use_today_for_ss_open_tracker',
    UseNonvolatileSsOpenTracker: 'use_nonvolatile_ss_open_tracker',
    DisableSsOpenTracker: 'disable_ss_open_tracker',
    AcquireGoogleRefreshTokenForNewUser: 'acquire_google_refresh_token_for_new_user',
    AcquireGoogleRefreshToken: 'acquire_google_refresh_token',
    EnableGsheetOauthAutoRefresh: 'enable_gsheet_oauth_auto_refresh',
    EnableAgentApiGoogleRefresh: 'enable_agent_api_google_refresh',
    EnableJsonFlattening: 'enable_json_flattening',
    EnableSnowflakeOauthSchemaLimit: 'enable_snowflake_oauth_schema_limit',
    EnableOidcSso: 'enable_oidc_sso',
    EnableXeroConnector: 'enable_xero_connector',
    EnableExcelWriteback: 'enable_excel_writeback',
    EnableExcelWritebackMultipartUpload: 'enable_excel_writeback_multipart_upload',
    EnableExcelSnapshot: 'enable_excel_snapshot',
    EnableAlertsV2SlackImage: 'enable_alerts_v2_slack_image',
    EnablePricingPageUpdates: 'enable_pricing_page_updates',
    EnableSoqlColumnReindex: 'enable_soql_column_reindex',
    EnableGoogleCalendar: 'enable_google_calendar',
    EnableSalesforceDateConversionToSheetFormat: 'enable_salesforce_date_conversion_to_sheet_format',
    EnableGongConnector: 'enable_gong_connector',
    EnableRedditAds: 'enable_reddit_ads',
    EnableSurveymonkey: 'enable_surveymonkey',
    EnableGustoConnector: 'enable_gusto_connector',
    EnableIntercomConnector: 'enable_intercom_connector',
    EnableEtsyConnector: 'enable_etsy_connector',
    EnableZoomConnector: 'enable_zoom_connector',
    EnableWebflowConnector: 'enable_webflow_connector',
    EnableSalesloftConnector: 'enable_salesloft_connector',
    EnableNetflixQuiverConnector: 'enable_netflix_quiver_connector',
    EnableHideInactiveUnlicensedInAdmin: 'enable_hide_inactive_unlicensed_in_admin',
    EnableNetsuiteCrxConnector: 'enable_netsuite_crx_connector',
    EnableNetsuiteCrxFilters: 'enable_netsuite_crx_filters',
    EnableNetsuiteCrxFiltersForPaidUsers: 'enable_netsuite_crx_filters_for_paid_users',
    EnableSkipNetsuiteCrxFilterErrors: 'enable_skip_netsuite_crx_filter_errors',
    EnableNetsuiteCrxScreenshot: 'enable_netsuite_crx_screenshot',
    EnableHubspotV2: 'enable_hubspot_v2',
    EnableHubspotV2WriteBack: 'enable_hubspot_v2_write_back',
    EnableHubspotAssociatedEnumFieldsToStr: 'enable_hubspot_associated_enum_fields_to_str',
    EnableHubspotOwnerCustomColumns: 'enable_hubspot_owner_custom_columns',
    EnableHubspotDealStageNameFix: 'enable_hubspot_deal_stage_name_fix',
    EnableExcludeHiddenFields: 'enable_exclude_hidden_fields',
    EnableBigcommerceConnector: 'enable_bigcommerce_connector',
    EnableConnectorOnboarding: 'enable_connector_onboarding',
    EnableSmartleadConnector: 'enable_smartlead_connector',
    EnableHubspotAsyncImport: 'enable_hubspot_async_import',
    EnableCommaConversionForEuLocales: 'enable_comma_conversion_for_eu_locales',
    EnableSkipGsheetLocaleFormattingTableau: 'enable_skip_gsheet_locale_formatting_tableau',
    EnableTableauRemoveNonBreakingSpace: 'enable_tableau_remove_non_breaking_space',
    EnableVcrMetadataComputation: 'enable_vcr_metadata_computation',
    EnableAffinityConnector: 'enable_affinity_connector',
    EnableGmailDiscountTake50coeff: 'enable_gmail_discount_take50coeff',
    EnableGsheetWriteInChunks: 'enable_gsheet_write_in_chunks',
    EnableLogDataSizeInGsheetWriteFail: 'enable_log_data_size_in_gsheet_write_fail',
    EnableVerifyTokenInSubOptions: 'enable_verify_token_in_sub_options',
    EnableEscapingSuboptionsInCuratedApi: 'enable_escaping_suboptions_in_curated_api',
    EnableZendeskMessenger: 'enable_zendesk_messenger',
    UseIntercomGenericTokenEndpoint: 'use_intercom_generic_token_endpoint',
    EnableSqlHostValidation: 'enable_sql_host_validation',
    EnableSqlPreviewImportCache: 'enable_sql_preview_import_cache',
    EnableSqlSshTunnel: 'enable_sql_ssh_tunnel',
    EnableFacebookAdsTemplateEnhancement: 'enable_facebook_ads_template_enhancement',
    EnableOnboardingMarketingTemplates: 'enable_onboarding_marketing_templates',
    EnableShiprocketConnector: 'enable_shiprocket_connector',
    EnableVerifyConnectionForSqlConnectors: 'enable_verify_connection_for_sql_connectors',
    EnableConnectionNaming: 'enable_connection_naming',
    SmartAlertFastPreviewFlow: 'smart_alert_fast_preview_flow',
    EnableSnowflakePercentFix: 'enable_snowflake_percent_fix',
    ExtendQuickbooksReportPivot: 'extend_quickbooks_report_pivot',
    EnableSalesforceCurrencyStitching: 'enable_salesforce_currency_stitching',
    RetainAlertsEmailCopy: 'retain_alerts_email_copy',
    EnableRipplingConnector: 'enable_rippling_connector',
    EnableHeadlessChromeImage: 'enable_headless_chrome_image',
    EnableJiraLinkedIssueFlattening: 'enable_jira_linked_issue_flattening',
    EnableJiraCustomFieldUnwrap: 'enable_jira_custom_field_unwrap',
    EnableClickableUrlForObjectIds: 'enable_clickable_url_for_object_ids',
    EnableLookerIsOneOfOptions: 'enable_looker_is_one_of_options',
    EnableSnowflakeIsOneOfOptions: 'enable_snowflake_is_one_of_options',
    EnableSnowflakeGetSchemaBulkTablesViews: 'enable_snowflake_get_schema_bulk_tables_views',
    EnableNsWbInvalidFieldCaching: 'enable_ns_wb_invalid_field_caching',
    EnableInstagramInsightsReducedPageSize: 'enable_instagram_insights_reduced_page_size',
    EnableApolloConnector: 'enable_apollo_connector',
    EnableStripeDiscounts: 'enable_stripe_discounts',
    EnableStripeInvoiceLinesExpand: 'enable_stripe_invoice_lines_expand',
    EnableTempGdriveAuth: 'enable_temp_gdrive_auth',
    EnablePreviewRunFetchColumns: 'enable_preview_run_fetch_columns',
    EnableAutoUpdateAskcoeffBot: 'enable_auto_update_askcoeff_bot',
    EnableSalesforceConvertCurrency: 'enable_salesforce_convert_currency',
    EnableSalesforceFrequentlyUsedFields: 'enable_salesforce_frequently_used_fields',
    EnableLookerPpressInMemoryFilters: 'enable_looker_ppress_in_memory_filters',
    EnableLookerQuerySlugForModelExplore: 'enable_looker_query_slug_for_model_explore',
    EnableDatabricksOauth: 'enable_databricks_oauth',
    EnableArrowFlightSqlConnector: 'enable_arrow_flight_sql_connector',
    EnableMotherduckConnector: 'enable_motherduck_connector',
    EnableAuroraConnector: 'enable_aurora_connector',
    EnableCloudSqlConnector: 'enable_cloud_sql_connector',
    EnableSupabaseConnector: 'enable_supabase_connector',
    EnableNeonConnector: 'enable_neon_connector',
    EnableTimescaledbConnector: 'enable_timescaledb_connector',
    EnableClickhouseConnector: 'enable_clickhouse_connector',
    EnableAzurePostgresConnector: 'enable_azure_postgres_connector',
    EnableAzureMysqlConnector: 'enable_azure_mysql_connector',
    EnableAzureSqlConnector: 'enable_azure_sql_connector',
    EnableTableauParameterQuery: 'enable_tableau_parameter_query',
    EnableTableauApiV3: 'enable_tableau_api_v3',
    EnableTableauRestApiV327: 'enable_tableau_rest_api_v327',
    EnableTableauCustomViews: 'enable_tableau_custom_views',
    EnableTableauAsyncImport: 'enable_tableau_async_import',
    EnableRecipeBackfillForOldImports: 'enable_recipe_backfill_for_old_imports',
    EnableTemplatesV2PreviewAutoOpen: 'enable_templates_v2_preview_auto_open',
    EnableGmailConnector: 'enable_gmail_connector',
    EnableSageConnector: 'enable_sage_connector',
    EnableExcelAsyncImport: 'enable_excel_async_import',
    ShowAdminDisableConnectionSharing: 'show_admin_disable_connection_sharing',
    EnableQuickbooksJsonFlatteningFix: 'enable_quickbooks_json_flattening_fix',
    EnableRestrictChunkSizeForExcel: 'enable_restrict_chunk_size_for_excel',
    EnablePipedriveImportColumnFilter: 'enable_pipedrive_import_column_filter',
    EnableImportAutoAnalyst: 'enable_import_auto_analyst',
    EnableAgenticWorkflows: 'enable_agentic_workflows',
    EnableAnyApiAgent: 'enable_any_api_agent',
    EnableExcelScopeReconsent: 'enable_excel_scope_reconsent',
    EnableExcelAgenticUi: 'enable_excel_agentic_ui',
    EnableExcelSheetsAssistant: 'enable_excel_sheets_assistant',
    EnableWebDashboardRawTabs: 'enable_web_dashboard_raw_tabs',
    EnableBrowserAgentChat: 'enable_browser_agent_chat',
    EnableLinkedinConnector: 'enable_linkedin_connector',
    EnableBigqueryWriteback: 'enable_bigquery_writeback',
    EnableRevampedLookerAuth: 'enable_revamped_looker_auth',
    EnableMailchimpReducedRecordsPerPage: 'enable_mailchimp_reduced_records_per_page',
    EnableGoogleClassroomConnector: 'enable_google_classroom_connector',
    EnableSharepointListsConnector: 'enable_sharepoint_lists_connector',
    EnableCampfireConnector: 'enable_campfire_connector',
    EnableRilletConnector: 'enable_rillet_connector',
    EnableUsingCustomPlanPrices: 'enable_using_custom_plan_prices',
    EnableAutoAssignLicenses: 'enable_auto_assign_licenses',
    EnableAutoReassignReturningUsers: 'enable_auto_reassign_returning_users',
    EnableExpansionTrial: 'enable_expansion_trial',
    EnablePurchaseOwnPlanOnProTeamPlans: 'enable_purchase_own_plan_on_pro_team_plans',
    EnablePremiumConnectorAutoEnforcement: 'enable_premium_connector_auto_enforcement',
    EnablePremiumConnectorEnforcementEnterprise: 'enable_premium_connector_enforcement_enterprise',
    EnableLoggingResolvedValues: 'enable_logging_resolved_values',
    EnableAuthModals: 'enable_auth_modals',
    EnableNetsuiteReportsRawDataLogging: 'enable_netsuite_reports_raw_data_logging',
    EnableAlertResolvedRefLogs: 'enable_alert_resolved_ref_logs',
    EnableFormulaAutofillReadFewRows: 'enable_formula_autofill_read_few_rows',
    EnableSheetsAssistant: 'enable_sheets_assistant',
    EnableTableauApplyFiltersAsync: 'enable_tableau_apply_filters_async',
    EnableForcingLargeIntAsString: 'enable_forcing_large_int_as_string',
    EnableConnectionFailureNotifications: 'enable_connection_failure_notifications',
    EnableHideAnyoneEditAccessType: 'enable_hide_anyone_edit_access_type',
    EnableEnrichEarlyAccess: 'enable_enrich_early_access',
    EnableStrictClientIdCheck: 'enable_strict_client_id_check',
    ShowInviteCoworkersTabWebapp: 'show_invite_coworkers_tab_webapp',
    ShowTeamActivityTabWebapp: 'show_team_activity_tab_webapp',
    ShowPlansAndBillingOnlyForAdminsAndManagers: 'show_plans_and_billing_only_for_admins_and_managers',
    EnableWeeklyEmailSummary: 'enable_weekly_email_summary',
    EnableNewLookerFilters: 'enable_new_looker_filters',
    EnableSnowflakeKeyPairAuth: 'enable_snowflake_key_pair_auth',
    EnableTableauOauthViaOkta: 'enable_tableau_oauth_via_okta',
    EnableNormalisationForSalesforceReportApiFetch: 'enable_normalisation_for_salesforce_report_api_fetch',
    EnableSalesforceFeedback: 'enable_salesforce_feedback',
    EnableLinkedinAdsTemplateFix: 'enable_linkedin_ads_template_fix',
    EnableSqlEditorV2: 'enable_sql_editor_v2',
    EnableWalSizeLogging: 'enable_wal_size_logging',
    EnableTableSizeLogging: 'enable_table_size_logging',
    EnableScheduledSnapshotInAsyncMode: 'enable_scheduled_snapshot_in_async_mode',
    EnableSheetsAssistantContextAdders: 'enable_sheets_assistant_context_adders',
    EnableSfReportColOrder: 'enable_sf_report_col_order',
    EnableAiWebEnrichment: 'enable_ai_web_enrichment',
    EnableSheetsAssistantQuickstartOrder: 'enable_sheets_assistant_quickstart_order',
    EnableNetsuiteSummaryMode: 'enable_netsuite_summary_mode',
    EnableEnhancedCloningUx: 'enable_enhanced_cloning_ux',
    EnableTempRejectBulkRunPollWithoutStartDt: 'enable_temp_reject_bulk_run_poll_without_start_dt',
    EnableHubspotRateLimitRetry: 'enable_hubspot_rate_limit_retry',
    EnableExcelAutoDeleteImport: 'enable_excel_auto_delete_import',
    EnableExcelTextFormatForSqlColumns: 'enable_excel_text_format_for_sql_columns',
    EnableTextFilterCastForNonTextColumns: 'enable_text_filter_cast_for_non_text_columns',
    EnableHubspotPpress: 'enable_hubspot_ppress',
    EnableHubspotV3Apis: 'enable_hubspot_v3_apis',
    EnableExcelAutoRemoveSchedule: 'enable_excel_auto_remove_schedule',
    EnableAsyncRefreshForSalesforceManualImport: 'enable_async_refresh_for_salesforce_manual_import',
    EnableAsyncRefreshForGongManualImport: 'enable_async_refresh_for_gong_manual_import',
    EnableNetsuiteReportsIgnoreCurrencyFieldsInConsolidatedSubsidiary: 'enable_netsuite_reports_ignore_currency_fields_in_consolidated_subsidiary',
    EnableAsyncRefreshForCustomApiManualImport: 'enable_async_refresh_for_custom_api_manual_import',
    EnableAsyncRefreshForChargebeeManualImport: 'enable_async_refresh_for_chargebee_manual_import',
    EnableAsyncRefreshForSageManualImport: 'enable_async_refresh_for_sage_manual_import',
    EnableAsyncRefreshForCampfireManualImport: 'enable_async_refresh_for_campfire_manual_import',
    EnableAsyncRefreshForRilletManualImport: 'enable_async_refresh_for_rillet_manual_import',
    EnableAsyncRefreshForCodaManualImport: 'enable_async_refresh_for_coda_manual_import',
    EnableTableauOauthDirectTrustOption: 'enable_tableau_oauth_direct_trust_option',
    EnableAsyncImportsForNetsuiteAgent: 'enable_async_imports_for_netsuite_agent',
    EnableOpenBgTabInCrxRuns: 'enable_open_bg_tab_in_crx_runs',
    EnableHumanizedSqlColumnLabels: 'enable_humanized_sql_column_labels',
    EnableImportPivotTableAsExcelTable: 'enable_import_pivot_table_as_excel_table',
    EnableReplaceSpaceInBigqueryPivot: 'enable_replace_space_in_bigquery_pivot',
    EnableHubspotTimezoneForDateOperands: 'enable_hubspot_timezone_for_date_operands',
    EnableLookerApplyVisSetting: 'enable_looker_apply_vis_setting',
    EnableStripeZeroDecimalCurrency: 'enable_stripe_zero_decimal_currency',
    EnableEntraSsoAuthenticationProvider: 'enable_entra_sso_authentication_provider',
    EnableUsingMostUniqueIdColumnsForReports: 'enable_using_most_unique_id_columns_for_reports',
    EnableSalesforceReportCalculatedIdColumn: 'enable_salesforce_report_calculated_id_column',
    EnableSalesforceReportRelaxedCalculatedIdColumn: 'enable_salesforce_report_relaxed_calculated_id_column',
    EnableSalesforceReportColumnLimitTruncation: 'enable_salesforce_report_column_limit_truncation',
    EnableSalesforceReportLongTextEnrichment: 'enable_salesforce_report_long_text_enrichment',
    EnableSalesforceReportSkipUnsafeFilterLogic: 'enable_salesforce_report_skip_unsafe_filter_logic',
    EnableSalesforceReportAdaptiveKeysetColumn: 'enable_salesforce_report_adaptive_keyset_column',
    DisableExcelImportHeaderFormulaRefresh: 'disable_excel_import_header_formula_refresh',
    DisableExcelApplySuspend: 'disable_excel_apply_suspend',
    EnableHubspotFiltersRevamp: 'enable_hubspot_filters_revamp',
    EnableNetsuiteAfterCutoffDate: 'enable_netsuite_after_cutoff_date',
    EnableDeepBuilder: 'enable_deep_builder',
    EnableLogFetchPreviewResponse: 'enable_log_fetch_preview_response',
    EnableNetsuiteAgentSavedSearchSequencing: 'enable_netsuite_agent_saved_search_sequencing',
    EnableSsoResponseModeOverride: 'enable_sso_response_mode_override',
    EnableBigqueryWritebackDynamicBatchSize: 'enable_bigquery_writeback_dynamic_batch_size',
    EnableStreamingWriteback: 'enable_streaming_writeback',
    EnableBulkPropsCache: 'enable_bulk_props_cache',
    EnableSheetContextVersionPrune: 'enable_sheet_context_version_prune',
    EnableDataSourceBorrowingDebugLogs: 'enable_data_source_borrowing_debug_logs',
    EnableSharingLocalExcelImports: 'enable_sharing_local_excel_imports',
    EnableLookerNativePivot: 'enable_looker_native_pivot',
    EnableLookerMergeQuery: 'enable_looker_merge_query',
    EnableSqlPivotPreviewLoadOnDemand: 'enable_sql_pivot_preview_load_on_demand',
    EnablePivotValuesBeforeColumns: 'enable_pivot_values_before_columns',
    EnablePaginationContinuation: 'enable_pagination_continuation',
    EnableAutoRefreshForWebDashboard: 'enable_auto_refresh_for_web_dashboard',
    EnableWebDashboardAutofix: 'enable_web_dashboard_autofix',
    EnableCuratedAiConnectors: 'enable_curated_ai_connectors',
    EnableExcelContextSyncPerInstruction: 'enable_excel_context_sync_per_instruction',
    EnableExcelImportApplyDebugSnapshot: 'enable_excel_import_apply_debug_snapshot',
    EnableExcelInsertColumnVerify: 'enable_excel_insert_column_verify',
    EnableExcelBoundedSheetCreate: 'enable_excel_bounded_sheet_create',
    EnableSlackUnfurlWebDashboard: 'enable_slack_unfurl_web_dashboard',
    EnableWeeklyEmailPreFiltering: 'enable_weekly_email_pre_filtering',
    EnableDemoAccountScheduleExpiry: 'enable_demo_account_schedule_expiry',
    EnablePipedriveV2Upgrade: 'enable_pipedrive_v2_upgrade',
    EnableLeadGenEnrichAgent: 'enable_lead_gen_enrich_agent',
    EnableSnowflakeSemanticView: 'enable_snowflake_semantic_view',
    EnableSmartAlertsAgent: 'enable_smart_alerts_agent',
    EnableSmartAlertSunburstMedium: 'enable_smart_alert_sunburst_medium',
    EnableAiUsageMetering: 'enable_ai_usage_metering',
    EnableFeatureGateEncounters: 'enable_feature_gate_encounters',
    EnableAiUsageLimits: 'enable_ai_usage_limits',
    EnableSmartAlertSchemaReuse: 'enable_smart_alert_schema_reuse',
    EnableSmartAlertRawTabs: 'enable_smart_alert_raw_tabs',
    CoefficientInternalUsers: 'coefficient_internal_users',
    EnableAiConnectorDefaultForNewUsers: 'enable_ai_connector_default_for_new_users',
    EnableNetsuiteAgentForGmailUsers: 'enable_netsuite_agent_for_gmail_users',
    EnableMsTeamsDeliveryForRegularAlerts: 'enable_ms_teams_delivery_for_regular_alerts',
    EnableSentryLogging: 'enable_sentry_logging',
    EnableBothAiAndNonAiConnectorVersions: 'enable_both_ai_and_non_ai_connector_versions',
    EnableQuickstartRedirectToAppListing: 'enable_quickstart_redirect_to_app_listing',
    EnableFullCeleryDueScheduledRuns: 'enable_full_celery_due_scheduled_runs',
    EnableFullCeleryAlertClockTrigger: 'enable_full_celery_alert_clock_trigger',
    EnableNetsuiteFilterReadV2: 'enable_netsuite_filter_read_v2',
    EnableSkipNetsuiteCrxFilterReset: 'enable_skip_netsuite_crx_filter_reset',
    EnableNetsuiteCrxFilterFormulas: 'enable_netsuite_crx_filter_formulas',
    EnableSqlImportDetailsV2: 'enable_sql_import_details_v2',
    EnableLookerImportDetailsV2: 'enable_looker_import_details_v2',
    EnableLegacyAlertUi: 'enable_legacy_alert_ui',
    EnableSmartAlertsAgentExcel: 'enable_smart_alerts_agent_excel',
    EnableWebDashboardTrial: 'enable_web_dashboard_trial',
    EnableSaScopeTriage: 'enable_sa_scope_triage',
    EnableSaImportContext: 'enable_sa_import_context',
    EnableDashboardImportContext: 'enable_dashboard_import_context',
    EnableWebDashboardUserMemory: 'enable_web_dashboard_user_memory',
    EnableSaSpreadsheetMemory: 'enable_sa_spreadsheet_memory',
    EnableSaFormulaValidation: 'enable_sa_formula_validation',
    EnableSaThreadCompaction: 'enable_sa_thread_compaction',
    EnableSaStructuredConditionalFormat: 'enable_sa_structured_conditional_format',
    EnableWebDashboardCustomThemeCreation: 'enable_web_dashboard_custom_theme_creation',
    EnableDashboardLogoUploadByAdmin: 'enable_dashboard_logo_upload_by_admin',
    EnablePivotEmptyRowsSuppression: 'enable_pivot_empty_rows_suppression',
    DisablePipedriveV2PersonsLookup: 'disable_pipedrive_v2_persons_lookup',
    EnableNetsuiteAgentReportMetadataRows: 'enable_netsuite_agent_report_metadata_rows',
    EnableQuickbooksProjects: 'enable_quickbooks_projects',
    EnableViewAsFilter: 'enable_view_as_filter',
    EnableBigqueryRefreshTokenPersistence: 'enable_bigquery_refresh_token_persistence',
    EnableBigqueryPerDatasetTableListing: 'enable_bigquery_per_dataset_table_listing',
    EnableStaticUrlInReauthNotification: 'enable_static_url_in_reauth_notification',
    DisableAllAiFeatures: 'disable_all_ai_features',
    EnableQuickbooksBalanceSheetDetailsReport: 'enable_quickbooks_balance_sheet_details_report',
    EnableQuickbooksBudgetsVsActualsReport: 'enable_quickbooks_budgets_vs_actuals_report',
    EnableQuickbooksBvaActualsIdMatch: 'enable_quickbooks_bva_actuals_id_match',
    EnableQuickbooksCompareRowAlignment: 'enable_quickbooks_compare_row_alignment',
    EnableQuickbooksSalesByCustomerModernViewReport: 'enable_quickbooks_sales_by_customer_modern_view_report',
    EnableSfWritebackMappingIdAsString: 'enable_sf_writeback_mapping_id_as_string',
    EnableSalesforcePkce: 'enable_salesforce_pkce',
    EnableSalesforceLockedTokenRefresh: 'enable_salesforce_locked_token_refresh',
    EnableSalesforceSkipExpiredRefreshToken: 'enable_salesforce_skip_expired_refresh_token',
    EnableSalesforceProactiveTokenRefresh: 'enable_salesforce_proactive_token_refresh',
    EnableSkipExpiredRefreshToAll: 'enable_skip_expired_refresh_to_all',
    EnableSalesforceReportForceRestApiToAll: 'enable_salesforce_report_force_rest_api_to_all',
    EnableSalesforceRestGroupedReportReconstruction: 'enable_salesforce_rest_grouped_report_reconstruction',
    EnableSuperadminDashboardRestore: 'enable_superadmin_dashboard_restore',
    EnableWebDashboardTrialAdminOverrides: 'enable_web_dashboard_trial_admin_overrides',
    EnableSubscriptionWebDashboardLimit: 'enable_subscription_web_dashboard_limit',
    EnableSelfServeAiDashboards: 'enable_self_serve_ai_dashboards',
    DisableAiDashboardsOpenSalesDealCheck: 'disable_ai_dashboards_open_sales_deal_check',
    EnableWritebackConnectorRestrictions: 'enable_writeback_connector_restrictions',
    EnableFreeDomainEnforcementAdmin: 'enable_free_domain_enforcement_admin',
    EnableBillingMembersRedesign: 'enable_billing_members_redesign',
    EnableWebDashboardSuperAdminRequest: 'enable_web_dashboard_super_admin_request',
    EnableDashboardCoralDuskDefaultExperiment: 'enable_dashboard_coral_dusk_default_experiment',
    EnableCustomApiClientBasedPagination: 'enable_custom_api_client_based_pagination',
    EnableWritebackTemplates: 'enable_writeback_templates'
};
exports.FeatureGateId = {
    RefreshLimit: 'refresh_limit',
    Schedules: 'schedules',
    PremiumConnector: 'premium_connector',
    UnlicensedUser: 'unlicensed_user',
    DataSourceConnectionLimit: 'data_source_connection_limit',
    FreeTrialExpired: 'free_trial_expired',
    AiUsage: 'ai_usage',
    DisableAllAiFeatures: 'disable_all_ai_features'
};
exports.FilterClauseOperand = {
    And: 'and',
    Or: 'or'
};
exports.FilterGroupType = {
    Number: 'number',
    Text: 'text',
    Date: 'date',
    Boolean: 'boolean',
    Picklist: 'picklist',
    Multipicklist: 'multipicklist',
    Location: 'location'
};
exports.FilterOperandType = {
    Number: 'number',
    Text: 'text',
    Date: 'date',
    Boolean: 'boolean',
    Location: 'location',
    CellRefA1: 'cell_ref_a1'
};
exports.FilterOperatorType = {
    NumberEq: 'number_eq',
    NumberNe: 'number_ne',
    NumberLt: 'number_lt',
    NumberLte: 'number_lte',
    NumberGt: 'number_gt',
    NumberGte: 'number_gte',
    NumberIsEmpty: 'number_is_empty',
    NumberIsNotEmpty: 'number_is_not_empty',
    NumberIsOneOf: 'number_is_one_of',
    NumberIsNotOneOf: 'number_is_not_one_of',
    NumberIsBetween: 'number_is_between',
    NumberIsNotBetween: 'number_is_not_between',
    NumberMatchesAdvanced: 'number_matches_advanced',
    NumberIsNull: 'number_is_null',
    NumberIsNotNull: 'number_is_not_null',
    TextIsNotEmpty: 'text_is_not_empty',
    TextIsEmpty: 'text_is_empty',
    TextContains: 'text_contains',
    TextIsExactly: 'text_is_exactly',
    TextIsNotExactly: 'text_is_not_exactly',
    TextDoesNotContain: 'text_does_not_contain',
    TextIsOneOf: 'text_is_one_of',
    TextIsNotOneOf: 'text_is_not_one_of',
    TextStartsWith: 'text_starts_with',
    TextDoesNotStartsWith: 'text_does_not_starts_with',
    TextEndsWith: 'text_ends_with',
    TextDoesNotEndsWith: 'text_does_not_ends_with',
    TextIsBlank: 'text_is_blank',
    TextIsNotBlank: 'text_is_not_blank',
    TextMatchesAdvanced: 'text_matches_advanced',
    TextIsNull: 'text_is_null',
    TextIsNotNull: 'text_is_not_null',
    TextIsAnyvalue: 'text_is_anyvalue',
    DateIs: 'date_is',
    DateIsWithin: 'date_is_within',
    DateIsBefore: 'date_is_before',
    DateIsAfter: 'date_is_after',
    DateIsOnOrBefore: 'date_is_on_or_before',
    DateIsOnOrAfter: 'date_is_on_or_after',
    DateIsEmpty: 'date_is_empty',
    DateIsNotEmpty: 'date_is_not_empty',
    DateIsAnytime: 'date_is_anytime',
    DateMatchesAdvanced: 'date_matches_advanced',
    DateIsNull: 'date_is_null',
    DateIsNotNull: 'date_is_not_null',
    DateIsInTheLast: 'date_is_in_the_last',
    DateIsOnTheDay: 'date_is_on_the_day',
    DateIsInTheYear: 'date_is_in_the_year',
    DateIsInTheMonth: 'date_is_in_the_month',
    DateIsThis: 'date_is_this',
    DateIsNext: 'date_is_next',
    DateIsPrevious: 'date_is_previous',
    BooleanIsTrue: 'boolean_is_true',
    BooleanIsFalse: 'boolean_is_false',
    BooleanIsEmpty: 'boolean_is_empty',
    BooleanIsNotEmpty: 'boolean_is_not_empty',
    BooleanIsAnyValue: 'boolean_is_any_value',
    PicklistIsOneOf: 'picklist_is_one_of',
    PicklistIsNotOneOf: 'picklist_is_not_one_of',
    PicklistIsEmpty: 'picklist_is_empty',
    PicklistIsNotEmpty: 'picklist_is_not_empty',
    PicklistIsEqualTo: 'picklist_is_equal_to',
    PicklistIsAnyValue: 'picklist_is_any_value',
    MultipicklistHasAnyOneOf: 'multipicklist_has_any_one_of',
    MultipicklistDoesNotHaveAnyOf: 'multipicklist_does_not_have_any_of',
    MultipicklistIsEmpty: 'multipicklist_is_empty',
    MultipicklistIsNotEmpty: 'multipicklist_is_not_empty',
    LocationIsAnywhere: 'location_is_anywhere',
    LocationIsNull: 'location_is_null',
    LocationIsNotNull: 'location_is_not_null',
    LocationIsExactly: 'location_is_exactly',
    LocationIsInTheBox: 'location_is_in_the_box',
    LocationIsInTheCircle: 'location_is_in_the_circle',
    LocationMatchesAdvanced: 'location_matches_advanced'
};
exports.FlatColumnType = {
    JsonDump: 'json_dump',
    SplitToRows: 'split_to_rows',
    CommaSeparated: 'comma_separated'
};
exports.FormulaFunctionName = {
    HubspotLookup: 'hubspot_lookup',
    HubspotSearch: 'hubspot_search',
    SalesforceReport: 'salesforce_report',
    SqlQuery: 'sql_query',
    SalesforceLookup: 'salesforce_lookup',
    SalesforceSearch: 'salesforce_search',
    SalesforceReportLookup: 'salesforce_report_lookup'
};
exports.FormulaImportStatusLevel = {
    Warning: 'warning',
    Error: 'error',
    Ok: 'ok'
};
exports.GPTBuilderType = {
    Chart: 'chart',
    Formula: 'formula',
    Pivot: 'pivot',
    Sql: 'sql'
};
exports.GPTFunctionName = {
    Gpt: 'gpt',
    GptList: 'gpt_list',
    GptFill: 'gpt_fill',
    GptEdit: 'gpt_edit',
    GptTag: 'gpt_tag',
    GptClassify: 'gpt_classify',
    GptExtract: 'gpt_extract',
    GptSummarize: 'gpt_summarize',
    GptTranslate: 'gpt_translate',
    GptConvert: 'gpt_convert',
    GptCode: 'gpt_code',
    GptTable: 'gpt_table',
    GptMap: 'gpt_map',
    GptFormat: 'gpt_format'
};
exports.GSheetOAuthTokenStatus = {
    NotRequired: 'oauth_token_not_required',
    Required: 'oauth_token_required',
    Rejected: 'oauth_token_rejected',
    MigrationRequired: 'oauth_token_migration_required',
    Present: 'oauth_token_present',
    IsMissing: 'oauth_token_is_missing'
};
exports.GateEncounterSurface = {
    SheetsSidebar: 'sheets_sidebar',
    RefreshClick: 'refresh_click',
    Modal: 'modal',
    SchedulesPanel: 'schedules_panel',
    ImportRun: 'import_run',
    ScheduledRun: 'scheduled_run',
    EditImport: 'edit_import',
    SourcePicker: 'source_picker',
    SheetAssistant: 'sheet_assistant',
    SmartAlerts: 'smart_alerts',
    System: 'system',
    Unknown: 'unknown'
};
exports.GatedFeature = {
    HourlyRefresh: 'hourly_refresh',
    ScheduledImports: 'scheduled_imports',
    SharedDataSources: 'shared_data_sources',
    SharedDataImports: 'shared_data_imports',
    SlackEmailAlerts: 'slack_email_alerts',
    DynamicAlerts: 'dynamic_alerts',
    UnlimitedImportRowLimit: 'unlimited_import_row_limit',
    UnlimitedWriteback: 'unlimited_writeback',
    AutomatedWriteback: 'automated_writeback',
    ScheduledSnapshots: 'scheduled_snapshots',
    LegacyFeatures: 'legacy_features',
    EnablePremiumConnectors: 'enable_premium_connectors',
    UnlimitedQuickbookConnections: 'unlimited_quickbook_connections'
};
exports.GenericScraperParserType = {
    Html2text: 'html2text',
    MathewPythonMarkdownify: 'mathew_python_markdownify',
    PostlightParser: 'postlight_parser',
    KaufmannHtmkToMarkdown: 'kaufmann_htmk_to_markdown'
};
exports.GmailActionType = {
    GetLabels: 'get_labels',
    QueryEmails: 'query_emails',
    SelectEmail: 'select_email',
    InitChat: 'init_chat',
    NewChatMessage: 'new_chat_message',
    GetSummaryPrompt: 'get_summary_prompt',
    SelectAttachment: 'select_attachment'
};
exports.GmailImportType = {
    Emails: 'emails',
    BasicAttachment: 'basic_attachment'
};
exports.GoogleSheetsCellValueType = {
    Number: 'number',
    Boolean: 'boolean',
    String: 'string',
    Date: 'date',
    RangeNotFound: 'range_not_found'
};
exports.HubspotObjectTypeFieldType = {
    Date: 'date',
    Datetime: 'datetime',
    Enumeration: 'enumeration',
    Number: 'number',
    String: 'string',
    Bool: 'bool',
    Association: 'association'
};
exports.IdentityProvider = {
    Okta: 'okta',
    Duo: 'duo',
    Entra: 'entra'
};
exports.InstaAudienceDemographicMetrics = {
    EngagedAudienceDemographics: 'engaged_audience_demographics',
    ReachedAudienceDemographics: 'reached_audience_demographics',
    FollowerDemographics: 'follower_demographics'
};
exports.InstaDemographicMetricBreakdown = {
    Age: 'age',
    City: 'city',
    Country: 'country',
    Gender: 'gender'
};
exports.InstaFetchMode = {
    FromScratch: 'from_scratch'
};
exports.InstaInsightOptions = {
    PageEngagement: 'page_engagement',
    ContentEngagement: 'content_engagement',
    DemographicInsights: 'demographic_insights',
    BasicProfileDetails: 'basic_profile_details'
};
exports.InstaTimeframes = {
    Last14Days: 'last_14_days',
    Last30Days: 'last_30_days',
    Last90Days: 'last_90_days',
    PrevMonth: 'prev_month',
    ThisMonth: 'this_month',
    ThisWeek: 'this_week'
};
exports.LeadgenRunStatus = {
    Queued: 'queued',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled'
};
exports.LicenseRequestGateType = {
    PremiumConnector: 'premium_connector',
    General: 'general',
    RunLimit: 'run_limit'
};
exports.LookerConnectionEmailTriggerOptions = {
    OauthConnCreated: 'oauth_conn_created',
    ClientSecretConnCreated: 'client_secret_conn_created',
    UrlCopied: 'url_copied'
};
exports.LookerFetchMode = {
    Objects: 'objects',
    ExploreUrl: 'explore_url',
    Looks: 'looks'
};
exports.MergedCellValueOption = {
    CopyAcrossRows: 'copy_across_rows',
    CopyAcrossColumns: 'copy_across_columns',
    CopyAcrossRowsAndColumns: 'copy_across_rows_and_columns',
    KeepOriginalSparsity: 'keep_original_sparsity'
};
exports.MeterLimitEnforcementType = {
    Strict: 'strict',
    NotEnforced: 'not_enforced',
    NotApplicable: 'not_applicable'
};
exports.MeterLimitInterval = {
    Monthly: 'monthly',
    Forever: 'forever'
};
exports.MeterType = {
    GptApiCalls: 'gpt_api_calls',
    DataImportRuns: 'data_import_runs',
    AiUsageCost: 'ai_usage_cost'
};
exports.MicrosoftAdsReports = {
    AccountPerformanceReport: 'AccountPerformanceReport',
    AdDynamicTextPerformanceReport: 'AdDynamicTextPerformanceReport',
    AdExtensionByAdReport: 'AdExtensionByAdReport',
    AdExtensionByKeywordReport: 'AdExtensionByKeywordReport',
    AdExtensionDetailReport: 'AdExtensionDetailReport',
    AdGroupPerformanceReport: 'AdGroupPerformanceReport',
    AdPerformanceReport: 'AdPerformanceReport',
    AgeGenderAudienceReport: 'AgeGenderAudienceReport',
    AudiencePerformanceReport: 'AudiencePerformanceReport',
    BudgetSummaryReport: 'BudgetSummaryReport',
    CallDetailReport: 'CallDetailReport',
    CampaignPerformanceReport: 'CampaignPerformanceReport',
    ConversionPerformanceReport: 'ConversionPerformanceReport',
    DsaAutoTargetPerformanceReport: 'DSAAutoTargetPerformanceReport',
    DsaCategoryPerformanceReport: 'DSACategoryPerformanceReport',
    DsaSearchQueryPerformanceReport: 'DSASearchQueryPerformanceReport',
    DestinationUrlPerformanceReport: 'DestinationUrlPerformanceReport',
    GeographicPerformanceReport: 'GeographicPerformanceReport',
    GoalsAndFunnelsReport: 'GoalsAndFunnelsReport',
    HotelDimensionPerformanceReport: 'HotelDimensionPerformanceReport',
    HotelGroupPerformanceReport: 'HotelGroupPerformanceReport',
    KeywordPerformanceReport: 'KeywordPerformanceReport',
    NegativeKeywordConflictReport: 'NegativeKeywordConflictReport',
    ProductDimensionPerformanceReport: 'ProductDimensionPerformanceReport',
    ProductMatchCountReport: 'ProductMatchCountReport',
    ProductNegativeKeywordConflictReport: 'ProductNegativeKeywordConflictReport',
    ProductPartitionPerformanceReport: 'ProductPartitionPerformanceReport',
    ProductPartitionUnitPerformanceReport: 'ProductPartitionUnitPerformanceReport',
    ProductSearchQueryPerformanceReport: 'ProductSearchQueryPerformanceReport',
    ProfessionalDemographicsAudienceReport: 'ProfessionalDemographicsAudienceReport',
    PublisherUsagePerformanceReport: 'PublisherUsagePerformanceReport',
    SearchCampaignChangeHistoryReport: 'SearchCampaignChangeHistoryReport',
    SearchQueryPerformanceReport: 'SearchQueryPerformanceReport',
    ShareOfVoiceReport: 'ShareOfVoiceReport',
    UserLocationPerformanceReport: 'UserLocationPerformanceReport'
};
exports.NOSQLColumnDataType = {
    Boolean: 'boolean',
    Int: 'int',
    Float: 'float',
    Datetime: 'datetime',
    Text: 'text'
};
exports.NetSuiteFetchMode = {
    Datasets: 'datasets',
    Records: 'records',
    SavedSearches: 'saved_searches',
    SuiteqlQuery: 'suiteql_query',
    Workbooks: 'workbooks',
    Reports: 'reports'
};
exports.NetsuiteFeatureAccessType = {
    NUMBER_MINUS_1: -1,
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
};
exports.NumberFilterType = {
    Inclusive: '[inclusive]',
    Exclusive: '(exclusive)',
    RightExclusive: '[right-exclusive)',
    LeftExclusive: '(left-exclusive]'
};
exports.NumberFormat = {
    General: 'general',
    Number: 'number',
    Currency: 'currency',
    Accounting: 'accounting',
    Date: 'date',
    Time: 'time',
    Percentage: 'percentage',
    Fraction: 'fraction',
    Scientific: 'scientific',
    Text: 'text',
    Special: 'special',
    Custom: 'custom'
};
exports.OauthAttemptStatus = {
    InProgress: 'in_progress',
    Success: 'success',
    Failure: 'failure'
};
exports.OpenaiRunStatus = {
    Started: 'started',
    Queued: 'queued',
    InProgress: 'in_progress',
    Completed: 'completed',
    Failed: 'failed',
    Cancelled: 'cancelled',
    Canceling: 'canceling',
    RequiresAction: 'requires_action',
    Incomplete: 'incomplete'
};
exports.PBDashBlueprintID = {
    SalesFunnelTest1: 'sales_funnel_test_1',
    SalesRepScorecardTest2: 'sales_rep_scorecard_test_2',
    SalesFunnel: 'sales_funnel',
    DatabricksPilot: 'databricks_pilot'
};
exports.PPressFormMode = {
    Create: 'create',
    Update: 'update'
};
exports.ParameterizedCellRefType = {
    RefA1: 'ref_a1',
    NamedRange: 'named_range'
};
exports.PivotDimensionBucketingType = {
    Identity: 'identity',
    Day: 'day',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year'
};
exports.PivotValueAggregationType = {
    Sum: 'sum',
    Count: 'count',
    Countunique: 'countunique',
    Average: 'average',
    Max: 'max',
    Min: 'min'
};
exports.PreviewAutoRefreshMode = {
    SupportedAndDefaultOn: 'supported_and_default_on',
    SupportedButDefaultOff: 'supported_but_default_off',
    NotSupported: 'not_supported'
};
exports.QuickbooksFetchMode = {
    Report: 'report',
    Object: 'object',
    RawQuery: 'raw_query'
};
exports.QuickbooksObjects = {
    Account: 'Account',
    Attachable: 'Attachable',
    Bill: 'Bill',
    BillPayment: 'Bill Payment',
    Budget: 'Budget',
    Class: 'Class',
    CompanyCurrency: 'Company Currency',
    CreditCardPayment: 'Credit Card Payment',
    CreditMemo: 'Credit Memo',
    Customer: 'Customer',
    Department: 'Department',
    Deposit: 'Deposit',
    Employee: 'Employee',
    Estimate: 'Estimate',
    Invoice: 'Invoice',
    Item: 'Item',
    JournalEntry: 'Journal Entry',
    Payment: 'Payment',
    PaymentMethod: 'Payment Method',
    Project: 'Project',
    Purchase: 'Purchase',
    PurchaseOrder: 'Purchase Order',
    RefundReceipt: 'Refund Receipt',
    ReimburseCharge: 'Reimburse Charge',
    SalesReceipt: 'Sales Receipt',
    TaxAgency: 'Tax Agency',
    TaxCode: 'Tax Code',
    TaxRate: 'Tax Rate',
    Term: 'Term',
    TimeActivity: 'Time Activity',
    Transfer: 'Transfer',
    Vendor: 'Vendor',
    VendorCredit: 'Vendor Credit'
};
exports.QuickbooksReports = {
    AccountListDetail: 'Account List Detail',
    APAgingDetail: 'A/P Aging Detail',
    APAgingSummary: 'A/P Aging Summary',
    ARAgingDetail: 'A/R Aging Detail',
    ARAgingSummary: 'A/R Aging Summary',
    BalanceSheet: 'Balance Sheet',
    BalanceSheetDetail: 'Balance Sheet Detail',
    BudgetsVsActuals: 'Budgets vs Actuals',
    CashFlow: 'Cash Flow',
    CustomerBalance: 'Customer Balance',
    CustomerBalanceDetail: 'Customer Balance Detail',
    CustomerIncome: 'Customer Income',
    GeneralLedger: 'General Ledger',
    InventoryValuationDetail: 'Inventory Valuation Detail',
    InventoryValuationSummary: 'Inventory Valuation Summary',
    JournalReport: 'Journal Report',
    ProfitAndLoss: 'Profit And Loss',
    ProfitAndLossDetail: 'Profit And Loss Detail',
    SalesByClassSummary: 'Sales By Class Summary',
    SalesByCustomer: 'Sales By Customer',
    SalesByCustomerModernView: 'Sales By Customer (Modern View)',
    SalesByDepartment: 'Sales By Department',
    SalesByProduct: 'Sales By Product',
    TransactionList: 'Transaction List',
    TransactionListByCustomer: 'Transaction List By Customer',
    TransactionListByDate: 'Transaction List By Date',
    TransactionListByVendor: 'Transaction List By Vendor',
    TransactionListWithSplits: 'Transaction List With Splits',
    TrialBalance: 'Trial Balance',
    VendorBalance: 'Vendor Balance',
    VendorBalanceDetail: 'Vendor Balance Detail',
    VendorExpenses: 'Vendor Expenses',
    RawQuery: 'Raw Query'
};
exports.QuickstartRedirectType = {
    QuickstartSpreadsheet: 'quickstart_spreadsheet',
    AppListing: 'app_listing'
};
exports.QuickstartVariantType = {
    ColdProspect1: 'cold_prospect_1',
    ShopifyAppStore: 'shopify_app_store'
};
exports.QuiverFetchMode = {
    View: 'view'
};
exports.RestrictedFieldOptions = {
    IncludeAllFields: 'include_all_fields',
    RedactRestrictedFields: 'redact_restricted_fields'
};
exports.RilletFetchMode = {
    Object: 'object',
    Report: 'report'
};
exports.SQLColumnDataType = {
    Boolean: 'boolean',
    Int: 'int',
    Float: 'float',
    Datetime: 'datetime',
    Text: 'text'
};
exports.SSOAuthorizationURLResponseMode = {
    FormPost: 'form_post',
    Query: 'query'
};
exports.SageFetchMode = {
    Records: 'records',
    CustomReports: 'custom_reports',
    StandardReports: 'standard_reports',
    FinancialReports: 'financial_reports'
};
exports.SalesforceCustomFetchType = {
    Funnel: 'opportunity_funnel',
    History: 'opportunity_history',
    StageTransition: 'opportunity_stage_transition'
};
exports.SalesforceFetchMode = {
    Reports: 'reports',
    Objects: 'objects',
    SoqlQuery: 'soql_query',
    Custom: 'custom'
};
exports.SalesforceObjectTypeFieldType = {
    Address: 'address',
    AnyType: 'anyType',
    Base64: 'base64',
    Boolean: 'boolean',
    Combobox: 'combobox',
    Complexvalue: 'complexvalue',
    Currency: 'currency',
    Date: 'date',
    Datetime: 'datetime',
    Double: 'double',
    Email: 'email',
    Id: 'id',
    Int: 'int',
    Multipicklist: 'multipicklist',
    Percent: 'percent',
    Phone: 'phone',
    Picklist: 'picklist',
    Reference: 'reference',
    String: 'string',
    Textarea: 'textarea',
    Time: 'time',
    Url: 'url'
};
exports.SalesforceReportRenderType = {
    DetailRows: 'detail_rows',
    RetainFormat: 'retain_format'
};
exports.SalesforceReportType = {
    DetailReport: 'detail_report',
    AggregateReport: 'aggregate_report',
    JoinedReport: 'joined_report'
};
exports.SaveMemoryDecisionType = {
    Confirm: 'confirm',
    Reject: 'reject'
};
exports.SchemaFetchErrorStatus = {
    FailedForUnknownReason: 'failed_for_unknown_reason',
    SharedConnectionNotSupported: 'shared_connection_not_supported'
};
exports.SignupAttributionClaimTrigger = {
    SignupLaunch: 'signup_launch',
    FirstCoreImport: 'first_core_import'
};
exports.SignupSourceType = {
    Quickstart: 'quickstart',
    OnsheetButton: 'onsheet_button',
    Template: 'template',
    WebDashboard: 'web_dashboard'
};
exports.SmartAlertContentBlockType = {
    TableScreenshot: 'table_screenshot',
    ChartImage: 'chart_image',
    AiImage: 'ai_image',
    Text: 'text'
};
exports.SmartAlertEditAccessType = {
    AlertOwner: 'alert_owner',
    SameDomain: 'same_domain',
    Anyone: 'anyone'
};
exports.SmartAlertThreadSource = {
    Create: 'create',
    Preview: 'preview',
    Edit: 'edit'
};
exports.SnapshotAppendType = {
    AppendDown: 'Append down',
    AppendToTheRight: 'Append to the right',
    ReplaceAtStartingCell: 'Replace at starting cell'
};
exports.SnapshotComponentType = {
    SourceInfo: 'source_info',
    DestinationInfo: 'destination_info',
    Schedule: 'schedule',
    Retention: 'retention',
    Setting: 'setting',
    SnapshotName: 'snapshot_name'
};
exports.SnapshotRunStatus = {
    Success: 'success',
    Failed: 'failed',
    Paused: 'paused'
};
exports.SnapshotType = {
    EntireTab: 'Entire tab',
    SpecificRange: 'Specific range'
};
exports.SnowflakeKeypairOrigin = {
    CoeffGenerated: 'coeff_generated',
    UserUploaded: 'user_uploaded'
};
exports.SortType = {
    Asc: 'asc',
    Desc: 'desc'
};
exports.SourceType = {
    Gsheets: 'gsheets',
    Excel: 'excel'
};
exports.SpreadsheetColumnBehavior = {
    DontTouch: 'dont_touch',
    AutoFillDown: 'auto_fill_down'
};
exports.SpreadsheetShareOptions = {
    DontShare: 'dont_share',
    Viewer: 'viewer',
    Editor: 'editor'
};
exports.SubscriptionBillingInterval = {
    Monthly: 'monthly',
    Annually: 'annually'
};
exports.SubscriptionCancellationReason = {
    NoLongerNeed: 'no_longer_need',
    TooExpensive: 'too_expensive',
    MissingFeatures: 'missing_features',
    UsingAnotherTool: 'using_another_tool',
    AiToolsReplacedCoefficient: 'ai_tools_replaced_coefficient',
    Other: 'other'
};
exports.SubscriptionCheckoutMode = {
    SelfServe: 'self_serve',
    ContactUs: 'contact_us'
};
exports.SubscriptionInvoiceStatus = {
    Paid: 'paid',
    Posted: 'posted',
    PaymentDue: 'payment_due',
    NotPaid: 'not_paid',
    Voided: 'voided',
    Pending: 'pending'
};
exports.SubscriptionItemType = {
    Plan: 'plan',
    Addon: 'addon'
};
exports.SubscriptionPlanType = {
    NewUser: 'new_user',
    FreeTrial: 'free_trial',
    LifetimeFree: 'lifetime_free',
    Starter: 'starter',
    Plus: 'plus',
    Pro: 'pro',
    Custom: 'custom',
    Enterprise: 'enterprise'
};
exports.SubscriptionScheduledChangeType = {
    CancelSubscription: 'cancel_subscription',
    DowngradeToStarter: 'downgrade_to_starter',
    DowngradeToMonthlyBilling: 'downgrade_to_monthly_billing',
    DowngradeNumLicenses: 'downgrade_num_licenses'
};
exports.SubscriptionUpdateType = {
    Reassignment: 'reassignment',
    ModifySubscription: 'modify_subscription',
    ChangePaymentInfo: 'change_payment_info',
    CancelSubscription: 'cancel_subscription',
    ChangePayer: 'change_payer',
    ChangeDataSources: 'change_data_sources',
    AddPlanManager: 'add_plan_manager',
    RemovePlanManager: 'remove_plan_manager',
    UpdateBillingAddress: 'update_billing_address',
    UpdateAdditionalBillingContacts: 'update_additional_billing_contacts',
    AddUser: 'add_user',
    RemoveUser: 'remove_user',
    UndoCancellation: 'undo_cancellation',
    AddWebDashboardAddon: 'add_web_dashboard_addon',
    RemoveWebDashboardAddon: 'remove_web_dashboard_addon',
    RemoveScheduledChanges: 'remove_scheduled_changes'
};
exports.SupportEmailType = {
    AlertTryoutSlackTroubleConnecting: 'alert_tryout_slack_trouble_connecting',
    RatingPopupFeedback: 'rating_popup_feedback',
    BillingQuery: 'billing_query',
    WritebackIntegrationRequest: 'writeback_integration_request',
    ImportIntegrationRequest: 'import_integration_request',
    FeatureWaitlistJoined: 'feature_waitlist_joined',
    WebDashboardThemeRequest: 'web_dashboard_theme_request',
    WebDashboardSupportFeedback: 'web_dashboard_support_feedback'
};
exports.TableauConnectedAppTrustType = {
    OauthTrust: 'oauth_trust',
    DirectTrust: 'direct_trust'
};
exports.TableauDownloadType = {
    Data: 'tableau_data',
    Crosstab: 'tableau_crosstab'
};
exports.TableauWorksheetFilterType = {
    Multipicklist: 'multipicklist'
};
exports.TableauWorksheetParameterType = {
    Picklist: 'picklist'
};
exports.TableauWorksheetZoneType = {
    Filter: 'filter',
    Parameter: 'parameter'
};
exports.TextType = {
    Header: 'header',
    Body: 'body'
};
exports.TotalRowCountType = {
    Exact: 'exact',
    Approximate: 'approximate',
    AtLeast: 'at_least'
};
exports.TrialStateType = {
    TrialUnlimited: 'trial_unlimited',
    Trial1PreCountdown: 'trial_1_pre_countdown',
    Trial1Countdown: 'trial_1_countdown',
    Trial1Expired: 'trial_1_expired',
    Trial2ExtensionOffer: 'trial_2_extension_offer',
    Trial2PreCountdown: 'trial_2_pre_countdown',
    Trial2Countdown: 'trial_2_countdown',
    Trial2Expired: 'trial_2_expired',
    TrialManualCountdown: 'trial_manual_countdown',
    TrialManualExpired: 'trial_manual_expired',
    TrialDashboardCountdown: 'trial_dashboard_countdown',
    TrialDashboardExpired: 'trial_dashboard_expired',
    TrialExpansionPreCountdown: 'trial_expansion_pre_countdown',
    TrialExpansionCountdown: 'trial_expansion_countdown',
    TrialExpansionExpired: 'trial_expansion_expired',
    Paid: 'paid'
};
exports.UserExtraType = {
    FreeTrial: 'free_trial',
    OnboardingSurveyReply: 'onboarding_survey_reply',
    RatingPopup: 'rating_popup',
    InstallUtmParams: 'install_utm_params',
    UserSettings: 'user_settings',
    InviteCoworkerBanner: 'invite_coworker_banner',
    AlertDiscoveryBanner: 'alert_discovery_banner',
    AffiliateReferralParams: 'affiliate_referral_params',
    CoeffFeMetadata: 'coeff_fe_metadata',
    AlertBannerDismissState: 'alert_banner_dismiss_state',
    OidcSsoTokenInfo: 'oidc_sso_token_info',
    HubspotContactMetadata: 'hubspot_contact_metadata',
    UserDataDeletion: 'user_data_deletion',
    AutoAnalystRunFeedbacks: 'auto_analyst_run_feedbacks',
    LifetimeFreeStrictEnforcement: 'lifetime_free_strict_enforcement',
    SalesforceFeedback: 'salesforce_feedback',
    AgenticWorkflowsWelcome: 'agentic_workflows_welcome',
    BrowserAgentOnboarding: 'browser_agent_onboarding',
    UserMemory: 'user_memory',
    WebDashboardThemePreference: 'web_dashboard_theme_preference'
};
exports.UserRoleType = {
    Admin: 'admin',
    Member: 'member'
};
exports.VCRMode = {
    AuthMode: 'AUTH_MODE',
    ImportMode: 'IMPORT_MODE'
};
exports.VibeDashViewerType = {
    Owner: 'owner',
    Viewer: 'viewer'
};
exports.WebDashboardBuildingPhase = {
    Started: 'started',
    ExploringData: 'exploring_data',
    PlanningLayout: 'planning_layout',
    BuildingDashboard: 'building_dashboard',
    Completed: 'completed',
    Failed: 'failed'
};
exports.WebDashboardEligibility = {
    Eligible: 'eligible',
    EligibleWithPlan: 'eligible_with_plan',
    AlreadyHasAddon: 'already_has_addon',
    DomainHasDashboardPack: 'domain_has_dashboard_pack',
    DomainHasOtherSubscriptions: 'domain_has_other_subscriptions',
    MultiSeat: 'multi_seat',
    SalesManaged: 'sales_managed',
    OpenSalesDeal: 'open_sales_deal',
    SubscriptionNotActive: 'subscription_not_active',
    FeatureDisabled: 'feature_disabled',
    TooManyDashboards: 'too_many_dashboards'
};
exports.WebDashboardImportHealth = {
    Ok: 'ok',
    Erroring: 'erroring'
};
exports.WebDashboardPlanLimitSource = {
    SubscriptionSync: 'subscription_sync',
    ManualOverride: 'manual_override'
};
exports.WebDashboardRefreshType = {
    Manual: 'manual',
    Scheduled: 'scheduled'
};
exports.WebDashboardRunStatus = {
    Queued: 'queued',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed'
};
exports.WebDashboardShareRole = {
    Editor: 'editor',
    Viewer: 'viewer',
    Owner: 'owner',
    NoAccess: 'no_access'
};
exports.WebDashboardSharingLevel = {
    Private: 'private',
    Domain: 'domain',
    Public: 'public'
};
exports.WebDashboardSubscriptionRunStatus = {
    Queued: 'queued',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed',
    Skipped: 'skipped'
};
exports.WebDashboardSubscriptionScope = {
    FullDashboard: 'full_dashboard',
    Blocks: 'blocks'
};
exports.WebDashboardSubscriptionTriggerType = {
    Scheduled: 'scheduled'
};
exports.WebDashboardTrialStateType = {
    TrialUnlimited: 'trial_unlimited',
    TrialCountdown: 'trial_countdown',
    TrialManualCountdown: 'trial_manual_countdown',
    TrialManualExpired: 'trial_manual_expired',
    TrialExpired: 'trial_expired',
    Paid: 'paid',
    Cancelled: 'cancelled'
};
exports.WebDashboardUpdateType = {
    Revert: 'revert'
};
exports.WriteResultsToSheetStatus = {
    FailedForUnknownReason: 'failed_for_unknown_reason',
    SpreadsheetCellLimitExceeded: 'spreadsheet_cell_limit_exceeded'
};
exports.WritebackMappingProblemType = {
    MissingColumn: 'missing_column',
    MappingRule: 'mapping_rule',
    RejectedField: 'rejected_field',
    MissingRequiredField: 'missing_required_field'
};
exports.WritebackMode = {
    Insert: 'insert',
    Update: 'update',
    Upsert: 'upsert',
    InsertWithLineItems: 'insert_with_line_items',
    UpdateWithLineItems: 'update_with_line_items',
    Delete: 'delete',
    Void: 'void',
    AddLineItems: 'add_line_items',
    RemoveLineItems: 'remove_line_items',
    SyncList: 'sync_list',
    AddToList: 'add_to_list',
    RemoveFromList: 'remove_from_list',
    AddAssociatedRecord: 'add_associated_record',
    RemoveAssociatedRecord: 'remove_associated_record'
};
exports.WritebackRunOverallStatusType = {
    Ok: 'ok',
    SomeRecordsFailed: 'some_records_failed',
    AllRecordsFailed: 'all_records_failed',
    DataSourceNeedsReauth: 'data_source_needs_reauth',
    UnknownError: 'unknown_error',
    MappingError: 'mapping_error',
    FreeTrialExpired: 'free_trial_expired',
    SalesforceExceededQuota: 'salesforce_exceeded_quota',
    SalesforceBulkApiNotEnabled: 'salesforce_bulk_api_not_enabled',
    SalesforceGenericError: 'salesforce_generic_error',
    HubspotGenericError: 'hubspot_generic_error',
    HubspotInvalidAssociation: 'hubspot_invalid_association',
    HubspotListNotFound: 'hubspot_list_not_found',
    SpreadsheetFormatError: 'spreadsheet_format_error',
    UnsupportedOperation: 'unsupported_operation',
    DuplicateMappedColumns: 'duplicate_mapped_columns',
    WritebackDisabled: 'writeback_disabled',
    WritebackDisabledForConnector: 'writeback_disabled_for_connector',
    DataSourceDisabledByAdmin: 'data_source_disabled_by_admin',
    SharedConnectionNotSupported: 'shared_connection_not_supported',
    NoSuchTable: 'no_such_table',
    NoSuchDatabase: 'no_such_database',
    TableHasNoId: 'table_has_no_id',
    IdNotMapped: 'id_not_mapped',
    ExternalIdNotMapped: 'external_id_not_mapped',
    FieldPermissionError: 'field_permission_error',
    TargetApiFailed: 'target_api_failed',
    ImportsInProgress: 'imports_in_progress',
    WritebackAlreadyInProgress: 'writeback_already_in_progress',
    WritebackTimedoutInQueue: 'writeback_timedout_in_queue',
    WritebackTimedoutInProgress: 'writeback_timedout_in_progress',
    WritebackTerminated: 'writeback_terminated',
    SpreadsheetNotFound: 'spreadsheet_not_found',
    SpreadsheetTabNotFound: 'spreadsheet_tab_not_found',
    ConnectionError: 'connection_error'
};
exports.WritebackRunStartOption = {
    LegacySyncMode: 'legacy_sync_mode',
    FailIfInProgress: 'fail_if_in_progress'
};
exports.WritebackRunTaskStage = {
    InQueue: 'in_queue',
    InProgress: 'in_progress',
    Done: 'done'
};
exports.WritebackRunTriggerType = {
    Manual: 'manual',
    Scheduled: 'scheduled'
};
exports.WritebackSalesforceApiType = {
    Rest: 'rest',
    Bulk: 'bulk'
};
exports.WritebackScheduleExportType = {
    AllRows: 'all_rows',
    SelectedRows: 'selected_rows'
};
exports.XeroAgingBy = {
    DueDate: 'due_date',
    InvoiceDate: 'invoice_date'
};
exports.XeroAgingGrouping = {
    None: 'none',
    Contact: 'contact',
    DocumentType: 'document_type',
    Total: 'total',
    BillDate: 'bill_date',
    BillReference: 'bill_reference',
    ContactAccountNumber: 'contact_account_number',
    DueDate: 'due_date'
};
exports.XeroFetchMode = {
    Object: 'object',
    Report: 'report'
};
exports.XeroObjects = {
    Invoices: 'Invoices',
    Contacts: 'Contacts',
    Quotes: 'Quotes',
    PurchaseOrders: 'PurchaseOrders',
    BankTransactions: 'BankTransactions',
    BankTransfers: 'BankTransfers',
    Items: 'Items',
    Payments: 'Payments',
    Prepayments: 'Prepayments',
    BatchPayments: 'BatchPayments',
    Accounts: 'Accounts',
    Budgets: 'Budgets',
    Users: 'Users',
    Journals: 'Journals',
    TrackingCategories: 'TrackingCategories'
};
exports.XeroReports = {
    BalanceSheet: 'BalanceSheet',
    ProfitAndLoss: 'ProfitAndLoss',
    TrialBalance: 'TrialBalance',
    BankSummary: 'BankSummary',
    BudgetSummary: 'BudgetSummary',
    GstReport: 'GSTReport',
    AccountsPayableAgingSummary: 'AccountsPayableAgingSummary',
    AccountsPayableAgingDetail: 'AccountsPayableAgingDetail',
    AccountsReceivableAgingSummary: 'AccountsReceivableAgingSummary',
    AccountsReceivableAgingDetail: 'AccountsReceivableAgingDetail'
};
exports.XeroTimeframe = {
    Month: 'MONTH',
    Quarter: 'QUARTER',
    Year: 'YEAR'
};
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        abortWritebackMultipartUpload: function (writeback_id, abort_writeback_multipart_upload_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('abortWritebackMultipartUpload', 'writeback_id', writeback_id);
                    localVarPath = "/api/s3_upload_url/writeback_data/{writeback_id}/multipart/abort"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(abort_writeback_multipart_upload_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        activateSmartAlert: function (activate_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/activate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(activate_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        addAgentCredits: function (add_agent_credits_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent_credits/add";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(add_agent_credits_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        addCouponToDomain: function (domain, add_coupon_to_domain_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('addCouponToDomain', 'domain', domain);
                    localVarPath = "/api/retool/domain/{domain}/coupon"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(add_coupon_to_domain_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminGetAgentThreadMessages: function (thread_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('adminGetAgentThreadMessages', 'thread_id', thread_id);
                    localVarPath = "/api/retool/agent_threads/{thread_id}/messages"
                        .replace("{".concat("thread_id", "}"), encodeURIComponent(String(thread_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminGetSmartAlertRuns: function (smart_alert_id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('adminGetSmartAlertRuns', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/retool/smart_alerts/{smart_alert_id}/runs"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminGetSmartAlertThread: function (smart_alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('adminGetSmartAlertThread', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/retool/smart_alerts/{smart_alert_id}/thread"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminGetThreadAnalysisResults: function (analysis_id, email, domain, agent_type, since, until, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('adminGetThreadAnalysisResults', 'analysis_id', analysis_id);
                    localVarPath = "/api/retool/thread_analyses/{analysis_id}/results"
                        .replace("{".concat("analysis_id", "}"), encodeURIComponent(String(analysis_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (agent_type !== undefined) {
                        localVarQueryParameter['agent_type'] = agent_type;
                    }
                    if (since !== undefined) {
                        localVarQueryParameter['since'] = since;
                    }
                    if (until !== undefined) {
                        localVarQueryParameter['until'] = until;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminListThreadAnalyses: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/thread_analyses";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminSearchSmartAlerts: function (email, smart_alert_id, spreadsheet_id, run_id, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/smart_alerts/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (smart_alert_id !== undefined) {
                        localVarQueryParameter['smart_alert_id'] = smart_alert_id;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (run_id !== undefined) {
                        localVarQueryParameter['run_id'] = run_id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        adminSearchWebDashboards: function (web_dashboard_id, email, domain, spreadsheet_id, exclude_coefficient_io, source_type, build_status, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/web_dashboards/search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (web_dashboard_id !== undefined) {
                        localVarQueryParameter['web_dashboard_id'] = web_dashboard_id;
                    }
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (exclude_coefficient_io !== undefined) {
                        localVarQueryParameter['exclude_coefficient_io'] = exclude_coefficient_io;
                    }
                    if (source_type !== undefined) {
                        localVarQueryParameter['source_type'] = source_type;
                    }
                    if (build_status !== undefined) {
                        localVarQueryParameter['build_status'] = build_status;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertRemoveSlackConnection: function (alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('alertRemoveSlackConnection', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}/remove_slack"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertSlackAuthTest: function (alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('alertSlackAuthTest', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}/slack_auth_test"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertValidateSelectedTableRange: function (alert_validate_selected_table_range_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/validate_selected_table_range";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alert_validate_selected_table_range_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertsClockTrigger: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/clock_trigger";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertsGetRangeScreenshot: function (alerts_get_range_screenshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/get_range_screenshot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alerts_get_range_screenshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertsMonitoredCellsDidChange: function (alerts_monitored_cells_did_change_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/monitored_cells_did_change";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alerts_monitored_cells_did_change_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertsSendPreview: function (alerts_send_preview_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/send_preview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alerts_send_preview_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        alertsSendTryout: function (alerts_send_tryout_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts/send_tryout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alerts_send_tryout_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        analyticsTrack: function (analytics_track_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/a/t";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analytics_track_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        analyticsTrackAnonymousEvents: function (analytics_track_anonymous_events_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/a/ta";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analytics_track_anonymous_events_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        analyticsTrackPreUserEvent: function (analytics_track_pre_user_event_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/analytics/track_pre_user_event";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(analytics_track_pre_user_event_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        archiveWebDashboard: function (web_dashboard_id, archive_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('archiveWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/archive"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(archive_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authGoogleJWTCallback: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/google_jwt_callback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authLogout: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        authSignup: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/signup";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        autoExpandRange: function (range, google_sheets_file_id, google_sheets_tab_id, excel_file_id, excel_drive_id, excel_site_id, excel_sheet_id, spreadsheet_id, tab_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('autoExpandRange', 'range', range);
                    localVarPath = "/api/snapshot/auto_expand_range";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (range !== undefined) {
                        localVarQueryParameter['range'] = range;
                    }
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    if (google_sheets_tab_id !== undefined) {
                        localVarQueryParameter['google_sheets_tab_id'] = google_sheets_tab_id;
                    }
                    if (excel_file_id !== undefined) {
                        localVarQueryParameter['excel_file_id'] = excel_file_id;
                    }
                    if (excel_drive_id !== undefined) {
                        localVarQueryParameter['excel_drive_id'] = excel_drive_id;
                    }
                    if (excel_site_id !== undefined) {
                        localVarQueryParameter['excel_site_id'] = excel_site_id;
                    }
                    if (excel_sheet_id !== undefined) {
                        localVarQueryParameter['excel_sheet_id'] = excel_sheet_id;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (tab_id !== undefined) {
                        localVarQueryParameter['tab_id'] = tab_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        boxGetAuthToken: function (box_get_auth_token_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/box/get_oauth_token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(box_get_auth_token_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        boxGetCsvRawValues: function (box_get_csv_raw_values_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/box/get_csv_raw_values_box";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(box_get_csv_raw_values_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        browserAgentCommandResult: function (command_id, browser_agent_command_result_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('browserAgentCommandResult', 'command_id', command_id);
                    localVarPath = "/api/browser_agent/command_result/{command_id}"
                        .replace("{".concat("command_id", "}"), encodeURIComponent(String(command_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(browser_agent_command_result_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        browserAgentConnection: function (browser_agent_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/browser_agent/connections";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(browser_agent_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        browserAgentConnectionStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/browser_agent/check_connection_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        bulkEditSchedule: function (bulk_edit_schedule_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports/bulk_edit_schedule";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulk_edit_schedule_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        bulkPollDataImportRunStatus: function (bulk_poll_data_import_run_status_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports/bulk_run_poll";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulk_poll_data_import_run_status_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkConnection: function (data_source_type, check_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkConnection', 'data_source_type', data_source_type);
                    localVarPath = "/api/data_source_apis/{data_source_type}/check_connection"
                        .replace("{".concat("data_source_type", "}"), encodeURIComponent(String(data_source_type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(check_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkDataSourceConnectionLimit: function (data_source_type, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkDataSourceConnectionLimit', 'data_source_type', data_source_type);
                    (0, common_1.assertParamExists)('checkDataSourceConnectionLimit', 'domain', domain);
                    localVarPath = "/api/data_sources/check_connection_limit";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkMSTeamsBotInChannel: function (check_ms_teams_bot_in_channel_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_teams/bot_in_channel_check";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(check_ms_teams_bot_in_channel_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkSalesforceAppInstall: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkSalesforceAppInstall', 'data_source_id', data_source_id);
                    localVarPath = "/api/salesforce/app_install/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkWebDashboardEditPermission: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkWebDashboardEditPermission', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/check_edit_permission"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkWebDashboardPermissionPublic: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkWebDashboardPermissionPublic', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/check_permission_public"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkWebsocketStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/netsuite_crx/check_websocket_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        checkWritebackMappings: function (writeback_id, check_writeback_mappings_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('checkWritebackMappings', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/check_mappings"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(check_writeback_mappings_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        claimSignupAttributionEvents: function (claim_signup_attribution_events_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/signup_attribution_events/claim";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(claim_signup_attribution_events_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloneSpreadsheet: function (clone_spreadsheet_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/clone_spreadsheet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clone_spreadsheet_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloneSpreadsheetAlerts: function (clone_spreadsheet_alerts_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/clone_spreadsheet/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clone_spreadsheet_alerts_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloneSpreadsheetSnapshots: function (clone_spreadsheet_snapshots_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/clone_spreadsheet/snapshots";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clone_spreadsheet_snapshots_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloneSpreadsheetUnpauseSchedules: function (clone_spreadsheet_unpause_schedules_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/clone_spreadsheet/unpause_schedules";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clone_spreadsheet_unpause_schedules_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloneSpreadsheetWritebacks: function (clone_spreadsheet_writebacks_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/clone_spreadsheet/writebacks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(clone_spreadsheet_writebacks_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        cloudLookup: function (cloud_lookup_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/virtual_imports/cloud_lookup";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cloud_lookup_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        coeffSearch: function (coeff_search_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/coeff_search";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coeff_search_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        coeffSearchExperimental: function (coeff_search_experimental_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/coeff_search_experimental";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(coeff_search_experimental_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        completeDataImportsTransfer: function (complete_data_imports_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports_transfer/complete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_data_imports_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        completeExcelSheetsContextMultipartUpload: function (complete_excel_sheets_context_multipart_upload_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/excel_sheets/context/complete_multipart_upload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_excel_sheets_context_multipart_upload_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        completeWritebackMultipartUpload: function (writeback_id, complete_writeback_multipart_upload_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('completeWritebackMultipartUpload', 'writeback_id', writeback_id);
                    localVarPath = "/api/s3_upload_url/writeback_data/{writeback_id}/multipart/complete"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_writeback_multipart_upload_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createAgentImport: function (create_agent_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/v1/imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_agent_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createAgentTask: function (create_agent_task_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_agent_task_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createAlert: function (create_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createCloudTable: function (create_cloud_table_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/cloud_tables";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_cloud_table_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createConnection: function (create_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/netsuite_crx/connections";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createDataImport: function (create_data_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_data_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createDataImportRecipe: function (create_data_import_recipe_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_import_recipes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_data_import_recipe_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createDataSource: function (create_data_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_data_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createDomainFamily: function (create_domain_family_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/domain_families";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_domain_family_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createDynamicClone: function (create_dynamic_clone_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/dynamic_clones";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_dynamic_clone_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createEnrich: function (create_enrich_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/enriches";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_enrich_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createInternalWebDashboard: function (create_internal_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboard/create_internal";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_internal_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createLeadGen: function (create_lead_gen_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/leadgens";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_lead_gen_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createLookerUrlBasedAuth: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/apps/create_url_based_auth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createOauthAttempt: function (create_oauth_attempt_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/oauth_attempt";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_oauth_attempt_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createPBDash: function (create_pb_dash_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/pb_dashes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_pb_dash_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createPlaceholderWebDashboard: function (create_placeholder_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboard/create_placeholder";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_placeholder_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createSmartAlert: function (create_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createSnapshot: function (create_snapshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/snapshot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_snapshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createSubscriptionCustomDeal: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/custom_deals/new";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createUserAlias: function (create_user_alias_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/create_user_alias";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_user_alias_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createUserRequest: function (create_user_request_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user_request";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_user_request_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createWebDashboardSubscription: function (web_dashboard_id, create_web_dashboard_subscription_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('createWebDashboardSubscription', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_web_dashboard_subscription_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createWorkspace: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/workspaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        createWriteback: function (create_writeback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/writebacks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(create_writeback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        crxCheckLoginStatus: function (account_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('crxCheckLoginStatus', 'account_id', account_id);
                    localVarPath = "/api/netsuite_crx/check_login_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (account_id !== undefined) {
                        localVarQueryParameter['account_id'] = account_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        crxGetFilters: function (report_url, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('crxGetFilters', 'report_url', report_url);
                    localVarPath = "/api/netsuite_crx/get_filters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (report_url !== undefined) {
                        localVarQueryParameter['report_url'] = report_url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        crxValidateUrl: function (report_url, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('crxValidateUrl', 'report_url', report_url);
                    localVarPath = "/api/netsuite_crx/validate_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (report_url !== undefined) {
                        localVarQueryParameter['report_url'] = report_url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        csvVerifyBoxFile: function (csv_verify_box_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/csv/verify_box_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csv_verify_box_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        csvVerifyEgnyteFile: function (csv_verify_egnyte_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/csv/verify_egnyte_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csv_verify_egnyte_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        csvVerifyOneDriveFile: function (csv_verify_one_drive_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/csv/verify_one_drive_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csv_verify_one_drive_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        csvVerifyUrl: function (csv_verify_url_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/csv/verify_csv_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(csv_verify_url_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteAgentImport: function (import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteAgentImport', 'import_id', import_id);
                    localVarPath = "/api/agent/v1/imports/{import_id}"
                        .replace("{".concat("import_id", "}"), encodeURIComponent(String(import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteAgentTask: function (task_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteAgentTask', 'task_id', task_id);
                    localVarPath = "/api/agent/task/{task_id}"
                        .replace("{".concat("task_id", "}"), encodeURIComponent(String(task_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteAlert: function (alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteAlert', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteArrowFlightSqlAppInfo: function (delete_arrow_flight_sql_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/arrow_flight_sql/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_arrow_flight_sql_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteCloudTable: function (cloud_table_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteCloudTable', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_table/{cloud_table_id}"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteCustomOAuthAppInfo: function (delete_custom_o_auth_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/custom_oauth/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_custom_o_auth_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDataImport: function (data_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDataImport', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDataImportRecipe: function (data_import_recipe_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDataImportRecipe', 'data_import_recipe_id', data_import_recipe_id);
                    localVarPath = "/api/data_import_recipes/{data_import_recipe_id}"
                        .replace("{".concat("data_import_recipe_id", "}"), encodeURIComponent(String(data_import_recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDataSource: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api/data_sources/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDatabricksAppInfo: function (delete_databricks_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/databricks/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_databricks_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDomainFamily: function (domain_family_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDomainFamily', 'domain_family_id', domain_family_id);
                    localVarPath = "/api/retool/domain_family/{domain_family_id}"
                        .replace("{".concat("domain_family_id", "}"), encodeURIComponent(String(domain_family_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteDynamicClone: function (dynamic_clone_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteDynamicClone', 'dynamic_clone_id', dynamic_clone_id);
                    localVarPath = "/api/dynamic_clones/{dynamic_clone_id}"
                        .replace("{".concat("dynamic_clone_id", "}"), encodeURIComponent(String(dynamic_clone_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteEnrich: function (enrich_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteEnrich', 'enrich_id', enrich_id);
                    localVarPath = "/api/enrich/{enrich_id}"
                        .replace("{".concat("enrich_id", "}"), encodeURIComponent(String(enrich_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteInvite: function (invite_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteInvite', 'invite_id', invite_id);
                    localVarPath = "/api/invites/{invite_id}"
                        .replace("{".concat("invite_id", "}"), encodeURIComponent(String(invite_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteLeadGen: function (leadgen_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteLeadGen', 'leadgen_id', leadgen_id);
                    localVarPath = "/api/leadgen/{leadgen_id}"
                        .replace("{".concat("leadgen_id", "}"), encodeURIComponent(String(leadgen_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteLookerAppInfo: function (delete_looker_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_looker_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteNetSuiteAppInfo: function (delete_net_suite_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/delete_app";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_net_suite_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deletePBDash: function (pb_dash_id, delete_target_google_sheets_tab, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deletePBDash', 'pb_dash_id', pb_dash_id);
                    localVarPath = "/api/pb_dashes/{pb_dash_id}"
                        .replace("{".concat("pb_dash_id", "}"), encodeURIComponent(String(pb_dash_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (delete_target_google_sheets_tab !== undefined) {
                        localVarQueryParameter['delete_target_google_sheets_tab'] = delete_target_google_sheets_tab;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deletePublicTemplate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/public_templates";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteRecipe: function (recipe_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteRecipe', 'recipe_id', recipe_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteSnapshot: function (snapshot_id, delete_snapshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteSnapshot', 'snapshot_id', snapshot_id);
                    localVarPath = "/api/snapshot/{snapshot_id}"
                        .replace("{".concat("snapshot_id", "}"), encodeURIComponent(String(snapshot_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_snapshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteSnowflakeAppInfo: function (delete_snowflake_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/snowflake/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_snowflake_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteTableauAppInfo: function (delete_tableau_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/tableau/apps/delete";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(delete_tableau_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteUser: function (user_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteUser', 'user_id', user_id);
                    localVarPath = "/api/users/{user_id}"
                        .replace("{".concat("user_id", "}"), encodeURIComponent(String(user_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteWebDashboard: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard_with_auth/{web_dashboard_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteWebDashboardCustomLogo: function (variant, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteWebDashboardCustomLogo', 'variant', variant);
                    localVarPath = "/api/web_dashboards/custom_logo/{variant}"
                        .replace("{".concat("variant", "}"), encodeURIComponent(String(variant)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteWebDashboardCustomTheme: function (theme_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteWebDashboardCustomTheme', 'theme_id', theme_id);
                    localVarPath = "/api/web_dashboards/custom_themes/{theme_id}"
                        .replace("{".concat("theme_id", "}"), encodeURIComponent(String(theme_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteWebDashboardSubscription', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('deleteWebDashboardSubscription', 'web_dashboard_subscription_id', web_dashboard_subscription_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions/{web_dashboard_subscription_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)))
                        .replace("{".concat("web_dashboard_subscription_id", "}"), encodeURIComponent(String(web_dashboard_subscription_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        deleteWriteback: function (writeback_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('deleteWriteback', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        describeAgentConnection: function (connection_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('describeAgentConnection', 'connection_id', connection_id);
                    localVarPath = "/api/agent/v1/connections/{connection_id}"
                        .replace("{".concat("connection_id", "}"), encodeURIComponent(String(connection_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        describeAgentConnectionSource: function (connection_id, object_name, schema_name, search, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('describeAgentConnectionSource', 'connection_id', connection_id);
                    localVarPath = "/api/agent/v1/connections/{connection_id}/source"
                        .replace("{".concat("connection_id", "}"), encodeURIComponent(String(connection_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (object_name !== undefined) {
                        localVarQueryParameter['object_name'] = object_name;
                    }
                    if (schema_name !== undefined) {
                        localVarQueryParameter['schema_name'] = schema_name;
                    }
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        downloadSQLiteDB: function (spreadsheet_id, spreadsheet_version_id, dashboard_id, table_name, all_tables, cache_key, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('downloadSQLiteDB', 'spreadsheet_id', spreadsheet_id);
                    localVarPath = "/api/web_dashboard/download_sqlite_db";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (spreadsheet_version_id !== undefined) {
                        localVarQueryParameter['spreadsheet_version_id'] = spreadsheet_version_id;
                    }
                    if (dashboard_id !== undefined) {
                        localVarQueryParameter['dashboard_id'] = dashboard_id;
                    }
                    if (table_name !== undefined) {
                        localVarQueryParameter['table_name'] = table_name;
                    }
                    if (all_tables !== undefined) {
                        localVarQueryParameter['all_tables'] = all_tables;
                    }
                    if (cache_key !== undefined) {
                        localVarQueryParameter['cache_key'] = cache_key;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        duplicateWebDashboard: function (web_dashboard_id, duplicate_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('duplicateWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/duplicate"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(duplicate_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        editDomainFamily: function (domain_family_id, edit_domain_family_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('editDomainFamily', 'domain_family_id', domain_family_id);
                    localVarPath = "/api/retool/domain_family/{domain_family_id}"
                        .replace("{".concat("domain_family_id", "}"), encodeURIComponent(String(domain_family_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(edit_domain_family_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        egnyteGetCsvRawValues: function (egnyte_get_csv_raw_values_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/egnyte/get_csv_raw_values_egnyte";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(egnyte_get_csv_raw_values_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        emailRedirect: function (target_id, source_id, source, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('emailRedirect', 'target_id', target_id);
                    (0, common_1.assertParamExists)('emailRedirect', 'source_id', source_id);
                    (0, common_1.assertParamExists)('emailRedirect', 'source', source);
                    localVarPath = "/api/email_redirect";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_id !== undefined) {
                        localVarQueryParameter['target_id'] = target_id;
                    }
                    if (source_id !== undefined) {
                        localVarQueryParameter['source_id'] = source_id;
                    }
                    if (source !== undefined) {
                        localVarQueryParameter['source'] = source;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        errorsTrackUserProblem: function (errors_track_user_problem_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/errors/track_user_problem";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(errors_track_user_problem_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelDataImportRunTestFlow: function (excel_data_import_run_test_flow_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/excel_data_import_run_test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_data_import_run_test_flow_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelGetMetadata: function (excel_get_metadata_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/excel/get_metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_get_metadata_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelRedirect: function (id, redirection_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('excelRedirect', 'id', id);
                    (0, common_1.assertParamExists)('excelRedirect', 'redirection_type', redirection_type);
                    localVarPath = "/api/excel_redirect/{redirection_type}/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                        .replace("{".concat("redirection_type", "}"), encodeURIComponent(String(redirection_type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelVerifyBoxFile: function (excel_verify_box_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/excel/verify_box_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_verify_box_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelVerifyEgnyteFile: function (excel_verify_egnyte_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/excel/verify_egnyte_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_verify_egnyte_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelVerifyOneDriveFile: function (excel_verify_one_drive_file_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/excel/verify_one_drive_file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_verify_one_drive_file_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        excelVerifyUrl: function (excel_verify_url_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/excel/verify_excel_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(excel_verify_url_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        exchangeAuthToken: function (exchange_auth_token_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/exchange_token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(exchange_auth_token_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        exchangeCRXAuthToken: function (exchange_crx_auth_token_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/exchange_crx_token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(exchange_crx_auth_token_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        fetchSnapshotClientPlan: function (snapshot_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('fetchSnapshotClientPlan', 'snapshot_id', snapshot_id);
                    localVarPath = "/api/snapshot/run/{snapshot_id}/client_plan"
                        .replace("{".concat("snapshot_id", "}"), encodeURIComponent(String(snapshot_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        fetchSnapshotSheets: function (google_sheet_file_id, excel_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/snapshot/sheets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheet_file_id !== undefined) {
                        localVarQueryParameter['google_sheet_file_id'] = google_sheet_file_id;
                    }
                    if (excel_file_id !== undefined) {
                        localVarQueryParameter['excel_file_id'] = excel_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        fetchSnapshots: function (google_sheet_file_id, google_sheet_tab_id, excel_file_id, user_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/snapshot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheet_file_id !== undefined) {
                        localVarQueryParameter['google_sheet_file_id'] = google_sheet_file_id;
                    }
                    if (google_sheet_tab_id !== undefined) {
                        localVarQueryParameter['google_sheet_tab_id'] = google_sheet_tab_id;
                    }
                    if (excel_file_id !== undefined) {
                        localVarQueryParameter['excel_file_id'] = excel_file_id;
                    }
                    if (user_id !== undefined) {
                        localVarQueryParameter['user_id'] = user_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        fetchWritebacksSchema: function (data_source_id, fetch_writebacks_schema_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('fetchWritebacksSchema', 'data_source_id', data_source_id);
                    localVarPath = "/api/writebacks/fetch_schema/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fetch_writebacks_schema_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        forceRestoreWebDashboard: function (web_dashboard_id, force_restore_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('forceRestoreWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/retool/web_dashboards/{web_dashboard_id}/force_restore"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(force_restore_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gSheetsGetColumns: function (g_sheets_get_columns_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_sheets/get_columns";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(g_sheets_get_columns_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gSheetsGetNamedRangeParameters: function (target_google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('gSheetsGetNamedRangeParameters', 'target_google_sheets_file_id', target_google_sheets_file_id);
                    localVarPath = "/api/google_sheets/named_range_parameters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_google_sheets_file_id !== undefined) {
                        localVarQueryParameter['target_google_sheets_file_id'] = target_google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gSheetsGetTabs: function (g_sheets_get_tabs_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_sheets/get_tabs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(g_sheets_get_tabs_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gSheetsUpsertNamedRangeParameter: function (g_sheets_upsert_named_range_parameter_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/google_sheets/named_range_parameters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(g_sheets_upsert_named_range_parameter_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        generateDashboardSheetsContext: function (generate_dashboard_sheets_context_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/dashboard_sheets_context/generate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generate_dashboard_sheets_context_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        generateExcelSheetsContext: function (generate_excel_sheets_context_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/excel_sheets/context/generate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generate_excel_sheets_context_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        generateSheetsContext: function (generate_sheets_context_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/google_sheets/context/generate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generate_sheets_context_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        generateSheetsContextExtended: function (generate_sheets_context_extended_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/google_sheets/context/generate_extended";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generate_sheets_context_extended_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        genericScraperBulkRun: function (generic_scraper_bulk_run_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/generic_scraper/bulk_run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generic_scraper_bulk_run_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAccountsInfo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/netsuite_crx/get_accounts_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAdminAgentCreditHistory: function (email, limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAdminAgentCreditHistory', 'email', email);
                    localVarPath = "/api/admin/agent_credits/history";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAdminAgentCredits: function (email, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAdminAgentCredits', 'email', email);
                    localVarPath = "/api/admin/agent_credits";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentCreditHistory: function (limit, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent_credits/history";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentCredits: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent_credits";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentImport: function (import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAgentImport', 'import_id', import_id);
                    localVarPath = "/api/agent/v1/imports/{import_id}"
                        .replace("{".concat("import_id", "}"), encodeURIComponent(String(import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentRun: function (run_id, wait_seconds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAgentRun', 'run_id', run_id);
                    localVarPath = "/api/agent/v1/runs/{run_id}"
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (wait_seconds !== undefined) {
                        localVarQueryParameter['wait_seconds'] = wait_seconds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentTask: function (task_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAgentTask', 'task_id', task_id);
                    localVarPath = "/api/agent/task/{task_id}"
                        .replace("{".concat("task_id", "}"), encodeURIComponent(String(task_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentTasks: function (thread_id, spreadsheet_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/task";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (thread_id !== undefined) {
                        localVarQueryParameter['thread_id'] = thread_id;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentThreadRun: function (thread_id, agent_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAgentThreadRun', 'thread_id', thread_id);
                    (0, common_1.assertParamExists)('getAgentThreadRun', 'agent_type', agent_type);
                    localVarPath = "/api/agent/thread/run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (thread_id !== undefined) {
                        localVarQueryParameter['thread_id'] = thread_id;
                    }
                    if (agent_type !== undefined) {
                        localVarQueryParameter['agent_type'] = agent_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAgentThreads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/threads";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (updated_dt_offset !== undefined) {
                        localVarQueryParameter['updated_dt_offset'] = updated_dt_offset;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (web_dashboard_id !== undefined) {
                        localVarQueryParameter['web_dashboard_id'] = web_dashboard_id;
                    }
                    if (agent_type !== undefined) {
                        localVarQueryParameter['agent_type'] = agent_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAiUsageAllowance: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ai_usage_allowance";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlert: function (alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAlert', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlertReport: function (alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAlertReport', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/report/{alert_id}"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlertRunHistory: function (alert_id, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAlertRunHistory', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}/run_history"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlerts: function (google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getArchivedWebDashboards: function (email, domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/archived_web_dashboards";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAssistantThreadV2Run: function (thread_id, assistant_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAssistantThreadV2Run', 'thread_id', thread_id);
                    (0, common_1.assertParamExists)('getAssistantThreadV2Run', 'assistant_type', assistant_type);
                    localVarPath = "/api/assistant/threadv2/run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (thread_id !== undefined) {
                        localVarQueryParameter['thread_id'] = thread_id;
                    }
                    if (assistant_type !== undefined) {
                        localVarQueryParameter['assistant_type'] = assistant_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAssistantThreadV2Threads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/assistant/threadv2/threads";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (updated_dt_offset !== undefined) {
                        localVarQueryParameter['updated_dt_offset'] = updated_dt_offset;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (web_dashboard_id !== undefined) {
                        localVarQueryParameter['web_dashboard_id'] = web_dashboard_id;
                    }
                    if (agent_type !== undefined) {
                        localVarQueryParameter['agent_type'] = agent_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAutoAnalystRunStatus: function (auto_analyses_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAutoAnalystRunStatus', 'auto_analyses_run_id', auto_analyses_run_id);
                    localVarPath = "/api/auto_analyst/status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (auto_analyses_run_id !== undefined) {
                        localVarQueryParameter['auto_analyses_run_id'] = auto_analyses_run_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getBillingDetails: function (get_billing_details_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/billing_details";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_billing_details_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getChargebeeCoupons: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/chargebee/coupons";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getClientFlags: function (google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/client_flags";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getClonedSpreadsheetSource: function (cloned_spreadsheet_file_id, source_spreadsheet_data_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getClonedSpreadsheetSource', 'cloned_spreadsheet_file_id', cloned_spreadsheet_file_id);
                    localVarPath = "/api/cloned_spreadsheet_source";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cloned_spreadsheet_file_id !== undefined) {
                        localVarQueryParameter['cloned_spreadsheet_file_id'] = cloned_spreadsheet_file_id;
                    }
                    if (source_spreadsheet_data_import_id !== undefined) {
                        localVarQueryParameter['source_spreadsheet_data_import_id'] = source_spreadsheet_data_import_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getCloudTable: function (cloud_table_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getCloudTable', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_table/{cloud_table_id}"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getCloudTableData: function (cloud_table_id, get_cloud_table_data_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getCloudTableData', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_tables/{cloud_table_id}/get_data"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_cloud_table_data_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getCloudTableRunHistory: function (cloud_table_id, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getCloudTableRunHistory', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_tables/{cloud_table_id}/run_history"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getCloudTables: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/cloud_tables";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getCuratedAPIAgentWelcomeConfig: function (data_source_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getCuratedAPIAgentWelcomeConfig', 'data_source_type', data_source_type);
                    localVarPath = "/api/curated-api-agent/welcome-config";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDashboardSpreadsheets: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/dashboard/spreadsheets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDashboardTeamActivity: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/dashboard/team_activity";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImport: function (data_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImport', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportCompatibleDataSources: function (data_import_id, restricted_field_option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportCompatibleDataSources', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/get_compatible_data_sources"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (restricted_field_option !== undefined) {
                        localVarQueryParameter['restricted_field_option'] = restricted_field_option;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportDueScheduledRuns: function (get_data_import_due_scheduled_runs_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_import_due_scheduled_runs";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_data_import_due_scheduled_runs_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportEditAccessType: function (data_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportEditAccessType', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/edit_access_type"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportQuery: function (data_source_type, get_data_import_query_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportQuery', 'data_source_type', data_source_type);
                    localVarPath = "/api/data_source_apis/{data_source_type}/get_query"
                        .replace("{".concat("data_source_type", "}"), encodeURIComponent(String(data_source_type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_data_import_query_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRecipe: function (data_import_recipe_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportRecipe', 'data_import_recipe_id', data_import_recipe_id);
                    localVarPath = "/api/data_import_recipes/{data_import_recipe_id}"
                        .replace("{".concat("data_import_recipe_id", "}"), encodeURIComponent(String(data_import_recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRecipes: function (data_source_type, limit, custom_api_previous_import_option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_import_recipes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (custom_api_previous_import_option !== undefined) {
                        localVarQueryParameter['custom_api_previous_import_option'] = custom_api_previous_import_option;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRunHistory: function (data_import_id, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportRunHistory', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/run_history"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportRunStatus: function (data_import_id, max_wait_time_secs, data_import_run_id, preempt_option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportRunStatus', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/run_poll"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (max_wait_time_secs !== undefined) {
                        localVarQueryParameter['max_wait_time_secs'] = max_wait_time_secs;
                    }
                    if (data_import_run_id !== undefined) {
                        localVarQueryParameter['data_import_run_id'] = data_import_run_id;
                    }
                    if (preempt_option !== undefined) {
                        localVarQueryParameter['preempt_option'] = preempt_option;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImportWriterPlan: function (data_import_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImportWriterPlan', 'data_import_run_id', data_import_run_id);
                    localVarPath = "/api/data_import_runs/{data_import_run_id}/writer_plan"
                        .replace("{".concat("data_import_run_id", "}"), encodeURIComponent(String(data_import_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImports: function (target_google_sheets_file_id, include_deleted, data_source_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_google_sheets_file_id !== undefined) {
                        localVarQueryParameter['target_google_sheets_file_id'] = target_google_sheets_file_id;
                    }
                    if (include_deleted !== undefined) {
                        localVarQueryParameter['include_deleted'] = include_deleted;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSource: function (data_source_id, restricted_field_option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api/data_sources/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (restricted_field_option !== undefined) {
                        localVarQueryParameter['restricted_field_option'] = restricted_field_option;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSourceSQLTable: function (data_source_id, schema_name, table_name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSourceSQLTable', 'data_source_id', data_source_id);
                    (0, common_1.assertParamExists)('getDataSourceSQLTable', 'schema_name', schema_name);
                    (0, common_1.assertParamExists)('getDataSourceSQLTable', 'table_name', table_name);
                    localVarPath = "/api/data_sources/{data_source_id}/schemas/{schema_name}/tables/{table_name}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)))
                        .replace("{".concat("schema_name", "}"), encodeURIComponent(String(schema_name)))
                        .replace("{".concat("table_name", "}"), encodeURIComponent(String(table_name)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSourceSchema: function (data_source_id, schema_name, force_refresh, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSourceSchema', 'data_source_id', data_source_id);
                    (0, common_1.assertParamExists)('getDataSourceSchema', 'schema_name', schema_name);
                    localVarPath = "/api/data_sources/{data_source_id}/schemas/{schema_name}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)))
                        .replace("{".concat("schema_name", "}"), encodeURIComponent(String(schema_name)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (force_refresh !== undefined) {
                        localVarQueryParameter['force_refresh'] = force_refresh;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSourceSchemas: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataSourceSchemas', 'data_source_id', data_source_id);
                    localVarPath = "/api/data_sources/{data_source_id}/schemas"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataSources: function (restricted_field_option, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (restricted_field_option !== undefined) {
                        localVarQueryParameter['restricted_field_option'] = restricted_field_option;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainCoupon: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDomainCoupon', 'domain', domain);
                    localVarPath = "/api/retool/domain/{domain}/coupon"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainFamilies: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/domain_families";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainFamily: function (domain_family_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDomainFamily', 'domain_family_id', domain_family_id);
                    localVarPath = "/api/retool/domain_family/{domain_family_id}"
                        .replace("{".concat("domain_family_id", "}"), encodeURIComponent(String(domain_family_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainFamilyChangeLog: function (domain_family_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDomainFamilyChangeLog', 'domain_family_id', domain_family_id);
                    localVarPath = "/api/retool/domain_family/{domain_family_id}/change_log"
                        .replace("{".concat("domain_family_id", "}"), encodeURIComponent(String(domain_family_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainUsers: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/users/domain";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDynamicClone: function (dynamic_clone_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDynamicClone', 'dynamic_clone_id', dynamic_clone_id);
                    localVarPath = "/api/dynamic_clones/{dynamic_clone_id}"
                        .replace("{".concat("dynamic_clone_id", "}"), encodeURIComponent(String(dynamic_clone_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDynamicClones: function (google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/dynamic_clones";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEditorThreadMessages: function (dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getEditorThreadMessages', 'dashboard_id', dashboard_id);
                    localVarPath = "/api/retool/web_dashboard/{dashboard_id}/editor_thread_messages"
                        .replace("{".concat("dashboard_id", "}"), encodeURIComponent(String(dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEgnyteToken: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getEgnyteToken', 'data_source_id', data_source_id);
                    localVarPath = "/api/data_sources/{data_source_id}/egnyte/token"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnabledDataSources: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/enabled_data_sources";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnrich: function (enrich_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getEnrich', 'enrich_id', enrich_id);
                    localVarPath = "/api/enrich/{enrich_id}"
                        .replace("{".concat("enrich_id", "}"), encodeURIComponent(String(enrich_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnrichMetadata: function (get_enrich_metadata_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/enrich_metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_enrich_metadata_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnrichRunStatus: function (enrich_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getEnrichRunStatus', 'enrich_run_id', enrich_run_id);
                    localVarPath = "/api/enrich_run/{enrich_run_id}/status"
                        .replace("{".concat("enrich_run_id", "}"), encodeURIComponent(String(enrich_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnrichRuns: function (enrich_id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getEnrichRuns', 'enrich_id', enrich_id);
                    localVarPath = "/api/enrich/{enrich_id}/runs"
                        .replace("{".concat("enrich_id", "}"), encodeURIComponent(String(enrich_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getEnriches: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/enriches";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getExcelFileId: function (get_excel_file_id_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/excel_addon/get_excel_file_id";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_excel_file_id_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getExcelSheetsContextPresignedUrl: function (get_excel_sheets_context_presigned_url_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/excel_sheets/context/presigned_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_excel_sheets_context_presigned_url_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getFormulaImportCompatibleDataSources: function (formula_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getFormulaImportCompatibleDataSources', 'formula_import_id', formula_import_id);
                    localVarPath = "/api/formula_imports/{formula_import_id}/get_compatible_data_sources"
                        .replace("{".concat("formula_import_id", "}"), encodeURIComponent(String(formula_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getInvitations: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getInvitations', 'domain', domain);
                    localVarPath = "/api/invitation/{domain}"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getLatestWebDashboardRun: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getLatestWebDashboardRun', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/latest_run"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getLeadGen: function (leadgen_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getLeadGen', 'leadgen_id', leadgen_id);
                    localVarPath = "/api/leadgen/{leadgen_id}"
                        .replace("{".concat("leadgen_id", "}"), encodeURIComponent(String(leadgen_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getLeadGenRunStatus: function (leadgen_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getLeadGenRunStatus', 'leadgen_run_id', leadgen_run_id);
                    localVarPath = "/api/leadgen_run/{leadgen_run_id}/status"
                        .replace("{".concat("leadgen_run_id", "}"), encodeURIComponent(String(leadgen_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getLeadGenRuns: function (leadgen_id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getLeadGenRuns', 'leadgen_id', leadgen_id);
                    localVarPath = "/api/leadgen/{leadgen_id}/runs"
                        .replace("{".concat("leadgen_id", "}"), encodeURIComponent(String(leadgen_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getLeadGens: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/leadgens";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getMSTeamsAuthStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_teams/auth_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getMSTeamsTeamsAndChannels: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_teams/teams_and_channels";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getNetsuiteReportMetadataInfo: function (get_netsuite_report_metadata_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/get_report_metadata_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_netsuite_report_metadata_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getOIDCLoginUrl: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/oidc/get_sso_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getOauthAttempt: function (oauth_attempt_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getOauthAttempt', 'oauth_attempt_id', oauth_attempt_id);
                    localVarPath = "/api/oauth_attempt/{oauth_attempt_id}"
                        .replace("{".concat("oauth_attempt_id", "}"), encodeURIComponent(String(oauth_attempt_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getPBDash: function (pb_dash_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getPBDash', 'pb_dash_id', pb_dash_id);
                    localVarPath = "/api/pb_dashes/{pb_dash_id}"
                        .replace("{".concat("pb_dash_id", "}"), encodeURIComponent(String(pb_dash_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getPBDashBlueprints: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/pb_dash_blueprints";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getPBDashes: function (target_google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/pb_dashes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_google_sheets_file_id !== undefined) {
                        localVarQueryParameter['target_google_sheets_file_id'] = target_google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getPublicTemplates: function (data_source_type, filename, public_template_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/public_templates";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    if (filename !== undefined) {
                        localVarQueryParameter['filename'] = filename;
                    }
                    if (public_template_id !== undefined) {
                        localVarQueryParameter['public_template_id'] = public_template_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getRESTLetInfo: function (get_rest_let_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/get_netsuite_restlet_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_rest_let_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getRecipe: function (recipe_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getRecipe', 'recipe_id', recipe_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSQLiteDownloadURL: function (dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getSQLiteDownloadURL', 'dashboard_id', dashboard_id);
                    localVarPath = "/api/web_dashboard/{dashboard_id}/sqlite_download_url"
                        .replace("{".concat("dashboard_id", "}"), encodeURIComponent(String(dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSQLiteDownloadURLPublic: function (dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getSQLiteDownloadURLPublic', 'dashboard_id', dashboard_id);
                    localVarPath = "/api/web_dashboard/{dashboard_id}/sqlite_download_url/public"
                        .replace("{".concat("dashboard_id", "}"), encodeURIComponent(String(dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSlackAuthStatus: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/auth_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSlackChannelsAndUsers: function (alert_id, force_refresh, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/channels_and_users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (alert_id !== undefined) {
                        localVarQueryParameter['alert_id'] = alert_id;
                    }
                    if (force_refresh !== undefined) {
                        localVarQueryParameter['force_refresh'] = force_refresh;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSmartAlert: function (smart_alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getSmartAlert', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (smart_alert_id !== undefined) {
                        localVarQueryParameter['smart_alert_id'] = smart_alert_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSmartAlertRuns: function (smart_alert_id, limit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getSmartAlertRuns', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alert/{smart_alert_id}/runs"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSmartAlertSuggestions: function (google_sheets_file_id, excel_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/suggestions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    if (excel_file_id !== undefined) {
                        localVarQueryParameter['excel_file_id'] = excel_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSnowflakeKeyPair: function (get_snowflake_key_pair_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/snowflake/get_key_pair";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_snowflake_key_pair_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSubscriptionInfo: function (subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/subscription_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subscription_id !== undefined) {
                        localVarQueryParameter['subscription_id'] = subscription_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSubscriptionInvoiceUrl: function (invoice_id, subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getSubscriptionInvoiceUrl', 'invoice_id', invoice_id);
                    localVarPath = "/api/subscriptions/invoices/{invoice_id}"
                        .replace("{".concat("invoice_id", "}"), encodeURIComponent(String(invoice_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subscription_id !== undefined) {
                        localVarQueryParameter['subscription_id'] = subscription_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSubscriptionInvoices: function (subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/invoices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subscription_id !== undefined) {
                        localVarQueryParameter['subscription_id'] = subscription_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSubscriptions: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getSubscriptionsPreCheckout: function (subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/pre_checkout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subscription_id !== undefined) {
                        localVarQueryParameter['subscription_id'] = subscription_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUsageMeter: function (meter_type_str, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getUsageMeter', 'meter_type_str', meter_type_str);
                    localVarPath = "/api/usage_meter/{meter_type_str}"
                        .replace("{".concat("meter_type_str", "}"), encodeURIComponent(String(meter_type_str)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUser: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUserExtra: function (user_extra_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getUserExtra', 'user_extra_type', user_extra_type);
                    localVarPath = "/api/user_extras";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (user_extra_type !== undefined) {
                        localVarQueryParameter['user_extra_type'] = user_extra_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUserSSOInfo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/oidc/user_sso_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getVirtualImportData: function (data_import_id, get_virtual_import_data_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getVirtualImportData', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/get_cached_data"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_virtual_import_data_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboard: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardForScreenshot: function (web_dashboard_id, screenshot_token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardForScreenshot', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('getWebDashboardForScreenshot', 'screenshot_token', screenshot_token);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/screenshot_access"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (screenshot_token !== undefined) {
                        localVarQueryParameter['screenshot_token'] = screenshot_token;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardOffer: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/web_dashboard_offer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardPlanLimit: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardPlanLimit', 'domain', domain);
                    localVarPath = "/api/retool/domains/{domain}/web_dashboard_plan_limit"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardPlanUsage: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboards/plan_usage";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardPublic: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardPublic', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/public"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardRun: function (web_dashboard_id, web_dashboard_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardRun', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('getWebDashboardRun', 'web_dashboard_run_id', web_dashboard_run_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/run/{web_dashboard_run_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)))
                        .replace("{".concat("web_dashboard_run_id", "}"), encodeURIComponent(String(web_dashboard_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardTabImpact: function (web_dashboard_id, tab_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardTabImpact', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('getWebDashboardTabImpact', 'tab_id', tab_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/tab_impact"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (tab_id !== undefined) {
                        localVarQueryParameter['tab_id'] = tab_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardTrialHistory: function (product_trial_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWebDashboardTrialHistory', 'product_trial_id', product_trial_id);
                    localVarPath = "/api/retool/web_dashboard_trials/{product_trial_id}/history"
                        .replace("{".concat("product_trial_id", "}"), encodeURIComponent(String(product_trial_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebDashboardTrialUsers: function (domain, emails, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/web_dashboard_trial_users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (emails !== undefined) {
                        localVarQueryParameter['emails'] = emails;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWebhookUrl: function (get_webhook_url_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(get_webhook_url_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWorkspace: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/workspaces";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWriteback: function (writeback_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWriteback', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackMatchingDataSource: function (writeback_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebackMatchingDataSource', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/matching_data_source"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackRowStatuses: function (writeback_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebackRowStatuses', 'writeback_run_id', writeback_run_id);
                    localVarPath = "/api/writeback_runs/{writeback_run_id}/row_statuses_csv"
                        .replace("{".concat("writeback_run_id", "}"), encodeURIComponent(String(writeback_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackRunHistory: function (writeback_id, offset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebackRunHistory', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/run_history"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackUploadDataUrl: function (writeback_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebackUploadDataUrl', 'writeback_id', writeback_id);
                    localVarPath = "/api/s3_upload_url/writeback_data/{writeback_id}"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebackWriterPlan: function (writeback_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebackWriterPlan', 'writeback_run_id', writeback_run_id);
                    localVarPath = "/api/writeback_runs/{writeback_run_id}/writer_plan"
                        .replace("{".concat("writeback_run_id", "}"), encodeURIComponent(String(writeback_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebacks: function (target_google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/writebacks";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_google_sheets_file_id !== undefined) {
                        localVarQueryParameter['target_google_sheets_file_id'] = target_google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getWritebacksSchema: function (data_source_id, object_name, writeback_mode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getWritebacksSchema', 'data_source_id', data_source_id);
                    localVarPath = "/api/writebacks/get_schema/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (object_name !== undefined) {
                        localVarQueryParameter['object_name'] = object_name;
                    }
                    if (writeback_mode !== undefined) {
                        localVarQueryParameter['writeback_mode'] = writeback_mode;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getZendeskChatSessionJWT: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/zendesk_chat_session_jwt";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        googleAnalyticsGetSchema: function (google_analytics_get_schema_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_analytics/get_schema";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(google_analytics_get_schema_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        googleAnalyticsGetSchemaAlias: function (google_analytics_get_schema_alias_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/ga/get_schema";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(google_analytics_get_schema_alias_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        googleDriveCheckConnection: function (google_drive_check_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_drive/check_connection";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(google_drive_check_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        googleDriveGetAuthToken: function (google_drive_get_auth_token_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_drive/get_oauth_token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(google_drive_get_auth_token_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        googleDriveGetCsvRawValues: function (google_drive_get_csv_raw_values_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/google_drive/get_csv_raw_values";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(google_drive_get_csv_raw_values_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptChart: function (gpt_chart_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/chart";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_chart_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptChartWriter: function (gpt_chart_writer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/chart_writer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_chart_writer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptFeedback: function (gpt_feedback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/feedback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_feedback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptFormula: function (gpt_formula_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/formula";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_formula_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptPivot: function (gpt_pivot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/pivot";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_pivot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptPivotWriter: function (gpt_pivot_writer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/pivot_writer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_pivot_writer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptSQL: function (gpt_sql_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/sql";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_sql_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        gptSQLFixQuery: function (gpt_sql_fix_query_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt/sql_fix_query";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(gpt_sql_fix_query_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        handleMSGraphWebhook: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_graph_webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        handleSmartAlertsOnChange: function (handle_smart_alerts_on_change_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/on_change";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(handle_smart_alerts_on_change_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetAllLists: function (hubspot_get_all_lists_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/get_all_lists";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_all_lists_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetObjectType: function (hubspot_get_object_type_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/object_type";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_object_type_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetObjectTypes: function (hubspot_get_object_types_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/object_types";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_object_types_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetPipelineStages: function (hubspot_get_pipeline_stages_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/get_pipeline_stages";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_pipeline_stages_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetPipelines: function (hubspot_get_pipelines_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/get_pipelines";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_pipelines_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        hubspotGetPipelinesMultiObject: function (hubspot_get_pipelines_multi_object_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/hubspot/get_pipelines_multi_object";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(hubspot_get_pipelines_multi_object_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        initiateDataimportsTransfer: function (initiate_dataimports_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports_transfer/initiate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiate_dataimports_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        initiateSlackMarketplaceOauth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack-marketplace/initiate-oauth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        inviteWebDashboardShare: function (web_dashboard_id, invite_web_dashboard_share_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('inviteWebDashboardShare', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/shares"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(invite_web_dashboard_share_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        killWritebackRun: function (writeback_id, writeback_run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('killWritebackRun', 'writeback_id', writeback_id);
                    (0, common_1.assertParamExists)('killWritebackRun', 'writeback_run_id', writeback_run_id);
                    localVarPath = "/api/writeback/{writeback_id}/run/{writeback_run_id}"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)))
                        .replace("{".concat("writeback_run_id", "}"), encodeURIComponent(String(writeback_run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listAgentConnections: function (query, connection_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/v1/connections";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (query !== undefined) {
                        localVarQueryParameter['query'] = query;
                    }
                    if (connection_type !== undefined) {
                        localVarQueryParameter['connection_type'] = connection_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listAgentImports: function (spreadsheet_id, connection_id, owned_by_me, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/v1/imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (spreadsheet_id !== undefined) {
                        localVarQueryParameter['spreadsheet_id'] = spreadsheet_id;
                    }
                    if (connection_id !== undefined) {
                        localVarQueryParameter['connection_id'] = connection_id;
                    }
                    if (owned_by_me !== undefined) {
                        localVarQueryParameter['owned_by_me'] = owned_by_me;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listArrowFlightSqlAppInfo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/arrow_flight_sql/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listCustomOAuthAppInfo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/custom_oauth/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listDatabricksAppInfo: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/databricks/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listFormulaImports: function (target_google_sheets_file_id, data_source_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('listFormulaImports', 'target_google_sheets_file_id', target_google_sheets_file_id);
                    localVarPath = "/api/formula_imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (target_google_sheets_file_id !== undefined) {
                        localVarQueryParameter['target_google_sheets_file_id'] = target_google_sheets_file_id;
                    }
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listLicenseRequests: function (subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('listLicenseRequests', 'subscription_id', subscription_id);
                    localVarPath = "/api/subscriptions/license_requests";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subscription_id !== undefined) {
                        localVarQueryParameter['subscription_id'] = subscription_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listLookerAppInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listNetSuiteAppInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/list_apps";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listRecipes: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/browser_automation/recipes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listSmartAlerts: function (excel_file_id, google_sheets_file_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (excel_file_id !== undefined) {
                        localVarQueryParameter['excel_file_id'] = excel_file_id;
                    }
                    if (google_sheets_file_id !== undefined) {
                        localVarQueryParameter['google_sheets_file_id'] = google_sheets_file_id;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listSnowflakeAppInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/snowflake/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listTableauAppInfo: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/tableau/apps/list";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listWebDashboardCustomThemes: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboards/custom_themes";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listWebDashboardShares: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('listWebDashboardShares', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/shares"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listWebDashboardSubscriptionRuns: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('listWebDashboardSubscriptionRuns', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('listWebDashboardSubscriptionRuns', 'web_dashboard_subscription_id', web_dashboard_subscription_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions/{web_dashboard_subscription_id}/runs"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)))
                        .replace("{".concat("web_dashboard_subscription_id", "}"), encodeURIComponent(String(web_dashboard_subscription_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listWebDashboardSubscriptions: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('listWebDashboardSubscriptions', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        listWebDashboards: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboards";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        loadDashboardVersion: function (load_dashboard_version_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/web_dashboard/load_version";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(load_dashboard_version_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerCheckConnection: function (looker_check_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/check_connection";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_check_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerFetchUrlBasedAuthDetails: function (looker_fetch_url_based_auth_details_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/apps/fetch_url_based_auth_details";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_fetch_url_based_auth_details_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerGetDashboardElements: function (looker_get_dashboard_elements_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/get_dashboard_elements";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_get_dashboard_elements_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerGetDataSourceOwnerMetaData: function (looker_get_data_source_owner_meta_data_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/data_source_owner_meta_data";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_get_data_source_owner_meta_data_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerGetFolder: function (looker_get_folder_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/get_folder";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_get_folder_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerGetObjects: function (looker_get_objects_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/get_objects";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_get_objects_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerGetSchema: function (looker_get_schema_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/get_schema";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_get_schema_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        lookerSearchObjects: function (looker_search_objects_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/looker/search_objects";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(looker_search_objects_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        maybeCreateUser: function (signup_source, signup_source_campaign, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/users/maybe_create";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (signup_source !== undefined) {
                        localVarQueryParameter['signup_source'] = signup_source;
                    }
                    if (signup_source_campaign !== undefined) {
                        localVarQueryParameter['signup_source_campaign'] = signup_source_campaign;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        maybeSendEmailImportRefreshBlocked: function (data_import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('maybeSendEmailImportRefreshBlocked', 'data_import_id', data_import_id);
                    localVarPath = "/api/maybe_send_email_import_refresh_blocked/{data_import_id}"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        migrateSnapshotToV2: function (migrate_snapshot_to_v2_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/snapshot/migrate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(migrate_snapshot_to_v2_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        noSqlGetSchema: function (no_sql_get_schema_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/mongodb/get_schema";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(no_sql_get_schema_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        oauth2ProxyGrant: function (service_id, state, code, error, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('oauth2ProxyGrant', 'service_id', service_id);
                    localVarPath = "/api/oauth2_proxy/{service_id}"
                        .replace("{".concat("service_id", "}"), encodeURIComponent(String(service_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (error !== undefined) {
                        localVarQueryParameter['error'] = error;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        oauth2ProxyGrantFormPost: function (service_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('oauth2ProxyGrantFormPost', 'service_id', service_id);
                    localVarPath = "/api/oauth2_proxy/{service_id}"
                        .replace("{".concat("service_id", "}"), encodeURIComponent(String(service_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        oauth2Uninstall: function (service_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('oauth2Uninstall', 'service_id', service_id);
                    localVarPath = "/api/oauth2_proxy/{service_id}"
                        .replace("{".concat("service_id", "}"), encodeURIComponent(String(service_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        oneDriveGetCsvRawValues: function (one_drive_get_csv_raw_values_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/one_drive/get_csv_raw_values_one_drive";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(one_drive_get_csv_raw_values_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        parsePageContent: function (parse_page_content_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/generic_scraper/parse_page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(parse_page_content_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        patchUserExtra: function (patch_user_extra_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user_extras";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patch_user_extra_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        patchWebDashboard: function (web_dashboard_id, patch_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('patchWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard_with_auth/{web_dashboard_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patch_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        patchWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, patch_web_dashboard_subscription_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('patchWebDashboardSubscription', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('patchWebDashboardSubscription', 'web_dashboard_subscription_id', web_dashboard_subscription_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions/{web_dashboard_subscription_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)))
                        .replace("{".concat("web_dashboard_subscription_id", "}"), encodeURIComponent(String(web_dashboard_subscription_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(patch_web_dashboard_subscription_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        pauseAgentImport: function (import_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('pauseAgentImport', 'import_id', import_id);
                    localVarPath = "/api/agent/v1/imports/{import_id}/pause"
                        .replace("{".concat("import_id", "}"), encodeURIComponent(String(import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postAgentThread: function (post_agent_thread_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/thread";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(post_agent_thread_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postAgentThreadPause: function (thread_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('postAgentThreadPause', 'thread_id', thread_id);
                    localVarPath = "/api/agent/thread/{thread_id}/pause"
                        .replace("{".concat("thread_id", "}"), encodeURIComponent(String(thread_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postAssistantThreadV2: function (post_assistant_thread_v2_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/assistant/threadv2";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(post_assistant_thread_v2_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postAssistantThreadV2Feedback: function (post_assistant_thread_v2_feedback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/assistant/threadv2/feedback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(post_assistant_thread_v2_feedback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postAutoAnalyses: function (post_auto_analyses_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auto_analyst";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(post_auto_analyses_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postGPTFunctionsClearCache: function (post_gpt_functions_clear_cache_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt_functions/clear_cache";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(post_gpt_functions_clear_cache_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        postMSTeamsBotMessages: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_teams/bot/messages";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ppressPreviewModalRenderForm: function (ppress_preview_modal_render_form_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ppress/preview_modal/render_form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ppress_preview_modal_render_form_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ppressRenderAuthForm: function (ppress_render_auth_form_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ppress/auth/render_form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ppress_render_auth_form_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ppressRenderForm: function (ppress_render_form_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ppress/render_form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ppress_render_form_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ppressRenderPublicTemplateForm: function (ppress_render_public_template_form_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ppress/public_template/render_form";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ppress_render_public_template_form_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        presignWebDashboardBlockScreenshot: function (request_id, presign_web_dashboard_block_screenshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('presignWebDashboardBlockScreenshot', 'request_id', request_id);
                    localVarPath = "/api/web_dashboard/block_screenshot_presign/{request_id}"
                        .replace("{".concat("request_id", "}"), encodeURIComponent(String(request_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(presign_web_dashboard_block_screenshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        previewAgentImportSource: function (connection_id, preview_agent_import_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('previewAgentImportSource', 'connection_id', connection_id);
                    localVarPath = "/api/agent/v1/connections/{connection_id}/preview"
                        .replace("{".concat("connection_id", "}"), encodeURIComponent(String(connection_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preview_agent_import_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        previewRunWriteback: function (writeback_id, preview_run_writeback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('previewRunWriteback', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/preview_run"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preview_run_writeback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        previewSmartAlert: function (preview_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/preview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(preview_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        processCustomFunction: function (process_custom_function_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/custom_function";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(process_custom_function_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        processCustomFunctionAsync: function (process_custom_function_async_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/custom_function_async";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(process_custom_function_async_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        putCRXGetFiltersAttempt: function (attempt_id, put_crx_get_filters_attempt_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('putCRXGetFiltersAttempt', 'attempt_id', attempt_id);
                    localVarPath = "/api/netsuite_crx/get_filters_attempt/{attempt_id}"
                        .replace("{".concat("attempt_id", "}"), encodeURIComponent(String(attempt_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(put_crx_get_filters_attempt_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        putCRXLoginStatusCheckAttempt: function (attempt_id, put_crx_login_status_check_attempt_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('putCRXLoginStatusCheckAttempt', 'attempt_id', attempt_id);
                    localVarPath = "/api/netsuite_crx/check_login_status_attempt/{attempt_id}"
                        .replace("{".concat("attempt_id", "}"), encodeURIComponent(String(attempt_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(put_crx_login_status_check_attempt_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        putCRXRunAttempt: function (crx_run_attempt_id, put_crx_run_attempt_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('putCRXRunAttempt', 'crx_run_attempt_id', crx_run_attempt_id);
                    localVarPath = "/api/netsuite_crx/crx_run_attempt/{crx_run_attempt_id}"
                        .replace("{".concat("crx_run_attempt_id", "}"), encodeURIComponent(String(crx_run_attempt_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(put_crx_run_attempt_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        putCRXValidateUrlAttempt: function (attempt_id, put_crx_validate_url_attempt_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('putCRXValidateUrlAttempt', 'attempt_id', attempt_id);
                    localVarPath = "/api/netsuite_crx/validate_url_attempt/{attempt_id}"
                        .replace("{".concat("attempt_id", "}"), encodeURIComponent(String(attempt_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(put_crx_validate_url_attempt_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        quickbooksGetReportFilter: function (quickbooks_get_report_filter_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/quickbooks/get_report_filter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quickbooks_get_report_filter_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        quickbooksGetReportFilters: function (quickbooks_get_report_filters_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/quickbooks/get_report_filters";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quickbooks_get_report_filters_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        quickstart: function (email, force_create, addon_platform, variant_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('quickstart', 'email', email);
                    localVarPath = "/api/quickstart";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (force_create !== undefined) {
                        localVarQueryParameter['force_create'] = force_create;
                    }
                    if (addon_platform !== undefined) {
                        localVarQueryParameter['addon_platform'] = addon_platform;
                    }
                    if (variant_type !== undefined) {
                        localVarQueryParameter['variant_type'] = variant_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ratingPopupSetRating: function (rating_popup_set_rating_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/rating_popup/set_rating";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rating_popup_set_rating_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        ratingPopupTrackShown: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/rating_popup/track_shown";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        recipeRunResults: function (recipe_id, run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('recipeRunResults', 'recipe_id', recipe_id);
                    (0, common_1.assertParamExists)('recipeRunResults', 'run_id', run_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}/runs/{run_id}/results"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)))
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        recipeRunStatus: function (recipe_id, run_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('recipeRunStatus', 'recipe_id', recipe_id);
                    (0, common_1.assertParamExists)('recipeRunStatus', 'run_id', run_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}/runs/{run_id}/status"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)))
                        .replace("{".concat("run_id", "}"), encodeURIComponent(String(run_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        recordWebDashboardView: function (web_dashboard_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('recordWebDashboardView', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/record_view"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        recordWebDashboardViewPublic: function (web_dashboard_id, record_web_dashboard_view_public_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('recordWebDashboardViewPublic', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/record_view_public"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(record_web_dashboard_view_public_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        refreshAuthToken: function (refresh_auth_token_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/auth/refresh_token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refresh_auth_token_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        refreshCustomFunctionFormula: function (refresh_custom_function_formula_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/custom_function/refresh_formula";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refresh_custom_function_formula_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        refreshNetsuiteReportMetadata: function (refresh_netsuite_report_metadata_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/refresh_report_metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refresh_netsuite_report_metadata_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        refreshWebDashboard: function (web_dashboard_id, refresh_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('refreshWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/refresh"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(refresh_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        removeCouponFromDomain: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('removeCouponFromDomain', 'domain', domain);
                    localVarPath = "/api/retool/domain/{domain}/coupon"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        removeCouponFromSubscription: function (subscription_id, coupon, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('removeCouponFromSubscription', 'subscription_id', subscription_id);
                    localVarPath = "/api/retool/subscription/{subscription_id}/coupon"
                        .replace("{".concat("subscription_id", "}"), encodeURIComponent(String(subscription_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (coupon !== undefined) {
                        localVarQueryParameter['coupon'] = coupon;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        removeWebDashboardPlanLimitOverride: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('removeWebDashboardPlanLimitOverride', 'domain', domain);
                    localVarPath = "/api/retool/domains/{domain}/web_dashboard_plan_limit"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        reportExcelManualRunOutcome: function (report_excel_manual_run_outcome_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_import_runs/report_excel_manual_run_outcome";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report_excel_manual_run_outcome_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        reportSnapshotClientOutcome: function (snapshot_id, report_snapshot_client_outcome_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('reportSnapshotClientOutcome', 'snapshot_id', snapshot_id);
                    localVarPath = "/api/snapshot/run/{snapshot_id}/client_outcome"
                        .replace("{".concat("snapshot_id", "}"), encodeURIComponent(String(snapshot_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(report_snapshot_client_outcome_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        requestLicense: function (request_license_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/request_license";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(request_license_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        resendInvite: function (invite_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('resendInvite', 'invite_id', invite_id);
                    localVarPath = "/api/invites/{invite_id}/resend_invite"
                        .replace("{".concat("invite_id", "}"), encodeURIComponent(String(invite_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        resetUser: function (reset_user_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/reset_user";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reset_user_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        resetUserMeter: function (reset_user_meter_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/reset_user_meter";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reset_user_meter_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        resolveLicenseRequest: function (resolve_license_request_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/license_requests/resolve";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resolve_license_request_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        restoreWebDashboardCustomTheme: function (theme_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('restoreWebDashboardCustomTheme', 'theme_id', theme_id);
                    localVarPath = "/api/web_dashboards/custom_themes/{theme_id}/restore"
                        .replace("{".concat("theme_id", "}"), encodeURIComponent(String(theme_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        retoolSetFreeTrialAutomaticStartMode: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/set_free_trial_automatic_start_mode";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        retoolTrialStateBulkUpdateWithTrialState: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/trial_state_bulk_update_with_trial_state";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        retoolTrialStateBulkUpdateWithUserEmail: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/trial_state_bulk_update_with_user_email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        retoolUpdateSubscriptionEstimate: function (retool_update_subscription_estimate_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/retool_update_estimate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(retool_update_subscription_estimate_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        retoolWebDashboardTrialBulkUpdate: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/web_dashboard_trial_bulk_update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        revokeMSTeamsAuth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/ms_teams/revoke";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        revokeSlackAuth: function (revoke_slack_auth_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/revoke";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(revoke_slack_auth_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runAgentImport: function (import_id, run_agent_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runAgentImport', 'import_id', import_id);
                    localVarPath = "/api/agent/v1/imports/{import_id}/run"
                        .replace("{".concat("import_id", "}"), encodeURIComponent(String(import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_agent_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runAgentTask: function (task_id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runAgentTask', 'task_id', task_id);
                    localVarPath = "/api/agent/task/{task_id}/run"
                        .replace("{".concat("task_id", "}"), encodeURIComponent(String(task_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runCloudTable: function (cloud_table_id, is_scheduled_run, run_cloud_table_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runCloudTable', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_tables/{cloud_table_id}/run"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (is_scheduled_run !== undefined) {
                        localVarQueryParameter['is_scheduled_run'] = is_scheduled_run;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_cloud_table_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runCloudTablePreviewRun: function (run_cloud_table_preview_run_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/cloud_tables/preview_run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_cloud_table_preview_run_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataImport: function (data_import_id, is_scheduled_run, is_triggered_by_parameterized_filter, proposed_run_id, run_data_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runDataImport', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/run"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (is_scheduled_run !== undefined) {
                        localVarQueryParameter['is_scheduled_run'] = is_scheduled_run;
                    }
                    if (is_triggered_by_parameterized_filter !== undefined) {
                        localVarQueryParameter['is_triggered_by_parameterized_filter'] = is_triggered_by_parameterized_filter;
                    }
                    if (proposed_run_id !== undefined) {
                        localVarQueryParameter['proposed_run_id'] = proposed_run_id;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_data_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataImportFieldChoices: function (run_data_import_field_choices_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports/field_choices";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_data_import_field_choices_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataImportMulti: function (run_data_import_multi_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports/run_multi";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_data_import_multi_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataImportPreviewRun: function (run_data_import_preview_run_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_imports/preview_run";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_data_import_preview_run_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataImportSnapshot: function (data_import_id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runDataImportSnapshot', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/run_snapshot_now"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDataimportMorpheus: function (data_import_id, run_dataimport_morpheus_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runDataimportMorpheus', 'data_import_id', data_import_id);
                    localVarPath = "/api/morpheus/data_imports/{data_import_id}/run"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_dataimport_morpheus_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runDynamicClone: function (dynamic_clone_id, run_dynamic_clone_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runDynamicClone', 'dynamic_clone_id', dynamic_clone_id);
                    localVarPath = "/api/dynamic_clones/{dynamic_clone_id}/run"
                        .replace("{".concat("dynamic_clone_id", "}"), encodeURIComponent(String(dynamic_clone_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_dynamic_clone_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runEnrich: function (enrich_id, run_enrich_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runEnrich', 'enrich_id', enrich_id);
                    localVarPath = "/api/enrich/{enrich_id}/run"
                        .replace("{".concat("enrich_id", "}"), encodeURIComponent(String(enrich_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_enrich_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runFormulaFunction: function (run_formula_function_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/formula_functions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_formula_function_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runGPTFunction: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/gpt_functions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runLeadGen: function (leadgen_id, run_lead_gen_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runLeadGen', 'leadgen_id', leadgen_id);
                    localVarPath = "/api/leadgen/{leadgen_id}/run"
                        .replace("{".concat("leadgen_id", "}"), encodeURIComponent(String(leadgen_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_lead_gen_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runRecipe: function (recipe_id, run_recipe_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runRecipe', 'recipe_id', recipe_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}/run"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_recipe_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runSmartAlert: function (smart_alert_id, run_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runSmartAlert', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alert/{smart_alert_id}/run"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runSnapshot: function (snapshot_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runSnapshot', 'snapshot_id', snapshot_id);
                    localVarPath = "/api/snapshot/run/{snapshot_id}"
                        .replace("{".concat("snapshot_id", "}"), encodeURIComponent(String(snapshot_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runWebhook: function (webhook_token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runWebhook', 'webhook_token', webhook_token);
                    localVarPath = "/api/webhook/{webhook_token}"
                        .replace("{".concat("webhook_token", "}"), encodeURIComponent(String(webhook_token)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runWriteback: function (writeback_id, run_writeback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('runWriteback', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/run"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_writeback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        runWritebackMulti: function (run_writeback_multi_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/writebacks/run_multi";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(run_writeback_multi_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sageDeleteFinancialReport: function (report_name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('sageDeleteFinancialReport', 'report_name', report_name);
                    localVarPath = "/api/sage/delete_financial_report";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (report_name !== undefined) {
                        localVarQueryParameter['report_name'] = report_name;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sageGetFinancialReports: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('sageGetFinancialReports', 'data_source_id', data_source_id);
                    localVarPath = "/api/sage/get_financial_reports/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        salesforceGetObjectType: function (salesforce_get_object_type_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/salesforce/object_type";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(salesforce_get_object_type_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        salesforceGetObjectTypes: function (salesforce_get_object_types_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/salesforce/object_types";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(salesforce_get_object_types_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        salesforceGetReportType: function (salesforce_get_report_type_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/salesforce/report_type";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(salesforce_get_report_type_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        salesforceGetReports: function (salesforce_get_reports_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/salesforce/get_reports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(salesforce_get_reports_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        saveAffiliateReferral: function (save_affiliate_referral_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/affiliate_referrals";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(save_affiliate_referral_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        screenshotDelay: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/screenshot-delay";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sendCoworkerInvitation: function (send_coworker_invitation_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/coworker_invitation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(send_coworker_invitation_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sendInvite: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/invites";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sendPreviewSmartAlert: function (send_preview_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/smart_alerts/send_preview";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(send_preview_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sendSupportEmail: function (send_support_email_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/support/send_email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(send_support_email_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setUserExtra: function (set_user_extra_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/user_extras";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_user_extra_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setWebDashboardCustomLogo: function (set_web_dashboard_custom_logo_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/web_dashboards/custom_logo";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_web_dashboard_custom_logo_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setWebDashboardCustomThemeDefault: function (theme_id, set_web_dashboard_custom_theme_default_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('setWebDashboardCustomThemeDefault', 'theme_id', theme_id);
                    localVarPath = "/api/web_dashboards/custom_themes/{theme_id}/default"
                        .replace("{".concat("theme_id", "}"), encodeURIComponent(String(theme_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_web_dashboard_custom_theme_default_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setWebDashboardPlanLimitOverride: function (domain, set_web_dashboard_plan_limit_override_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('setWebDashboardPlanLimitOverride', 'domain', domain);
                    localVarPath = "/api/retool/domains/{domain}/web_dashboard_plan_limit"
                        .replace("{".concat("domain", "}"), encodeURIComponent(String(domain)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_web_dashboard_plan_limit_override_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyAuth: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/shopify/auth";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyDeleteCustomer: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/shopify/webhook/customers/redact";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyDeleteShop: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/shopify/webhook/shop/redact";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shopifyGetCustomer: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/shopify/webhook/customers/data_request";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        shouldSkipSuboptions: function (data_source_type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('shouldSkipSuboptions', 'data_source_type', data_source_type);
                    localVarPath = "/api/should_skip_suboptions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (data_source_type !== undefined) {
                        localVarQueryParameter['data_source_type'] = data_source_type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        signWritebackMultipartParts: function (writeback_id, sign_writeback_multipart_parts_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('signWritebackMultipartParts', 'writeback_id', writeback_id);
                    localVarPath = "/api/s3_upload_url/writeback_data/{writeback_id}/multipart/parts"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sign_writeback_multipart_parts_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        slackAuthTest: function (token, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/auth_test";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (token !== undefined) {
                        localVarQueryParameter['token'] = token;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        slackDashboardUnfurlEvents: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/dashboard_unfurl/events";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        slackDashboardUnfurlInteraction: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/dashboard_unfurl/interaction";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        slackInteractionCallback: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/slack/interaction_callback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        smartAlertMSTeamsAuthTest: function (smart_alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('smartAlertMSTeamsAuthTest', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alerts/{smart_alert_id}/ms_teams_auth_test"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        smartAlertSlackAuthTest: function (smart_alert_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('smartAlertSlackAuthTest', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alerts/{smart_alert_id}/slack_auth_test"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        sqlGetSchema: function (data_source_type, sql_get_schema_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('sqlGetSchema', 'data_source_type', data_source_type);
                    localVarPath = "/api/data_source_apis/{data_source_type}/get_schema"
                        .replace("{".concat("data_source_type", "}"), encodeURIComponent(String(data_source_type)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sql_get_schema_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        startWritebackMultipartUpload: function (writeback_id, start_writeback_multipart_upload_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('startWritebackMultipartUpload', 'writeback_id', writeback_id);
                    localVarPath = "/api/s3_upload_url/writeback_data/{writeback_id}/multipart"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(start_writeback_multipart_upload_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        storeAgentGoogleGrant: function (store_agent_google_grant_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/agent/v1/google_grant";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(store_agent_google_grant_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        subscriptionsChargebeeWebhook: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/chargebee_webhook";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        subscriptionsCheckout: function (subscriptions_checkout_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/checkout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subscriptions_checkout_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauCheckConnection: function (tableau_check_connection_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/check_connection";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_check_connection_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauGetRecentlyViewedWorksheets: function (tableau_get_recently_viewed_worksheets_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/get_recently_viewed_worksheets";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_get_recently_viewed_worksheets_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauGetServerInfo: function (tableau_get_server_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/server_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_get_server_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauGetViewsInDashboard: function (tableau_get_views_in_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/get_tableau_views_in_dashboard";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_get_views_in_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauGetWorksheet: function (tableau_get_worksheet_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/get_tableau_worksheet";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_get_worksheet_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        tableauGetWorksheetFromUrl: function (tableau_get_worksheet_from_url_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/tableau/get_worksheet_from_url";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tableau_get_worksheet_from_url_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        triggerLookerConnEmail: function (trigger_looker_conn_email_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/trigger_url_connection_email";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trigger_looker_conn_email_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        undoWebDashboardRefresh: function (web_dashboard_id, undo_web_dashboard_refresh_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('undoWebDashboardRefresh', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/undo_refresh"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(undo_web_dashboard_refresh_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateAgentImport: function (import_id, update_agent_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateAgentImport', 'import_id', import_id);
                    localVarPath = "/api/agent/v1/imports/{import_id}"
                        .replace("{".concat("import_id", "}"), encodeURIComponent(String(import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_agent_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateAgentTask: function (task_id, update_agent_task_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateAgentTask', 'task_id', task_id);
                    localVarPath = "/api/agent/task/{task_id}"
                        .replace("{".concat("task_id", "}"), encodeURIComponent(String(task_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_agent_task_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateAlert: function (alert_id, update_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateAlert', 'alert_id', alert_id);
                    localVarPath = "/api/alerts/{alert_id}"
                        .replace("{".concat("alert_id", "}"), encodeURIComponent(String(alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateCloudTable: function (cloud_table_id, update_cloud_table_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateCloudTable', 'cloud_table_id', cloud_table_id);
                    localVarPath = "/api/cloud_table/{cloud_table_id}"
                        .replace("{".concat("cloud_table_id", "}"), encodeURIComponent(String(cloud_table_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_cloud_table_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataImport: function (data_import_id, update_data_import_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataImport', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_import_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataImportDataSource: function (data_import_id, update_data_import_data_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataImportDataSource', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/update_data_source"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_import_data_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataImportEditAccessType: function (data_import_id, update_data_import_edit_access_type_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataImportEditAccessType', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/edit_access_type"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_import_edit_access_type_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataImportRecipe: function (data_import_recipe_id, update_data_import_recipe_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataImportRecipe', 'data_import_recipe_id', data_import_recipe_id);
                    localVarPath = "/api/data_import_recipes/{data_import_recipe_id}"
                        .replace("{".concat("data_import_recipe_id", "}"), encodeURIComponent(String(data_import_recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_import_recipe_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataImportTargetInfo: function (data_import_id, update_data_import_target_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataImportTargetInfo', 'data_import_id', data_import_id);
                    localVarPath = "/api/data_imports/{data_import_id}/update_target_info"
                        .replace("{".concat("data_import_id", "}"), encodeURIComponent(String(data_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_import_target_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDataSource', 'data_source_id', data_source_id);
                    localVarPath = "/api/data_sources/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_data_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateDynamicClone: function (dynamic_clone_id, update_dynamic_clone_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateDynamicClone', 'dynamic_clone_id', dynamic_clone_id);
                    localVarPath = "/api/dynamic_clones/{dynamic_clone_id}"
                        .replace("{".concat("dynamic_clone_id", "}"), encodeURIComponent(String(dynamic_clone_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_dynamic_clone_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateEnrich: function (enrich_id, update_enrich_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateEnrich', 'enrich_id', enrich_id);
                    localVarPath = "/api/enrich/{enrich_id}"
                        .replace("{".concat("enrich_id", "}"), encodeURIComponent(String(enrich_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_enrich_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateFormulaImportDataSource: function (formula_import_id, update_formula_import_data_source_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateFormulaImportDataSource', 'formula_import_id', formula_import_id);
                    localVarPath = "/api/formula_imports/{formula_import_id}/update_data_source"
                        .replace("{".concat("formula_import_id", "}"), encodeURIComponent(String(formula_import_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_formula_import_data_source_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateLeadGen: function (leadgen_id, update_lead_gen_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateLeadGen', 'leadgen_id', leadgen_id);
                    localVarPath = "/api/leadgen/{leadgen_id}"
                        .replace("{".concat("leadgen_id", "}"), encodeURIComponent(String(leadgen_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_lead_gen_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updatePBDash: function (pb_dash_id, update_pb_dash_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updatePBDash', 'pb_dash_id', pb_dash_id);
                    localVarPath = "/api/pb_dashes/{pb_dash_id}"
                        .replace("{".concat("pb_dash_id", "}"), encodeURIComponent(String(pb_dash_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_pb_dash_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateRecipe: function (recipe_id, update_recipe_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateRecipe', 'recipe_id', recipe_id);
                    localVarPath = "/api/browser_automation/recipes/{recipe_id}"
                        .replace("{".concat("recipe_id", "}"), encodeURIComponent(String(recipe_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_recipe_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSmartAlert: function (smart_alert_id, update_smart_alert_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateSmartAlert', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alerts/{smart_alert_id}"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_smart_alert_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSmartAlertEditAccessType: function (smart_alert_id, update_smart_alert_edit_access_type_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateSmartAlertEditAccessType', 'smart_alert_id', smart_alert_id);
                    localVarPath = "/api/smart_alerts/{smart_alert_id}/edit_access_type"
                        .replace("{".concat("smart_alert_id", "}"), encodeURIComponent(String(smart_alert_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_smart_alert_edit_access_type_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSnapshot: function (snapshot_id, update_snapshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateSnapshot', 'snapshot_id', snapshot_id);
                    localVarPath = "/api/snapshot/{snapshot_id}"
                        .replace("{".concat("snapshot_id", "}"), encodeURIComponent(String(snapshot_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_snapshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSubscriptionCustomDeal: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/custom_deals/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSubscriptionEstimate: function (update_subscription_estimate_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/update_estimate";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_subscription_estimate_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSubscriptionViaRetool: function (update_subscription_via_retool_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/retool/subscription_update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_subscription_via_retool_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateSubscriptions: function (update_subscriptions_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/subscriptions/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_subscriptions_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateTableauAppInfo: function (update_tableau_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/tableau/apps/update";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_tableau_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateUser: function (user_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateUser', 'user_id', user_id);
                    localVarPath = "/api/users/{user_id}"
                        .replace("{".concat("user_id", "}"), encodeURIComponent(String(user_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateUserMe: function (update_user_me_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/users/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_user_me_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWebDashboard: function (web_dashboard_id, update_web_dashboard_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWebDashboard', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard_with_auth/{web_dashboard_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_web_dashboard_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, update_web_dashboard_subscription_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWebDashboardSubscription', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('updateWebDashboardSubscription', 'web_dashboard_subscription_id', web_dashboard_subscription_id);
                    localVarPath = "/api/web_dashboards/{web_dashboard_id}/subscriptions/{web_dashboard_subscription_id}"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)))
                        .replace("{".concat("web_dashboard_subscription_id", "}"), encodeURIComponent(String(web_dashboard_subscription_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_web_dashboard_subscription_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWebDashboardTabsConfig: function (web_dashboard_id, update_web_dashboard_tabs_config_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWebDashboardTabsConfig', 'web_dashboard_id', web_dashboard_id);
                    localVarPath = "/api/web_dashboard/{web_dashboard_id}/tabs_config"
                        .replace("{".concat("web_dashboard_id", "}"), encodeURIComponent(String(web_dashboard_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_web_dashboard_tabs_config_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWorkspace: function (workspace_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWorkspace', 'workspace_id', workspace_id);
                    localVarPath = "/api/workspaces/{workspace_id}"
                        .replace("{".concat("workspace_id", "}"), encodeURIComponent(String(workspace_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWriteback: function (writeback_id, update_writeback_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWriteback', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_writeback_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        updateWritebackMappingLabels: function (writeback_id, update_writeback_mapping_labels_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('updateWritebackMappingLabels', 'writeback_id', writeback_id);
                    localVarPath = "/api/writeback/{writeback_id}/mapping_labels"
                        .replace("{".concat("writeback_id", "}"), encodeURIComponent(String(writeback_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(update_writeback_mapping_labels_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        uploadWebDashboardBlockScreenshot: function (request_id, upload_web_dashboard_block_screenshot_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('uploadWebDashboardBlockScreenshot', 'request_id', request_id);
                    localVarPath = "/api/web_dashboard/block_screenshot_upload/{request_id}"
                        .replace("{".concat("request_id", "}"), encodeURIComponent(String(request_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upload_web_dashboard_block_screenshot_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertArrowFlightSqlAppInfo: function (upsert_arrow_flight_sql_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/arrow_flight_sql/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_arrow_flight_sql_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertCustomOAuthAppInfo: function (upsert_custom_o_auth_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/custom_oauth/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_custom_o_auth_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertDatabricksAppInfo: function (upsert_databricks_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/databricks/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_databricks_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertLookerAppInfo: function (upsert_looker_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/looker/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_looker_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertNetSuiteAppInfo: function (upsert_net_suite_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_source_apis/netsuite/upsert_app_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_net_suite_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertPublicTemplate: function (upsert_public_template_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/public_templates";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_public_template_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertSnowflakeAppInfo: function (upsert_snowflake_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/snowflake/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_snowflake_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertTableauAppInfo: function (upsert_tableau_app_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/data_sources/tableau/apps/upsert";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_tableau_app_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        validateWritebackMappings: function (data_source_id, validate_writeback_mappings_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('validateWritebackMappings', 'data_source_id', data_source_id);
                    localVarPath = "/api/writebacks/validate_mappings/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(validate_writeback_mappings_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        vcrAuthGetInstanceInfo: function (vcr_auth_get_instance_info_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/vcr/auth/get_instance_info";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vcr_auth_get_instance_info_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        vcrMetadata: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/vcr/metadata";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        vcrStartAuthSession: function (vcr_start_auth_session_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/vcr/auth/start_session";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(vcr_start_auth_session_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        vcrTerminateAuthSession: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api/vcr/auth/terminate_session";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        verifyConnectionStatus: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('verifyConnectionStatus', 'data_source_id', data_source_id);
                    localVarPath = "/api/auth/verify_connection_status/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        viewWebDashboardAsSuperAdmin: function (web_dashboard_id, reason, ts, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('viewWebDashboardAsSuperAdmin', 'web_dashboard_id', web_dashboard_id);
                    (0, common_1.assertParamExists)('viewWebDashboardAsSuperAdmin', 'reason', reason);
                    (0, common_1.assertParamExists)('viewWebDashboardAsSuperAdmin', 'ts', ts);
                    localVarPath = "/api/retool/view_web_dashboard_as_super_admin";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (web_dashboard_id !== undefined) {
                        localVarQueryParameter['web_dashboard_id'] = web_dashboard_id;
                    }
                    if (reason !== undefined) {
                        localVarQueryParameter['reason'] = reason;
                    }
                    if (ts !== undefined) {
                        localVarQueryParameter['ts'] = ts;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        abortWritebackMultipartUpload: function (writeback_id, abort_writeback_multipart_upload_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.abortWritebackMultipartUpload(writeback_id, abort_writeback_multipart_upload_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        activateSmartAlert: function (activate_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.activateSmartAlert(activate_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        addAgentCredits: function (add_agent_credits_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.addAgentCredits(add_agent_credits_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        addCouponToDomain: function (domain, add_coupon_to_domain_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.addCouponToDomain(domain, add_coupon_to_domain_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminGetAgentThreadMessages: function (thread_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminGetAgentThreadMessages(thread_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminGetSmartAlertRuns: function (smart_alert_id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminGetSmartAlertRuns(smart_alert_id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminGetSmartAlertThread: function (smart_alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminGetSmartAlertThread(smart_alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminGetThreadAnalysisResults: function (analysis_id, email, domain, agent_type, since, until, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminGetThreadAnalysisResults(analysis_id, email, domain, agent_type, since, until, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminListThreadAnalyses: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminListThreadAnalyses(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminSearchSmartAlerts: function (email, smart_alert_id, spreadsheet_id, run_id, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminSearchSmartAlerts(email, smart_alert_id, spreadsheet_id, run_id, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        adminSearchWebDashboards: function (web_dashboard_id, email, domain, spreadsheet_id, exclude_coefficient_io, source_type, build_status, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.adminSearchWebDashboards(web_dashboard_id, email, domain, spreadsheet_id, exclude_coefficient_io, source_type, build_status, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertRemoveSlackConnection: function (alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertRemoveSlackConnection(alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertSlackAuthTest: function (alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertSlackAuthTest(alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertValidateSelectedTableRange: function (alert_validate_selected_table_range_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertValidateSelectedTableRange(alert_validate_selected_table_range_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertsClockTrigger: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertsClockTrigger(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertsGetRangeScreenshot: function (alerts_get_range_screenshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertsGetRangeScreenshot(alerts_get_range_screenshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertsMonitoredCellsDidChange: function (alerts_monitored_cells_did_change_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertsMonitoredCellsDidChange(alerts_monitored_cells_did_change_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertsSendPreview: function (alerts_send_preview_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertsSendPreview(alerts_send_preview_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        alertsSendTryout: function (alerts_send_tryout_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.alertsSendTryout(alerts_send_tryout_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        analyticsTrack: function (analytics_track_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.analyticsTrack(analytics_track_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        analyticsTrackAnonymousEvents: function (analytics_track_anonymous_events_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.analyticsTrackAnonymousEvents(analytics_track_anonymous_events_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        analyticsTrackPreUserEvent: function (analytics_track_pre_user_event_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.analyticsTrackPreUserEvent(analytics_track_pre_user_event_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        archiveWebDashboard: function (web_dashboard_id, archive_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.archiveWebDashboard(web_dashboard_id, archive_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authGoogleJWTCallback: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authGoogleJWTCallback(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authLogout: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authLogout(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        authSignup: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.authSignup(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        autoExpandRange: function (range, google_sheets_file_id, google_sheets_tab_id, excel_file_id, excel_drive_id, excel_site_id, excel_sheet_id, spreadsheet_id, tab_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.autoExpandRange(range, google_sheets_file_id, google_sheets_tab_id, excel_file_id, excel_drive_id, excel_site_id, excel_sheet_id, spreadsheet_id, tab_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        boxGetAuthToken: function (box_get_auth_token_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.boxGetAuthToken(box_get_auth_token_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        boxGetCsvRawValues: function (box_get_csv_raw_values_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.boxGetCsvRawValues(box_get_csv_raw_values_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        browserAgentCommandResult: function (command_id, browser_agent_command_result_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.browserAgentCommandResult(command_id, browser_agent_command_result_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        browserAgentConnection: function (browser_agent_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.browserAgentConnection(browser_agent_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        browserAgentConnectionStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.browserAgentConnectionStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        bulkEditSchedule: function (bulk_edit_schedule_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.bulkEditSchedule(bulk_edit_schedule_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        bulkPollDataImportRunStatus: function (bulk_poll_data_import_run_status_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.bulkPollDataImportRunStatus(bulk_poll_data_import_run_status_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkConnection: function (data_source_type, check_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkConnection(data_source_type, check_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkDataSourceConnectionLimit: function (data_source_type, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkDataSourceConnectionLimit(data_source_type, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkMSTeamsBotInChannel: function (check_ms_teams_bot_in_channel_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkMSTeamsBotInChannel(check_ms_teams_bot_in_channel_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkSalesforceAppInstall: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkSalesforceAppInstall(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkWebDashboardEditPermission: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkWebDashboardEditPermission(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkWebDashboardPermissionPublic: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkWebDashboardPermissionPublic(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkWebsocketStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkWebsocketStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        checkWritebackMappings: function (writeback_id, check_writeback_mappings_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.checkWritebackMappings(writeback_id, check_writeback_mappings_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        claimSignupAttributionEvents: function (claim_signup_attribution_events_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.claimSignupAttributionEvents(claim_signup_attribution_events_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloneSpreadsheet: function (clone_spreadsheet_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloneSpreadsheet(clone_spreadsheet_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloneSpreadsheetAlerts: function (clone_spreadsheet_alerts_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloneSpreadsheetAlerts(clone_spreadsheet_alerts_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloneSpreadsheetSnapshots: function (clone_spreadsheet_snapshots_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloneSpreadsheetSnapshots(clone_spreadsheet_snapshots_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloneSpreadsheetUnpauseSchedules: function (clone_spreadsheet_unpause_schedules_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloneSpreadsheetUnpauseSchedules(clone_spreadsheet_unpause_schedules_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloneSpreadsheetWritebacks: function (clone_spreadsheet_writebacks_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloneSpreadsheetWritebacks(clone_spreadsheet_writebacks_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        cloudLookup: function (cloud_lookup_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.cloudLookup(cloud_lookup_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        coeffSearch: function (coeff_search_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.coeffSearch(coeff_search_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        coeffSearchExperimental: function (coeff_search_experimental_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.coeffSearchExperimental(coeff_search_experimental_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        completeDataImportsTransfer: function (complete_data_imports_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeDataImportsTransfer(complete_data_imports_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        completeExcelSheetsContextMultipartUpload: function (complete_excel_sheets_context_multipart_upload_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeExcelSheetsContextMultipartUpload(complete_excel_sheets_context_multipart_upload_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        completeWritebackMultipartUpload: function (writeback_id, complete_writeback_multipart_upload_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeWritebackMultipartUpload(writeback_id, complete_writeback_multipart_upload_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createAgentImport: function (create_agent_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createAgentImport(create_agent_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createAgentTask: function (create_agent_task_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createAgentTask(create_agent_task_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createAlert: function (create_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createAlert(create_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createCloudTable: function (create_cloud_table_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createCloudTable(create_cloud_table_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createConnection: function (create_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createConnection(create_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createDataImport: function (create_data_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createDataImport(create_data_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createDataImportRecipe: function (create_data_import_recipe_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createDataImportRecipe(create_data_import_recipe_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createDataSource: function (create_data_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createDataSource(create_data_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createDomainFamily: function (create_domain_family_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createDomainFamily(create_domain_family_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createDynamicClone: function (create_dynamic_clone_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createDynamicClone(create_dynamic_clone_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createEnrich: function (create_enrich_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createEnrich(create_enrich_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createInternalWebDashboard: function (create_internal_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createInternalWebDashboard(create_internal_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createLeadGen: function (create_lead_gen_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createLeadGen(create_lead_gen_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createLookerUrlBasedAuth: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createLookerUrlBasedAuth(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createOauthAttempt: function (create_oauth_attempt_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createOauthAttempt(create_oauth_attempt_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createPBDash: function (create_pb_dash_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createPBDash(create_pb_dash_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createPlaceholderWebDashboard: function (create_placeholder_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createPlaceholderWebDashboard(create_placeholder_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createSmartAlert: function (create_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createSmartAlert(create_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createSnapshot: function (create_snapshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createSnapshot(create_snapshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createSubscriptionCustomDeal: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createSubscriptionCustomDeal(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createUserAlias: function (create_user_alias_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createUserAlias(create_user_alias_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createUserRequest: function (create_user_request_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createUserRequest(create_user_request_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createWebDashboardSubscription: function (web_dashboard_id, create_web_dashboard_subscription_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createWebDashboardSubscription(web_dashboard_id, create_web_dashboard_subscription_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createWorkspace: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createWorkspace(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        createWriteback: function (create_writeback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.createWriteback(create_writeback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        crxCheckLoginStatus: function (account_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.crxCheckLoginStatus(account_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        crxGetFilters: function (report_url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.crxGetFilters(report_url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        crxValidateUrl: function (report_url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.crxValidateUrl(report_url, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        csvVerifyBoxFile: function (csv_verify_box_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.csvVerifyBoxFile(csv_verify_box_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        csvVerifyEgnyteFile: function (csv_verify_egnyte_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.csvVerifyEgnyteFile(csv_verify_egnyte_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        csvVerifyOneDriveFile: function (csv_verify_one_drive_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.csvVerifyOneDriveFile(csv_verify_one_drive_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        csvVerifyUrl: function (csv_verify_url_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.csvVerifyUrl(csv_verify_url_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteAgentImport: function (import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteAgentImport(import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteAgentTask: function (task_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteAgentTask(task_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteAlert: function (alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteAlert(alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteArrowFlightSqlAppInfo: function (delete_arrow_flight_sql_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteArrowFlightSqlAppInfo(delete_arrow_flight_sql_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteCloudTable: function (cloud_table_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteCloudTable(cloud_table_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteCustomOAuthAppInfo: function (delete_custom_o_auth_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteCustomOAuthAppInfo(delete_custom_o_auth_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDataImport: function (data_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDataImport(data_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDataImportRecipe: function (data_import_recipe_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDataImportRecipe(data_import_recipe_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDataSource: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDataSource(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDatabricksAppInfo: function (delete_databricks_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDatabricksAppInfo(delete_databricks_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDomainFamily: function (domain_family_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDomainFamily(domain_family_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteDynamicClone: function (dynamic_clone_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteDynamicClone(dynamic_clone_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteEnrich: function (enrich_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteEnrich(enrich_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteInvite: function (invite_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteInvite(invite_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteLeadGen: function (leadgen_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteLeadGen(leadgen_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteLookerAppInfo: function (delete_looker_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteLookerAppInfo(delete_looker_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteNetSuiteAppInfo: function (delete_net_suite_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteNetSuiteAppInfo(delete_net_suite_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deletePBDash: function (pb_dash_id, delete_target_google_sheets_tab, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deletePBDash(pb_dash_id, delete_target_google_sheets_tab, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deletePublicTemplate: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deletePublicTemplate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteRecipe: function (recipe_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteRecipe(recipe_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteSnapshot: function (snapshot_id, delete_snapshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteSnapshot(snapshot_id, delete_snapshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteSnowflakeAppInfo: function (delete_snowflake_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteSnowflakeAppInfo(delete_snowflake_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteTableauAppInfo: function (delete_tableau_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteTableauAppInfo(delete_tableau_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteUser: function (user_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteUser(user_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteWebDashboard: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteWebDashboard(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteWebDashboardCustomLogo: function (variant, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteWebDashboardCustomLogo(variant, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteWebDashboardCustomTheme: function (theme_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteWebDashboardCustomTheme(theme_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        deleteWriteback: function (writeback_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.deleteWriteback(writeback_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        describeAgentConnection: function (connection_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.describeAgentConnection(connection_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        describeAgentConnectionSource: function (connection_id, object_name, schema_name, search, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.describeAgentConnectionSource(connection_id, object_name, schema_name, search, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        downloadSQLiteDB: function (spreadsheet_id, spreadsheet_version_id, dashboard_id, table_name, all_tables, cache_key, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.downloadSQLiteDB(spreadsheet_id, spreadsheet_version_id, dashboard_id, table_name, all_tables, cache_key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        duplicateWebDashboard: function (web_dashboard_id, duplicate_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.duplicateWebDashboard(web_dashboard_id, duplicate_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        editDomainFamily: function (domain_family_id, edit_domain_family_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.editDomainFamily(domain_family_id, edit_domain_family_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        egnyteGetCsvRawValues: function (egnyte_get_csv_raw_values_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.egnyteGetCsvRawValues(egnyte_get_csv_raw_values_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        emailRedirect: function (target_id, source_id, source, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.emailRedirect(target_id, source_id, source, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        errorsTrackUserProblem: function (errors_track_user_problem_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.errorsTrackUserProblem(errors_track_user_problem_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelDataImportRunTestFlow: function (excel_data_import_run_test_flow_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelDataImportRunTestFlow(excel_data_import_run_test_flow_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelGetMetadata: function (excel_get_metadata_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelGetMetadata(excel_get_metadata_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelRedirect: function (id, redirection_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelRedirect(id, redirection_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelVerifyBoxFile: function (excel_verify_box_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelVerifyBoxFile(excel_verify_box_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelVerifyEgnyteFile: function (excel_verify_egnyte_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelVerifyEgnyteFile(excel_verify_egnyte_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelVerifyOneDriveFile: function (excel_verify_one_drive_file_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelVerifyOneDriveFile(excel_verify_one_drive_file_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        excelVerifyUrl: function (excel_verify_url_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.excelVerifyUrl(excel_verify_url_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        exchangeAuthToken: function (exchange_auth_token_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.exchangeAuthToken(exchange_auth_token_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        exchangeCRXAuthToken: function (exchange_crx_auth_token_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.exchangeCRXAuthToken(exchange_crx_auth_token_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        fetchSnapshotClientPlan: function (snapshot_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.fetchSnapshotClientPlan(snapshot_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        fetchSnapshotSheets: function (google_sheet_file_id, excel_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.fetchSnapshotSheets(google_sheet_file_id, excel_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        fetchSnapshots: function (google_sheet_file_id, google_sheet_tab_id, excel_file_id, user_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.fetchSnapshots(google_sheet_file_id, google_sheet_tab_id, excel_file_id, user_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        fetchWritebacksSchema: function (data_source_id, fetch_writebacks_schema_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.fetchWritebacksSchema(data_source_id, fetch_writebacks_schema_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        forceRestoreWebDashboard: function (web_dashboard_id, force_restore_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.forceRestoreWebDashboard(web_dashboard_id, force_restore_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gSheetsGetColumns: function (g_sheets_get_columns_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gSheetsGetColumns(g_sheets_get_columns_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gSheetsGetNamedRangeParameters: function (target_google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gSheetsGetNamedRangeParameters(target_google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gSheetsGetTabs: function (g_sheets_get_tabs_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gSheetsGetTabs(g_sheets_get_tabs_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gSheetsUpsertNamedRangeParameter: function (g_sheets_upsert_named_range_parameter_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gSheetsUpsertNamedRangeParameter(g_sheets_upsert_named_range_parameter_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        generateDashboardSheetsContext: function (generate_dashboard_sheets_context_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.generateDashboardSheetsContext(generate_dashboard_sheets_context_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        generateExcelSheetsContext: function (generate_excel_sheets_context_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.generateExcelSheetsContext(generate_excel_sheets_context_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        generateSheetsContext: function (generate_sheets_context_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.generateSheetsContext(generate_sheets_context_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        generateSheetsContextExtended: function (generate_sheets_context_extended_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.generateSheetsContextExtended(generate_sheets_context_extended_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        genericScraperBulkRun: function (generic_scraper_bulk_run_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.genericScraperBulkRun(generic_scraper_bulk_run_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAccountsInfo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAccountsInfo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAdminAgentCreditHistory: function (email, limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAdminAgentCreditHistory(email, limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAdminAgentCredits: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAdminAgentCredits(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentCreditHistory: function (limit, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentCreditHistory(limit, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentCredits: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentCredits(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentImport: function (import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentImport(import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentRun: function (run_id, wait_seconds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentRun(run_id, wait_seconds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentTask: function (task_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentTask(task_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentTasks: function (thread_id, spreadsheet_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentTasks(thread_id, spreadsheet_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentThreadRun: function (thread_id, agent_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentThreadRun(thread_id, agent_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAgentThreads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAgentThreads(updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAiUsageAllowance: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAiUsageAllowance(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlert: function (alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlert(alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlertReport: function (alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlertReport(alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlertRunHistory: function (alert_id, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlertRunHistory(alert_id, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlerts: function (google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlerts(google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getArchivedWebDashboards: function (email, domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getArchivedWebDashboards(email, domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAssistantThreadV2Run: function (thread_id, assistant_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAssistantThreadV2Run(thread_id, assistant_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAssistantThreadV2Threads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAssistantThreadV2Threads(updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAutoAnalystRunStatus: function (auto_analyses_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAutoAnalystRunStatus(auto_analyses_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getBillingDetails: function (get_billing_details_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getBillingDetails(get_billing_details_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getChargebeeCoupons: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getChargebeeCoupons(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getClientFlags: function (google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getClientFlags(google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getClonedSpreadsheetSource: function (cloned_spreadsheet_file_id, source_spreadsheet_data_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getClonedSpreadsheetSource(cloned_spreadsheet_file_id, source_spreadsheet_data_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getCloudTable: function (cloud_table_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getCloudTable(cloud_table_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getCloudTableData: function (cloud_table_id, get_cloud_table_data_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getCloudTableData(cloud_table_id, get_cloud_table_data_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getCloudTableRunHistory: function (cloud_table_id, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getCloudTableRunHistory(cloud_table_id, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getCloudTables: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getCloudTables(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getCuratedAPIAgentWelcomeConfig: function (data_source_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getCuratedAPIAgentWelcomeConfig(data_source_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDashboardSpreadsheets: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDashboardSpreadsheets(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDashboardTeamActivity: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDashboardTeamActivity(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImport: function (data_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImport(data_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportCompatibleDataSources: function (data_import_id, restricted_field_option, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportCompatibleDataSources(data_import_id, restricted_field_option, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportDueScheduledRuns: function (get_data_import_due_scheduled_runs_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportDueScheduledRuns(get_data_import_due_scheduled_runs_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportEditAccessType: function (data_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportEditAccessType(data_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportQuery: function (data_source_type, get_data_import_query_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportQuery(data_source_type, get_data_import_query_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRecipe: function (data_import_recipe_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRecipe(data_import_recipe_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRecipes: function (data_source_type, limit, custom_api_previous_import_option, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRecipes(data_source_type, limit, custom_api_previous_import_option, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRunHistory: function (data_import_id, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRunHistory(data_import_id, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportRunStatus: function (data_import_id, max_wait_time_secs, data_import_run_id, preempt_option, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportRunStatus(data_import_id, max_wait_time_secs, data_import_run_id, preempt_option, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImportWriterPlan: function (data_import_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImportWriterPlan(data_import_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImports: function (target_google_sheets_file_id, include_deleted, data_source_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImports(target_google_sheets_file_id, include_deleted, data_source_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSource: function (data_source_id, restricted_field_option, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSource(data_source_id, restricted_field_option, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSourceSQLTable: function (data_source_id, schema_name, table_name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSourceSQLTable(data_source_id, schema_name, table_name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSourceSchema: function (data_source_id, schema_name, force_refresh, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSourceSchema(data_source_id, schema_name, force_refresh, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSourceSchemas: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSourceSchemas(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataSources: function (restricted_field_option, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataSources(restricted_field_option, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainCoupon: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainCoupon(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainFamilies: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainFamilies(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainFamily: function (domain_family_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainFamily(domain_family_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainFamilyChangeLog: function (domain_family_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainFamilyChangeLog(domain_family_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainUsers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainUsers(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDynamicClone: function (dynamic_clone_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDynamicClone(dynamic_clone_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDynamicClones: function (google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDynamicClones(google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEditorThreadMessages: function (dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEditorThreadMessages(dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEgnyteToken: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEgnyteToken(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnabledDataSources: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnabledDataSources(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnrich: function (enrich_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnrich(enrich_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnrichMetadata: function (get_enrich_metadata_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnrichMetadata(get_enrich_metadata_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnrichRunStatus: function (enrich_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnrichRunStatus(enrich_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnrichRuns: function (enrich_id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnrichRuns(enrich_id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getEnriches: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getEnriches(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getExcelFileId: function (get_excel_file_id_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getExcelFileId(get_excel_file_id_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getExcelSheetsContextPresignedUrl: function (get_excel_sheets_context_presigned_url_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getExcelSheetsContextPresignedUrl(get_excel_sheets_context_presigned_url_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getFormulaImportCompatibleDataSources: function (formula_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getFormulaImportCompatibleDataSources(formula_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getInvitations: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getInvitations(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getLatestWebDashboardRun: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getLatestWebDashboardRun(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getLeadGen: function (leadgen_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getLeadGen(leadgen_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getLeadGenRunStatus: function (leadgen_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getLeadGenRunStatus(leadgen_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getLeadGenRuns: function (leadgen_id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getLeadGenRuns(leadgen_id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getLeadGens: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getLeadGens(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getMSTeamsAuthStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getMSTeamsAuthStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getMSTeamsTeamsAndChannels: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getMSTeamsTeamsAndChannels(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getNetsuiteReportMetadataInfo: function (get_netsuite_report_metadata_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getNetsuiteReportMetadataInfo(get_netsuite_report_metadata_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getOIDCLoginUrl: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getOIDCLoginUrl(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getOauthAttempt: function (oauth_attempt_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getOauthAttempt(oauth_attempt_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getPBDash: function (pb_dash_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getPBDash(pb_dash_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getPBDashBlueprints: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getPBDashBlueprints(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getPBDashes: function (target_google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getPBDashes(target_google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getPublicTemplates: function (data_source_type, filename, public_template_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getPublicTemplates(data_source_type, filename, public_template_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getRESTLetInfo: function (get_rest_let_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getRESTLetInfo(get_rest_let_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getRecipe: function (recipe_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getRecipe(recipe_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSQLiteDownloadURL: function (dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSQLiteDownloadURL(dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSQLiteDownloadURLPublic: function (dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSQLiteDownloadURLPublic(dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSlackAuthStatus: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSlackAuthStatus(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSlackChannelsAndUsers: function (alert_id, force_refresh, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSlackChannelsAndUsers(alert_id, force_refresh, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSmartAlert: function (smart_alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSmartAlert(smart_alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSmartAlertRuns: function (smart_alert_id, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSmartAlertRuns(smart_alert_id, limit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSmartAlertSuggestions: function (google_sheets_file_id, excel_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSmartAlertSuggestions(google_sheets_file_id, excel_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSnowflakeKeyPair: function (get_snowflake_key_pair_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSnowflakeKeyPair(get_snowflake_key_pair_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSubscriptionInfo: function (subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSubscriptionInfo(subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSubscriptionInvoiceUrl: function (invoice_id, subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSubscriptionInvoiceUrl(invoice_id, subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSubscriptionInvoices: function (subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSubscriptionInvoices(subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSubscriptions: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSubscriptions(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getSubscriptionsPreCheckout: function (subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getSubscriptionsPreCheckout(subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUsageMeter: function (meter_type_str, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUsageMeter(meter_type_str, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUser: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUser(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUserExtra: function (user_extra_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUserExtra(user_extra_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUserSSOInfo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUserSSOInfo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getVirtualImportData: function (data_import_id, get_virtual_import_data_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getVirtualImportData(data_import_id, get_virtual_import_data_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboard: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboard(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardForScreenshot: function (web_dashboard_id, screenshot_token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardForScreenshot(web_dashboard_id, screenshot_token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardOffer: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardOffer(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardPlanLimit: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardPlanLimit(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardPlanUsage: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardPlanUsage(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardPublic: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardPublic(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardRun: function (web_dashboard_id, web_dashboard_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardRun(web_dashboard_id, web_dashboard_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardTabImpact: function (web_dashboard_id, tab_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardTabImpact(web_dashboard_id, tab_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardTrialHistory: function (product_trial_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardTrialHistory(product_trial_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebDashboardTrialUsers: function (domain, emails, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebDashboardTrialUsers(domain, emails, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWebhookUrl: function (get_webhook_url_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWebhookUrl(get_webhook_url_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWorkspace: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWorkspace(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWriteback: function (writeback_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWriteback(writeback_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackMatchingDataSource: function (writeback_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackMatchingDataSource(writeback_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackRowStatuses: function (writeback_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackRowStatuses(writeback_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackRunHistory: function (writeback_id, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackRunHistory(writeback_id, offset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackUploadDataUrl: function (writeback_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackUploadDataUrl(writeback_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebackWriterPlan: function (writeback_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebackWriterPlan(writeback_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebacks: function (target_google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebacks(target_google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getWritebacksSchema: function (data_source_id, object_name, writeback_mode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getWritebacksSchema(data_source_id, object_name, writeback_mode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getZendeskChatSessionJWT: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getZendeskChatSessionJWT(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        googleAnalyticsGetSchema: function (google_analytics_get_schema_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.googleAnalyticsGetSchema(google_analytics_get_schema_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        googleAnalyticsGetSchemaAlias: function (google_analytics_get_schema_alias_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.googleAnalyticsGetSchemaAlias(google_analytics_get_schema_alias_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        googleDriveCheckConnection: function (google_drive_check_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.googleDriveCheckConnection(google_drive_check_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        googleDriveGetAuthToken: function (google_drive_get_auth_token_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.googleDriveGetAuthToken(google_drive_get_auth_token_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        googleDriveGetCsvRawValues: function (google_drive_get_csv_raw_values_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.googleDriveGetCsvRawValues(google_drive_get_csv_raw_values_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptChart: function (gpt_chart_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptChart(gpt_chart_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptChartWriter: function (gpt_chart_writer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptChartWriter(gpt_chart_writer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptFeedback: function (gpt_feedback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptFeedback(gpt_feedback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptFormula: function (gpt_formula_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptFormula(gpt_formula_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptPivot: function (gpt_pivot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptPivot(gpt_pivot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptPivotWriter: function (gpt_pivot_writer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptPivotWriter(gpt_pivot_writer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptSQL: function (gpt_sql_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptSQL(gpt_sql_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        gptSQLFixQuery: function (gpt_sql_fix_query_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.gptSQLFixQuery(gpt_sql_fix_query_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        handleMSGraphWebhook: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.handleMSGraphWebhook(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        handleSmartAlertsOnChange: function (handle_smart_alerts_on_change_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.handleSmartAlertsOnChange(handle_smart_alerts_on_change_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetAllLists: function (hubspot_get_all_lists_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetAllLists(hubspot_get_all_lists_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetObjectType: function (hubspot_get_object_type_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetObjectType(hubspot_get_object_type_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetObjectTypes: function (hubspot_get_object_types_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetObjectTypes(hubspot_get_object_types_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetPipelineStages: function (hubspot_get_pipeline_stages_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetPipelineStages(hubspot_get_pipeline_stages_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetPipelines: function (hubspot_get_pipelines_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetPipelines(hubspot_get_pipelines_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        hubspotGetPipelinesMultiObject: function (hubspot_get_pipelines_multi_object_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.hubspotGetPipelinesMultiObject(hubspot_get_pipelines_multi_object_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        initiateDataimportsTransfer: function (initiate_dataimports_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.initiateDataimportsTransfer(initiate_dataimports_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        initiateSlackMarketplaceOauth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.initiateSlackMarketplaceOauth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        inviteWebDashboardShare: function (web_dashboard_id, invite_web_dashboard_share_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.inviteWebDashboardShare(web_dashboard_id, invite_web_dashboard_share_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        killWritebackRun: function (writeback_id, writeback_run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.killWritebackRun(writeback_id, writeback_run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listAgentConnections: function (query, connection_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listAgentConnections(query, connection_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listAgentImports: function (spreadsheet_id, connection_id, owned_by_me, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listAgentImports(spreadsheet_id, connection_id, owned_by_me, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listArrowFlightSqlAppInfo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listArrowFlightSqlAppInfo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listCustomOAuthAppInfo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listCustomOAuthAppInfo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listDatabricksAppInfo: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listDatabricksAppInfo(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listFormulaImports: function (target_google_sheets_file_id, data_source_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listFormulaImports(target_google_sheets_file_id, data_source_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listLicenseRequests: function (subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listLicenseRequests(subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listLookerAppInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listLookerAppInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listNetSuiteAppInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listNetSuiteAppInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listRecipes: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listRecipes(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listSmartAlerts: function (excel_file_id, google_sheets_file_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listSmartAlerts(excel_file_id, google_sheets_file_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listSnowflakeAppInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listSnowflakeAppInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listTableauAppInfo: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listTableauAppInfo(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listWebDashboardCustomThemes: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listWebDashboardCustomThemes(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listWebDashboardShares: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listWebDashboardShares(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listWebDashboardSubscriptionRuns: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listWebDashboardSubscriptionRuns(web_dashboard_id, web_dashboard_subscription_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listWebDashboardSubscriptions: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listWebDashboardSubscriptions(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        listWebDashboards: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.listWebDashboards(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        loadDashboardVersion: function (load_dashboard_version_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.loadDashboardVersion(load_dashboard_version_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerCheckConnection: function (looker_check_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerCheckConnection(looker_check_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerFetchUrlBasedAuthDetails: function (looker_fetch_url_based_auth_details_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerFetchUrlBasedAuthDetails(looker_fetch_url_based_auth_details_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerGetDashboardElements: function (looker_get_dashboard_elements_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerGetDashboardElements(looker_get_dashboard_elements_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerGetDataSourceOwnerMetaData: function (looker_get_data_source_owner_meta_data_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerGetDataSourceOwnerMetaData(looker_get_data_source_owner_meta_data_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerGetFolder: function (looker_get_folder_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerGetFolder(looker_get_folder_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerGetObjects: function (looker_get_objects_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerGetObjects(looker_get_objects_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerGetSchema: function (looker_get_schema_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerGetSchema(looker_get_schema_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        lookerSearchObjects: function (looker_search_objects_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.lookerSearchObjects(looker_search_objects_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        maybeCreateUser: function (signup_source, signup_source_campaign, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.maybeCreateUser(signup_source, signup_source_campaign, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        maybeSendEmailImportRefreshBlocked: function (data_import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.maybeSendEmailImportRefreshBlocked(data_import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        migrateSnapshotToV2: function (migrate_snapshot_to_v2_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.migrateSnapshotToV2(migrate_snapshot_to_v2_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        noSqlGetSchema: function (no_sql_get_schema_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.noSqlGetSchema(no_sql_get_schema_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        oauth2ProxyGrant: function (service_id, state, code, error, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.oauth2ProxyGrant(service_id, state, code, error, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        oauth2ProxyGrantFormPost: function (service_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.oauth2ProxyGrantFormPost(service_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        oauth2Uninstall: function (service_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.oauth2Uninstall(service_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        oneDriveGetCsvRawValues: function (one_drive_get_csv_raw_values_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.oneDriveGetCsvRawValues(one_drive_get_csv_raw_values_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        parsePageContent: function (parse_page_content_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.parsePageContent(parse_page_content_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        patchUserExtra: function (patch_user_extra_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.patchUserExtra(patch_user_extra_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        patchWebDashboard: function (web_dashboard_id, patch_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.patchWebDashboard(web_dashboard_id, patch_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        patchWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, patch_web_dashboard_subscription_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.patchWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, patch_web_dashboard_subscription_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        pauseAgentImport: function (import_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.pauseAgentImport(import_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postAgentThread: function (post_agent_thread_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postAgentThread(post_agent_thread_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postAgentThreadPause: function (thread_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postAgentThreadPause(thread_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postAssistantThreadV2: function (post_assistant_thread_v2_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postAssistantThreadV2(post_assistant_thread_v2_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postAssistantThreadV2Feedback: function (post_assistant_thread_v2_feedback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postAssistantThreadV2Feedback(post_assistant_thread_v2_feedback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postAutoAnalyses: function (post_auto_analyses_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postAutoAnalyses(post_auto_analyses_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postGPTFunctionsClearCache: function (post_gpt_functions_clear_cache_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postGPTFunctionsClearCache(post_gpt_functions_clear_cache_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        postMSTeamsBotMessages: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.postMSTeamsBotMessages(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ppressPreviewModalRenderForm: function (ppress_preview_modal_render_form_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ppressPreviewModalRenderForm(ppress_preview_modal_render_form_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ppressRenderAuthForm: function (ppress_render_auth_form_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ppressRenderAuthForm(ppress_render_auth_form_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ppressRenderForm: function (ppress_render_form_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ppressRenderForm(ppress_render_form_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ppressRenderPublicTemplateForm: function (ppress_render_public_template_form_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ppressRenderPublicTemplateForm(ppress_render_public_template_form_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        presignWebDashboardBlockScreenshot: function (request_id, presign_web_dashboard_block_screenshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.presignWebDashboardBlockScreenshot(request_id, presign_web_dashboard_block_screenshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        previewAgentImportSource: function (connection_id, preview_agent_import_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.previewAgentImportSource(connection_id, preview_agent_import_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        previewRunWriteback: function (writeback_id, preview_run_writeback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.previewRunWriteback(writeback_id, preview_run_writeback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        previewSmartAlert: function (preview_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.previewSmartAlert(preview_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        processCustomFunction: function (process_custom_function_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.processCustomFunction(process_custom_function_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        processCustomFunctionAsync: function (process_custom_function_async_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.processCustomFunctionAsync(process_custom_function_async_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        putCRXGetFiltersAttempt: function (attempt_id, put_crx_get_filters_attempt_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.putCRXGetFiltersAttempt(attempt_id, put_crx_get_filters_attempt_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        putCRXLoginStatusCheckAttempt: function (attempt_id, put_crx_login_status_check_attempt_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.putCRXLoginStatusCheckAttempt(attempt_id, put_crx_login_status_check_attempt_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        putCRXRunAttempt: function (crx_run_attempt_id, put_crx_run_attempt_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.putCRXRunAttempt(crx_run_attempt_id, put_crx_run_attempt_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        putCRXValidateUrlAttempt: function (attempt_id, put_crx_validate_url_attempt_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.putCRXValidateUrlAttempt(attempt_id, put_crx_validate_url_attempt_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        quickbooksGetReportFilter: function (quickbooks_get_report_filter_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.quickbooksGetReportFilter(quickbooks_get_report_filter_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        quickbooksGetReportFilters: function (quickbooks_get_report_filters_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.quickbooksGetReportFilters(quickbooks_get_report_filters_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        quickstart: function (email, force_create, addon_platform, variant_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.quickstart(email, force_create, addon_platform, variant_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ratingPopupSetRating: function (rating_popup_set_rating_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ratingPopupSetRating(rating_popup_set_rating_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        ratingPopupTrackShown: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.ratingPopupTrackShown(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        recipeRunResults: function (recipe_id, run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.recipeRunResults(recipe_id, run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        recipeRunStatus: function (recipe_id, run_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.recipeRunStatus(recipe_id, run_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        recordWebDashboardView: function (web_dashboard_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.recordWebDashboardView(web_dashboard_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        recordWebDashboardViewPublic: function (web_dashboard_id, record_web_dashboard_view_public_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.recordWebDashboardViewPublic(web_dashboard_id, record_web_dashboard_view_public_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        refreshAuthToken: function (refresh_auth_token_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.refreshAuthToken(refresh_auth_token_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        refreshCustomFunctionFormula: function (refresh_custom_function_formula_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.refreshCustomFunctionFormula(refresh_custom_function_formula_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        refreshNetsuiteReportMetadata: function (refresh_netsuite_report_metadata_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.refreshNetsuiteReportMetadata(refresh_netsuite_report_metadata_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        refreshWebDashboard: function (web_dashboard_id, refresh_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.refreshWebDashboard(web_dashboard_id, refresh_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        removeCouponFromDomain: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.removeCouponFromDomain(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        removeCouponFromSubscription: function (subscription_id, coupon, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.removeCouponFromSubscription(subscription_id, coupon, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        removeWebDashboardPlanLimitOverride: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.removeWebDashboardPlanLimitOverride(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        reportExcelManualRunOutcome: function (report_excel_manual_run_outcome_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.reportExcelManualRunOutcome(report_excel_manual_run_outcome_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        reportSnapshotClientOutcome: function (snapshot_id, report_snapshot_client_outcome_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.reportSnapshotClientOutcome(snapshot_id, report_snapshot_client_outcome_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        requestLicense: function (request_license_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.requestLicense(request_license_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        resendInvite: function (invite_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.resendInvite(invite_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        resetUser: function (reset_user_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.resetUser(reset_user_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        resetUserMeter: function (reset_user_meter_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.resetUserMeter(reset_user_meter_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        resolveLicenseRequest: function (resolve_license_request_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.resolveLicenseRequest(resolve_license_request_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        restoreWebDashboardCustomTheme: function (theme_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.restoreWebDashboardCustomTheme(theme_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        retoolSetFreeTrialAutomaticStartMode: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.retoolSetFreeTrialAutomaticStartMode(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        retoolTrialStateBulkUpdateWithTrialState: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.retoolTrialStateBulkUpdateWithTrialState(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        retoolTrialStateBulkUpdateWithUserEmail: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.retoolTrialStateBulkUpdateWithUserEmail(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        retoolUpdateSubscriptionEstimate: function (retool_update_subscription_estimate_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.retoolUpdateSubscriptionEstimate(retool_update_subscription_estimate_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        retoolWebDashboardTrialBulkUpdate: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.retoolWebDashboardTrialBulkUpdate(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        revokeMSTeamsAuth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.revokeMSTeamsAuth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        revokeSlackAuth: function (revoke_slack_auth_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.revokeSlackAuth(revoke_slack_auth_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runAgentImport: function (import_id, run_agent_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runAgentImport(import_id, run_agent_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runAgentTask: function (task_id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runAgentTask(task_id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runCloudTable: function (cloud_table_id, is_scheduled_run, run_cloud_table_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runCloudTable(cloud_table_id, is_scheduled_run, run_cloud_table_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runCloudTablePreviewRun: function (run_cloud_table_preview_run_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runCloudTablePreviewRun(run_cloud_table_preview_run_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataImport: function (data_import_id, is_scheduled_run, is_triggered_by_parameterized_filter, proposed_run_id, run_data_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataImport(data_import_id, is_scheduled_run, is_triggered_by_parameterized_filter, proposed_run_id, run_data_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataImportFieldChoices: function (run_data_import_field_choices_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataImportFieldChoices(run_data_import_field_choices_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataImportMulti: function (run_data_import_multi_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataImportMulti(run_data_import_multi_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataImportPreviewRun: function (run_data_import_preview_run_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataImportPreviewRun(run_data_import_preview_run_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataImportSnapshot: function (data_import_id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataImportSnapshot(data_import_id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDataimportMorpheus: function (data_import_id, run_dataimport_morpheus_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDataimportMorpheus(data_import_id, run_dataimport_morpheus_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runDynamicClone: function (dynamic_clone_id, run_dynamic_clone_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runDynamicClone(dynamic_clone_id, run_dynamic_clone_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runEnrich: function (enrich_id, run_enrich_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runEnrich(enrich_id, run_enrich_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runFormulaFunction: function (run_formula_function_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runFormulaFunction(run_formula_function_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runGPTFunction: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runGPTFunction(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runLeadGen: function (leadgen_id, run_lead_gen_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runLeadGen(leadgen_id, run_lead_gen_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runRecipe: function (recipe_id, run_recipe_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runRecipe(recipe_id, run_recipe_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runSmartAlert: function (smart_alert_id, run_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runSmartAlert(smart_alert_id, run_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runSnapshot: function (snapshot_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runSnapshot(snapshot_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runWebhook: function (webhook_token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runWebhook(webhook_token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runWriteback: function (writeback_id, run_writeback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runWriteback(writeback_id, run_writeback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        runWritebackMulti: function (run_writeback_multi_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.runWritebackMulti(run_writeback_multi_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sageDeleteFinancialReport: function (report_name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sageDeleteFinancialReport(report_name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sageGetFinancialReports: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sageGetFinancialReports(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        salesforceGetObjectType: function (salesforce_get_object_type_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.salesforceGetObjectType(salesforce_get_object_type_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        salesforceGetObjectTypes: function (salesforce_get_object_types_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.salesforceGetObjectTypes(salesforce_get_object_types_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        salesforceGetReportType: function (salesforce_get_report_type_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.salesforceGetReportType(salesforce_get_report_type_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        salesforceGetReports: function (salesforce_get_reports_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.salesforceGetReports(salesforce_get_reports_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        saveAffiliateReferral: function (save_affiliate_referral_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.saveAffiliateReferral(save_affiliate_referral_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        screenshotDelay: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.screenshotDelay(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sendCoworkerInvitation: function (send_coworker_invitation_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sendCoworkerInvitation(send_coworker_invitation_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sendInvite: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sendInvite(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sendPreviewSmartAlert: function (send_preview_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sendPreviewSmartAlert(send_preview_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sendSupportEmail: function (send_support_email_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sendSupportEmail(send_support_email_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setUserExtra: function (set_user_extra_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setUserExtra(set_user_extra_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setWebDashboardCustomLogo: function (set_web_dashboard_custom_logo_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setWebDashboardCustomLogo(set_web_dashboard_custom_logo_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setWebDashboardCustomThemeDefault: function (theme_id, set_web_dashboard_custom_theme_default_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setWebDashboardCustomThemeDefault(theme_id, set_web_dashboard_custom_theme_default_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setWebDashboardPlanLimitOverride: function (domain, set_web_dashboard_plan_limit_override_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setWebDashboardPlanLimitOverride(domain, set_web_dashboard_plan_limit_override_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyAuth: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyAuth(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyDeleteCustomer: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyDeleteCustomer(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyDeleteShop: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyDeleteShop(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shopifyGetCustomer: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shopifyGetCustomer(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        shouldSkipSuboptions: function (data_source_type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.shouldSkipSuboptions(data_source_type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        signWritebackMultipartParts: function (writeback_id, sign_writeback_multipart_parts_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.signWritebackMultipartParts(writeback_id, sign_writeback_multipart_parts_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        slackAuthTest: function (token, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.slackAuthTest(token, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        slackDashboardUnfurlEvents: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.slackDashboardUnfurlEvents(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        slackDashboardUnfurlInteraction: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.slackDashboardUnfurlInteraction(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        slackInteractionCallback: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.slackInteractionCallback(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        smartAlertMSTeamsAuthTest: function (smart_alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.smartAlertMSTeamsAuthTest(smart_alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        smartAlertSlackAuthTest: function (smart_alert_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.smartAlertSlackAuthTest(smart_alert_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        sqlGetSchema: function (data_source_type, sql_get_schema_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.sqlGetSchema(data_source_type, sql_get_schema_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        startWritebackMultipartUpload: function (writeback_id, start_writeback_multipart_upload_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.startWritebackMultipartUpload(writeback_id, start_writeback_multipart_upload_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        storeAgentGoogleGrant: function (store_agent_google_grant_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.storeAgentGoogleGrant(store_agent_google_grant_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        subscriptionsChargebeeWebhook: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionsChargebeeWebhook(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        subscriptionsCheckout: function (subscriptions_checkout_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.subscriptionsCheckout(subscriptions_checkout_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauCheckConnection: function (tableau_check_connection_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauCheckConnection(tableau_check_connection_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauGetRecentlyViewedWorksheets: function (tableau_get_recently_viewed_worksheets_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauGetRecentlyViewedWorksheets(tableau_get_recently_viewed_worksheets_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauGetServerInfo: function (tableau_get_server_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauGetServerInfo(tableau_get_server_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauGetViewsInDashboard: function (tableau_get_views_in_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauGetViewsInDashboard(tableau_get_views_in_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauGetWorksheet: function (tableau_get_worksheet_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauGetWorksheet(tableau_get_worksheet_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        tableauGetWorksheetFromUrl: function (tableau_get_worksheet_from_url_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.tableauGetWorksheetFromUrl(tableau_get_worksheet_from_url_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        triggerLookerConnEmail: function (trigger_looker_conn_email_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.triggerLookerConnEmail(trigger_looker_conn_email_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        undoWebDashboardRefresh: function (web_dashboard_id, undo_web_dashboard_refresh_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.undoWebDashboardRefresh(web_dashboard_id, undo_web_dashboard_refresh_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateAgentImport: function (import_id, update_agent_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateAgentImport(import_id, update_agent_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateAgentTask: function (task_id, update_agent_task_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateAgentTask(task_id, update_agent_task_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateAlert: function (alert_id, update_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateAlert(alert_id, update_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateCloudTable: function (cloud_table_id, update_cloud_table_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateCloudTable(cloud_table_id, update_cloud_table_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataImport: function (data_import_id, update_data_import_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataImport(data_import_id, update_data_import_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataImportDataSource: function (data_import_id, update_data_import_data_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataImportDataSource(data_import_id, update_data_import_data_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataImportEditAccessType: function (data_import_id, update_data_import_edit_access_type_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataImportEditAccessType(data_import_id, update_data_import_edit_access_type_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataImportRecipe: function (data_import_recipe_id, update_data_import_recipe_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataImportRecipe(data_import_recipe_id, update_data_import_recipe_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataImportTargetInfo: function (data_import_id, update_data_import_target_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataImportTargetInfo(data_import_id, update_data_import_target_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDataSource(data_source_id, update_data_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateDynamicClone: function (dynamic_clone_id, update_dynamic_clone_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateDynamicClone(dynamic_clone_id, update_dynamic_clone_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateEnrich: function (enrich_id, update_enrich_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateEnrich(enrich_id, update_enrich_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateFormulaImportDataSource: function (formula_import_id, update_formula_import_data_source_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateFormulaImportDataSource(formula_import_id, update_formula_import_data_source_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateLeadGen: function (leadgen_id, update_lead_gen_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateLeadGen(leadgen_id, update_lead_gen_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updatePBDash: function (pb_dash_id, update_pb_dash_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updatePBDash(pb_dash_id, update_pb_dash_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateRecipe: function (recipe_id, update_recipe_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateRecipe(recipe_id, update_recipe_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSmartAlert: function (smart_alert_id, update_smart_alert_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSmartAlert(smart_alert_id, update_smart_alert_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSmartAlertEditAccessType: function (smart_alert_id, update_smart_alert_edit_access_type_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSmartAlertEditAccessType(smart_alert_id, update_smart_alert_edit_access_type_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSnapshot: function (snapshot_id, update_snapshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSnapshot(snapshot_id, update_snapshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSubscriptionCustomDeal: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSubscriptionCustomDeal(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSubscriptionEstimate: function (update_subscription_estimate_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSubscriptionEstimate(update_subscription_estimate_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSubscriptionViaRetool: function (update_subscription_via_retool_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSubscriptionViaRetool(update_subscription_via_retool_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateSubscriptions: function (update_subscriptions_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateSubscriptions(update_subscriptions_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateTableauAppInfo: function (update_tableau_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateTableauAppInfo(update_tableau_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateUser: function (user_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateUser(user_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateUserMe: function (update_user_me_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateUserMe(update_user_me_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWebDashboard: function (web_dashboard_id, update_web_dashboard_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWebDashboard(web_dashboard_id, update_web_dashboard_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, update_web_dashboard_subscription_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, update_web_dashboard_subscription_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWebDashboardTabsConfig: function (web_dashboard_id, update_web_dashboard_tabs_config_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWebDashboardTabsConfig(web_dashboard_id, update_web_dashboard_tabs_config_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWorkspace: function (workspace_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWorkspace(workspace_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWriteback: function (writeback_id, update_writeback_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWriteback(writeback_id, update_writeback_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        updateWritebackMappingLabels: function (writeback_id, update_writeback_mapping_labels_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.updateWritebackMappingLabels(writeback_id, update_writeback_mapping_labels_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        uploadWebDashboardBlockScreenshot: function (request_id, upload_web_dashboard_block_screenshot_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.uploadWebDashboardBlockScreenshot(request_id, upload_web_dashboard_block_screenshot_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertArrowFlightSqlAppInfo: function (upsert_arrow_flight_sql_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertArrowFlightSqlAppInfo(upsert_arrow_flight_sql_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertCustomOAuthAppInfo: function (upsert_custom_o_auth_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertCustomOAuthAppInfo(upsert_custom_o_auth_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertDatabricksAppInfo: function (upsert_databricks_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertDatabricksAppInfo(upsert_databricks_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertLookerAppInfo: function (upsert_looker_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertLookerAppInfo(upsert_looker_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertNetSuiteAppInfo: function (upsert_net_suite_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertNetSuiteAppInfo(upsert_net_suite_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertPublicTemplate: function (upsert_public_template_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertPublicTemplate(upsert_public_template_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertSnowflakeAppInfo: function (upsert_snowflake_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertSnowflakeAppInfo(upsert_snowflake_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertTableauAppInfo: function (upsert_tableau_app_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertTableauAppInfo(upsert_tableau_app_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        validateWritebackMappings: function (data_source_id, validate_writeback_mappings_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.validateWritebackMappings(data_source_id, validate_writeback_mappings_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        vcrAuthGetInstanceInfo: function (vcr_auth_get_instance_info_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.vcrAuthGetInstanceInfo(vcr_auth_get_instance_info_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        vcrMetadata: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.vcrMetadata(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        vcrStartAuthSession: function (vcr_start_auth_session_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.vcrStartAuthSession(vcr_start_auth_session_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        vcrTerminateAuthSession: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.vcrTerminateAuthSession(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        verifyConnectionStatus: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.verifyConnectionStatus(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        viewWebDashboardAsSuperAdmin: function (web_dashboard_id, reason, ts, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.viewWebDashboardAsSuperAdmin(web_dashboard_id, reason, ts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        abortWritebackMultipartUpload: function (writeback_id, abort_writeback_multipart_upload_request, options) {
            return localVarFp.abortWritebackMultipartUpload(writeback_id, abort_writeback_multipart_upload_request, options).then(function (request) { return request(axios, basePath); });
        },
        activateSmartAlert: function (activate_smart_alert_request, options) {
            return localVarFp.activateSmartAlert(activate_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        addAgentCredits: function (add_agent_credits_request, options) {
            return localVarFp.addAgentCredits(add_agent_credits_request, options).then(function (request) { return request(axios, basePath); });
        },
        addCouponToDomain: function (domain, add_coupon_to_domain_request, options) {
            return localVarFp.addCouponToDomain(domain, add_coupon_to_domain_request, options).then(function (request) { return request(axios, basePath); });
        },
        adminGetAgentThreadMessages: function (thread_id, options) {
            return localVarFp.adminGetAgentThreadMessages(thread_id, options).then(function (request) { return request(axios, basePath); });
        },
        adminGetSmartAlertRuns: function (smart_alert_id, limit, options) {
            return localVarFp.adminGetSmartAlertRuns(smart_alert_id, limit, options).then(function (request) { return request(axios, basePath); });
        },
        adminGetSmartAlertThread: function (smart_alert_id, options) {
            return localVarFp.adminGetSmartAlertThread(smart_alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        adminGetThreadAnalysisResults: function (analysis_id, email, domain, agent_type, since, until, limit, offset, options) {
            return localVarFp.adminGetThreadAnalysisResults(analysis_id, email, domain, agent_type, since, until, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        adminListThreadAnalyses: function (options) {
            return localVarFp.adminListThreadAnalyses(options).then(function (request) { return request(axios, basePath); });
        },
        adminSearchSmartAlerts: function (email, smart_alert_id, spreadsheet_id, run_id, limit, offset, options) {
            return localVarFp.adminSearchSmartAlerts(email, smart_alert_id, spreadsheet_id, run_id, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        adminSearchWebDashboards: function (web_dashboard_id, email, domain, spreadsheet_id, exclude_coefficient_io, source_type, build_status, limit, offset, options) {
            return localVarFp.adminSearchWebDashboards(web_dashboard_id, email, domain, spreadsheet_id, exclude_coefficient_io, source_type, build_status, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        alertRemoveSlackConnection: function (alert_id, options) {
            return localVarFp.alertRemoveSlackConnection(alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        alertSlackAuthTest: function (alert_id, options) {
            return localVarFp.alertSlackAuthTest(alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        alertValidateSelectedTableRange: function (alert_validate_selected_table_range_request, options) {
            return localVarFp.alertValidateSelectedTableRange(alert_validate_selected_table_range_request, options).then(function (request) { return request(axios, basePath); });
        },
        alertsClockTrigger: function (body, options) {
            return localVarFp.alertsClockTrigger(body, options).then(function (request) { return request(axios, basePath); });
        },
        alertsGetRangeScreenshot: function (alerts_get_range_screenshot_request, options) {
            return localVarFp.alertsGetRangeScreenshot(alerts_get_range_screenshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        alertsMonitoredCellsDidChange: function (alerts_monitored_cells_did_change_request, options) {
            return localVarFp.alertsMonitoredCellsDidChange(alerts_monitored_cells_did_change_request, options).then(function (request) { return request(axios, basePath); });
        },
        alertsSendPreview: function (alerts_send_preview_request, options) {
            return localVarFp.alertsSendPreview(alerts_send_preview_request, options).then(function (request) { return request(axios, basePath); });
        },
        alertsSendTryout: function (alerts_send_tryout_request, options) {
            return localVarFp.alertsSendTryout(alerts_send_tryout_request, options).then(function (request) { return request(axios, basePath); });
        },
        analyticsTrack: function (analytics_track_request, options) {
            return localVarFp.analyticsTrack(analytics_track_request, options).then(function (request) { return request(axios, basePath); });
        },
        analyticsTrackAnonymousEvents: function (analytics_track_anonymous_events_request, options) {
            return localVarFp.analyticsTrackAnonymousEvents(analytics_track_anonymous_events_request, options).then(function (request) { return request(axios, basePath); });
        },
        analyticsTrackPreUserEvent: function (analytics_track_pre_user_event_request, options) {
            return localVarFp.analyticsTrackPreUserEvent(analytics_track_pre_user_event_request, options).then(function (request) { return request(axios, basePath); });
        },
        archiveWebDashboard: function (web_dashboard_id, archive_web_dashboard_request, options) {
            return localVarFp.archiveWebDashboard(web_dashboard_id, archive_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        authGoogleJWTCallback: function (options) {
            return localVarFp.authGoogleJWTCallback(options).then(function (request) { return request(axios, basePath); });
        },
        authLogout: function (options) {
            return localVarFp.authLogout(options).then(function (request) { return request(axios, basePath); });
        },
        authSignup: function (options) {
            return localVarFp.authSignup(options).then(function (request) { return request(axios, basePath); });
        },
        autoExpandRange: function (range, google_sheets_file_id, google_sheets_tab_id, excel_file_id, excel_drive_id, excel_site_id, excel_sheet_id, spreadsheet_id, tab_id, options) {
            return localVarFp.autoExpandRange(range, google_sheets_file_id, google_sheets_tab_id, excel_file_id, excel_drive_id, excel_site_id, excel_sheet_id, spreadsheet_id, tab_id, options).then(function (request) { return request(axios, basePath); });
        },
        boxGetAuthToken: function (box_get_auth_token_request, options) {
            return localVarFp.boxGetAuthToken(box_get_auth_token_request, options).then(function (request) { return request(axios, basePath); });
        },
        boxGetCsvRawValues: function (box_get_csv_raw_values_request, options) {
            return localVarFp.boxGetCsvRawValues(box_get_csv_raw_values_request, options).then(function (request) { return request(axios, basePath); });
        },
        browserAgentCommandResult: function (command_id, browser_agent_command_result_request, options) {
            return localVarFp.browserAgentCommandResult(command_id, browser_agent_command_result_request, options).then(function (request) { return request(axios, basePath); });
        },
        browserAgentConnection: function (browser_agent_connection_request, options) {
            return localVarFp.browserAgentConnection(browser_agent_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        browserAgentConnectionStatus: function (options) {
            return localVarFp.browserAgentConnectionStatus(options).then(function (request) { return request(axios, basePath); });
        },
        bulkEditSchedule: function (bulk_edit_schedule_request, options) {
            return localVarFp.bulkEditSchedule(bulk_edit_schedule_request, options).then(function (request) { return request(axios, basePath); });
        },
        bulkPollDataImportRunStatus: function (bulk_poll_data_import_run_status_request, options) {
            return localVarFp.bulkPollDataImportRunStatus(bulk_poll_data_import_run_status_request, options).then(function (request) { return request(axios, basePath); });
        },
        checkConnection: function (data_source_type, check_connection_request, options) {
            return localVarFp.checkConnection(data_source_type, check_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        checkDataSourceConnectionLimit: function (data_source_type, domain, options) {
            return localVarFp.checkDataSourceConnectionLimit(data_source_type, domain, options).then(function (request) { return request(axios, basePath); });
        },
        checkMSTeamsBotInChannel: function (check_ms_teams_bot_in_channel_request, options) {
            return localVarFp.checkMSTeamsBotInChannel(check_ms_teams_bot_in_channel_request, options).then(function (request) { return request(axios, basePath); });
        },
        checkSalesforceAppInstall: function (data_source_id, options) {
            return localVarFp.checkSalesforceAppInstall(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        checkWebDashboardEditPermission: function (web_dashboard_id, options) {
            return localVarFp.checkWebDashboardEditPermission(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        checkWebDashboardPermissionPublic: function (web_dashboard_id, options) {
            return localVarFp.checkWebDashboardPermissionPublic(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        checkWebsocketStatus: function (options) {
            return localVarFp.checkWebsocketStatus(options).then(function (request) { return request(axios, basePath); });
        },
        checkWritebackMappings: function (writeback_id, check_writeback_mappings_request, options) {
            return localVarFp.checkWritebackMappings(writeback_id, check_writeback_mappings_request, options).then(function (request) { return request(axios, basePath); });
        },
        claimSignupAttributionEvents: function (claim_signup_attribution_events_request, options) {
            return localVarFp.claimSignupAttributionEvents(claim_signup_attribution_events_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloneSpreadsheet: function (clone_spreadsheet_request, options) {
            return localVarFp.cloneSpreadsheet(clone_spreadsheet_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloneSpreadsheetAlerts: function (clone_spreadsheet_alerts_request, options) {
            return localVarFp.cloneSpreadsheetAlerts(clone_spreadsheet_alerts_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloneSpreadsheetSnapshots: function (clone_spreadsheet_snapshots_request, options) {
            return localVarFp.cloneSpreadsheetSnapshots(clone_spreadsheet_snapshots_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloneSpreadsheetUnpauseSchedules: function (clone_spreadsheet_unpause_schedules_request, options) {
            return localVarFp.cloneSpreadsheetUnpauseSchedules(clone_spreadsheet_unpause_schedules_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloneSpreadsheetWritebacks: function (clone_spreadsheet_writebacks_request, options) {
            return localVarFp.cloneSpreadsheetWritebacks(clone_spreadsheet_writebacks_request, options).then(function (request) { return request(axios, basePath); });
        },
        cloudLookup: function (cloud_lookup_request, options) {
            return localVarFp.cloudLookup(cloud_lookup_request, options).then(function (request) { return request(axios, basePath); });
        },
        coeffSearch: function (coeff_search_request, options) {
            return localVarFp.coeffSearch(coeff_search_request, options).then(function (request) { return request(axios, basePath); });
        },
        coeffSearchExperimental: function (coeff_search_experimental_request, options) {
            return localVarFp.coeffSearchExperimental(coeff_search_experimental_request, options).then(function (request) { return request(axios, basePath); });
        },
        completeDataImportsTransfer: function (complete_data_imports_transfer_request, options) {
            return localVarFp.completeDataImportsTransfer(complete_data_imports_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        completeExcelSheetsContextMultipartUpload: function (complete_excel_sheets_context_multipart_upload_request, options) {
            return localVarFp.completeExcelSheetsContextMultipartUpload(complete_excel_sheets_context_multipart_upload_request, options).then(function (request) { return request(axios, basePath); });
        },
        completeWritebackMultipartUpload: function (writeback_id, complete_writeback_multipart_upload_request, options) {
            return localVarFp.completeWritebackMultipartUpload(writeback_id, complete_writeback_multipart_upload_request, options).then(function (request) { return request(axios, basePath); });
        },
        createAgentImport: function (create_agent_import_request, options) {
            return localVarFp.createAgentImport(create_agent_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        createAgentTask: function (create_agent_task_request, options) {
            return localVarFp.createAgentTask(create_agent_task_request, options).then(function (request) { return request(axios, basePath); });
        },
        createAlert: function (create_alert_request, options) {
            return localVarFp.createAlert(create_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        createCloudTable: function (create_cloud_table_request, options) {
            return localVarFp.createCloudTable(create_cloud_table_request, options).then(function (request) { return request(axios, basePath); });
        },
        createConnection: function (create_connection_request, options) {
            return localVarFp.createConnection(create_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        createDataImport: function (create_data_import_request, options) {
            return localVarFp.createDataImport(create_data_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        createDataImportRecipe: function (create_data_import_recipe_request, options) {
            return localVarFp.createDataImportRecipe(create_data_import_recipe_request, options).then(function (request) { return request(axios, basePath); });
        },
        createDataSource: function (create_data_source_request, options) {
            return localVarFp.createDataSource(create_data_source_request, options).then(function (request) { return request(axios, basePath); });
        },
        createDomainFamily: function (create_domain_family_request, options) {
            return localVarFp.createDomainFamily(create_domain_family_request, options).then(function (request) { return request(axios, basePath); });
        },
        createDynamicClone: function (create_dynamic_clone_request, options) {
            return localVarFp.createDynamicClone(create_dynamic_clone_request, options).then(function (request) { return request(axios, basePath); });
        },
        createEnrich: function (create_enrich_request, options) {
            return localVarFp.createEnrich(create_enrich_request, options).then(function (request) { return request(axios, basePath); });
        },
        createInternalWebDashboard: function (create_internal_web_dashboard_request, options) {
            return localVarFp.createInternalWebDashboard(create_internal_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        createLeadGen: function (create_lead_gen_request, options) {
            return localVarFp.createLeadGen(create_lead_gen_request, options).then(function (request) { return request(axios, basePath); });
        },
        createLookerUrlBasedAuth: function (body, options) {
            return localVarFp.createLookerUrlBasedAuth(body, options).then(function (request) { return request(axios, basePath); });
        },
        createOauthAttempt: function (create_oauth_attempt_request, options) {
            return localVarFp.createOauthAttempt(create_oauth_attempt_request, options).then(function (request) { return request(axios, basePath); });
        },
        createPBDash: function (create_pb_dash_request, options) {
            return localVarFp.createPBDash(create_pb_dash_request, options).then(function (request) { return request(axios, basePath); });
        },
        createPlaceholderWebDashboard: function (create_placeholder_web_dashboard_request, options) {
            return localVarFp.createPlaceholderWebDashboard(create_placeholder_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        createSmartAlert: function (create_smart_alert_request, options) {
            return localVarFp.createSmartAlert(create_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        createSnapshot: function (create_snapshot_request, options) {
            return localVarFp.createSnapshot(create_snapshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        createSubscriptionCustomDeal: function (options) {
            return localVarFp.createSubscriptionCustomDeal(options).then(function (request) { return request(axios, basePath); });
        },
        createUserAlias: function (create_user_alias_request, options) {
            return localVarFp.createUserAlias(create_user_alias_request, options).then(function (request) { return request(axios, basePath); });
        },
        createUserRequest: function (create_user_request_request, options) {
            return localVarFp.createUserRequest(create_user_request_request, options).then(function (request) { return request(axios, basePath); });
        },
        createWebDashboardSubscription: function (web_dashboard_id, create_web_dashboard_subscription_request, options) {
            return localVarFp.createWebDashboardSubscription(web_dashboard_id, create_web_dashboard_subscription_request, options).then(function (request) { return request(axios, basePath); });
        },
        createWorkspace: function (options) {
            return localVarFp.createWorkspace(options).then(function (request) { return request(axios, basePath); });
        },
        createWriteback: function (create_writeback_request, options) {
            return localVarFp.createWriteback(create_writeback_request, options).then(function (request) { return request(axios, basePath); });
        },
        crxCheckLoginStatus: function (account_id, options) {
            return localVarFp.crxCheckLoginStatus(account_id, options).then(function (request) { return request(axios, basePath); });
        },
        crxGetFilters: function (report_url, options) {
            return localVarFp.crxGetFilters(report_url, options).then(function (request) { return request(axios, basePath); });
        },
        crxValidateUrl: function (report_url, options) {
            return localVarFp.crxValidateUrl(report_url, options).then(function (request) { return request(axios, basePath); });
        },
        csvVerifyBoxFile: function (csv_verify_box_file_request, options) {
            return localVarFp.csvVerifyBoxFile(csv_verify_box_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        csvVerifyEgnyteFile: function (csv_verify_egnyte_file_request, options) {
            return localVarFp.csvVerifyEgnyteFile(csv_verify_egnyte_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        csvVerifyOneDriveFile: function (csv_verify_one_drive_file_request, options) {
            return localVarFp.csvVerifyOneDriveFile(csv_verify_one_drive_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        csvVerifyUrl: function (csv_verify_url_request, options) {
            return localVarFp.csvVerifyUrl(csv_verify_url_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteAgentImport: function (import_id, options) {
            return localVarFp.deleteAgentImport(import_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteAgentTask: function (task_id, options) {
            return localVarFp.deleteAgentTask(task_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteAlert: function (alert_id, options) {
            return localVarFp.deleteAlert(alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteArrowFlightSqlAppInfo: function (delete_arrow_flight_sql_app_info_request, options) {
            return localVarFp.deleteArrowFlightSqlAppInfo(delete_arrow_flight_sql_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteCloudTable: function (cloud_table_id, options) {
            return localVarFp.deleteCloudTable(cloud_table_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteCustomOAuthAppInfo: function (delete_custom_o_auth_app_info_request, options) {
            return localVarFp.deleteCustomOAuthAppInfo(delete_custom_o_auth_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDataImport: function (data_import_id, options) {
            return localVarFp.deleteDataImport(data_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDataImportRecipe: function (data_import_recipe_id, options) {
            return localVarFp.deleteDataImportRecipe(data_import_recipe_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDataSource: function (data_source_id, options) {
            return localVarFp.deleteDataSource(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDatabricksAppInfo: function (delete_databricks_app_info_request, options) {
            return localVarFp.deleteDatabricksAppInfo(delete_databricks_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDomainFamily: function (domain_family_id, options) {
            return localVarFp.deleteDomainFamily(domain_family_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteDynamicClone: function (dynamic_clone_id, options) {
            return localVarFp.deleteDynamicClone(dynamic_clone_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteEnrich: function (enrich_id, options) {
            return localVarFp.deleteEnrich(enrich_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteInvite: function (invite_id, options) {
            return localVarFp.deleteInvite(invite_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteLeadGen: function (leadgen_id, options) {
            return localVarFp.deleteLeadGen(leadgen_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteLookerAppInfo: function (delete_looker_app_info_request, options) {
            return localVarFp.deleteLookerAppInfo(delete_looker_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteNetSuiteAppInfo: function (delete_net_suite_app_info_request, options) {
            return localVarFp.deleteNetSuiteAppInfo(delete_net_suite_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deletePBDash: function (pb_dash_id, delete_target_google_sheets_tab, options) {
            return localVarFp.deletePBDash(pb_dash_id, delete_target_google_sheets_tab, options).then(function (request) { return request(axios, basePath); });
        },
        deletePublicTemplate: function (options) {
            return localVarFp.deletePublicTemplate(options).then(function (request) { return request(axios, basePath); });
        },
        deleteRecipe: function (recipe_id, options) {
            return localVarFp.deleteRecipe(recipe_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteSnapshot: function (snapshot_id, delete_snapshot_request, options) {
            return localVarFp.deleteSnapshot(snapshot_id, delete_snapshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteSnowflakeAppInfo: function (delete_snowflake_app_info_request, options) {
            return localVarFp.deleteSnowflakeAppInfo(delete_snowflake_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteTableauAppInfo: function (delete_tableau_app_info_request, options) {
            return localVarFp.deleteTableauAppInfo(delete_tableau_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        deleteUser: function (user_id, options) {
            return localVarFp.deleteUser(user_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteWebDashboard: function (web_dashboard_id, options) {
            return localVarFp.deleteWebDashboard(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteWebDashboardCustomLogo: function (variant, options) {
            return localVarFp.deleteWebDashboardCustomLogo(variant, options).then(function (request) { return request(axios, basePath); });
        },
        deleteWebDashboardCustomTheme: function (theme_id, options) {
            return localVarFp.deleteWebDashboardCustomTheme(theme_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            return localVarFp.deleteWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        deleteWriteback: function (writeback_id, options) {
            return localVarFp.deleteWriteback(writeback_id, options).then(function (request) { return request(axios, basePath); });
        },
        describeAgentConnection: function (connection_id, options) {
            return localVarFp.describeAgentConnection(connection_id, options).then(function (request) { return request(axios, basePath); });
        },
        describeAgentConnectionSource: function (connection_id, object_name, schema_name, search, options) {
            return localVarFp.describeAgentConnectionSource(connection_id, object_name, schema_name, search, options).then(function (request) { return request(axios, basePath); });
        },
        downloadSQLiteDB: function (spreadsheet_id, spreadsheet_version_id, dashboard_id, table_name, all_tables, cache_key, options) {
            return localVarFp.downloadSQLiteDB(spreadsheet_id, spreadsheet_version_id, dashboard_id, table_name, all_tables, cache_key, options).then(function (request) { return request(axios, basePath); });
        },
        duplicateWebDashboard: function (web_dashboard_id, duplicate_web_dashboard_request, options) {
            return localVarFp.duplicateWebDashboard(web_dashboard_id, duplicate_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        editDomainFamily: function (domain_family_id, edit_domain_family_request, options) {
            return localVarFp.editDomainFamily(domain_family_id, edit_domain_family_request, options).then(function (request) { return request(axios, basePath); });
        },
        egnyteGetCsvRawValues: function (egnyte_get_csv_raw_values_request, options) {
            return localVarFp.egnyteGetCsvRawValues(egnyte_get_csv_raw_values_request, options).then(function (request) { return request(axios, basePath); });
        },
        emailRedirect: function (target_id, source_id, source, options) {
            return localVarFp.emailRedirect(target_id, source_id, source, options).then(function (request) { return request(axios, basePath); });
        },
        errorsTrackUserProblem: function (errors_track_user_problem_request, options) {
            return localVarFp.errorsTrackUserProblem(errors_track_user_problem_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelDataImportRunTestFlow: function (excel_data_import_run_test_flow_request, options) {
            return localVarFp.excelDataImportRunTestFlow(excel_data_import_run_test_flow_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelGetMetadata: function (excel_get_metadata_request, options) {
            return localVarFp.excelGetMetadata(excel_get_metadata_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelRedirect: function (id, redirection_type, options) {
            return localVarFp.excelRedirect(id, redirection_type, options).then(function (request) { return request(axios, basePath); });
        },
        excelVerifyBoxFile: function (excel_verify_box_file_request, options) {
            return localVarFp.excelVerifyBoxFile(excel_verify_box_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelVerifyEgnyteFile: function (excel_verify_egnyte_file_request, options) {
            return localVarFp.excelVerifyEgnyteFile(excel_verify_egnyte_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelVerifyOneDriveFile: function (excel_verify_one_drive_file_request, options) {
            return localVarFp.excelVerifyOneDriveFile(excel_verify_one_drive_file_request, options).then(function (request) { return request(axios, basePath); });
        },
        excelVerifyUrl: function (excel_verify_url_request, options) {
            return localVarFp.excelVerifyUrl(excel_verify_url_request, options).then(function (request) { return request(axios, basePath); });
        },
        exchangeAuthToken: function (exchange_auth_token_request, options) {
            return localVarFp.exchangeAuthToken(exchange_auth_token_request, options).then(function (request) { return request(axios, basePath); });
        },
        exchangeCRXAuthToken: function (exchange_crx_auth_token_request, options) {
            return localVarFp.exchangeCRXAuthToken(exchange_crx_auth_token_request, options).then(function (request) { return request(axios, basePath); });
        },
        fetchSnapshotClientPlan: function (snapshot_id, options) {
            return localVarFp.fetchSnapshotClientPlan(snapshot_id, options).then(function (request) { return request(axios, basePath); });
        },
        fetchSnapshotSheets: function (google_sheet_file_id, excel_file_id, options) {
            return localVarFp.fetchSnapshotSheets(google_sheet_file_id, excel_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        fetchSnapshots: function (google_sheet_file_id, google_sheet_tab_id, excel_file_id, user_id, options) {
            return localVarFp.fetchSnapshots(google_sheet_file_id, google_sheet_tab_id, excel_file_id, user_id, options).then(function (request) { return request(axios, basePath); });
        },
        fetchWritebacksSchema: function (data_source_id, fetch_writebacks_schema_request, options) {
            return localVarFp.fetchWritebacksSchema(data_source_id, fetch_writebacks_schema_request, options).then(function (request) { return request(axios, basePath); });
        },
        forceRestoreWebDashboard: function (web_dashboard_id, force_restore_web_dashboard_request, options) {
            return localVarFp.forceRestoreWebDashboard(web_dashboard_id, force_restore_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        gSheetsGetColumns: function (g_sheets_get_columns_request, options) {
            return localVarFp.gSheetsGetColumns(g_sheets_get_columns_request, options).then(function (request) { return request(axios, basePath); });
        },
        gSheetsGetNamedRangeParameters: function (target_google_sheets_file_id, options) {
            return localVarFp.gSheetsGetNamedRangeParameters(target_google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        gSheetsGetTabs: function (g_sheets_get_tabs_request, options) {
            return localVarFp.gSheetsGetTabs(g_sheets_get_tabs_request, options).then(function (request) { return request(axios, basePath); });
        },
        gSheetsUpsertNamedRangeParameter: function (g_sheets_upsert_named_range_parameter_request, options) {
            return localVarFp.gSheetsUpsertNamedRangeParameter(g_sheets_upsert_named_range_parameter_request, options).then(function (request) { return request(axios, basePath); });
        },
        generateDashboardSheetsContext: function (generate_dashboard_sheets_context_request, options) {
            return localVarFp.generateDashboardSheetsContext(generate_dashboard_sheets_context_request, options).then(function (request) { return request(axios, basePath); });
        },
        generateExcelSheetsContext: function (generate_excel_sheets_context_request, options) {
            return localVarFp.generateExcelSheetsContext(generate_excel_sheets_context_request, options).then(function (request) { return request(axios, basePath); });
        },
        generateSheetsContext: function (generate_sheets_context_request, options) {
            return localVarFp.generateSheetsContext(generate_sheets_context_request, options).then(function (request) { return request(axios, basePath); });
        },
        generateSheetsContextExtended: function (generate_sheets_context_extended_request, options) {
            return localVarFp.generateSheetsContextExtended(generate_sheets_context_extended_request, options).then(function (request) { return request(axios, basePath); });
        },
        genericScraperBulkRun: function (generic_scraper_bulk_run_request, options) {
            return localVarFp.genericScraperBulkRun(generic_scraper_bulk_run_request, options).then(function (request) { return request(axios, basePath); });
        },
        getAccountsInfo: function (options) {
            return localVarFp.getAccountsInfo(options).then(function (request) { return request(axios, basePath); });
        },
        getAdminAgentCreditHistory: function (email, limit, offset, options) {
            return localVarFp.getAdminAgentCreditHistory(email, limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getAdminAgentCredits: function (email, options) {
            return localVarFp.getAdminAgentCredits(email, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentCreditHistory: function (limit, offset, options) {
            return localVarFp.getAgentCreditHistory(limit, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentCredits: function (options) {
            return localVarFp.getAgentCredits(options).then(function (request) { return request(axios, basePath); });
        },
        getAgentImport: function (import_id, options) {
            return localVarFp.getAgentImport(import_id, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentRun: function (run_id, wait_seconds, options) {
            return localVarFp.getAgentRun(run_id, wait_seconds, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentTask: function (task_id, options) {
            return localVarFp.getAgentTask(task_id, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentTasks: function (thread_id, spreadsheet_id, options) {
            return localVarFp.getAgentTasks(thread_id, spreadsheet_id, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentThreadRun: function (thread_id, agent_type, options) {
            return localVarFp.getAgentThreadRun(thread_id, agent_type, options).then(function (request) { return request(axios, basePath); });
        },
        getAgentThreads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            return localVarFp.getAgentThreads(updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options).then(function (request) { return request(axios, basePath); });
        },
        getAiUsageAllowance: function (options) {
            return localVarFp.getAiUsageAllowance(options).then(function (request) { return request(axios, basePath); });
        },
        getAlert: function (alert_id, options) {
            return localVarFp.getAlert(alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        getAlertReport: function (alert_id, options) {
            return localVarFp.getAlertReport(alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        getAlertRunHistory: function (alert_id, offset, options) {
            return localVarFp.getAlertRunHistory(alert_id, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getAlerts: function (google_sheets_file_id, options) {
            return localVarFp.getAlerts(google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getArchivedWebDashboards: function (email, domain, options) {
            return localVarFp.getArchivedWebDashboards(email, domain, options).then(function (request) { return request(axios, basePath); });
        },
        getAssistantThreadV2Run: function (thread_id, assistant_type, options) {
            return localVarFp.getAssistantThreadV2Run(thread_id, assistant_type, options).then(function (request) { return request(axios, basePath); });
        },
        getAssistantThreadV2Threads: function (updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options) {
            return localVarFp.getAssistantThreadV2Threads(updated_dt_offset, sort_order, page_size, spreadsheet_id, web_dashboard_id, agent_type, options).then(function (request) { return request(axios, basePath); });
        },
        getAutoAnalystRunStatus: function (auto_analyses_run_id, options) {
            return localVarFp.getAutoAnalystRunStatus(auto_analyses_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getBillingDetails: function (get_billing_details_request, options) {
            return localVarFp.getBillingDetails(get_billing_details_request, options).then(function (request) { return request(axios, basePath); });
        },
        getChargebeeCoupons: function (options) {
            return localVarFp.getChargebeeCoupons(options).then(function (request) { return request(axios, basePath); });
        },
        getClientFlags: function (google_sheets_file_id, options) {
            return localVarFp.getClientFlags(google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getClonedSpreadsheetSource: function (cloned_spreadsheet_file_id, source_spreadsheet_data_import_id, options) {
            return localVarFp.getClonedSpreadsheetSource(cloned_spreadsheet_file_id, source_spreadsheet_data_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        getCloudTable: function (cloud_table_id, options) {
            return localVarFp.getCloudTable(cloud_table_id, options).then(function (request) { return request(axios, basePath); });
        },
        getCloudTableData: function (cloud_table_id, get_cloud_table_data_request, options) {
            return localVarFp.getCloudTableData(cloud_table_id, get_cloud_table_data_request, options).then(function (request) { return request(axios, basePath); });
        },
        getCloudTableRunHistory: function (cloud_table_id, offset, options) {
            return localVarFp.getCloudTableRunHistory(cloud_table_id, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getCloudTables: function (options) {
            return localVarFp.getCloudTables(options).then(function (request) { return request(axios, basePath); });
        },
        getCuratedAPIAgentWelcomeConfig: function (data_source_type, options) {
            return localVarFp.getCuratedAPIAgentWelcomeConfig(data_source_type, options).then(function (request) { return request(axios, basePath); });
        },
        getDashboardSpreadsheets: function (options) {
            return localVarFp.getDashboardSpreadsheets(options).then(function (request) { return request(axios, basePath); });
        },
        getDashboardTeamActivity: function (options) {
            return localVarFp.getDashboardTeamActivity(options).then(function (request) { return request(axios, basePath); });
        },
        getDataImport: function (data_import_id, options) {
            return localVarFp.getDataImport(data_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportCompatibleDataSources: function (data_import_id, restricted_field_option, options) {
            return localVarFp.getDataImportCompatibleDataSources(data_import_id, restricted_field_option, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportDueScheduledRuns: function (get_data_import_due_scheduled_runs_request, options) {
            return localVarFp.getDataImportDueScheduledRuns(get_data_import_due_scheduled_runs_request, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportEditAccessType: function (data_import_id, options) {
            return localVarFp.getDataImportEditAccessType(data_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportQuery: function (data_source_type, get_data_import_query_request, options) {
            return localVarFp.getDataImportQuery(data_source_type, get_data_import_query_request, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRecipe: function (data_import_recipe_id, options) {
            return localVarFp.getDataImportRecipe(data_import_recipe_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRecipes: function (data_source_type, limit, custom_api_previous_import_option, options) {
            return localVarFp.getDataImportRecipes(data_source_type, limit, custom_api_previous_import_option, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRunHistory: function (data_import_id, offset, options) {
            return localVarFp.getDataImportRunHistory(data_import_id, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportRunStatus: function (data_import_id, max_wait_time_secs, data_import_run_id, preempt_option, options) {
            return localVarFp.getDataImportRunStatus(data_import_id, max_wait_time_secs, data_import_run_id, preempt_option, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImportWriterPlan: function (data_import_run_id, options) {
            return localVarFp.getDataImportWriterPlan(data_import_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImports: function (target_google_sheets_file_id, include_deleted, data_source_type, options) {
            return localVarFp.getDataImports(target_google_sheets_file_id, include_deleted, data_source_type, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSource: function (data_source_id, restricted_field_option, options) {
            return localVarFp.getDataSource(data_source_id, restricted_field_option, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSourceSQLTable: function (data_source_id, schema_name, table_name, options) {
            return localVarFp.getDataSourceSQLTable(data_source_id, schema_name, table_name, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSourceSchema: function (data_source_id, schema_name, force_refresh, options) {
            return localVarFp.getDataSourceSchema(data_source_id, schema_name, force_refresh, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSourceSchemas: function (data_source_id, options) {
            return localVarFp.getDataSourceSchemas(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDataSources: function (restricted_field_option, options) {
            return localVarFp.getDataSources(restricted_field_option, options).then(function (request) { return request(axios, basePath); });
        },
        getDomainCoupon: function (domain, options) {
            return localVarFp.getDomainCoupon(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getDomainFamilies: function (options) {
            return localVarFp.getDomainFamilies(options).then(function (request) { return request(axios, basePath); });
        },
        getDomainFamily: function (domain_family_id, options) {
            return localVarFp.getDomainFamily(domain_family_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDomainFamilyChangeLog: function (domain_family_id, options) {
            return localVarFp.getDomainFamilyChangeLog(domain_family_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDomainUsers: function (options) {
            return localVarFp.getDomainUsers(options).then(function (request) { return request(axios, basePath); });
        },
        getDynamicClone: function (dynamic_clone_id, options) {
            return localVarFp.getDynamicClone(dynamic_clone_id, options).then(function (request) { return request(axios, basePath); });
        },
        getDynamicClones: function (google_sheets_file_id, options) {
            return localVarFp.getDynamicClones(google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getEditorThreadMessages: function (dashboard_id, options) {
            return localVarFp.getEditorThreadMessages(dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getEgnyteToken: function (data_source_id, options) {
            return localVarFp.getEgnyteToken(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        getEnabledDataSources: function (domain, options) {
            return localVarFp.getEnabledDataSources(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getEnrich: function (enrich_id, options) {
            return localVarFp.getEnrich(enrich_id, options).then(function (request) { return request(axios, basePath); });
        },
        getEnrichMetadata: function (get_enrich_metadata_request, options) {
            return localVarFp.getEnrichMetadata(get_enrich_metadata_request, options).then(function (request) { return request(axios, basePath); });
        },
        getEnrichRunStatus: function (enrich_run_id, options) {
            return localVarFp.getEnrichRunStatus(enrich_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getEnrichRuns: function (enrich_id, limit, options) {
            return localVarFp.getEnrichRuns(enrich_id, limit, options).then(function (request) { return request(axios, basePath); });
        },
        getEnriches: function (options) {
            return localVarFp.getEnriches(options).then(function (request) { return request(axios, basePath); });
        },
        getExcelFileId: function (get_excel_file_id_request, options) {
            return localVarFp.getExcelFileId(get_excel_file_id_request, options).then(function (request) { return request(axios, basePath); });
        },
        getExcelSheetsContextPresignedUrl: function (get_excel_sheets_context_presigned_url_request, options) {
            return localVarFp.getExcelSheetsContextPresignedUrl(get_excel_sheets_context_presigned_url_request, options).then(function (request) { return request(axios, basePath); });
        },
        getFormulaImportCompatibleDataSources: function (formula_import_id, options) {
            return localVarFp.getFormulaImportCompatibleDataSources(formula_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        getInvitations: function (domain, options) {
            return localVarFp.getInvitations(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getLatestWebDashboardRun: function (web_dashboard_id, options) {
            return localVarFp.getLatestWebDashboardRun(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getLeadGen: function (leadgen_id, options) {
            return localVarFp.getLeadGen(leadgen_id, options).then(function (request) { return request(axios, basePath); });
        },
        getLeadGenRunStatus: function (leadgen_run_id, options) {
            return localVarFp.getLeadGenRunStatus(leadgen_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getLeadGenRuns: function (leadgen_id, limit, options) {
            return localVarFp.getLeadGenRuns(leadgen_id, limit, options).then(function (request) { return request(axios, basePath); });
        },
        getLeadGens: function (options) {
            return localVarFp.getLeadGens(options).then(function (request) { return request(axios, basePath); });
        },
        getMSTeamsAuthStatus: function (options) {
            return localVarFp.getMSTeamsAuthStatus(options).then(function (request) { return request(axios, basePath); });
        },
        getMSTeamsTeamsAndChannels: function (options) {
            return localVarFp.getMSTeamsTeamsAndChannels(options).then(function (request) { return request(axios, basePath); });
        },
        getNetsuiteReportMetadataInfo: function (get_netsuite_report_metadata_info_request, options) {
            return localVarFp.getNetsuiteReportMetadataInfo(get_netsuite_report_metadata_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        getOIDCLoginUrl: function (options) {
            return localVarFp.getOIDCLoginUrl(options).then(function (request) { return request(axios, basePath); });
        },
        getOauthAttempt: function (oauth_attempt_id, options) {
            return localVarFp.getOauthAttempt(oauth_attempt_id, options).then(function (request) { return request(axios, basePath); });
        },
        getPBDash: function (pb_dash_id, options) {
            return localVarFp.getPBDash(pb_dash_id, options).then(function (request) { return request(axios, basePath); });
        },
        getPBDashBlueprints: function (options) {
            return localVarFp.getPBDashBlueprints(options).then(function (request) { return request(axios, basePath); });
        },
        getPBDashes: function (target_google_sheets_file_id, options) {
            return localVarFp.getPBDashes(target_google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getPublicTemplates: function (data_source_type, filename, public_template_id, options) {
            return localVarFp.getPublicTemplates(data_source_type, filename, public_template_id, options).then(function (request) { return request(axios, basePath); });
        },
        getRESTLetInfo: function (get_rest_let_info_request, options) {
            return localVarFp.getRESTLetInfo(get_rest_let_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        getRecipe: function (recipe_id, options) {
            return localVarFp.getRecipe(recipe_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSQLiteDownloadURL: function (dashboard_id, options) {
            return localVarFp.getSQLiteDownloadURL(dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSQLiteDownloadURLPublic: function (dashboard_id, options) {
            return localVarFp.getSQLiteDownloadURLPublic(dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSlackAuthStatus: function (options) {
            return localVarFp.getSlackAuthStatus(options).then(function (request) { return request(axios, basePath); });
        },
        getSlackChannelsAndUsers: function (alert_id, force_refresh, options) {
            return localVarFp.getSlackChannelsAndUsers(alert_id, force_refresh, options).then(function (request) { return request(axios, basePath); });
        },
        getSmartAlert: function (smart_alert_id, options) {
            return localVarFp.getSmartAlert(smart_alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSmartAlertRuns: function (smart_alert_id, limit, options) {
            return localVarFp.getSmartAlertRuns(smart_alert_id, limit, options).then(function (request) { return request(axios, basePath); });
        },
        getSmartAlertSuggestions: function (google_sheets_file_id, excel_file_id, options) {
            return localVarFp.getSmartAlertSuggestions(google_sheets_file_id, excel_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSnowflakeKeyPair: function (get_snowflake_key_pair_request, options) {
            return localVarFp.getSnowflakeKeyPair(get_snowflake_key_pair_request, options).then(function (request) { return request(axios, basePath); });
        },
        getSubscriptionInfo: function (subscription_id, options) {
            return localVarFp.getSubscriptionInfo(subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSubscriptionInvoiceUrl: function (invoice_id, subscription_id, options) {
            return localVarFp.getSubscriptionInvoiceUrl(invoice_id, subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSubscriptionInvoices: function (subscription_id, options) {
            return localVarFp.getSubscriptionInvoices(subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        getSubscriptions: function (options) {
            return localVarFp.getSubscriptions(options).then(function (request) { return request(axios, basePath); });
        },
        getSubscriptionsPreCheckout: function (subscription_id, options) {
            return localVarFp.getSubscriptionsPreCheckout(subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        getUsageMeter: function (meter_type_str, options) {
            return localVarFp.getUsageMeter(meter_type_str, options).then(function (request) { return request(axios, basePath); });
        },
        getUser: function (options) {
            return localVarFp.getUser(options).then(function (request) { return request(axios, basePath); });
        },
        getUserExtra: function (user_extra_type, options) {
            return localVarFp.getUserExtra(user_extra_type, options).then(function (request) { return request(axios, basePath); });
        },
        getUserSSOInfo: function (options) {
            return localVarFp.getUserSSOInfo(options).then(function (request) { return request(axios, basePath); });
        },
        getVirtualImportData: function (data_import_id, get_virtual_import_data_request, options) {
            return localVarFp.getVirtualImportData(data_import_id, get_virtual_import_data_request, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboard: function (web_dashboard_id, options) {
            return localVarFp.getWebDashboard(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardForScreenshot: function (web_dashboard_id, screenshot_token, options) {
            return localVarFp.getWebDashboardForScreenshot(web_dashboard_id, screenshot_token, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardOffer: function (options) {
            return localVarFp.getWebDashboardOffer(options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardPlanLimit: function (domain, options) {
            return localVarFp.getWebDashboardPlanLimit(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardPlanUsage: function (options) {
            return localVarFp.getWebDashboardPlanUsage(options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardPublic: function (web_dashboard_id, options) {
            return localVarFp.getWebDashboardPublic(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardRun: function (web_dashboard_id, web_dashboard_run_id, options) {
            return localVarFp.getWebDashboardRun(web_dashboard_id, web_dashboard_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardTabImpact: function (web_dashboard_id, tab_id, options) {
            return localVarFp.getWebDashboardTabImpact(web_dashboard_id, tab_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardTrialHistory: function (product_trial_id, options) {
            return localVarFp.getWebDashboardTrialHistory(product_trial_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWebDashboardTrialUsers: function (domain, emails, options) {
            return localVarFp.getWebDashboardTrialUsers(domain, emails, options).then(function (request) { return request(axios, basePath); });
        },
        getWebhookUrl: function (get_webhook_url_request, options) {
            return localVarFp.getWebhookUrl(get_webhook_url_request, options).then(function (request) { return request(axios, basePath); });
        },
        getWorkspace: function (options) {
            return localVarFp.getWorkspace(options).then(function (request) { return request(axios, basePath); });
        },
        getWriteback: function (writeback_id, options) {
            return localVarFp.getWriteback(writeback_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackMatchingDataSource: function (writeback_id, options) {
            return localVarFp.getWritebackMatchingDataSource(writeback_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackRowStatuses: function (writeback_run_id, options) {
            return localVarFp.getWritebackRowStatuses(writeback_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackRunHistory: function (writeback_id, offset, options) {
            return localVarFp.getWritebackRunHistory(writeback_id, offset, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackUploadDataUrl: function (writeback_id, options) {
            return localVarFp.getWritebackUploadDataUrl(writeback_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebackWriterPlan: function (writeback_run_id, options) {
            return localVarFp.getWritebackWriterPlan(writeback_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebacks: function (target_google_sheets_file_id, options) {
            return localVarFp.getWritebacks(target_google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        getWritebacksSchema: function (data_source_id, object_name, writeback_mode, options) {
            return localVarFp.getWritebacksSchema(data_source_id, object_name, writeback_mode, options).then(function (request) { return request(axios, basePath); });
        },
        getZendeskChatSessionJWT: function (options) {
            return localVarFp.getZendeskChatSessionJWT(options).then(function (request) { return request(axios, basePath); });
        },
        googleAnalyticsGetSchema: function (google_analytics_get_schema_request, options) {
            return localVarFp.googleAnalyticsGetSchema(google_analytics_get_schema_request, options).then(function (request) { return request(axios, basePath); });
        },
        googleAnalyticsGetSchemaAlias: function (google_analytics_get_schema_alias_request, options) {
            return localVarFp.googleAnalyticsGetSchemaAlias(google_analytics_get_schema_alias_request, options).then(function (request) { return request(axios, basePath); });
        },
        googleDriveCheckConnection: function (google_drive_check_connection_request, options) {
            return localVarFp.googleDriveCheckConnection(google_drive_check_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        googleDriveGetAuthToken: function (google_drive_get_auth_token_request, options) {
            return localVarFp.googleDriveGetAuthToken(google_drive_get_auth_token_request, options).then(function (request) { return request(axios, basePath); });
        },
        googleDriveGetCsvRawValues: function (google_drive_get_csv_raw_values_request, options) {
            return localVarFp.googleDriveGetCsvRawValues(google_drive_get_csv_raw_values_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptChart: function (gpt_chart_request, options) {
            return localVarFp.gptChart(gpt_chart_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptChartWriter: function (gpt_chart_writer_request, options) {
            return localVarFp.gptChartWriter(gpt_chart_writer_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptFeedback: function (gpt_feedback_request, options) {
            return localVarFp.gptFeedback(gpt_feedback_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptFormula: function (gpt_formula_request, options) {
            return localVarFp.gptFormula(gpt_formula_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptPivot: function (gpt_pivot_request, options) {
            return localVarFp.gptPivot(gpt_pivot_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptPivotWriter: function (gpt_pivot_writer_request, options) {
            return localVarFp.gptPivotWriter(gpt_pivot_writer_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptSQL: function (gpt_sql_request, options) {
            return localVarFp.gptSQL(gpt_sql_request, options).then(function (request) { return request(axios, basePath); });
        },
        gptSQLFixQuery: function (gpt_sql_fix_query_request, options) {
            return localVarFp.gptSQLFixQuery(gpt_sql_fix_query_request, options).then(function (request) { return request(axios, basePath); });
        },
        handleMSGraphWebhook: function (options) {
            return localVarFp.handleMSGraphWebhook(options).then(function (request) { return request(axios, basePath); });
        },
        handleSmartAlertsOnChange: function (handle_smart_alerts_on_change_request, options) {
            return localVarFp.handleSmartAlertsOnChange(handle_smart_alerts_on_change_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetAllLists: function (hubspot_get_all_lists_request, options) {
            return localVarFp.hubspotGetAllLists(hubspot_get_all_lists_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetObjectType: function (hubspot_get_object_type_request, options) {
            return localVarFp.hubspotGetObjectType(hubspot_get_object_type_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetObjectTypes: function (hubspot_get_object_types_request, options) {
            return localVarFp.hubspotGetObjectTypes(hubspot_get_object_types_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetPipelineStages: function (hubspot_get_pipeline_stages_request, options) {
            return localVarFp.hubspotGetPipelineStages(hubspot_get_pipeline_stages_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetPipelines: function (hubspot_get_pipelines_request, options) {
            return localVarFp.hubspotGetPipelines(hubspot_get_pipelines_request, options).then(function (request) { return request(axios, basePath); });
        },
        hubspotGetPipelinesMultiObject: function (hubspot_get_pipelines_multi_object_request, options) {
            return localVarFp.hubspotGetPipelinesMultiObject(hubspot_get_pipelines_multi_object_request, options).then(function (request) { return request(axios, basePath); });
        },
        initiateDataimportsTransfer: function (initiate_dataimports_transfer_request, options) {
            return localVarFp.initiateDataimportsTransfer(initiate_dataimports_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        initiateSlackMarketplaceOauth: function (options) {
            return localVarFp.initiateSlackMarketplaceOauth(options).then(function (request) { return request(axios, basePath); });
        },
        inviteWebDashboardShare: function (web_dashboard_id, invite_web_dashboard_share_request, options) {
            return localVarFp.inviteWebDashboardShare(web_dashboard_id, invite_web_dashboard_share_request, options).then(function (request) { return request(axios, basePath); });
        },
        killWritebackRun: function (writeback_id, writeback_run_id, options) {
            return localVarFp.killWritebackRun(writeback_id, writeback_run_id, options).then(function (request) { return request(axios, basePath); });
        },
        listAgentConnections: function (query, connection_type, options) {
            return localVarFp.listAgentConnections(query, connection_type, options).then(function (request) { return request(axios, basePath); });
        },
        listAgentImports: function (spreadsheet_id, connection_id, owned_by_me, options) {
            return localVarFp.listAgentImports(spreadsheet_id, connection_id, owned_by_me, options).then(function (request) { return request(axios, basePath); });
        },
        listArrowFlightSqlAppInfo: function (options) {
            return localVarFp.listArrowFlightSqlAppInfo(options).then(function (request) { return request(axios, basePath); });
        },
        listCustomOAuthAppInfo: function (options) {
            return localVarFp.listCustomOAuthAppInfo(options).then(function (request) { return request(axios, basePath); });
        },
        listDatabricksAppInfo: function (options) {
            return localVarFp.listDatabricksAppInfo(options).then(function (request) { return request(axios, basePath); });
        },
        listFormulaImports: function (target_google_sheets_file_id, data_source_type, options) {
            return localVarFp.listFormulaImports(target_google_sheets_file_id, data_source_type, options).then(function (request) { return request(axios, basePath); });
        },
        listLicenseRequests: function (subscription_id, options) {
            return localVarFp.listLicenseRequests(subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        listLookerAppInfo: function (body, options) {
            return localVarFp.listLookerAppInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        listNetSuiteAppInfo: function (body, options) {
            return localVarFp.listNetSuiteAppInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        listRecipes: function (options) {
            return localVarFp.listRecipes(options).then(function (request) { return request(axios, basePath); });
        },
        listSmartAlerts: function (excel_file_id, google_sheets_file_id, options) {
            return localVarFp.listSmartAlerts(excel_file_id, google_sheets_file_id, options).then(function (request) { return request(axios, basePath); });
        },
        listSnowflakeAppInfo: function (body, options) {
            return localVarFp.listSnowflakeAppInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        listTableauAppInfo: function (body, options) {
            return localVarFp.listTableauAppInfo(body, options).then(function (request) { return request(axios, basePath); });
        },
        listWebDashboardCustomThemes: function (options) {
            return localVarFp.listWebDashboardCustomThemes(options).then(function (request) { return request(axios, basePath); });
        },
        listWebDashboardShares: function (web_dashboard_id, options) {
            return localVarFp.listWebDashboardShares(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        listWebDashboardSubscriptionRuns: function (web_dashboard_id, web_dashboard_subscription_id, options) {
            return localVarFp.listWebDashboardSubscriptionRuns(web_dashboard_id, web_dashboard_subscription_id, options).then(function (request) { return request(axios, basePath); });
        },
        listWebDashboardSubscriptions: function (web_dashboard_id, options) {
            return localVarFp.listWebDashboardSubscriptions(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        listWebDashboards: function (options) {
            return localVarFp.listWebDashboards(options).then(function (request) { return request(axios, basePath); });
        },
        loadDashboardVersion: function (load_dashboard_version_request, options) {
            return localVarFp.loadDashboardVersion(load_dashboard_version_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerCheckConnection: function (looker_check_connection_request, options) {
            return localVarFp.lookerCheckConnection(looker_check_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerFetchUrlBasedAuthDetails: function (looker_fetch_url_based_auth_details_request, options) {
            return localVarFp.lookerFetchUrlBasedAuthDetails(looker_fetch_url_based_auth_details_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerGetDashboardElements: function (looker_get_dashboard_elements_request, options) {
            return localVarFp.lookerGetDashboardElements(looker_get_dashboard_elements_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerGetDataSourceOwnerMetaData: function (looker_get_data_source_owner_meta_data_request, options) {
            return localVarFp.lookerGetDataSourceOwnerMetaData(looker_get_data_source_owner_meta_data_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerGetFolder: function (looker_get_folder_request, options) {
            return localVarFp.lookerGetFolder(looker_get_folder_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerGetObjects: function (looker_get_objects_request, options) {
            return localVarFp.lookerGetObjects(looker_get_objects_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerGetSchema: function (looker_get_schema_request, options) {
            return localVarFp.lookerGetSchema(looker_get_schema_request, options).then(function (request) { return request(axios, basePath); });
        },
        lookerSearchObjects: function (looker_search_objects_request, options) {
            return localVarFp.lookerSearchObjects(looker_search_objects_request, options).then(function (request) { return request(axios, basePath); });
        },
        maybeCreateUser: function (signup_source, signup_source_campaign, options) {
            return localVarFp.maybeCreateUser(signup_source, signup_source_campaign, options).then(function (request) { return request(axios, basePath); });
        },
        maybeSendEmailImportRefreshBlocked: function (data_import_id, options) {
            return localVarFp.maybeSendEmailImportRefreshBlocked(data_import_id, options).then(function (request) { return request(axios, basePath); });
        },
        migrateSnapshotToV2: function (migrate_snapshot_to_v2_request, options) {
            return localVarFp.migrateSnapshotToV2(migrate_snapshot_to_v2_request, options).then(function (request) { return request(axios, basePath); });
        },
        noSqlGetSchema: function (no_sql_get_schema_request, options) {
            return localVarFp.noSqlGetSchema(no_sql_get_schema_request, options).then(function (request) { return request(axios, basePath); });
        },
        oauth2ProxyGrant: function (service_id, state, code, error, options) {
            return localVarFp.oauth2ProxyGrant(service_id, state, code, error, options).then(function (request) { return request(axios, basePath); });
        },
        oauth2ProxyGrantFormPost: function (service_id, options) {
            return localVarFp.oauth2ProxyGrantFormPost(service_id, options).then(function (request) { return request(axios, basePath); });
        },
        oauth2Uninstall: function (service_id, options) {
            return localVarFp.oauth2Uninstall(service_id, options).then(function (request) { return request(axios, basePath); });
        },
        oneDriveGetCsvRawValues: function (one_drive_get_csv_raw_values_request, options) {
            return localVarFp.oneDriveGetCsvRawValues(one_drive_get_csv_raw_values_request, options).then(function (request) { return request(axios, basePath); });
        },
        parsePageContent: function (parse_page_content_request, options) {
            return localVarFp.parsePageContent(parse_page_content_request, options).then(function (request) { return request(axios, basePath); });
        },
        patchUserExtra: function (patch_user_extra_request, options) {
            return localVarFp.patchUserExtra(patch_user_extra_request, options).then(function (request) { return request(axios, basePath); });
        },
        patchWebDashboard: function (web_dashboard_id, patch_web_dashboard_request, options) {
            return localVarFp.patchWebDashboard(web_dashboard_id, patch_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        patchWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, patch_web_dashboard_subscription_request, options) {
            return localVarFp.patchWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, patch_web_dashboard_subscription_request, options).then(function (request) { return request(axios, basePath); });
        },
        pauseAgentImport: function (import_id, options) {
            return localVarFp.pauseAgentImport(import_id, options).then(function (request) { return request(axios, basePath); });
        },
        postAgentThread: function (post_agent_thread_request, options) {
            return localVarFp.postAgentThread(post_agent_thread_request, options).then(function (request) { return request(axios, basePath); });
        },
        postAgentThreadPause: function (thread_id, options) {
            return localVarFp.postAgentThreadPause(thread_id, options).then(function (request) { return request(axios, basePath); });
        },
        postAssistantThreadV2: function (post_assistant_thread_v2_request, options) {
            return localVarFp.postAssistantThreadV2(post_assistant_thread_v2_request, options).then(function (request) { return request(axios, basePath); });
        },
        postAssistantThreadV2Feedback: function (post_assistant_thread_v2_feedback_request, options) {
            return localVarFp.postAssistantThreadV2Feedback(post_assistant_thread_v2_feedback_request, options).then(function (request) { return request(axios, basePath); });
        },
        postAutoAnalyses: function (post_auto_analyses_request, options) {
            return localVarFp.postAutoAnalyses(post_auto_analyses_request, options).then(function (request) { return request(axios, basePath); });
        },
        postGPTFunctionsClearCache: function (post_gpt_functions_clear_cache_request, options) {
            return localVarFp.postGPTFunctionsClearCache(post_gpt_functions_clear_cache_request, options).then(function (request) { return request(axios, basePath); });
        },
        postMSTeamsBotMessages: function (options) {
            return localVarFp.postMSTeamsBotMessages(options).then(function (request) { return request(axios, basePath); });
        },
        ppressPreviewModalRenderForm: function (ppress_preview_modal_render_form_request, options) {
            return localVarFp.ppressPreviewModalRenderForm(ppress_preview_modal_render_form_request, options).then(function (request) { return request(axios, basePath); });
        },
        ppressRenderAuthForm: function (ppress_render_auth_form_request, options) {
            return localVarFp.ppressRenderAuthForm(ppress_render_auth_form_request, options).then(function (request) { return request(axios, basePath); });
        },
        ppressRenderForm: function (ppress_render_form_request, options) {
            return localVarFp.ppressRenderForm(ppress_render_form_request, options).then(function (request) { return request(axios, basePath); });
        },
        ppressRenderPublicTemplateForm: function (ppress_render_public_template_form_request, options) {
            return localVarFp.ppressRenderPublicTemplateForm(ppress_render_public_template_form_request, options).then(function (request) { return request(axios, basePath); });
        },
        presignWebDashboardBlockScreenshot: function (request_id, presign_web_dashboard_block_screenshot_request, options) {
            return localVarFp.presignWebDashboardBlockScreenshot(request_id, presign_web_dashboard_block_screenshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        previewAgentImportSource: function (connection_id, preview_agent_import_source_request, options) {
            return localVarFp.previewAgentImportSource(connection_id, preview_agent_import_source_request, options).then(function (request) { return request(axios, basePath); });
        },
        previewRunWriteback: function (writeback_id, preview_run_writeback_request, options) {
            return localVarFp.previewRunWriteback(writeback_id, preview_run_writeback_request, options).then(function (request) { return request(axios, basePath); });
        },
        previewSmartAlert: function (preview_smart_alert_request, options) {
            return localVarFp.previewSmartAlert(preview_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        processCustomFunction: function (process_custom_function_request, options) {
            return localVarFp.processCustomFunction(process_custom_function_request, options).then(function (request) { return request(axios, basePath); });
        },
        processCustomFunctionAsync: function (process_custom_function_async_request, options) {
            return localVarFp.processCustomFunctionAsync(process_custom_function_async_request, options).then(function (request) { return request(axios, basePath); });
        },
        putCRXGetFiltersAttempt: function (attempt_id, put_crx_get_filters_attempt_request, options) {
            return localVarFp.putCRXGetFiltersAttempt(attempt_id, put_crx_get_filters_attempt_request, options).then(function (request) { return request(axios, basePath); });
        },
        putCRXLoginStatusCheckAttempt: function (attempt_id, put_crx_login_status_check_attempt_request, options) {
            return localVarFp.putCRXLoginStatusCheckAttempt(attempt_id, put_crx_login_status_check_attempt_request, options).then(function (request) { return request(axios, basePath); });
        },
        putCRXRunAttempt: function (crx_run_attempt_id, put_crx_run_attempt_request, options) {
            return localVarFp.putCRXRunAttempt(crx_run_attempt_id, put_crx_run_attempt_request, options).then(function (request) { return request(axios, basePath); });
        },
        putCRXValidateUrlAttempt: function (attempt_id, put_crx_validate_url_attempt_request, options) {
            return localVarFp.putCRXValidateUrlAttempt(attempt_id, put_crx_validate_url_attempt_request, options).then(function (request) { return request(axios, basePath); });
        },
        quickbooksGetReportFilter: function (quickbooks_get_report_filter_request, options) {
            return localVarFp.quickbooksGetReportFilter(quickbooks_get_report_filter_request, options).then(function (request) { return request(axios, basePath); });
        },
        quickbooksGetReportFilters: function (quickbooks_get_report_filters_request, options) {
            return localVarFp.quickbooksGetReportFilters(quickbooks_get_report_filters_request, options).then(function (request) { return request(axios, basePath); });
        },
        quickstart: function (email, force_create, addon_platform, variant_type, options) {
            return localVarFp.quickstart(email, force_create, addon_platform, variant_type, options).then(function (request) { return request(axios, basePath); });
        },
        ratingPopupSetRating: function (rating_popup_set_rating_request, options) {
            return localVarFp.ratingPopupSetRating(rating_popup_set_rating_request, options).then(function (request) { return request(axios, basePath); });
        },
        ratingPopupTrackShown: function (options) {
            return localVarFp.ratingPopupTrackShown(options).then(function (request) { return request(axios, basePath); });
        },
        recipeRunResults: function (recipe_id, run_id, options) {
            return localVarFp.recipeRunResults(recipe_id, run_id, options).then(function (request) { return request(axios, basePath); });
        },
        recipeRunStatus: function (recipe_id, run_id, options) {
            return localVarFp.recipeRunStatus(recipe_id, run_id, options).then(function (request) { return request(axios, basePath); });
        },
        recordWebDashboardView: function (web_dashboard_id, options) {
            return localVarFp.recordWebDashboardView(web_dashboard_id, options).then(function (request) { return request(axios, basePath); });
        },
        recordWebDashboardViewPublic: function (web_dashboard_id, record_web_dashboard_view_public_request, options) {
            return localVarFp.recordWebDashboardViewPublic(web_dashboard_id, record_web_dashboard_view_public_request, options).then(function (request) { return request(axios, basePath); });
        },
        refreshAuthToken: function (refresh_auth_token_request, options) {
            return localVarFp.refreshAuthToken(refresh_auth_token_request, options).then(function (request) { return request(axios, basePath); });
        },
        refreshCustomFunctionFormula: function (refresh_custom_function_formula_request, options) {
            return localVarFp.refreshCustomFunctionFormula(refresh_custom_function_formula_request, options).then(function (request) { return request(axios, basePath); });
        },
        refreshNetsuiteReportMetadata: function (refresh_netsuite_report_metadata_request, options) {
            return localVarFp.refreshNetsuiteReportMetadata(refresh_netsuite_report_metadata_request, options).then(function (request) { return request(axios, basePath); });
        },
        refreshWebDashboard: function (web_dashboard_id, refresh_web_dashboard_request, options) {
            return localVarFp.refreshWebDashboard(web_dashboard_id, refresh_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        removeCouponFromDomain: function (domain, options) {
            return localVarFp.removeCouponFromDomain(domain, options).then(function (request) { return request(axios, basePath); });
        },
        removeCouponFromSubscription: function (subscription_id, coupon, options) {
            return localVarFp.removeCouponFromSubscription(subscription_id, coupon, options).then(function (request) { return request(axios, basePath); });
        },
        removeWebDashboardPlanLimitOverride: function (domain, options) {
            return localVarFp.removeWebDashboardPlanLimitOverride(domain, options).then(function (request) { return request(axios, basePath); });
        },
        reportExcelManualRunOutcome: function (report_excel_manual_run_outcome_request, options) {
            return localVarFp.reportExcelManualRunOutcome(report_excel_manual_run_outcome_request, options).then(function (request) { return request(axios, basePath); });
        },
        reportSnapshotClientOutcome: function (snapshot_id, report_snapshot_client_outcome_request, options) {
            return localVarFp.reportSnapshotClientOutcome(snapshot_id, report_snapshot_client_outcome_request, options).then(function (request) { return request(axios, basePath); });
        },
        requestLicense: function (request_license_request, options) {
            return localVarFp.requestLicense(request_license_request, options).then(function (request) { return request(axios, basePath); });
        },
        resendInvite: function (invite_id, options) {
            return localVarFp.resendInvite(invite_id, options).then(function (request) { return request(axios, basePath); });
        },
        resetUser: function (reset_user_request, options) {
            return localVarFp.resetUser(reset_user_request, options).then(function (request) { return request(axios, basePath); });
        },
        resetUserMeter: function (reset_user_meter_request, options) {
            return localVarFp.resetUserMeter(reset_user_meter_request, options).then(function (request) { return request(axios, basePath); });
        },
        resolveLicenseRequest: function (resolve_license_request_request, options) {
            return localVarFp.resolveLicenseRequest(resolve_license_request_request, options).then(function (request) { return request(axios, basePath); });
        },
        restoreWebDashboardCustomTheme: function (theme_id, options) {
            return localVarFp.restoreWebDashboardCustomTheme(theme_id, options).then(function (request) { return request(axios, basePath); });
        },
        retoolSetFreeTrialAutomaticStartMode: function (options) {
            return localVarFp.retoolSetFreeTrialAutomaticStartMode(options).then(function (request) { return request(axios, basePath); });
        },
        retoolTrialStateBulkUpdateWithTrialState: function (options) {
            return localVarFp.retoolTrialStateBulkUpdateWithTrialState(options).then(function (request) { return request(axios, basePath); });
        },
        retoolTrialStateBulkUpdateWithUserEmail: function (options) {
            return localVarFp.retoolTrialStateBulkUpdateWithUserEmail(options).then(function (request) { return request(axios, basePath); });
        },
        retoolUpdateSubscriptionEstimate: function (retool_update_subscription_estimate_request, options) {
            return localVarFp.retoolUpdateSubscriptionEstimate(retool_update_subscription_estimate_request, options).then(function (request) { return request(axios, basePath); });
        },
        retoolWebDashboardTrialBulkUpdate: function (options) {
            return localVarFp.retoolWebDashboardTrialBulkUpdate(options).then(function (request) { return request(axios, basePath); });
        },
        revokeMSTeamsAuth: function (options) {
            return localVarFp.revokeMSTeamsAuth(options).then(function (request) { return request(axios, basePath); });
        },
        revokeSlackAuth: function (revoke_slack_auth_request, options) {
            return localVarFp.revokeSlackAuth(revoke_slack_auth_request, options).then(function (request) { return request(axios, basePath); });
        },
        runAgentImport: function (import_id, run_agent_import_request, options) {
            return localVarFp.runAgentImport(import_id, run_agent_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        runAgentTask: function (task_id, body, options) {
            return localVarFp.runAgentTask(task_id, body, options).then(function (request) { return request(axios, basePath); });
        },
        runCloudTable: function (cloud_table_id, is_scheduled_run, run_cloud_table_request, options) {
            return localVarFp.runCloudTable(cloud_table_id, is_scheduled_run, run_cloud_table_request, options).then(function (request) { return request(axios, basePath); });
        },
        runCloudTablePreviewRun: function (run_cloud_table_preview_run_request, options) {
            return localVarFp.runCloudTablePreviewRun(run_cloud_table_preview_run_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDataImport: function (data_import_id, is_scheduled_run, is_triggered_by_parameterized_filter, proposed_run_id, run_data_import_request, options) {
            return localVarFp.runDataImport(data_import_id, is_scheduled_run, is_triggered_by_parameterized_filter, proposed_run_id, run_data_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDataImportFieldChoices: function (run_data_import_field_choices_request, options) {
            return localVarFp.runDataImportFieldChoices(run_data_import_field_choices_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDataImportMulti: function (run_data_import_multi_request, options) {
            return localVarFp.runDataImportMulti(run_data_import_multi_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDataImportPreviewRun: function (run_data_import_preview_run_request, options) {
            return localVarFp.runDataImportPreviewRun(run_data_import_preview_run_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDataImportSnapshot: function (data_import_id, body, options) {
            return localVarFp.runDataImportSnapshot(data_import_id, body, options).then(function (request) { return request(axios, basePath); });
        },
        runDataimportMorpheus: function (data_import_id, run_dataimport_morpheus_request, options) {
            return localVarFp.runDataimportMorpheus(data_import_id, run_dataimport_morpheus_request, options).then(function (request) { return request(axios, basePath); });
        },
        runDynamicClone: function (dynamic_clone_id, run_dynamic_clone_request, options) {
            return localVarFp.runDynamicClone(dynamic_clone_id, run_dynamic_clone_request, options).then(function (request) { return request(axios, basePath); });
        },
        runEnrich: function (enrich_id, run_enrich_request, options) {
            return localVarFp.runEnrich(enrich_id, run_enrich_request, options).then(function (request) { return request(axios, basePath); });
        },
        runFormulaFunction: function (run_formula_function_request, options) {
            return localVarFp.runFormulaFunction(run_formula_function_request, options).then(function (request) { return request(axios, basePath); });
        },
        runGPTFunction: function (options) {
            return localVarFp.runGPTFunction(options).then(function (request) { return request(axios, basePath); });
        },
        runLeadGen: function (leadgen_id, run_lead_gen_request, options) {
            return localVarFp.runLeadGen(leadgen_id, run_lead_gen_request, options).then(function (request) { return request(axios, basePath); });
        },
        runRecipe: function (recipe_id, run_recipe_request, options) {
            return localVarFp.runRecipe(recipe_id, run_recipe_request, options).then(function (request) { return request(axios, basePath); });
        },
        runSmartAlert: function (smart_alert_id, run_smart_alert_request, options) {
            return localVarFp.runSmartAlert(smart_alert_id, run_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        runSnapshot: function (snapshot_id, options) {
            return localVarFp.runSnapshot(snapshot_id, options).then(function (request) { return request(axios, basePath); });
        },
        runWebhook: function (webhook_token, options) {
            return localVarFp.runWebhook(webhook_token, options).then(function (request) { return request(axios, basePath); });
        },
        runWriteback: function (writeback_id, run_writeback_request, options) {
            return localVarFp.runWriteback(writeback_id, run_writeback_request, options).then(function (request) { return request(axios, basePath); });
        },
        runWritebackMulti: function (run_writeback_multi_request, options) {
            return localVarFp.runWritebackMulti(run_writeback_multi_request, options).then(function (request) { return request(axios, basePath); });
        },
        sageDeleteFinancialReport: function (report_name, options) {
            return localVarFp.sageDeleteFinancialReport(report_name, options).then(function (request) { return request(axios, basePath); });
        },
        sageGetFinancialReports: function (data_source_id, options) {
            return localVarFp.sageGetFinancialReports(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        salesforceGetObjectType: function (salesforce_get_object_type_request, options) {
            return localVarFp.salesforceGetObjectType(salesforce_get_object_type_request, options).then(function (request) { return request(axios, basePath); });
        },
        salesforceGetObjectTypes: function (salesforce_get_object_types_request, options) {
            return localVarFp.salesforceGetObjectTypes(salesforce_get_object_types_request, options).then(function (request) { return request(axios, basePath); });
        },
        salesforceGetReportType: function (salesforce_get_report_type_request, options) {
            return localVarFp.salesforceGetReportType(salesforce_get_report_type_request, options).then(function (request) { return request(axios, basePath); });
        },
        salesforceGetReports: function (salesforce_get_reports_request, options) {
            return localVarFp.salesforceGetReports(salesforce_get_reports_request, options).then(function (request) { return request(axios, basePath); });
        },
        saveAffiliateReferral: function (save_affiliate_referral_request, options) {
            return localVarFp.saveAffiliateReferral(save_affiliate_referral_request, options).then(function (request) { return request(axios, basePath); });
        },
        screenshotDelay: function (options) {
            return localVarFp.screenshotDelay(options).then(function (request) { return request(axios, basePath); });
        },
        sendCoworkerInvitation: function (send_coworker_invitation_request, options) {
            return localVarFp.sendCoworkerInvitation(send_coworker_invitation_request, options).then(function (request) { return request(axios, basePath); });
        },
        sendInvite: function (options) {
            return localVarFp.sendInvite(options).then(function (request) { return request(axios, basePath); });
        },
        sendPreviewSmartAlert: function (send_preview_smart_alert_request, options) {
            return localVarFp.sendPreviewSmartAlert(send_preview_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        sendSupportEmail: function (send_support_email_request, options) {
            return localVarFp.sendSupportEmail(send_support_email_request, options).then(function (request) { return request(axios, basePath); });
        },
        setUserExtra: function (set_user_extra_request, options) {
            return localVarFp.setUserExtra(set_user_extra_request, options).then(function (request) { return request(axios, basePath); });
        },
        setWebDashboardCustomLogo: function (set_web_dashboard_custom_logo_request, options) {
            return localVarFp.setWebDashboardCustomLogo(set_web_dashboard_custom_logo_request, options).then(function (request) { return request(axios, basePath); });
        },
        setWebDashboardCustomThemeDefault: function (theme_id, set_web_dashboard_custom_theme_default_request, options) {
            return localVarFp.setWebDashboardCustomThemeDefault(theme_id, set_web_dashboard_custom_theme_default_request, options).then(function (request) { return request(axios, basePath); });
        },
        setWebDashboardPlanLimitOverride: function (domain, set_web_dashboard_plan_limit_override_request, options) {
            return localVarFp.setWebDashboardPlanLimitOverride(domain, set_web_dashboard_plan_limit_override_request, options).then(function (request) { return request(axios, basePath); });
        },
        shopifyAuth: function (options) {
            return localVarFp.shopifyAuth(options).then(function (request) { return request(axios, basePath); });
        },
        shopifyDeleteCustomer: function (body, options) {
            return localVarFp.shopifyDeleteCustomer(body, options).then(function (request) { return request(axios, basePath); });
        },
        shopifyDeleteShop: function (body, options) {
            return localVarFp.shopifyDeleteShop(body, options).then(function (request) { return request(axios, basePath); });
        },
        shopifyGetCustomer: function (body, options) {
            return localVarFp.shopifyGetCustomer(body, options).then(function (request) { return request(axios, basePath); });
        },
        shouldSkipSuboptions: function (data_source_type, options) {
            return localVarFp.shouldSkipSuboptions(data_source_type, options).then(function (request) { return request(axios, basePath); });
        },
        signWritebackMultipartParts: function (writeback_id, sign_writeback_multipart_parts_request, options) {
            return localVarFp.signWritebackMultipartParts(writeback_id, sign_writeback_multipart_parts_request, options).then(function (request) { return request(axios, basePath); });
        },
        slackAuthTest: function (token, options) {
            return localVarFp.slackAuthTest(token, options).then(function (request) { return request(axios, basePath); });
        },
        slackDashboardUnfurlEvents: function (options) {
            return localVarFp.slackDashboardUnfurlEvents(options).then(function (request) { return request(axios, basePath); });
        },
        slackDashboardUnfurlInteraction: function (options) {
            return localVarFp.slackDashboardUnfurlInteraction(options).then(function (request) { return request(axios, basePath); });
        },
        slackInteractionCallback: function (options) {
            return localVarFp.slackInteractionCallback(options).then(function (request) { return request(axios, basePath); });
        },
        smartAlertMSTeamsAuthTest: function (smart_alert_id, options) {
            return localVarFp.smartAlertMSTeamsAuthTest(smart_alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        smartAlertSlackAuthTest: function (smart_alert_id, options) {
            return localVarFp.smartAlertSlackAuthTest(smart_alert_id, options).then(function (request) { return request(axios, basePath); });
        },
        sqlGetSchema: function (data_source_type, sql_get_schema_request, options) {
            return localVarFp.sqlGetSchema(data_source_type, sql_get_schema_request, options).then(function (request) { return request(axios, basePath); });
        },
        startWritebackMultipartUpload: function (writeback_id, start_writeback_multipart_upload_request, options) {
            return localVarFp.startWritebackMultipartUpload(writeback_id, start_writeback_multipart_upload_request, options).then(function (request) { return request(axios, basePath); });
        },
        storeAgentGoogleGrant: function (store_agent_google_grant_request, options) {
            return localVarFp.storeAgentGoogleGrant(store_agent_google_grant_request, options).then(function (request) { return request(axios, basePath); });
        },
        subscriptionsChargebeeWebhook: function (options) {
            return localVarFp.subscriptionsChargebeeWebhook(options).then(function (request) { return request(axios, basePath); });
        },
        subscriptionsCheckout: function (subscriptions_checkout_request, options) {
            return localVarFp.subscriptionsCheckout(subscriptions_checkout_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauCheckConnection: function (tableau_check_connection_request, options) {
            return localVarFp.tableauCheckConnection(tableau_check_connection_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauGetRecentlyViewedWorksheets: function (tableau_get_recently_viewed_worksheets_request, options) {
            return localVarFp.tableauGetRecentlyViewedWorksheets(tableau_get_recently_viewed_worksheets_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauGetServerInfo: function (tableau_get_server_info_request, options) {
            return localVarFp.tableauGetServerInfo(tableau_get_server_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauGetViewsInDashboard: function (tableau_get_views_in_dashboard_request, options) {
            return localVarFp.tableauGetViewsInDashboard(tableau_get_views_in_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauGetWorksheet: function (tableau_get_worksheet_request, options) {
            return localVarFp.tableauGetWorksheet(tableau_get_worksheet_request, options).then(function (request) { return request(axios, basePath); });
        },
        tableauGetWorksheetFromUrl: function (tableau_get_worksheet_from_url_request, options) {
            return localVarFp.tableauGetWorksheetFromUrl(tableau_get_worksheet_from_url_request, options).then(function (request) { return request(axios, basePath); });
        },
        triggerLookerConnEmail: function (trigger_looker_conn_email_request, options) {
            return localVarFp.triggerLookerConnEmail(trigger_looker_conn_email_request, options).then(function (request) { return request(axios, basePath); });
        },
        undoWebDashboardRefresh: function (web_dashboard_id, undo_web_dashboard_refresh_request, options) {
            return localVarFp.undoWebDashboardRefresh(web_dashboard_id, undo_web_dashboard_refresh_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateAgentImport: function (import_id, update_agent_import_request, options) {
            return localVarFp.updateAgentImport(import_id, update_agent_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateAgentTask: function (task_id, update_agent_task_request, options) {
            return localVarFp.updateAgentTask(task_id, update_agent_task_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateAlert: function (alert_id, update_alert_request, options) {
            return localVarFp.updateAlert(alert_id, update_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateCloudTable: function (cloud_table_id, update_cloud_table_request, options) {
            return localVarFp.updateCloudTable(cloud_table_id, update_cloud_table_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataImport: function (data_import_id, update_data_import_request, options) {
            return localVarFp.updateDataImport(data_import_id, update_data_import_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataImportDataSource: function (data_import_id, update_data_import_data_source_request, options) {
            return localVarFp.updateDataImportDataSource(data_import_id, update_data_import_data_source_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataImportEditAccessType: function (data_import_id, update_data_import_edit_access_type_request, options) {
            return localVarFp.updateDataImportEditAccessType(data_import_id, update_data_import_edit_access_type_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataImportRecipe: function (data_import_recipe_id, update_data_import_recipe_request, options) {
            return localVarFp.updateDataImportRecipe(data_import_recipe_id, update_data_import_recipe_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataImportTargetInfo: function (data_import_id, update_data_import_target_info_request, options) {
            return localVarFp.updateDataImportTargetInfo(data_import_id, update_data_import_target_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDataSource: function (data_source_id, update_data_source_request, options) {
            return localVarFp.updateDataSource(data_source_id, update_data_source_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateDynamicClone: function (dynamic_clone_id, update_dynamic_clone_request, options) {
            return localVarFp.updateDynamicClone(dynamic_clone_id, update_dynamic_clone_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateEnrich: function (enrich_id, update_enrich_request, options) {
            return localVarFp.updateEnrich(enrich_id, update_enrich_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateFormulaImportDataSource: function (formula_import_id, update_formula_import_data_source_request, options) {
            return localVarFp.updateFormulaImportDataSource(formula_import_id, update_formula_import_data_source_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateLeadGen: function (leadgen_id, update_lead_gen_request, options) {
            return localVarFp.updateLeadGen(leadgen_id, update_lead_gen_request, options).then(function (request) { return request(axios, basePath); });
        },
        updatePBDash: function (pb_dash_id, update_pb_dash_request, options) {
            return localVarFp.updatePBDash(pb_dash_id, update_pb_dash_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateRecipe: function (recipe_id, update_recipe_request, options) {
            return localVarFp.updateRecipe(recipe_id, update_recipe_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSmartAlert: function (smart_alert_id, update_smart_alert_request, options) {
            return localVarFp.updateSmartAlert(smart_alert_id, update_smart_alert_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSmartAlertEditAccessType: function (smart_alert_id, update_smart_alert_edit_access_type_request, options) {
            return localVarFp.updateSmartAlertEditAccessType(smart_alert_id, update_smart_alert_edit_access_type_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSnapshot: function (snapshot_id, update_snapshot_request, options) {
            return localVarFp.updateSnapshot(snapshot_id, update_snapshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSubscriptionCustomDeal: function (options) {
            return localVarFp.updateSubscriptionCustomDeal(options).then(function (request) { return request(axios, basePath); });
        },
        updateSubscriptionEstimate: function (update_subscription_estimate_request, options) {
            return localVarFp.updateSubscriptionEstimate(update_subscription_estimate_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSubscriptionViaRetool: function (update_subscription_via_retool_request, options) {
            return localVarFp.updateSubscriptionViaRetool(update_subscription_via_retool_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateSubscriptions: function (update_subscriptions_request, options) {
            return localVarFp.updateSubscriptions(update_subscriptions_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateTableauAppInfo: function (update_tableau_app_info_request, options) {
            return localVarFp.updateTableauAppInfo(update_tableau_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateUser: function (user_id, options) {
            return localVarFp.updateUser(user_id, options).then(function (request) { return request(axios, basePath); });
        },
        updateUserMe: function (update_user_me_request, options) {
            return localVarFp.updateUserMe(update_user_me_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateWebDashboard: function (web_dashboard_id, update_web_dashboard_request, options) {
            return localVarFp.updateWebDashboard(web_dashboard_id, update_web_dashboard_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateWebDashboardSubscription: function (web_dashboard_id, web_dashboard_subscription_id, update_web_dashboard_subscription_request, options) {
            return localVarFp.updateWebDashboardSubscription(web_dashboard_id, web_dashboard_subscription_id, update_web_dashboard_subscription_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateWebDashboardTabsConfig: function (web_dashboard_id, update_web_dashboard_tabs_config_request, options) {
            return localVarFp.updateWebDashboardTabsConfig(web_dashboard_id, update_web_dashboard_tabs_config_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateWorkspace: function (workspace_id, options) {
            return localVarFp.updateWorkspace(workspace_id, options).then(function (request) { return request(axios, basePath); });
        },
        updateWriteback: function (writeback_id, update_writeback_request, options) {
            return localVarFp.updateWriteback(writeback_id, update_writeback_request, options).then(function (request) { return request(axios, basePath); });
        },
        updateWritebackMappingLabels: function (writeback_id, update_writeback_mapping_labels_request, options) {
            return localVarFp.updateWritebackMappingLabels(writeback_id, update_writeback_mapping_labels_request, options).then(function (request) { return request(axios, basePath); });
        },
        uploadWebDashboardBlockScreenshot: function (request_id, upload_web_dashboard_block_screenshot_request, options) {
            return localVarFp.uploadWebDashboardBlockScreenshot(request_id, upload_web_dashboard_block_screenshot_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertArrowFlightSqlAppInfo: function (upsert_arrow_flight_sql_app_info_request, options) {
            return localVarFp.upsertArrowFlightSqlAppInfo(upsert_arrow_flight_sql_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertCustomOAuthAppInfo: function (upsert_custom_o_auth_app_info_request, options) {
            return localVarFp.upsertCustomOAuthAppInfo(upsert_custom_o_auth_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertDatabricksAppInfo: function (upsert_databricks_app_info_request, options) {
            return localVarFp.upsertDatabricksAppInfo(upsert_databricks_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertLookerAppInfo: function (upsert_looker_app_info_request, options) {
            return localVarFp.upsertLookerAppInfo(upsert_looker_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertNetSuiteAppInfo: function (upsert_net_suite_app_info_request, options) {
            return localVarFp.upsertNetSuiteAppInfo(upsert_net_suite_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertPublicTemplate: function (upsert_public_template_request, options) {
            return localVarFp.upsertPublicTemplate(upsert_public_template_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertSnowflakeAppInfo: function (upsert_snowflake_app_info_request, options) {
            return localVarFp.upsertSnowflakeAppInfo(upsert_snowflake_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertTableauAppInfo: function (upsert_tableau_app_info_request, options) {
            return localVarFp.upsertTableauAppInfo(upsert_tableau_app_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        validateWritebackMappings: function (data_source_id, validate_writeback_mappings_request, options) {
            return localVarFp.validateWritebackMappings(data_source_id, validate_writeback_mappings_request, options).then(function (request) { return request(axios, basePath); });
        },
        vcrAuthGetInstanceInfo: function (vcr_auth_get_instance_info_request, options) {
            return localVarFp.vcrAuthGetInstanceInfo(vcr_auth_get_instance_info_request, options).then(function (request) { return request(axios, basePath); });
        },
        vcrMetadata: function (options) {
            return localVarFp.vcrMetadata(options).then(function (request) { return request(axios, basePath); });
        },
        vcrStartAuthSession: function (vcr_start_auth_session_request, options) {
            return localVarFp.vcrStartAuthSession(vcr_start_auth_session_request, options).then(function (request) { return request(axios, basePath); });
        },
        vcrTerminateAuthSession: function (options) {
            return localVarFp.vcrTerminateAuthSession(options).then(function (request) { return request(axios, basePath); });
        },
        verifyConnectionStatus: function (data_source_id, options) {
            return localVarFp.verifyConnectionStatus(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        viewWebDashboardAsSuperAdmin: function (web_dashboard_id, reason, ts, options) {
            return localVarFp.viewWebDashboardAsSuperAdmin(web_dashboard_id, reason, ts, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
var DefaultApi = (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultApi.prototype.abortWritebackMultipartUpload = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).abortWritebackMultipartUpload(requestParameters.writeback_id, requestParameters.abort_writeback_multipart_upload_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.activateSmartAlert = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).activateSmartAlert(requestParameters.activate_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.addAgentCredits = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).addAgentCredits(requestParameters.add_agent_credits_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.addCouponToDomain = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addCouponToDomain(requestParameters.domain, requestParameters.add_coupon_to_domain_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminGetAgentThreadMessages = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).adminGetAgentThreadMessages(requestParameters.thread_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminGetSmartAlertRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).adminGetSmartAlertRuns(requestParameters.smart_alert_id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminGetSmartAlertThread = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).adminGetSmartAlertThread(requestParameters.smart_alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminGetThreadAnalysisResults = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).adminGetThreadAnalysisResults(requestParameters.analysis_id, requestParameters.email, requestParameters.domain, requestParameters.agent_type, requestParameters.since, requestParameters.until, requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminListThreadAnalyses = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).adminListThreadAnalyses(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminSearchSmartAlerts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).adminSearchSmartAlerts(requestParameters.email, requestParameters.smart_alert_id, requestParameters.spreadsheet_id, requestParameters.run_id, requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.adminSearchWebDashboards = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).adminSearchWebDashboards(requestParameters.web_dashboard_id, requestParameters.email, requestParameters.domain, requestParameters.spreadsheet_id, requestParameters.exclude_coefficient_io, requestParameters.source_type, requestParameters.build_status, requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertRemoveSlackConnection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).alertRemoveSlackConnection(requestParameters.alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertSlackAuthTest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).alertSlackAuthTest(requestParameters.alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertValidateSelectedTableRange = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertValidateSelectedTableRange(requestParameters.alert_validate_selected_table_range_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertsClockTrigger = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertsClockTrigger(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertsGetRangeScreenshot = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertsGetRangeScreenshot(requestParameters.alerts_get_range_screenshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertsMonitoredCellsDidChange = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertsMonitoredCellsDidChange(requestParameters.alerts_monitored_cells_did_change_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertsSendPreview = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertsSendPreview(requestParameters.alerts_send_preview_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.alertsSendTryout = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).alertsSendTryout(requestParameters.alerts_send_tryout_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.analyticsTrack = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).analyticsTrack(requestParameters.analytics_track_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.analyticsTrackAnonymousEvents = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).analyticsTrackAnonymousEvents(requestParameters.analytics_track_anonymous_events_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.analyticsTrackPreUserEvent = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).analyticsTrackPreUserEvent(requestParameters.analytics_track_pre_user_event_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.archiveWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).archiveWebDashboard(requestParameters.web_dashboard_id, requestParameters.archive_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.authGoogleJWTCallback = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authGoogleJWTCallback(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.authLogout = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authLogout(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.authSignup = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).authSignup(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.autoExpandRange = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).autoExpandRange(requestParameters.range, requestParameters.google_sheets_file_id, requestParameters.google_sheets_tab_id, requestParameters.excel_file_id, requestParameters.excel_drive_id, requestParameters.excel_site_id, requestParameters.excel_sheet_id, requestParameters.spreadsheet_id, requestParameters.tab_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.boxGetAuthToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).boxGetAuthToken(requestParameters.box_get_auth_token_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.boxGetCsvRawValues = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).boxGetCsvRawValues(requestParameters.box_get_csv_raw_values_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.browserAgentCommandResult = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).browserAgentCommandResult(requestParameters.command_id, requestParameters.browser_agent_command_result_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.browserAgentConnection = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).browserAgentConnection(requestParameters.browser_agent_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.browserAgentConnectionStatus = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).browserAgentConnectionStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.bulkEditSchedule = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).bulkEditSchedule(requestParameters.bulk_edit_schedule_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.bulkPollDataImportRunStatus = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).bulkPollDataImportRunStatus(requestParameters.bulk_poll_data_import_run_status_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkConnection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkConnection(requestParameters.data_source_type, requestParameters.check_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkDataSourceConnectionLimit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkDataSourceConnectionLimit(requestParameters.data_source_type, requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkMSTeamsBotInChannel = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).checkMSTeamsBotInChannel(requestParameters.check_ms_teams_bot_in_channel_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkSalesforceAppInstall = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkSalesforceAppInstall(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkWebDashboardEditPermission = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkWebDashboardEditPermission(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkWebDashboardPermissionPublic = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkWebDashboardPermissionPublic(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkWebsocketStatus = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkWebsocketStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.checkWritebackMappings = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).checkWritebackMappings(requestParameters.writeback_id, requestParameters.check_writeback_mappings_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.claimSignupAttributionEvents = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).claimSignupAttributionEvents(requestParameters.claim_signup_attribution_events_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloneSpreadsheet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloneSpreadsheet(requestParameters.clone_spreadsheet_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloneSpreadsheetAlerts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloneSpreadsheetAlerts(requestParameters.clone_spreadsheet_alerts_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloneSpreadsheetSnapshots = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloneSpreadsheetSnapshots(requestParameters.clone_spreadsheet_snapshots_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloneSpreadsheetUnpauseSchedules = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloneSpreadsheetUnpauseSchedules(requestParameters.clone_spreadsheet_unpause_schedules_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloneSpreadsheetWritebacks = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloneSpreadsheetWritebacks(requestParameters.clone_spreadsheet_writebacks_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.cloudLookup = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).cloudLookup(requestParameters.cloud_lookup_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.coeffSearch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).coeffSearch(requestParameters.coeff_search_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.coeffSearchExperimental = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).coeffSearchExperimental(requestParameters.coeff_search_experimental_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.completeDataImportsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).completeDataImportsTransfer(requestParameters.complete_data_imports_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.completeExcelSheetsContextMultipartUpload = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).completeExcelSheetsContextMultipartUpload(requestParameters.complete_excel_sheets_context_multipart_upload_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.completeWritebackMultipartUpload = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).completeWritebackMultipartUpload(requestParameters.writeback_id, requestParameters.complete_writeback_multipart_upload_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createAgentImport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createAgentImport(requestParameters.create_agent_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createAgentTask = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createAgentTask(requestParameters.create_agent_task_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createAlert = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createAlert(requestParameters.create_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createCloudTable = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createCloudTable(requestParameters.create_cloud_table_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createConnection = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createConnection(requestParameters.create_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createDataImport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createDataImport(requestParameters.create_data_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createDataImportRecipe = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createDataImportRecipe(requestParameters.create_data_import_recipe_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createDataSource = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createDataSource(requestParameters.create_data_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createDomainFamily = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createDomainFamily(requestParameters.create_domain_family_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createDynamicClone = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createDynamicClone(requestParameters.create_dynamic_clone_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createEnrich = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createEnrich(requestParameters.create_enrich_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createInternalWebDashboard = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createInternalWebDashboard(requestParameters.create_internal_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createLeadGen = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createLeadGen(requestParameters.create_lead_gen_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createLookerUrlBasedAuth = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createLookerUrlBasedAuth(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createOauthAttempt = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createOauthAttempt(requestParameters.create_oauth_attempt_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createPBDash = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createPBDash(requestParameters.create_pb_dash_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createPlaceholderWebDashboard = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createPlaceholderWebDashboard(requestParameters.create_placeholder_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createSmartAlert = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createSmartAlert(requestParameters.create_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createSnapshot = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createSnapshot(requestParameters.create_snapshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createSubscriptionCustomDeal = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createSubscriptionCustomDeal(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createUserAlias = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createUserAlias(requestParameters.create_user_alias_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createUserRequest = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createUserRequest(requestParameters.create_user_request_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createWebDashboardSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createWebDashboardSubscription(requestParameters.web_dashboard_id, requestParameters.create_web_dashboard_subscription_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createWorkspace = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createWorkspace(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.createWriteback = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).createWriteback(requestParameters.create_writeback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.crxCheckLoginStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).crxCheckLoginStatus(requestParameters.account_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.crxGetFilters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).crxGetFilters(requestParameters.report_url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.crxValidateUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).crxValidateUrl(requestParameters.report_url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.csvVerifyBoxFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).csvVerifyBoxFile(requestParameters.csv_verify_box_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.csvVerifyEgnyteFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).csvVerifyEgnyteFile(requestParameters.csv_verify_egnyte_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.csvVerifyOneDriveFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).csvVerifyOneDriveFile(requestParameters.csv_verify_one_drive_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.csvVerifyUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).csvVerifyUrl(requestParameters.csv_verify_url_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteAgentImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteAgentImport(requestParameters.import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteAgentTask = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteAgentTask(requestParameters.task_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteAlert(requestParameters.alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteArrowFlightSqlAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteArrowFlightSqlAppInfo(requestParameters.delete_arrow_flight_sql_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteCloudTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteCloudTable(requestParameters.cloud_table_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteCustomOAuthAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteCustomOAuthAppInfo(requestParameters.delete_custom_o_auth_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDataImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDataImport(requestParameters.data_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDataImportRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDataImportRecipe(requestParameters.data_import_recipe_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDataSource(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDatabricksAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteDatabricksAppInfo(requestParameters.delete_databricks_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDomainFamily = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDomainFamily(requestParameters.domain_family_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteDynamicClone = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteDynamicClone(requestParameters.dynamic_clone_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteEnrich = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteEnrich(requestParameters.enrich_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteInvite = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteInvite(requestParameters.invite_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteLeadGen = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteLeadGen(requestParameters.leadgen_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteLookerAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteLookerAppInfo(requestParameters.delete_looker_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteNetSuiteAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteNetSuiteAppInfo(requestParameters.delete_net_suite_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deletePBDash = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deletePBDash(requestParameters.pb_dash_id, requestParameters.delete_target_google_sheets_tab, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deletePublicTemplate = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deletePublicTemplate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteRecipe(requestParameters.recipe_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteSnapshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteSnapshot(requestParameters.snapshot_id, requestParameters.delete_snapshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteSnowflakeAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteSnowflakeAppInfo(requestParameters.delete_snowflake_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteTableauAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).deleteTableauAppInfo(requestParameters.delete_tableau_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteUser(requestParameters.user_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWebDashboard(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteWebDashboardCustomLogo = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWebDashboardCustomLogo(requestParameters.variant, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteWebDashboardCustomTheme = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWebDashboardCustomTheme(requestParameters.theme_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteWebDashboardSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWebDashboardSubscription(requestParameters.web_dashboard_id, requestParameters.web_dashboard_subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.deleteWriteback = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).deleteWriteback(requestParameters.writeback_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.describeAgentConnection = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).describeAgentConnection(requestParameters.connection_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.describeAgentConnectionSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).describeAgentConnectionSource(requestParameters.connection_id, requestParameters.object_name, requestParameters.schema_name, requestParameters.search, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.downloadSQLiteDB = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).downloadSQLiteDB(requestParameters.spreadsheet_id, requestParameters.spreadsheet_version_id, requestParameters.dashboard_id, requestParameters.table_name, requestParameters.all_tables, requestParameters.cache_key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.duplicateWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).duplicateWebDashboard(requestParameters.web_dashboard_id, requestParameters.duplicate_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.editDomainFamily = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).editDomainFamily(requestParameters.domain_family_id, requestParameters.edit_domain_family_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.egnyteGetCsvRawValues = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).egnyteGetCsvRawValues(requestParameters.egnyte_get_csv_raw_values_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.emailRedirect = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).emailRedirect(requestParameters.target_id, requestParameters.source_id, requestParameters.source, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.errorsTrackUserProblem = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).errorsTrackUserProblem(requestParameters.errors_track_user_problem_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelDataImportRunTestFlow = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelDataImportRunTestFlow(requestParameters.excel_data_import_run_test_flow_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelGetMetadata = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelGetMetadata(requestParameters.excel_get_metadata_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelRedirect = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).excelRedirect(requestParameters.id, requestParameters.redirection_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelVerifyBoxFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelVerifyBoxFile(requestParameters.excel_verify_box_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelVerifyEgnyteFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelVerifyEgnyteFile(requestParameters.excel_verify_egnyte_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelVerifyOneDriveFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelVerifyOneDriveFile(requestParameters.excel_verify_one_drive_file_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.excelVerifyUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).excelVerifyUrl(requestParameters.excel_verify_url_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.exchangeAuthToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).exchangeAuthToken(requestParameters.exchange_auth_token_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.exchangeCRXAuthToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).exchangeCRXAuthToken(requestParameters.exchange_crx_auth_token_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.fetchSnapshotClientPlan = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).fetchSnapshotClientPlan(requestParameters.snapshot_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.fetchSnapshotSheets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).fetchSnapshotSheets(requestParameters.google_sheet_file_id, requestParameters.excel_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.fetchSnapshots = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).fetchSnapshots(requestParameters.google_sheet_file_id, requestParameters.google_sheet_tab_id, requestParameters.excel_file_id, requestParameters.user_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.fetchWritebacksSchema = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).fetchWritebacksSchema(requestParameters.data_source_id, requestParameters.fetch_writebacks_schema_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.forceRestoreWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).forceRestoreWebDashboard(requestParameters.web_dashboard_id, requestParameters.force_restore_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gSheetsGetColumns = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gSheetsGetColumns(requestParameters.g_sheets_get_columns_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gSheetsGetNamedRangeParameters = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).gSheetsGetNamedRangeParameters(requestParameters.target_google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gSheetsGetTabs = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gSheetsGetTabs(requestParameters.g_sheets_get_tabs_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gSheetsUpsertNamedRangeParameter = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gSheetsUpsertNamedRangeParameter(requestParameters.g_sheets_upsert_named_range_parameter_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.generateDashboardSheetsContext = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).generateDashboardSheetsContext(requestParameters.generate_dashboard_sheets_context_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.generateExcelSheetsContext = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).generateExcelSheetsContext(requestParameters.generate_excel_sheets_context_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.generateSheetsContext = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).generateSheetsContext(requestParameters.generate_sheets_context_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.generateSheetsContextExtended = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).generateSheetsContextExtended(requestParameters.generate_sheets_context_extended_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.genericScraperBulkRun = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).genericScraperBulkRun(requestParameters.generic_scraper_bulk_run_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAccountsInfo = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAccountsInfo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAdminAgentCreditHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAdminAgentCreditHistory(requestParameters.email, requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAdminAgentCredits = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAdminAgentCredits(requestParameters.email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentCreditHistory = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getAgentCreditHistory(requestParameters.limit, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentCredits = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAgentCredits(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAgentImport(requestParameters.import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAgentRun(requestParameters.run_id, requestParameters.wait_seconds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentTask = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAgentTask(requestParameters.task_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentTasks = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getAgentTasks(requestParameters.thread_id, requestParameters.spreadsheet_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentThreadRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAgentThreadRun(requestParameters.thread_id, requestParameters.agent_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAgentThreads = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getAgentThreads(requestParameters.updated_dt_offset, requestParameters.sort_order, requestParameters.page_size, requestParameters.spreadsheet_id, requestParameters.web_dashboard_id, requestParameters.agent_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAiUsageAllowance = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAiUsageAllowance(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAlert(requestParameters.alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlertReport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAlertReport(requestParameters.alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlertRunHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAlertRunHistory(requestParameters.alert_id, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlerts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getAlerts(requestParameters.google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getArchivedWebDashboards = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getArchivedWebDashboards(requestParameters.email, requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAssistantThreadV2Run = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAssistantThreadV2Run(requestParameters.thread_id, requestParameters.assistant_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAssistantThreadV2Threads = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getAssistantThreadV2Threads(requestParameters.updated_dt_offset, requestParameters.sort_order, requestParameters.page_size, requestParameters.spreadsheet_id, requestParameters.web_dashboard_id, requestParameters.agent_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAutoAnalystRunStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAutoAnalystRunStatus(requestParameters.auto_analyses_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getBillingDetails = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getBillingDetails(requestParameters.get_billing_details_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getChargebeeCoupons = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getChargebeeCoupons(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getClientFlags = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getClientFlags(requestParameters.google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getClonedSpreadsheetSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getClonedSpreadsheetSource(requestParameters.cloned_spreadsheet_file_id, requestParameters.source_spreadsheet_data_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getCloudTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCloudTable(requestParameters.cloud_table_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getCloudTableData = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCloudTableData(requestParameters.cloud_table_id, requestParameters.get_cloud_table_data_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getCloudTableRunHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCloudTableRunHistory(requestParameters.cloud_table_id, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getCloudTables = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCloudTables(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getCuratedAPIAgentWelcomeConfig = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getCuratedAPIAgentWelcomeConfig(requestParameters.data_source_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDashboardSpreadsheets = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDashboardSpreadsheets(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDashboardTeamActivity = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDashboardTeamActivity(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImport(requestParameters.data_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportCompatibleDataSources = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportCompatibleDataSources(requestParameters.data_import_id, requestParameters.restricted_field_option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportDueScheduledRuns = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportDueScheduledRuns(requestParameters.get_data_import_due_scheduled_runs_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportEditAccessType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportEditAccessType(requestParameters.data_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportQuery = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportQuery(requestParameters.data_source_type, requestParameters.get_data_import_query_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRecipe(requestParameters.data_import_recipe_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRecipes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRecipes(requestParameters.data_source_type, requestParameters.limit, requestParameters.custom_api_previous_import_option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRunHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRunHistory(requestParameters.data_import_id, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportRunStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportRunStatus(requestParameters.data_import_id, requestParameters.max_wait_time_secs, requestParameters.data_import_run_id, requestParameters.preempt_option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImportWriterPlan = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImportWriterPlan(requestParameters.data_import_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImports = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDataImports(requestParameters.target_google_sheets_file_id, requestParameters.include_deleted, requestParameters.data_source_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSource(requestParameters.data_source_id, requestParameters.restricted_field_option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSourceSQLTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSourceSQLTable(requestParameters.data_source_id, requestParameters.schema_name, requestParameters.table_name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSourceSchema = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSourceSchema(requestParameters.data_source_id, requestParameters.schema_name, requestParameters.force_refresh, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSourceSchemas = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataSourceSchemas(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataSources = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDataSources(requestParameters.restricted_field_option, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainCoupon = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainCoupon(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainFamilies = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainFamilies(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainFamily = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainFamily(requestParameters.domain_family_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainFamilyChangeLog = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainFamilyChangeLog(requestParameters.domain_family_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainUsers = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainUsers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDynamicClone = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicClone(requestParameters.dynamic_clone_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDynamicClones = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDynamicClones(requestParameters.google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEditorThreadMessages = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEditorThreadMessages(requestParameters.dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEgnyteToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEgnyteToken(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnabledDataSources = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getEnabledDataSources(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnrich = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEnrich(requestParameters.enrich_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnrichMetadata = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getEnrichMetadata(requestParameters.get_enrich_metadata_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnrichRunStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEnrichRunStatus(requestParameters.enrich_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnrichRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEnrichRuns(requestParameters.enrich_id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getEnriches = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getEnriches(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getExcelFileId = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getExcelFileId(requestParameters.get_excel_file_id_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getExcelSheetsContextPresignedUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getExcelSheetsContextPresignedUrl(requestParameters.get_excel_sheets_context_presigned_url_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getFormulaImportCompatibleDataSources = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getFormulaImportCompatibleDataSources(requestParameters.formula_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getInvitations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getInvitations(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getLatestWebDashboardRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLatestWebDashboardRun(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getLeadGen = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLeadGen(requestParameters.leadgen_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getLeadGenRunStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLeadGenRunStatus(requestParameters.leadgen_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getLeadGenRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLeadGenRuns(requestParameters.leadgen_id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getLeadGens = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getLeadGens(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getMSTeamsAuthStatus = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getMSTeamsAuthStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getMSTeamsTeamsAndChannels = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getMSTeamsTeamsAndChannels(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getNetsuiteReportMetadataInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getNetsuiteReportMetadataInfo(requestParameters.get_netsuite_report_metadata_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getOIDCLoginUrl = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getOIDCLoginUrl(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getOauthAttempt = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getOauthAttempt(requestParameters.oauth_attempt_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getPBDash = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPBDash(requestParameters.pb_dash_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getPBDashBlueprints = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getPBDashBlueprints(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getPBDashes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getPBDashes(requestParameters.target_google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getPublicTemplates = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getPublicTemplates(requestParameters.data_source_type, requestParameters.filename, requestParameters.public_template_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getRESTLetInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getRESTLetInfo(requestParameters.get_rest_let_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getRecipe(requestParameters.recipe_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSQLiteDownloadURL = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSQLiteDownloadURL(requestParameters.dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSQLiteDownloadURLPublic = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSQLiteDownloadURLPublic(requestParameters.dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSlackAuthStatus = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSlackAuthStatus(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSlackChannelsAndUsers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSlackChannelsAndUsers(requestParameters.alert_id, requestParameters.force_refresh, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSmartAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSmartAlert(requestParameters.smart_alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSmartAlertRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSmartAlertRuns(requestParameters.smart_alert_id, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSmartAlertSuggestions = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSmartAlertSuggestions(requestParameters.google_sheets_file_id, requestParameters.excel_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSnowflakeKeyPair = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSnowflakeKeyPair(requestParameters.get_snowflake_key_pair_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSubscriptionInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionInfo(requestParameters.subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSubscriptionInvoiceUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionInvoiceUrl(requestParameters.invoice_id, requestParameters.subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSubscriptionInvoices = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionInvoices(requestParameters.subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSubscriptions = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptions(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getSubscriptionsPreCheckout = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getSubscriptionsPreCheckout(requestParameters.subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUsageMeter = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUsageMeter(requestParameters.meter_type_str, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUser = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUser(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUserExtra = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUserExtra(requestParameters.user_extra_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUserSSOInfo = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUserSSOInfo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getVirtualImportData = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getVirtualImportData(requestParameters.data_import_id, requestParameters.get_virtual_import_data_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboard(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardForScreenshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardForScreenshot(requestParameters.web_dashboard_id, requestParameters.screenshot_token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardOffer = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardOffer(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardPlanLimit = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardPlanLimit(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardPlanUsage = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardPlanUsage(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardPublic = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardPublic(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardRun(requestParameters.web_dashboard_id, requestParameters.web_dashboard_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardTabImpact = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardTabImpact(requestParameters.web_dashboard_id, requestParameters.tab_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardTrialHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardTrialHistory(requestParameters.product_trial_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebDashboardTrialUsers = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getWebDashboardTrialUsers(requestParameters.domain, requestParameters.emails, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWebhookUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getWebhookUrl(requestParameters.get_webhook_url_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWorkspace = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWorkspace(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWriteback = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWriteback(requestParameters.writeback_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackMatchingDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackMatchingDataSource(requestParameters.writeback_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackRowStatuses = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackRowStatuses(requestParameters.writeback_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackRunHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackRunHistory(requestParameters.writeback_id, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackUploadDataUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackUploadDataUrl(requestParameters.writeback_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebackWriterPlan = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebackWriterPlan(requestParameters.writeback_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebacks = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getWritebacks(requestParameters.target_google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getWritebacksSchema = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getWritebacksSchema(requestParameters.data_source_id, requestParameters.object_name, requestParameters.writeback_mode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getZendeskChatSessionJWT = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getZendeskChatSessionJWT(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.googleAnalyticsGetSchema = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).googleAnalyticsGetSchema(requestParameters.google_analytics_get_schema_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.googleAnalyticsGetSchemaAlias = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).googleAnalyticsGetSchemaAlias(requestParameters.google_analytics_get_schema_alias_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.googleDriveCheckConnection = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).googleDriveCheckConnection(requestParameters.google_drive_check_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.googleDriveGetAuthToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).googleDriveGetAuthToken(requestParameters.google_drive_get_auth_token_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.googleDriveGetCsvRawValues = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).googleDriveGetCsvRawValues(requestParameters.google_drive_get_csv_raw_values_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptChart = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptChart(requestParameters.gpt_chart_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptChartWriter = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptChartWriter(requestParameters.gpt_chart_writer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptFeedback = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptFeedback(requestParameters.gpt_feedback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptFormula = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptFormula(requestParameters.gpt_formula_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptPivot = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptPivot(requestParameters.gpt_pivot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptPivotWriter = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptPivotWriter(requestParameters.gpt_pivot_writer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptSQL = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptSQL(requestParameters.gpt_sql_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.gptSQLFixQuery = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).gptSQLFixQuery(requestParameters.gpt_sql_fix_query_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.handleMSGraphWebhook = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).handleMSGraphWebhook(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.handleSmartAlertsOnChange = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).handleSmartAlertsOnChange(requestParameters.handle_smart_alerts_on_change_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetAllLists = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetAllLists(requestParameters.hubspot_get_all_lists_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetObjectType = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetObjectType(requestParameters.hubspot_get_object_type_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetObjectTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetObjectTypes(requestParameters.hubspot_get_object_types_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetPipelineStages = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetPipelineStages(requestParameters.hubspot_get_pipeline_stages_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetPipelines = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetPipelines(requestParameters.hubspot_get_pipelines_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.hubspotGetPipelinesMultiObject = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).hubspotGetPipelinesMultiObject(requestParameters.hubspot_get_pipelines_multi_object_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.initiateDataimportsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).initiateDataimportsTransfer(requestParameters.initiate_dataimports_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.initiateSlackMarketplaceOauth = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).initiateSlackMarketplaceOauth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.inviteWebDashboardShare = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).inviteWebDashboardShare(requestParameters.web_dashboard_id, requestParameters.invite_web_dashboard_share_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.killWritebackRun = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).killWritebackRun(requestParameters.writeback_id, requestParameters.writeback_run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listAgentConnections = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listAgentConnections(requestParameters.query, requestParameters.connection_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listAgentImports = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listAgentImports(requestParameters.spreadsheet_id, requestParameters.connection_id, requestParameters.owned_by_me, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listArrowFlightSqlAppInfo = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listArrowFlightSqlAppInfo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listCustomOAuthAppInfo = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listCustomOAuthAppInfo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listDatabricksAppInfo = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listDatabricksAppInfo(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listFormulaImports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listFormulaImports(requestParameters.target_google_sheets_file_id, requestParameters.data_source_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listLicenseRequests = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listLicenseRequests(requestParameters.subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listLookerAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listLookerAppInfo(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listNetSuiteAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listNetSuiteAppInfo(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listRecipes = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listRecipes(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listSmartAlerts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listSmartAlerts(requestParameters.excel_file_id, requestParameters.google_sheets_file_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listSnowflakeAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listSnowflakeAppInfo(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listTableauAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).listTableauAppInfo(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listWebDashboardCustomThemes = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listWebDashboardCustomThemes(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listWebDashboardShares = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listWebDashboardShares(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listWebDashboardSubscriptionRuns = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listWebDashboardSubscriptionRuns(requestParameters.web_dashboard_id, requestParameters.web_dashboard_subscription_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listWebDashboardSubscriptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listWebDashboardSubscriptions(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.listWebDashboards = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listWebDashboards(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.loadDashboardVersion = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).loadDashboardVersion(requestParameters.load_dashboard_version_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerCheckConnection = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerCheckConnection(requestParameters.looker_check_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerFetchUrlBasedAuthDetails = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerFetchUrlBasedAuthDetails(requestParameters.looker_fetch_url_based_auth_details_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerGetDashboardElements = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerGetDashboardElements(requestParameters.looker_get_dashboard_elements_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerGetDataSourceOwnerMetaData = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerGetDataSourceOwnerMetaData(requestParameters.looker_get_data_source_owner_meta_data_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerGetFolder = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerGetFolder(requestParameters.looker_get_folder_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerGetObjects = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerGetObjects(requestParameters.looker_get_objects_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerGetSchema = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerGetSchema(requestParameters.looker_get_schema_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.lookerSearchObjects = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).lookerSearchObjects(requestParameters.looker_search_objects_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.maybeCreateUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).maybeCreateUser(requestParameters.signup_source, requestParameters.signup_source_campaign, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.maybeSendEmailImportRefreshBlocked = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).maybeSendEmailImportRefreshBlocked(requestParameters.data_import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.migrateSnapshotToV2 = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).migrateSnapshotToV2(requestParameters.migrate_snapshot_to_v2_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.noSqlGetSchema = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).noSqlGetSchema(requestParameters.no_sql_get_schema_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.oauth2ProxyGrant = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).oauth2ProxyGrant(requestParameters.service_id, requestParameters.state, requestParameters.code, requestParameters.error, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.oauth2ProxyGrantFormPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).oauth2ProxyGrantFormPost(requestParameters.service_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.oauth2Uninstall = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).oauth2Uninstall(requestParameters.service_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.oneDriveGetCsvRawValues = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).oneDriveGetCsvRawValues(requestParameters.one_drive_get_csv_raw_values_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.parsePageContent = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).parsePageContent(requestParameters.parse_page_content_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.patchUserExtra = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).patchUserExtra(requestParameters.patch_user_extra_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.patchWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWebDashboard(requestParameters.web_dashboard_id, requestParameters.patch_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.patchWebDashboardSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).patchWebDashboardSubscription(requestParameters.web_dashboard_id, requestParameters.web_dashboard_subscription_id, requestParameters.patch_web_dashboard_subscription_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.pauseAgentImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).pauseAgentImport(requestParameters.import_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postAgentThread = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).postAgentThread(requestParameters.post_agent_thread_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postAgentThreadPause = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postAgentThreadPause(requestParameters.thread_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postAssistantThreadV2 = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).postAssistantThreadV2(requestParameters.post_assistant_thread_v2_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postAssistantThreadV2Feedback = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).postAssistantThreadV2Feedback(requestParameters.post_assistant_thread_v2_feedback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postAutoAnalyses = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).postAutoAnalyses(requestParameters.post_auto_analyses_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postGPTFunctionsClearCache = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).postGPTFunctionsClearCache(requestParameters.post_gpt_functions_clear_cache_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.postMSTeamsBotMessages = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).postMSTeamsBotMessages(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ppressPreviewModalRenderForm = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).ppressPreviewModalRenderForm(requestParameters.ppress_preview_modal_render_form_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ppressRenderAuthForm = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).ppressRenderAuthForm(requestParameters.ppress_render_auth_form_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ppressRenderForm = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).ppressRenderForm(requestParameters.ppress_render_form_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ppressRenderPublicTemplateForm = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).ppressRenderPublicTemplateForm(requestParameters.ppress_render_public_template_form_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.presignWebDashboardBlockScreenshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).presignWebDashboardBlockScreenshot(requestParameters.request_id, requestParameters.presign_web_dashboard_block_screenshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.previewAgentImportSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).previewAgentImportSource(requestParameters.connection_id, requestParameters.preview_agent_import_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.previewRunWriteback = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).previewRunWriteback(requestParameters.writeback_id, requestParameters.preview_run_writeback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.previewSmartAlert = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).previewSmartAlert(requestParameters.preview_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.processCustomFunction = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).processCustomFunction(requestParameters.process_custom_function_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.processCustomFunctionAsync = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).processCustomFunctionAsync(requestParameters.process_custom_function_async_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.putCRXGetFiltersAttempt = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putCRXGetFiltersAttempt(requestParameters.attempt_id, requestParameters.put_crx_get_filters_attempt_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.putCRXLoginStatusCheckAttempt = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putCRXLoginStatusCheckAttempt(requestParameters.attempt_id, requestParameters.put_crx_login_status_check_attempt_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.putCRXRunAttempt = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putCRXRunAttempt(requestParameters.crx_run_attempt_id, requestParameters.put_crx_run_attempt_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.putCRXValidateUrlAttempt = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).putCRXValidateUrlAttempt(requestParameters.attempt_id, requestParameters.put_crx_validate_url_attempt_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.quickbooksGetReportFilter = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).quickbooksGetReportFilter(requestParameters.quickbooks_get_report_filter_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.quickbooksGetReportFilters = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).quickbooksGetReportFilters(requestParameters.quickbooks_get_report_filters_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.quickstart = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).quickstart(requestParameters.email, requestParameters.force_create, requestParameters.addon_platform, requestParameters.variant_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ratingPopupSetRating = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).ratingPopupSetRating(requestParameters.rating_popup_set_rating_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.ratingPopupTrackShown = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).ratingPopupTrackShown(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.recipeRunResults = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).recipeRunResults(requestParameters.recipe_id, requestParameters.run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.recipeRunStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).recipeRunStatus(requestParameters.recipe_id, requestParameters.run_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.recordWebDashboardView = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).recordWebDashboardView(requestParameters.web_dashboard_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.recordWebDashboardViewPublic = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).recordWebDashboardViewPublic(requestParameters.web_dashboard_id, requestParameters.record_web_dashboard_view_public_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.refreshAuthToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).refreshAuthToken(requestParameters.refresh_auth_token_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.refreshCustomFunctionFormula = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).refreshCustomFunctionFormula(requestParameters.refresh_custom_function_formula_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.refreshNetsuiteReportMetadata = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).refreshNetsuiteReportMetadata(requestParameters.refresh_netsuite_report_metadata_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.refreshWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).refreshWebDashboard(requestParameters.web_dashboard_id, requestParameters.refresh_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.removeCouponFromDomain = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).removeCouponFromDomain(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.removeCouponFromSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).removeCouponFromSubscription(requestParameters.subscription_id, requestParameters.coupon, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.removeWebDashboardPlanLimitOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).removeWebDashboardPlanLimitOverride(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.reportExcelManualRunOutcome = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).reportExcelManualRunOutcome(requestParameters.report_excel_manual_run_outcome_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.reportSnapshotClientOutcome = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).reportSnapshotClientOutcome(requestParameters.snapshot_id, requestParameters.report_snapshot_client_outcome_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.requestLicense = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).requestLicense(requestParameters.request_license_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.resendInvite = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).resendInvite(requestParameters.invite_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.resetUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).resetUser(requestParameters.reset_user_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.resetUserMeter = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).resetUserMeter(requestParameters.reset_user_meter_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.resolveLicenseRequest = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).resolveLicenseRequest(requestParameters.resolve_license_request_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.restoreWebDashboardCustomTheme = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).restoreWebDashboardCustomTheme(requestParameters.theme_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.retoolSetFreeTrialAutomaticStartMode = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).retoolSetFreeTrialAutomaticStartMode(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.retoolTrialStateBulkUpdateWithTrialState = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).retoolTrialStateBulkUpdateWithTrialState(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.retoolTrialStateBulkUpdateWithUserEmail = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).retoolTrialStateBulkUpdateWithUserEmail(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.retoolUpdateSubscriptionEstimate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).retoolUpdateSubscriptionEstimate(requestParameters.retool_update_subscription_estimate_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.retoolWebDashboardTrialBulkUpdate = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).retoolWebDashboardTrialBulkUpdate(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.revokeMSTeamsAuth = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).revokeMSTeamsAuth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.revokeSlackAuth = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).revokeSlackAuth(requestParameters.revoke_slack_auth_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runAgentImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runAgentImport(requestParameters.import_id, requestParameters.run_agent_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runAgentTask = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runAgentTask(requestParameters.task_id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runCloudTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runCloudTable(requestParameters.cloud_table_id, requestParameters.is_scheduled_run, requestParameters.run_cloud_table_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runCloudTablePreviewRun = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runCloudTablePreviewRun(requestParameters.run_cloud_table_preview_run_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runDataImport(requestParameters.data_import_id, requestParameters.is_scheduled_run, requestParameters.is_triggered_by_parameterized_filter, requestParameters.proposed_run_id, requestParameters.run_data_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataImportFieldChoices = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runDataImportFieldChoices(requestParameters.run_data_import_field_choices_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataImportMulti = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runDataImportMulti(requestParameters.run_data_import_multi_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataImportPreviewRun = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runDataImportPreviewRun(requestParameters.run_data_import_preview_run_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataImportSnapshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runDataImportSnapshot(requestParameters.data_import_id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDataimportMorpheus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runDataimportMorpheus(requestParameters.data_import_id, requestParameters.run_dataimport_morpheus_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runDynamicClone = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runDynamicClone(requestParameters.dynamic_clone_id, requestParameters.run_dynamic_clone_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runEnrich = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runEnrich(requestParameters.enrich_id, requestParameters.run_enrich_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runFormulaFunction = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runFormulaFunction(requestParameters.run_formula_function_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runGPTFunction = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runGPTFunction(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runLeadGen = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runLeadGen(requestParameters.leadgen_id, requestParameters.run_lead_gen_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runRecipe(requestParameters.recipe_id, requestParameters.run_recipe_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runSmartAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runSmartAlert(requestParameters.smart_alert_id, requestParameters.run_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runSnapshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runSnapshot(requestParameters.snapshot_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runWebhook = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runWebhook(requestParameters.webhook_token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runWriteback = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).runWriteback(requestParameters.writeback_id, requestParameters.run_writeback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.runWritebackMulti = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).runWritebackMulti(requestParameters.run_writeback_multi_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sageDeleteFinancialReport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sageDeleteFinancialReport(requestParameters.report_name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sageGetFinancialReports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sageGetFinancialReports(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.salesforceGetObjectType = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).salesforceGetObjectType(requestParameters.salesforce_get_object_type_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.salesforceGetObjectTypes = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).salesforceGetObjectTypes(requestParameters.salesforce_get_object_types_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.salesforceGetReportType = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).salesforceGetReportType(requestParameters.salesforce_get_report_type_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.salesforceGetReports = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).salesforceGetReports(requestParameters.salesforce_get_reports_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.saveAffiliateReferral = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).saveAffiliateReferral(requestParameters.save_affiliate_referral_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.screenshotDelay = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).screenshotDelay(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sendCoworkerInvitation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).sendCoworkerInvitation(requestParameters.send_coworker_invitation_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sendInvite = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sendInvite(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sendPreviewSmartAlert = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).sendPreviewSmartAlert(requestParameters.send_preview_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sendSupportEmail = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).sendSupportEmail(requestParameters.send_support_email_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setUserExtra = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).setUserExtra(requestParameters.set_user_extra_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setWebDashboardCustomLogo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).setWebDashboardCustomLogo(requestParameters.set_web_dashboard_custom_logo_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setWebDashboardCustomThemeDefault = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).setWebDashboardCustomThemeDefault(requestParameters.theme_id, requestParameters.set_web_dashboard_custom_theme_default_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setWebDashboardPlanLimitOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).setWebDashboardPlanLimitOverride(requestParameters.domain, requestParameters.set_web_dashboard_plan_limit_override_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.shopifyAuth = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).shopifyAuth(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.shopifyDeleteCustomer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).shopifyDeleteCustomer(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.shopifyDeleteShop = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).shopifyDeleteShop(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.shopifyGetCustomer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).shopifyGetCustomer(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.shouldSkipSuboptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).shouldSkipSuboptions(requestParameters.data_source_type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.signWritebackMultipartParts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).signWritebackMultipartParts(requestParameters.writeback_id, requestParameters.sign_writeback_multipart_parts_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.slackAuthTest = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).slackAuthTest(requestParameters.token, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.slackDashboardUnfurlEvents = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).slackDashboardUnfurlEvents(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.slackDashboardUnfurlInteraction = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).slackDashboardUnfurlInteraction(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.slackInteractionCallback = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).slackInteractionCallback(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.smartAlertMSTeamsAuthTest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).smartAlertMSTeamsAuthTest(requestParameters.smart_alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.smartAlertSlackAuthTest = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).smartAlertSlackAuthTest(requestParameters.smart_alert_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.sqlGetSchema = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sqlGetSchema(requestParameters.data_source_type, requestParameters.sql_get_schema_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.startWritebackMultipartUpload = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).startWritebackMultipartUpload(requestParameters.writeback_id, requestParameters.start_writeback_multipart_upload_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.storeAgentGoogleGrant = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).storeAgentGoogleGrant(requestParameters.store_agent_google_grant_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.subscriptionsChargebeeWebhook = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionsChargebeeWebhook(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.subscriptionsCheckout = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).subscriptionsCheckout(requestParameters.subscriptions_checkout_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauCheckConnection = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauCheckConnection(requestParameters.tableau_check_connection_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauGetRecentlyViewedWorksheets = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauGetRecentlyViewedWorksheets(requestParameters.tableau_get_recently_viewed_worksheets_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauGetServerInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauGetServerInfo(requestParameters.tableau_get_server_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauGetViewsInDashboard = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauGetViewsInDashboard(requestParameters.tableau_get_views_in_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauGetWorksheet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauGetWorksheet(requestParameters.tableau_get_worksheet_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.tableauGetWorksheetFromUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).tableauGetWorksheetFromUrl(requestParameters.tableau_get_worksheet_from_url_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.triggerLookerConnEmail = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).triggerLookerConnEmail(requestParameters.trigger_looker_conn_email_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.undoWebDashboardRefresh = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).undoWebDashboardRefresh(requestParameters.web_dashboard_id, requestParameters.undo_web_dashboard_refresh_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateAgentImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateAgentImport(requestParameters.import_id, requestParameters.update_agent_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateAgentTask = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateAgentTask(requestParameters.task_id, requestParameters.update_agent_task_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateAlert(requestParameters.alert_id, requestParameters.update_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateCloudTable = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCloudTable(requestParameters.cloud_table_id, requestParameters.update_cloud_table_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataImport(requestParameters.data_import_id, requestParameters.update_data_import_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataImportDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataImportDataSource(requestParameters.data_import_id, requestParameters.update_data_import_data_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataImportEditAccessType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataImportEditAccessType(requestParameters.data_import_id, requestParameters.update_data_import_edit_access_type_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataImportRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataImportRecipe(requestParameters.data_import_recipe_id, requestParameters.update_data_import_recipe_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataImportTargetInfo = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataImportTargetInfo(requestParameters.data_import_id, requestParameters.update_data_import_target_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDataSource(requestParameters.data_source_id, requestParameters.update_data_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateDynamicClone = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateDynamicClone(requestParameters.dynamic_clone_id, requestParameters.update_dynamic_clone_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateEnrich = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateEnrich(requestParameters.enrich_id, requestParameters.update_enrich_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateFormulaImportDataSource = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateFormulaImportDataSource(requestParameters.formula_import_id, requestParameters.update_formula_import_data_source_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateLeadGen = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateLeadGen(requestParameters.leadgen_id, requestParameters.update_lead_gen_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updatePBDash = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updatePBDash(requestParameters.pb_dash_id, requestParameters.update_pb_dash_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateRecipe = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateRecipe(requestParameters.recipe_id, requestParameters.update_recipe_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSmartAlert = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateSmartAlert(requestParameters.smart_alert_id, requestParameters.update_smart_alert_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSmartAlertEditAccessType = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateSmartAlertEditAccessType(requestParameters.smart_alert_id, requestParameters.update_smart_alert_edit_access_type_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSnapshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateSnapshot(requestParameters.snapshot_id, requestParameters.update_snapshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSubscriptionCustomDeal = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateSubscriptionCustomDeal(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSubscriptionEstimate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).updateSubscriptionEstimate(requestParameters.update_subscription_estimate_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSubscriptionViaRetool = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).updateSubscriptionViaRetool(requestParameters.update_subscription_via_retool_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateSubscriptions = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).updateSubscriptions(requestParameters.update_subscriptions_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateTableauAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).updateTableauAppInfo(requestParameters.update_tableau_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateUser(requestParameters.user_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateUserMe = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).updateUserMe(requestParameters.update_user_me_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWebDashboard = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWebDashboard(requestParameters.web_dashboard_id, requestParameters.update_web_dashboard_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWebDashboardSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWebDashboardSubscription(requestParameters.web_dashboard_id, requestParameters.web_dashboard_subscription_id, requestParameters.update_web_dashboard_subscription_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWebDashboardTabsConfig = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWebDashboardTabsConfig(requestParameters.web_dashboard_id, requestParameters.update_web_dashboard_tabs_config_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWorkspace = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWorkspace(requestParameters.workspace_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWriteback = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWriteback(requestParameters.writeback_id, requestParameters.update_writeback_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.updateWritebackMappingLabels = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateWritebackMappingLabels(requestParameters.writeback_id, requestParameters.update_writeback_mapping_labels_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.uploadWebDashboardBlockScreenshot = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).uploadWebDashboardBlockScreenshot(requestParameters.request_id, requestParameters.upload_web_dashboard_block_screenshot_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertArrowFlightSqlAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertArrowFlightSqlAppInfo(requestParameters.upsert_arrow_flight_sql_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertCustomOAuthAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertCustomOAuthAppInfo(requestParameters.upsert_custom_o_auth_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertDatabricksAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertDatabricksAppInfo(requestParameters.upsert_databricks_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertLookerAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertLookerAppInfo(requestParameters.upsert_looker_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertNetSuiteAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertNetSuiteAppInfo(requestParameters.upsert_net_suite_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertPublicTemplate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertPublicTemplate(requestParameters.upsert_public_template_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertSnowflakeAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertSnowflakeAppInfo(requestParameters.upsert_snowflake_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertTableauAppInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).upsertTableauAppInfo(requestParameters.upsert_tableau_app_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.validateWritebackMappings = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).validateWritebackMappings(requestParameters.data_source_id, requestParameters.validate_writeback_mappings_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.vcrAuthGetInstanceInfo = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).vcrAuthGetInstanceInfo(requestParameters.vcr_auth_get_instance_info_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.vcrMetadata = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).vcrMetadata(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.vcrStartAuthSession = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).vcrStartAuthSession(requestParameters.vcr_start_auth_session_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.vcrTerminateAuthSession = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).vcrTerminateAuthSession(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.verifyConnectionStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).verifyConnectionStatus(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.viewWebDashboardAsSuperAdmin = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).viewWebDashboardAsSuperAdmin(requestParameters.web_dashboard_id, requestParameters.reason, requestParameters.ts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
